export const EXAM_1_ARCHIVE = {
  "examId": "final_exam",
  "title": "Kreed Odisha Official Evaluation Examination (Set 1)",
  "dateDisplay": "Sunday, 18 October 2026",
  "totalCandidates": 101,
  "summary": [
    {
      "Metric": "Examination Name",
      "Value": "Kreed Odisha Official Evaluation Examination"
    },
    {
      "Metric": "Examination Date",
      "Value": "Sunday, 18 October 2026"
    },
    {
      "Metric": "Exam Scheduled Window",
      "Value": "01:00 PM - 02:00 PM IST (Concluded at 2:00 PM)"
    },
    {
      "Metric": "Batch Definition",
      "Value": "Unified Examination (All Candidates & Batches Single Pool)"
    },
    {
      "Metric": "Total Enrolled Candidates Present",
      "Value": 101
    },
    {
      "Metric": "Candidates Who Actually Attempted Paper",
      "Value": 84
    },
    {
      "Metric": "Candidates In Lobby Only (0 Answers)",
      "Value": 17
    },
    {
      "Metric": "Qualified Candidates (>= 50% Marks)",
      "Value": 67
    },
    {
      "Metric": "Pass Percentage (of exam takers)",
      "Value": "79.8%"
    },
    {
      "Metric": "Average Score (of exam takers)",
      "Value": "22.54 / 30"
    },
    {
      "Metric": "Maximum Score Achieved",
      "Value": "30 / 30"
    }
  ],
  "candidates": [
    {
      "rank": 1,
      "registrationNumber": "KOP/2026/06/0158",
      "studentName": "SANKAR GOUDA",
      "mobileNumber": "9861868755",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:25 pm",
      "startTime": "13:15 IST",
      "submissionTime": "18/10/2026, 2:08:42 pm",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 1,
        "Registration ID": "KOP/2026/06/0158",
        "Candidate Name": "SANKAR GOUDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q1 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q1 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q1 Mark": 1,
        "Q2 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q2 Candidate Answer": "B: 45 minutes",
        "Q2 Correct Key": "B: 45 minutes",
        "Q2 Mark": 1,
        "Q3 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q3 Candidate Answer": "C: 3",
        "Q3 Correct Key": "C: 3",
        "Q3 Mark": 1,
        "Q4 Question": "Lactose (milk sugar) is made of:",
        "Q4 Candidate Answer": "C: Glucose + Galactose",
        "Q4 Correct Key": "C: Glucose + Galactose",
        "Q4 Mark": 1,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "B: Swami Vivekananda",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 1,
        "Q6 Question": "What is the minimum size of the high jump landing mat?",
        "Q6 Candidate Answer": "B: 5 m × 3 m",
        "Q6 Correct Key": "B: 5 m × 3 m",
        "Q6 Mark": 1,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q8 Candidate Answer": "C: 11",
        "Q8 Correct Key": "C: 11",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's shot?",
        "Q9 Candidate Answer": "C: 7.260 kg",
        "Q9 Correct Key": "C: 7.260 kg",
        "Q9 Mark": 1,
        "Q10 Question": "Which of the following is a Niyama?",
        "Q10 Candidate Answer": "C: Svadhyaya",
        "Q10 Correct Key": "C: Svadhyaya",
        "Q10 Mark": 1,
        "Q11 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q11 Candidate Answer": "B: To hold or maintain",
        "Q11 Correct Key": "B: To hold or maintain",
        "Q11 Mark": 1,
        "Q12 Question": "What is the diameter of the shot put circle?",
        "Q12 Candidate Answer": "B: 2.135 m",
        "Q12 Correct Key": "B: 2.135 m",
        "Q12 Mark": 1,
        "Q13 Question": "Which of the following is NOT a flight style in long jump?",
        "Q13 Candidate Answer": "D: Fosbury flop",
        "Q13 Correct Key": "D: Fosbury flop",
        "Q13 Mark": 1,
        "Q14 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q14 Candidate Answer": "C: Protein",
        "Q14 Correct Key": "C: Protein",
        "Q14 Mark": 1,
        "Q15 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q15 Candidate Answer": "C: Disqualified",
        "Q15 Correct Key": "C: Disqualified",
        "Q15 Mark": 1,
        "Q16 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q16 Candidate Answer": "C: 6",
        "Q16 Correct Key": "C: 6",
        "Q16 Mark": 1,
        "Q17 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q17 Candidate Answer": "C: Pratyahara",
        "Q17 Correct Key": "C: Pratyahara",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the women's discus?",
        "Q18 Candidate Answer": "B: 1 kg",
        "Q18 Correct Key": "B: 1 kg",
        "Q18 Mark": 1,
        "Q19 Question": "How high is the plasticine indicator board?",
        "Q19 Candidate Answer": "B: 7 mm",
        "Q19 Correct Key": "B: 7 mm",
        "Q19 Mark": 1,
        "Q20 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q20 Candidate Answer": "B: 45 mm",
        "Q20 Correct Key": "B: 45 mm",
        "Q20 Mark": 1,
        "Q21 Question": "What is the official distance of a marathon?",
        "Q21 Candidate Answer": "C: 42.195 km",
        "Q21 Correct Key": "C: 42.195 km",
        "Q21 Mark": 1,
        "Q22 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q22 Candidate Answer": "C: Karma Yoga",
        "Q22 Correct Key": "C: Karma Yoga",
        "Q22 Mark": 1,
        "Q23 Question": "In track and field, a green card is shown when:",
        "Q23 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q23 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q23 Mark": 1,
        "Q24 Question": "What is the javelin throwing sector angle?",
        "Q24 Candidate Answer": "A: 28.96°",
        "Q24 Correct Key": "A: 28.96°",
        "Q24 Mark": 1,
        "Q25 Question": "What is the correct sequence of phases in the triple jump?",
        "Q25 Candidate Answer": "C: Hop – Step – Jump",
        "Q25 Correct Key": "C: Hop – Step – Jump",
        "Q25 Mark": 1,
        "Q26 Question": "What are the dimensions of the take-off board in long jump?",
        "Q26 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q26 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q26 Mark": 1,
        "Q27 Question": "How is a triple jump measured?",
        "Q27 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q27 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q27 Mark": 1,
        "Q28 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q28 Candidate Answer": "B: Yama",
        "Q28 Correct Key": "B: Yama",
        "Q28 Mark": 1,
        "Q29 Question": "What is the diameter of the discus throwing circle?",
        "Q29 Candidate Answer": "B: 2.50 m",
        "Q29 Correct Key": "B: 2.50 m",
        "Q29 Mark": 1,
        "Q30 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q30 Candidate Answer": "C: To join or unite",
        "Q30 Correct Key": "C: To join or unite",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 2,
      "registrationNumber": "KOP/2026/06/0257",
      "studentName": "GUPTESWAR GOUDA",
      "mobileNumber": "7008238773",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:14 pm",
      "startTime": "18 Oct 2026, 01:17:18 pm",
      "submissionTime": "18 Oct 2026, 01:46:43 pm",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 2,
        "Registration ID": "KOP/2026/06/0257",
        "Candidate Name": "GUPTESWAR GOUDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "C: Svadhyaya",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 1,
        "Q2 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q2 Candidate Answer": "C: Pratyahara",
        "Q2 Correct Key": "C: Pratyahara",
        "Q2 Mark": 1,
        "Q3 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q3 Candidate Answer": "B: To hold or maintain",
        "Q3 Correct Key": "B: To hold or maintain",
        "Q3 Mark": 1,
        "Q4 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q4 Candidate Answer": "C: Disqualified",
        "Q4 Correct Key": "C: Disqualified",
        "Q4 Mark": 1,
        "Q5 Question": "What are the dimensions of the take-off board in long jump?",
        "Q5 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Mark": 1,
        "Q6 Question": "What is the diameter of the shot put circle?",
        "Q6 Candidate Answer": "B: 2.135 m",
        "Q6 Correct Key": "B: 2.135 m",
        "Q6 Mark": 1,
        "Q7 Question": "How much energy does 1 g of fat give?",
        "Q7 Candidate Answer": "C: 9.1 kcal",
        "Q7 Correct Key": "C: 9.1 kcal",
        "Q7 Mark": 1,
        "Q8 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q8 Candidate Answer": "B: Comparing their second-best performances",
        "Q8 Correct Key": "B: Comparing their second-best performances",
        "Q8 Mark": 1,
        "Q9 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q9 Candidate Answer": "B: Yama",
        "Q9 Correct Key": "B: Yama",
        "Q9 Mark": 1,
        "Q10 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q10 Candidate Answer": "B: Swami Vivekananda",
        "Q10 Correct Key": "B: Swami Vivekananda",
        "Q10 Mark": 1,
        "Q11 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q11 Candidate Answer": "C: 20 m",
        "Q11 Correct Key": "C: 20 m",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the women's discus?",
        "Q12 Candidate Answer": "B: 1 kg",
        "Q12 Correct Key": "B: 1 kg",
        "Q12 Mark": 1,
        "Q13 Question": "What is the official distance of a marathon?",
        "Q13 Candidate Answer": "C: 42.195 km",
        "Q13 Correct Key": "C: 42.195 km",
        "Q13 Mark": 1,
        "Q14 Question": "Which statement about pole vault is correct?",
        "Q14 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q14 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q14 Mark": 1,
        "Q15 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q15 Candidate Answer": "B: 45 minutes",
        "Q15 Correct Key": "B: 45 minutes",
        "Q15 Mark": 1,
        "Q16 Question": "If the shot lands on one of the sector lines:",
        "Q16 Candidate Answer": "C: It is called a foul and not measured",
        "Q16 Correct Key": "C: It is called a foul and not measured",
        "Q16 Mark": 1,
        "Q17 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q17 Candidate Answer": "D: Fosbury Flop",
        "Q17 Correct Key": "D: Fosbury Flop",
        "Q17 Mark": 1,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 1,
        "Q19 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q19 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Mark": 1,
        "Q20 Question": "A javelin throw is valid only if:",
        "Q20 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q20 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q20 Mark": 1,
        "Q21 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q21 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q21 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q21 Mark": 1,
        "Q22 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q22 Candidate Answer": "C: 3",
        "Q22 Correct Key": "C: 3",
        "Q22 Mark": 1,
        "Q23 Question": "In track and field, a green card is shown when:",
        "Q23 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q23 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q23 Mark": 1,
        "Q24 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q24 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q24 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q24 Mark": 1,
        "Q25 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q25 Candidate Answer": "B: Scissors Jump",
        "Q25 Correct Key": "B: Scissors Jump",
        "Q25 Mark": 1,
        "Q26 Question": "In international competition, the pole vault landing area must be at least:",
        "Q26 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q26 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q26 Mark": 1,
        "Q27 Question": "What is the correct sequence of phases in the triple jump?",
        "Q27 Candidate Answer": "C: Hop – Step – Jump",
        "Q27 Correct Key": "C: Hop – Step – Jump",
        "Q27 Mark": 1,
        "Q28 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q28 Candidate Answer": "C: 34.92°",
        "Q28 Correct Key": "C: 34.92°",
        "Q28 Mark": 1,
        "Q29 Question": "Which of the following is NOT a flight style in long jump?",
        "Q29 Candidate Answer": "D: Fosbury flop",
        "Q29 Correct Key": "D: Fosbury flop",
        "Q29 Mark": 1,
        "Q30 Question": "What is the diameter of the discus throwing circle?",
        "Q30 Candidate Answer": "B: 2.50 m",
        "Q30 Correct Key": "B: 2.50 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 3,
      "registrationNumber": "KOP/2026/07/0377",
      "studentName": "MITRABHANU SABAR",
      "mobileNumber": "7978318199",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:05:35 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 3,
        "Registration ID": "KOP/2026/07/0377",
        "Candidate Name": "MITRABHANU SABAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 1,
        "Q2 Question": "In which throwing event are gloves allowed?",
        "Q2 Candidate Answer": "D: Hammer throw",
        "Q2 Correct Key": "D: Hammer throw",
        "Q2 Mark": 1,
        "Q3 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q3 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q3 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q3 Mark": 1,
        "Q4 Question": "How is a triple jump measured?",
        "Q4 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Mark": 1,
        "Q5 Question": "How high is the plasticine indicator board?",
        "Q5 Candidate Answer": "B: 7 mm",
        "Q5 Correct Key": "B: 7 mm",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the women's discus?",
        "Q6 Candidate Answer": "B: 1 kg",
        "Q6 Correct Key": "B: 1 kg",
        "Q6 Mark": 1,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 1,
        "Q8 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q8 Candidate Answer": "B: To hold or maintain",
        "Q8 Correct Key": "B: To hold or maintain",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's javelin?",
        "Q9 Candidate Answer": "C: 800 g",
        "Q9 Correct Key": "C: 800 g",
        "Q9 Mark": 1,
        "Q10 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q10 Candidate Answer": "C: 6",
        "Q10 Correct Key": "C: 6",
        "Q10 Mark": 1,
        "Q11 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q11 Candidate Answer": "A: Laya Yoga",
        "Q11 Correct Key": "A: Laya Yoga",
        "Q11 Mark": 1,
        "Q12 Question": "Which of the following is NOT a flight style in long jump?",
        "Q12 Candidate Answer": "D: Fosbury flop",
        "Q12 Correct Key": "D: Fosbury flop",
        "Q12 Mark": 1,
        "Q13 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q13 Candidate Answer": "C: Karma Yoga",
        "Q13 Correct Key": "C: Karma Yoga",
        "Q13 Mark": 1,
        "Q14 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q14 Candidate Answer": "C: 20 m",
        "Q14 Correct Key": "C: 20 m",
        "Q14 Mark": 1,
        "Q15 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q15 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Mark": 1,
        "Q16 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q16 Candidate Answer": "D: Fosbury Flop",
        "Q16 Correct Key": "D: Fosbury Flop",
        "Q16 Mark": 1,
        "Q17 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q17 Candidate Answer": "B: 1:2:1",
        "Q17 Correct Key": "B: 1:2:1",
        "Q17 Mark": 1,
        "Q18 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q18 Candidate Answer": "C: 11",
        "Q18 Correct Key": "C: 11",
        "Q18 Mark": 1,
        "Q19 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q19 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q19 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q19 Mark": 1,
        "Q20 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q20 Candidate Answer": "C: 32 m/s",
        "Q20 Correct Key": "C: 32 m/s",
        "Q20 Mark": 1,
        "Q21 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q21 Candidate Answer": "C: Protein",
        "Q21 Correct Key": "C: Protein",
        "Q21 Mark": 1,
        "Q22 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q22 Candidate Answer": "C: 3",
        "Q22 Correct Key": "C: 3",
        "Q22 Mark": 1,
        "Q23 Question": "What is the weight of the men's shot?",
        "Q23 Candidate Answer": "C: 7.260 kg",
        "Q23 Correct Key": "C: 7.260 kg",
        "Q23 Mark": 1,
        "Q24 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q24 Candidate Answer": "B: Glide method",
        "Q24 Correct Key": "B: Glide method",
        "Q24 Mark": 1,
        "Q25 Question": "What is the official distance of a marathon?",
        "Q25 Candidate Answer": "C: 42.195 km",
        "Q25 Correct Key": "C: 42.195 km",
        "Q25 Mark": 1,
        "Q26 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q26 Candidate Answer": "C: 34.92°",
        "Q26 Correct Key": "C: 34.92°",
        "Q26 Mark": 1,
        "Q27 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q27 Candidate Answer": "C: To join or unite",
        "Q27 Correct Key": "C: To join or unite",
        "Q27 Mark": 1,
        "Q28 Question": "What is the javelin throwing sector angle?",
        "Q28 Candidate Answer": "A: 28.96°",
        "Q28 Correct Key": "A: 28.96°",
        "Q28 Mark": 1,
        "Q29 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q29 Candidate Answer": "C: Disqualified",
        "Q29 Correct Key": "C: Disqualified",
        "Q29 Mark": 1,
        "Q30 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q30 Candidate Answer": "D: Orthodox grip",
        "Q30 Correct Key": "D: Orthodox grip",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 4,
      "registrationNumber": "KOP/2026/07/0428",
      "studentName": "RUPESH KUMAR KHAMARI",
      "mobileNumber": "8455986315",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:36 pm",
      "startTime": "18 Oct 2026, 01:15:19 pm",
      "submissionTime": "18 Oct 2026, 01:49:41 pm",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 4,
        "Registration ID": "KOP/2026/07/0428",
        "Candidate Name": "RUPESH KUMAR KHAMARI",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q1 Candidate Answer": "C: Protein",
        "Q1 Correct Key": "C: Protein",
        "Q1 Mark": 1,
        "Q2 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q2 Candidate Answer": "B: Glide method",
        "Q2 Correct Key": "B: Glide method",
        "Q2 Mark": 1,
        "Q3 Question": "Which of the following is a Niyama?",
        "Q3 Candidate Answer": "C: Svadhyaya",
        "Q3 Correct Key": "C: Svadhyaya",
        "Q3 Mark": 1,
        "Q4 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q4 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q4 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q4 Mark": 1,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "B: Swami Vivekananda",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 1,
        "Q6 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q6 Candidate Answer": "C: 11",
        "Q6 Correct Key": "C: 11",
        "Q6 Mark": 1,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 1,
        "Q8 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q8 Candidate Answer": "D: Orthodox grip",
        "Q8 Correct Key": "D: Orthodox grip",
        "Q8 Mark": 1,
        "Q9 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q9 Candidate Answer": "B: Scissors Jump",
        "Q9 Correct Key": "B: Scissors Jump",
        "Q9 Mark": 1,
        "Q10 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q10 Candidate Answer": "C: 32 m/s",
        "Q10 Correct Key": "C: 32 m/s",
        "Q10 Mark": 1,
        "Q11 Question": "Lactose (milk sugar) is made of:",
        "Q11 Candidate Answer": "C: Glucose + Galactose",
        "Q11 Correct Key": "C: Glucose + Galactose",
        "Q11 Mark": 1,
        "Q12 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q12 Candidate Answer": "B: 45 mm",
        "Q12 Correct Key": "B: 45 mm",
        "Q12 Mark": 1,
        "Q13 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q13 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q13 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q13 Mark": 1,
        "Q14 Question": "What is the official distance of a marathon?",
        "Q14 Candidate Answer": "C: 42.195 km",
        "Q14 Correct Key": "C: 42.195 km",
        "Q14 Mark": 1,
        "Q15 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q15 Candidate Answer": "C: Pratyahara",
        "Q15 Correct Key": "C: Pratyahara",
        "Q15 Mark": 1,
        "Q16 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q16 Candidate Answer": "B: To hold or maintain",
        "Q16 Correct Key": "B: To hold or maintain",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the shot put circle?",
        "Q17 Candidate Answer": "B: 2.135 m",
        "Q17 Correct Key": "B: 2.135 m",
        "Q17 Mark": 1,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 1,
        "Q19 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q19 Candidate Answer": "D: Fosbury Flop",
        "Q19 Correct Key": "D: Fosbury Flop",
        "Q19 Mark": 1,
        "Q20 Question": "In international competition, the pole vault landing area must be at least:",
        "Q20 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q20 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q20 Mark": 1,
        "Q21 Question": "What are the dimensions of the take-off board in long jump?",
        "Q21 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q21 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q21 Mark": 1,
        "Q22 Question": "What is the weight of the men's shot?",
        "Q22 Candidate Answer": "C: 7.260 kg",
        "Q22 Correct Key": "C: 7.260 kg",
        "Q22 Mark": 1,
        "Q23 Question": "What is the weight of the women's discus?",
        "Q23 Candidate Answer": "B: 1 kg",
        "Q23 Correct Key": "B: 1 kg",
        "Q23 Mark": 1,
        "Q24 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q24 Candidate Answer": "C: 3",
        "Q24 Correct Key": "C: 3",
        "Q24 Mark": 1,
        "Q25 Question": "A javelin throw is valid only if:",
        "Q25 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q25 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q25 Mark": 1,
        "Q26 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q26 Candidate Answer": "C: 34.92°",
        "Q26 Correct Key": "C: 34.92°",
        "Q26 Mark": 1,
        "Q27 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q27 Candidate Answer": "B: Comparing their second-best performances",
        "Q27 Correct Key": "B: Comparing their second-best performances",
        "Q27 Mark": 1,
        "Q28 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q28 Candidate Answer": "C: 2 minutes",
        "Q28 Correct Key": "C: 2 minutes",
        "Q28 Mark": 1,
        "Q29 Question": "Which of the following is NOT a flight style in long jump?",
        "Q29 Candidate Answer": "D: Fosbury flop",
        "Q29 Correct Key": "D: Fosbury flop",
        "Q29 Mark": 1,
        "Q30 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q30 Candidate Answer": "C: 6",
        "Q30 Correct Key": "C: 6",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 5,
      "registrationNumber": "KOP/2026/07/0438",
      "studentName": "SASHIKANT PRADHAN",
      "mobileNumber": "9178178077",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:52 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 5,
        "Registration ID": "KOP/2026/07/0438",
        "Candidate Name": "SASHIKANT PRADHAN",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "D: Fosbury flop",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 1,
        "Q2 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q2 Candidate Answer": "B: Swami Vivekananda",
        "Q2 Correct Key": "B: Swami Vivekananda",
        "Q2 Mark": 1,
        "Q3 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q3 Candidate Answer": "B: Scissors Jump",
        "Q3 Correct Key": "B: Scissors Jump",
        "Q3 Mark": 1,
        "Q4 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q4 Candidate Answer": "C: 3",
        "Q4 Correct Key": "C: 3",
        "Q4 Mark": 1,
        "Q5 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q5 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q5 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q5 Mark": 1,
        "Q6 Question": "What is the official distance of a marathon?",
        "Q6 Candidate Answer": "C: 42.195 km",
        "Q6 Correct Key": "C: 42.195 km",
        "Q6 Mark": 1,
        "Q7 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q7 Candidate Answer": "B: To hold or maintain",
        "Q7 Correct Key": "B: To hold or maintain",
        "Q7 Mark": 1,
        "Q8 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q8 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Mark": 1,
        "Q9 Question": "What is the diameter of the discus throwing circle?",
        "Q9 Candidate Answer": "B: 2.50 m",
        "Q9 Correct Key": "B: 2.50 m",
        "Q9 Mark": 1,
        "Q10 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q10 Candidate Answer": "C: Protein",
        "Q10 Correct Key": "C: Protein",
        "Q10 Mark": 1,
        "Q11 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q11 Candidate Answer": "B: Yama",
        "Q11 Correct Key": "B: Yama",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the men's javelin?",
        "Q12 Candidate Answer": "C: 800 g",
        "Q12 Correct Key": "C: 800 g",
        "Q12 Mark": 1,
        "Q13 Question": "How is a triple jump measured?",
        "Q13 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q13 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q13 Mark": 1,
        "Q14 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q14 Candidate Answer": "C: 2 minutes",
        "Q14 Correct Key": "C: 2 minutes",
        "Q14 Mark": 1,
        "Q15 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q15 Candidate Answer": "C: 34.92°",
        "Q15 Correct Key": "C: 34.92°",
        "Q15 Mark": 1,
        "Q16 Question": "In international competition, the pole vault landing area must be at least:",
        "Q16 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q16 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q16 Mark": 1,
        "Q17 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q17 Candidate Answer": "B: 45 minutes",
        "Q17 Correct Key": "B: 45 minutes",
        "Q17 Mark": 1,
        "Q18 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q18 Candidate Answer": "C: 11",
        "Q18 Correct Key": "C: 11",
        "Q18 Mark": 1,
        "Q19 Question": "In track and field, a green card is shown when:",
        "Q19 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q19 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q19 Mark": 1,
        "Q20 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q20 Candidate Answer": "D: Orthodox grip",
        "Q20 Correct Key": "D: Orthodox grip",
        "Q20 Mark": 1,
        "Q21 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q21 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q21 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q21 Mark": 1,
        "Q22 Question": "What is the javelin throwing sector angle?",
        "Q22 Candidate Answer": "A: 28.96°",
        "Q22 Correct Key": "A: 28.96°",
        "Q22 Mark": 1,
        "Q23 Question": "How much energy does 1 g of fat give?",
        "Q23 Candidate Answer": "C: 9.1 kcal",
        "Q23 Correct Key": "C: 9.1 kcal",
        "Q23 Mark": 1,
        "Q24 Question": "Which of the following is a Niyama?",
        "Q24 Candidate Answer": "C: Svadhyaya",
        "Q24 Correct Key": "C: Svadhyaya",
        "Q24 Mark": 1,
        "Q25 Question": "In which throwing event are gloves allowed?",
        "Q25 Candidate Answer": "D: Hammer throw",
        "Q25 Correct Key": "D: Hammer throw",
        "Q25 Mark": 1,
        "Q26 Question": "What is the diameter of the shot put circle?",
        "Q26 Candidate Answer": "B: 2.135 m",
        "Q26 Correct Key": "B: 2.135 m",
        "Q26 Mark": 1,
        "Q27 Question": "Lactose (milk sugar) is made of:",
        "Q27 Candidate Answer": "C: Glucose + Galactose",
        "Q27 Correct Key": "C: Glucose + Galactose",
        "Q27 Mark": 1,
        "Q28 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q28 Candidate Answer": "A: Laya Yoga",
        "Q28 Correct Key": "A: Laya Yoga",
        "Q28 Mark": 1,
        "Q29 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q29 Candidate Answer": "C: Disqualified",
        "Q29 Correct Key": "C: Disqualified",
        "Q29 Mark": 1,
        "Q30 Question": "How high is the plasticine indicator board?",
        "Q30 Candidate Answer": "B: 7 mm",
        "Q30 Correct Key": "B: 7 mm",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 6,
      "registrationNumber": "KOP/2026/08/0547",
      "studentName": "BADAL PANIGRAHI",
      "mobileNumber": "8908159249",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:13:54 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 6,
        "Registration ID": "KOP/2026/08/0547",
        "Candidate Name": "BADAL PANIGRAHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q1 Candidate Answer": "C: 20 m",
        "Q1 Correct Key": "C: 20 m",
        "Q1 Mark": 1,
        "Q2 Question": "In which throwing event are gloves allowed?",
        "Q2 Candidate Answer": "D: Hammer throw",
        "Q2 Correct Key": "D: Hammer throw",
        "Q2 Mark": 1,
        "Q3 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q3 Candidate Answer": "B: 45 minutes",
        "Q3 Correct Key": "B: 45 minutes",
        "Q3 Mark": 1,
        "Q4 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q4 Candidate Answer": "C: Karma Yoga",
        "Q4 Correct Key": "C: Karma Yoga",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "C: 11",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 1,
        "Q6 Question": "How much energy does 1 g of fat give?",
        "Q6 Candidate Answer": "C: 9.1 kcal",
        "Q6 Correct Key": "C: 9.1 kcal",
        "Q6 Mark": 1,
        "Q7 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q7 Candidate Answer": "D: Fosbury Flop",
        "Q7 Correct Key": "D: Fosbury Flop",
        "Q7 Mark": 1,
        "Q8 Question": "Which of the following is NOT a flight style in long jump?",
        "Q8 Candidate Answer": "D: Fosbury flop",
        "Q8 Correct Key": "D: Fosbury flop",
        "Q8 Mark": 1,
        "Q9 Question": "A javelin throw is valid only if:",
        "Q9 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q9 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q9 Mark": 1,
        "Q10 Question": "In track and field, a green card is shown when:",
        "Q10 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q10 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q10 Mark": 1,
        "Q11 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q11 Candidate Answer": "B: To hold or maintain",
        "Q11 Correct Key": "B: To hold or maintain",
        "Q11 Mark": 1,
        "Q12 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q12 Candidate Answer": "C: 3",
        "Q12 Correct Key": "C: 3",
        "Q12 Mark": 1,
        "Q13 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q13 Candidate Answer": "B: 45 mm",
        "Q13 Correct Key": "B: 45 mm",
        "Q13 Mark": 1,
        "Q14 Question": "What is the correct sequence of phases in the triple jump?",
        "Q14 Candidate Answer": "C: Hop – Step – Jump",
        "Q14 Correct Key": "C: Hop – Step – Jump",
        "Q14 Mark": 1,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "B: Swami Vivekananda",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 1,
        "Q17 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q17 Candidate Answer": "C: 6",
        "Q17 Correct Key": "C: 6",
        "Q17 Mark": 1,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 1,
        "Q19 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q19 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q19 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q19 Mark": 1,
        "Q20 Question": "What is the javelin throwing sector angle?",
        "Q20 Candidate Answer": "A: 28.96°",
        "Q20 Correct Key": "A: 28.96°",
        "Q20 Mark": 1,
        "Q21 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q21 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q21 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q21 Mark": 1,
        "Q22 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q22 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q22 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q22 Mark": 1,
        "Q23 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q23 Candidate Answer": "C: 34.92°",
        "Q23 Correct Key": "C: 34.92°",
        "Q23 Mark": 1,
        "Q24 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q24 Candidate Answer": "C: 2 minutes",
        "Q24 Correct Key": "C: 2 minutes",
        "Q24 Mark": 1,
        "Q25 Question": "Which statement about pole vault is correct?",
        "Q25 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Mark": 1,
        "Q26 Question": "Lactose (milk sugar) is made of:",
        "Q26 Candidate Answer": "C: Glucose + Galactose",
        "Q26 Correct Key": "C: Glucose + Galactose",
        "Q26 Mark": 1,
        "Q27 Question": "What is the weight of the women's discus?",
        "Q27 Candidate Answer": "B: 1 kg",
        "Q27 Correct Key": "B: 1 kg",
        "Q27 Mark": 1,
        "Q28 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q28 Candidate Answer": "C: Pratyahara",
        "Q28 Correct Key": "C: Pratyahara",
        "Q28 Mark": 1,
        "Q29 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q29 Candidate Answer": "B: Comparing their second-best performances",
        "Q29 Correct Key": "B: Comparing their second-best performances",
        "Q29 Mark": 1,
        "Q30 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q30 Candidate Answer": "C: Protein",
        "Q30 Correct Key": "C: Protein",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 7,
      "registrationNumber": "KOP/2026/09/0052",
      "studentName": "ADYASHA NAYAK",
      "mobileNumber": "9348432022",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:02:00 pm",
      "startTime": "18 Oct 2026, 01:16:43 pm",
      "submissionTime": "18 Oct 2026, 01:53:21 pm",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 7,
        "Registration ID": "KOP/2026/09/0052",
        "Candidate Name": "ADYASHA NAYAK",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "What are the dimensions of the take-off board in long jump?",
        "Q1 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q1 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q1 Mark": 1,
        "Q2 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q2 Candidate Answer": "B: Comparing their second-best performances",
        "Q2 Correct Key": "B: Comparing their second-best performances",
        "Q2 Mark": 1,
        "Q3 Question": "Which of the following is a Niyama?",
        "Q3 Candidate Answer": "C: Svadhyaya",
        "Q3 Correct Key": "C: Svadhyaya",
        "Q3 Mark": 1,
        "Q4 Question": "How much energy does 1 g of fat give?",
        "Q4 Candidate Answer": "C: 9.1 kcal",
        "Q4 Correct Key": "C: 9.1 kcal",
        "Q4 Mark": 1,
        "Q5 Question": "Lactose (milk sugar) is made of:",
        "Q5 Candidate Answer": "C: Glucose + Galactose",
        "Q5 Correct Key": "C: Glucose + Galactose",
        "Q5 Mark": 1,
        "Q6 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q6 Candidate Answer": "B: 45 minutes",
        "Q6 Correct Key": "B: 45 minutes",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "C: 42.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 1,
        "Q8 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q8 Candidate Answer": "C: 11",
        "Q8 Correct Key": "C: 11",
        "Q8 Mark": 1,
        "Q9 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q9 Candidate Answer": "C: 2 minutes",
        "Q9 Correct Key": "C: 2 minutes",
        "Q9 Mark": 1,
        "Q10 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q10 Candidate Answer": "B: 1:2:1",
        "Q10 Correct Key": "B: 1:2:1",
        "Q10 Mark": 1,
        "Q11 Question": "What is the javelin throwing sector angle?",
        "Q11 Candidate Answer": "A: 28.96°",
        "Q11 Correct Key": "A: 28.96°",
        "Q11 Mark": 1,
        "Q12 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q12 Candidate Answer": "C: To join or unite",
        "Q12 Correct Key": "C: To join or unite",
        "Q12 Mark": 1,
        "Q13 Question": "If the shot lands on one of the sector lines:",
        "Q13 Candidate Answer": "C: It is called a foul and not measured",
        "Q13 Correct Key": "C: It is called a foul and not measured",
        "Q13 Mark": 1,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 1,
        "Q15 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q15 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q15 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q15 Mark": 1,
        "Q16 Question": "What is the correct sequence of phases in the triple jump?",
        "Q16 Candidate Answer": "C: Hop – Step – Jump",
        "Q16 Correct Key": "C: Hop – Step – Jump",
        "Q16 Mark": 1,
        "Q17 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q17 Candidate Answer": "C: 34.92°",
        "Q17 Correct Key": "C: 34.92°",
        "Q17 Mark": 1,
        "Q18 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q18 Candidate Answer": "C: 32 m/s",
        "Q18 Correct Key": "C: 32 m/s",
        "Q18 Mark": 1,
        "Q19 Question": "Which statement about pole vault is correct?",
        "Q19 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q19 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q19 Mark": 1,
        "Q20 Question": "In which throwing event are gloves allowed?",
        "Q20 Candidate Answer": "D: Hammer throw",
        "Q20 Correct Key": "D: Hammer throw",
        "Q20 Mark": 1,
        "Q21 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q21 Candidate Answer": "D: Fosbury Flop",
        "Q21 Correct Key": "D: Fosbury Flop",
        "Q21 Mark": 1,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "C: 800 g",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 1,
        "Q23 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q23 Candidate Answer": "B: To hold or maintain",
        "Q23 Correct Key": "B: To hold or maintain",
        "Q23 Mark": 1,
        "Q24 Question": "How high is the plasticine indicator board?",
        "Q24 Candidate Answer": "B: 7 mm",
        "Q24 Correct Key": "B: 7 mm",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 1,
        "Q26 Question": "Which of the following is NOT a flight style in long jump?",
        "Q26 Candidate Answer": "D: Fosbury flop",
        "Q26 Correct Key": "D: Fosbury flop",
        "Q26 Mark": 1,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "B: Glide method",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 1,
        "Q28 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q28 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q28 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q28 Mark": 1,
        "Q29 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q29 Candidate Answer": "C: 3",
        "Q29 Correct Key": "C: 3",
        "Q29 Mark": 1,
        "Q30 Question": "What is the minimum size of the high jump landing mat?",
        "Q30 Candidate Answer": "B: 5 m × 3 m",
        "Q30 Correct Key": "B: 5 m × 3 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 8,
      "registrationNumber": "KOP/2026/09/0302",
      "studentName": "DEBASISH SAHUKAR",
      "mobileNumber": "9861856160",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:27 pm",
      "startTime": "18 Oct 2026, 01:17:09 pm",
      "submissionTime": "18 Oct 2026, 01:31:53 pm",
      "questionsAnswered": "30 / 30",
      "score": 30,
      "totalMarks": 30,
      "percentage": 100,
      "correctCount": 30,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 8,
        "Registration ID": "KOP/2026/09/0302",
        "Candidate Name": "DEBASISH SAHUKAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "30 / 30",
        "Percentage": "100%",
        "Result": "QUALIFIED",
        "Q1 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q1 Candidate Answer": "C: Disqualified",
        "Q1 Correct Key": "C: Disqualified",
        "Q1 Mark": 1,
        "Q2 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q2 Candidate Answer": "C: 11",
        "Q2 Correct Key": "C: 11",
        "Q2 Mark": 1,
        "Q3 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q3 Candidate Answer": "C: 20 m",
        "Q3 Correct Key": "C: 20 m",
        "Q3 Mark": 1,
        "Q4 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q4 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q4 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q4 Mark": 1,
        "Q5 Question": "What is the javelin throwing sector angle?",
        "Q5 Candidate Answer": "A: 28.96°",
        "Q5 Correct Key": "A: 28.96°",
        "Q5 Mark": 1,
        "Q6 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q6 Candidate Answer": "C: 32 m/s",
        "Q6 Correct Key": "C: 32 m/s",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum size of the high jump landing mat?",
        "Q7 Candidate Answer": "B: 5 m × 3 m",
        "Q7 Correct Key": "B: 5 m × 3 m",
        "Q7 Mark": 1,
        "Q8 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q8 Candidate Answer": "D: Fosbury Flop",
        "Q8 Correct Key": "D: Fosbury Flop",
        "Q8 Mark": 1,
        "Q9 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q9 Candidate Answer": "C: 34.92°",
        "Q9 Correct Key": "C: 34.92°",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's shot?",
        "Q10 Candidate Answer": "C: 7.260 kg",
        "Q10 Correct Key": "C: 7.260 kg",
        "Q10 Mark": 1,
        "Q11 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q11 Candidate Answer": "A: Laya Yoga",
        "Q11 Correct Key": "A: Laya Yoga",
        "Q11 Mark": 1,
        "Q12 Question": "How high is the plasticine indicator board?",
        "Q12 Candidate Answer": "B: 7 mm",
        "Q12 Correct Key": "B: 7 mm",
        "Q12 Mark": 1,
        "Q13 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q13 Candidate Answer": "B: Comparing their second-best performances",
        "Q13 Correct Key": "B: Comparing their second-best performances",
        "Q13 Mark": 1,
        "Q14 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q14 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q14 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q14 Mark": 1,
        "Q15 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q15 Candidate Answer": "B: Swami Vivekananda",
        "Q15 Correct Key": "B: Swami Vivekananda",
        "Q15 Mark": 1,
        "Q16 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q16 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q16 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q16 Mark": 1,
        "Q17 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q17 Candidate Answer": "C: To join or unite",
        "Q17 Correct Key": "C: To join or unite",
        "Q17 Mark": 1,
        "Q18 Question": "Which of the following is NOT a flight style in long jump?",
        "Q18 Candidate Answer": "D: Fosbury flop",
        "Q18 Correct Key": "D: Fosbury flop",
        "Q18 Mark": 1,
        "Q19 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q19 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q19 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q19 Mark": 1,
        "Q20 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q20 Candidate Answer": "C: 2 minutes",
        "Q20 Correct Key": "C: 2 minutes",
        "Q20 Mark": 1,
        "Q21 Question": "If the shot lands on one of the sector lines:",
        "Q21 Candidate Answer": "C: It is called a foul and not measured",
        "Q21 Correct Key": "C: It is called a foul and not measured",
        "Q21 Mark": 1,
        "Q22 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q22 Candidate Answer": "C: Karma Yoga",
        "Q22 Correct Key": "C: Karma Yoga",
        "Q22 Mark": 1,
        "Q23 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q23 Candidate Answer": "B: 1:2:1",
        "Q23 Correct Key": "B: 1:2:1",
        "Q23 Mark": 1,
        "Q24 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q24 Candidate Answer": "C: 3",
        "Q24 Correct Key": "C: 3",
        "Q24 Mark": 1,
        "Q25 Question": "What is the diameter of the discus throwing circle?",
        "Q25 Candidate Answer": "B: 2.50 m",
        "Q25 Correct Key": "B: 2.50 m",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the women's discus?",
        "Q26 Candidate Answer": "B: 1 kg",
        "Q26 Correct Key": "B: 1 kg",
        "Q26 Mark": 1,
        "Q27 Question": "What are the dimensions of the take-off board in long jump?",
        "Q27 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Mark": 1,
        "Q28 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q28 Candidate Answer": "D: Orthodox grip",
        "Q28 Correct Key": "D: Orthodox grip",
        "Q28 Mark": 1,
        "Q29 Question": "A javelin throw is valid only if:",
        "Q29 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q29 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 9,
      "registrationNumber": "HD/KOP/2026/0745",
      "studentName": "DEBASIS MAHAPATRA",
      "mobileNumber": "9777400205",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:38 pm",
      "startTime": "18 Oct 2026, 01:16:25 pm",
      "submissionTime": "18 Oct 2026, 01:51:22 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 9,
        "Registration ID": "HD/KOP/2026/0745",
        "Candidate Name": "DEBASIS MAHAPATRA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "C: 7.260 kg",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 1,
        "Q2 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q2 Candidate Answer": "D: Fosbury Flop",
        "Q2 Correct Key": "D: Fosbury Flop",
        "Q2 Mark": 1,
        "Q3 Question": "What is the correct sequence of phases in the triple jump?",
        "Q3 Candidate Answer": "C: Hop – Step – Jump",
        "Q3 Correct Key": "C: Hop – Step – Jump",
        "Q3 Mark": 1,
        "Q4 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q4 Candidate Answer": "B: Swami Vivekananda",
        "Q4 Correct Key": "B: Swami Vivekananda",
        "Q4 Mark": 1,
        "Q5 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q5 Candidate Answer": "C: Polish grip",
        "Q5 Correct Key": "D: Orthodox grip",
        "Q5 Mark": 0,
        "Q6 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q6 Candidate Answer": "B: 45 mm",
        "Q6 Correct Key": "B: 45 mm",
        "Q6 Mark": 1,
        "Q7 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q7 Candidate Answer": "C: Pratyahara",
        "Q7 Correct Key": "C: Pratyahara",
        "Q7 Mark": 1,
        "Q8 Question": "Which of the following is a Niyama?",
        "Q8 Candidate Answer": "C: Svadhyaya",
        "Q8 Correct Key": "C: Svadhyaya",
        "Q8 Mark": 1,
        "Q9 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q9 Candidate Answer": "C: Disqualified",
        "Q9 Correct Key": "C: Disqualified",
        "Q9 Mark": 1,
        "Q10 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q10 Candidate Answer": "C: Protein",
        "Q10 Correct Key": "C: Protein",
        "Q10 Mark": 1,
        "Q11 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q11 Candidate Answer": "B: 45 minutes",
        "Q11 Correct Key": "B: 45 minutes",
        "Q11 Mark": 1,
        "Q12 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q12 Candidate Answer": "A: Laya Yoga",
        "Q12 Correct Key": "A: Laya Yoga",
        "Q12 Mark": 1,
        "Q13 Question": "What is the diameter of the discus throwing circle?",
        "Q13 Candidate Answer": "B: 2.50 m",
        "Q13 Correct Key": "B: 2.50 m",
        "Q13 Mark": 1,
        "Q14 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q14 Candidate Answer": "C: 3",
        "Q14 Correct Key": "C: 3",
        "Q14 Mark": 1,
        "Q15 Question": "What is the weight of the men's javelin?",
        "Q15 Candidate Answer": "C: 800 g",
        "Q15 Correct Key": "C: 800 g",
        "Q15 Mark": 1,
        "Q16 Question": "In which throwing event are gloves allowed?",
        "Q16 Candidate Answer": "D: Hammer throw",
        "Q16 Correct Key": "D: Hammer throw",
        "Q16 Mark": 1,
        "Q17 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q17 Candidate Answer": "B: 1:2:1",
        "Q17 Correct Key": "B: 1:2:1",
        "Q17 Mark": 1,
        "Q18 Question": "In international competition, the pole vault landing area must be at least:",
        "Q18 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q18 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q18 Mark": 1,
        "Q19 Question": "What is the diameter of the shot put circle?",
        "Q19 Candidate Answer": "B: 2.135 m",
        "Q19 Correct Key": "B: 2.135 m",
        "Q19 Mark": 1,
        "Q20 Question": "Which statement about pole vault is correct?",
        "Q20 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q20 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q20 Mark": 1,
        "Q21 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q21 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q21 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q21 Mark": 1,
        "Q22 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q22 Candidate Answer": "C: 20 m",
        "Q22 Correct Key": "C: 20 m",
        "Q22 Mark": 1,
        "Q23 Question": "How high is the plasticine indicator board?",
        "Q23 Candidate Answer": "B: 7 mm",
        "Q23 Correct Key": "B: 7 mm",
        "Q23 Mark": 1,
        "Q24 Question": "Lactose (milk sugar) is made of:",
        "Q24 Candidate Answer": "C: Glucose + Galactose",
        "Q24 Correct Key": "C: Glucose + Galactose",
        "Q24 Mark": 1,
        "Q25 Question": "What is the official distance of a marathon?",
        "Q25 Candidate Answer": "C: 42.195 km",
        "Q25 Correct Key": "C: 42.195 km",
        "Q25 Mark": 1,
        "Q26 Question": "A javelin throw is valid only if:",
        "Q26 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q26 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q26 Mark": 1,
        "Q27 Question": "In track and field, a green card is shown when:",
        "Q27 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q27 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q27 Mark": 1,
        "Q28 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q28 Candidate Answer": "C: 2 minutes",
        "Q28 Correct Key": "C: 2 minutes",
        "Q28 Mark": 1,
        "Q29 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q29 Candidate Answer": "B: Glide method",
        "Q29 Correct Key": "B: Glide method",
        "Q29 Mark": 1,
        "Q30 Question": "What is the minimum size of the high jump landing mat?",
        "Q30 Candidate Answer": "B: 5 m × 3 m",
        "Q30 Correct Key": "B: 5 m × 3 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 10,
      "registrationNumber": "KOP/2026/05/0101",
      "studentName": "HIMANSU SEKHAR PATRO",
      "mobileNumber": "7847098134",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:03:17 pm",
      "startTime": "18 Oct 2026, 02:05:15 pm",
      "submissionTime": "18 Oct 2026, 02:11:55 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 10,
        "Registration ID": "KOP/2026/05/0101",
        "Candidate Name": "HIMANSU SEKHAR PATRO",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q1 Candidate Answer": "C: 11",
        "Q1 Correct Key": "C: 11",
        "Q1 Mark": 1,
        "Q2 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q2 Candidate Answer": "C: 20 m",
        "Q2 Correct Key": "C: 20 m",
        "Q2 Mark": 1,
        "Q3 Question": "What is the weight of the women's discus?",
        "Q3 Candidate Answer": "B: 1 kg",
        "Q3 Correct Key": "B: 1 kg",
        "Q3 Mark": 1,
        "Q4 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q4 Candidate Answer": "C: 3",
        "Q4 Correct Key": "C: 3",
        "Q4 Mark": 1,
        "Q5 Question": "What is the javelin throwing sector angle?",
        "Q5 Candidate Answer": "A: 28.96°",
        "Q5 Correct Key": "A: 28.96°",
        "Q5 Mark": 1,
        "Q6 Question": "Which statement about pole vault is correct?",
        "Q6 Candidate Answer": "A: Gloves are not permitted",
        "Q6 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q6 Mark": 0,
        "Q7 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q7 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Mark": 1,
        "Q8 Question": "What is the weight of the men's shot?",
        "Q8 Candidate Answer": "C: 7.260 kg",
        "Q8 Correct Key": "C: 7.260 kg",
        "Q8 Mark": 1,
        "Q9 Question": "What is the diameter of the discus throwing circle?",
        "Q9 Candidate Answer": "B: 2.50 m",
        "Q9 Correct Key": "B: 2.50 m",
        "Q9 Mark": 1,
        "Q10 Question": "What is the diameter of the shot put circle?",
        "Q10 Candidate Answer": "B: 2.135 m",
        "Q10 Correct Key": "B: 2.135 m",
        "Q10 Mark": 1,
        "Q11 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q11 Candidate Answer": "C: Protein",
        "Q11 Correct Key": "C: Protein",
        "Q11 Mark": 1,
        "Q12 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q12 Candidate Answer": "C: Karma Yoga",
        "Q12 Correct Key": "C: Karma Yoga",
        "Q12 Mark": 1,
        "Q13 Question": "If the shot lands on one of the sector lines:",
        "Q13 Candidate Answer": "C: It is called a foul and not measured",
        "Q13 Correct Key": "C: It is called a foul and not measured",
        "Q13 Mark": 1,
        "Q14 Question": "What is the correct sequence of phases in the triple jump?",
        "Q14 Candidate Answer": "C: Hop – Step – Jump",
        "Q14 Correct Key": "C: Hop – Step – Jump",
        "Q14 Mark": 1,
        "Q15 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q15 Candidate Answer": "C: 32 m/s",
        "Q15 Correct Key": "C: 32 m/s",
        "Q15 Mark": 1,
        "Q16 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q16 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q16 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q16 Mark": 1,
        "Q17 Question": "In track and field, a green card is shown when:",
        "Q17 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q17 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q17 Mark": 1,
        "Q18 Question": "How much energy does 1 g of fat give?",
        "Q18 Candidate Answer": "C: 9.1 kcal",
        "Q18 Correct Key": "C: 9.1 kcal",
        "Q18 Mark": 1,
        "Q19 Question": "Which of the following is NOT a flight style in long jump?",
        "Q19 Candidate Answer": "D: Fosbury flop",
        "Q19 Correct Key": "D: Fosbury flop",
        "Q19 Mark": 1,
        "Q20 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q20 Candidate Answer": "B: 45 minutes",
        "Q20 Correct Key": "B: 45 minutes",
        "Q20 Mark": 1,
        "Q21 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q21 Candidate Answer": "A: Laya Yoga",
        "Q21 Correct Key": "A: Laya Yoga",
        "Q21 Mark": 1,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "C: 800 g",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 1,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 1,
        "Q24 Question": "Lactose (milk sugar) is made of:",
        "Q24 Candidate Answer": "C: Glucose + Galactose",
        "Q24 Correct Key": "C: Glucose + Galactose",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 1,
        "Q26 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q26 Candidate Answer": "B: Scissors Jump",
        "Q26 Correct Key": "B: Scissors Jump",
        "Q26 Mark": 1,
        "Q27 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q27 Candidate Answer": "B: Swami Vivekananda",
        "Q27 Correct Key": "B: Swami Vivekananda",
        "Q27 Mark": 1,
        "Q28 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q28 Candidate Answer": "B: Yama",
        "Q28 Correct Key": "B: Yama",
        "Q28 Mark": 1,
        "Q29 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q29 Candidate Answer": "B: Comparing their second-best performances",
        "Q29 Correct Key": "B: Comparing their second-best performances",
        "Q29 Mark": 1,
        "Q30 Question": "What are the dimensions of the take-off board in long jump?",
        "Q30 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 11,
      "registrationNumber": "KOP/2026/06/0136",
      "studentName": "SUDHIR HARIPAL",
      "mobileNumber": "7751070026",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:12:47 pm",
      "startTime": "13:15 IST",
      "submissionTime": "18 Oct 2026, 02:13:42 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 11,
        "Registration ID": "KOP/2026/06/0136",
        "Candidate Name": "SUDHIR HARIPAL",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "0%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "D: Fosbury flop",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 1,
        "Q2 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q2 Candidate Answer": "C: 34.92°",
        "Q2 Correct Key": "C: 34.92°",
        "Q2 Mark": 1,
        "Q3 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q3 Candidate Answer": "B: Yama",
        "Q3 Correct Key": "B: Yama",
        "Q3 Mark": 1,
        "Q4 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q4 Candidate Answer": "C: 6",
        "Q4 Correct Key": "C: 6",
        "Q4 Mark": 1,
        "Q5 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q5 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q5 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q5 Mark": 1,
        "Q6 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q6 Candidate Answer": "B: Glide method",
        "Q6 Correct Key": "B: Glide method",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q7 Candidate Answer": "B: 45 mm",
        "Q7 Correct Key": "B: 45 mm",
        "Q7 Mark": 1,
        "Q8 Question": "How is a triple jump measured?",
        "Q8 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q8 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q8 Mark": 1,
        "Q9 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q9 Candidate Answer": "B: Comparing their second-best performances",
        "Q9 Correct Key": "B: Comparing their second-best performances",
        "Q9 Mark": 1,
        "Q10 Question": "What are the dimensions of the take-off board in long jump?",
        "Q10 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Mark": 1,
        "Q11 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q11 Candidate Answer": "C: Disqualified",
        "Q11 Correct Key": "C: Disqualified",
        "Q11 Mark": 1,
        "Q12 Question": "In which throwing event are gloves allowed?",
        "Q12 Candidate Answer": "D: Hammer throw",
        "Q12 Correct Key": "D: Hammer throw",
        "Q12 Mark": 1,
        "Q13 Question": "In track and field, a green card is shown when:",
        "Q13 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q13 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the men's javelin?",
        "Q14 Candidate Answer": "C: 800 g",
        "Q14 Correct Key": "C: 800 g",
        "Q14 Mark": 1,
        "Q15 Question": "What is the diameter of the discus throwing circle?",
        "Q15 Candidate Answer": "B: 2.50 m",
        "Q15 Correct Key": "B: 2.50 m",
        "Q15 Mark": 1,
        "Q16 Question": "Lactose (milk sugar) is made of:",
        "Q16 Candidate Answer": "C: Glucose + Galactose",
        "Q16 Correct Key": "C: Glucose + Galactose",
        "Q16 Mark": 1,
        "Q17 Question": "What is the official distance of a marathon?",
        "Q17 Candidate Answer": "C: 42.195 km",
        "Q17 Correct Key": "C: 42.195 km",
        "Q17 Mark": 1,
        "Q18 Question": "What is the javelin throwing sector angle?",
        "Q18 Candidate Answer": "A: 28.96°",
        "Q18 Correct Key": "A: 28.96°",
        "Q18 Mark": 1,
        "Q19 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q19 Candidate Answer": "C: 3",
        "Q19 Correct Key": "C: 3",
        "Q19 Mark": 1,
        "Q20 Question": "A javelin throw is valid only if:",
        "Q20 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q20 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q20 Mark": 1,
        "Q21 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q21 Candidate Answer": "D: Orthodox grip",
        "Q21 Correct Key": "D: Orthodox grip",
        "Q21 Mark": 1,
        "Q22 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q22 Candidate Answer": "C: 32 m/s",
        "Q22 Correct Key": "C: 32 m/s",
        "Q22 Mark": 1,
        "Q23 Question": "What is the diameter of the shot put circle?",
        "Q23 Candidate Answer": "B: 2.135 m",
        "Q23 Correct Key": "B: 2.135 m",
        "Q23 Mark": 1,
        "Q24 Question": "What is the weight of the women's discus?",
        "Q24 Candidate Answer": "B: 1 kg",
        "Q24 Correct Key": "B: 1 kg",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "D: High Jump, Javelin Throw, 400m",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 0,
        "Q26 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q26 Candidate Answer": "B: 45 minutes",
        "Q26 Correct Key": "B: 45 minutes",
        "Q26 Mark": 1,
        "Q27 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q27 Candidate Answer": "B: Scissors Jump",
        "Q27 Correct Key": "B: Scissors Jump",
        "Q27 Mark": 1,
        "Q28 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q28 Candidate Answer": "B: To hold or maintain",
        "Q28 Correct Key": "B: To hold or maintain",
        "Q28 Mark": 1,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "B: 7 mm",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 1,
        "Q30 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q30 Candidate Answer": "B: 1:2:1",
        "Q30 Correct Key": "B: 1:2:1",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 12,
      "registrationNumber": "KOP/2026/06/0144",
      "studentName": "SANJUKTA SUNA",
      "mobileNumber": "7849078348",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:06 pm",
      "startTime": "18 Oct 2026, 01:15:36 pm",
      "submissionTime": "18 Oct 2026, 01:47:20 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 12,
        "Registration ID": "KOP/2026/06/0144",
        "Candidate Name": "SANJUKTA SUNA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q1 Candidate Answer": "C: Pratyahara",
        "Q1 Correct Key": "C: Pratyahara",
        "Q1 Mark": 1,
        "Q2 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q2 Candidate Answer": "C: 34.92°",
        "Q2 Correct Key": "C: 34.92°",
        "Q2 Mark": 1,
        "Q3 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q3 Candidate Answer": "A: Laya Yoga",
        "Q3 Correct Key": "A: Laya Yoga",
        "Q3 Mark": 1,
        "Q4 Question": "What is the weight of the men's shot?",
        "Q4 Candidate Answer": "C: 7.260 kg",
        "Q4 Correct Key": "C: 7.260 kg",
        "Q4 Mark": 1,
        "Q5 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q5 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q5 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q5 Mark": 1,
        "Q6 Question": "If the shot lands on one of the sector lines:",
        "Q6 Candidate Answer": "C: It is called a foul and not measured",
        "Q6 Correct Key": "C: It is called a foul and not measured",
        "Q6 Mark": 1,
        "Q7 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q7 Candidate Answer": "C: Disqualified",
        "Q7 Correct Key": "C: Disqualified",
        "Q7 Mark": 1,
        "Q8 Question": "What is the javelin throwing sector angle?",
        "Q8 Candidate Answer": "A: 28.96°",
        "Q8 Correct Key": "A: 28.96°",
        "Q8 Mark": 1,
        "Q9 Question": "Which of the following is NOT a flight style in long jump?",
        "Q9 Candidate Answer": "D: Fosbury flop",
        "Q9 Correct Key": "D: Fosbury flop",
        "Q9 Mark": 1,
        "Q10 Question": "What is the official distance of a marathon?",
        "Q10 Candidate Answer": "C: 42.195 km",
        "Q10 Correct Key": "C: 42.195 km",
        "Q10 Mark": 1,
        "Q11 Question": "Which of the following is a Niyama?",
        "Q11 Candidate Answer": "C: Svadhyaya",
        "Q11 Correct Key": "C: Svadhyaya",
        "Q11 Mark": 1,
        "Q12 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q12 Candidate Answer": "D: Orthodox grip",
        "Q12 Correct Key": "D: Orthodox grip",
        "Q12 Mark": 1,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "A: Straddle",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 0,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 1,
        "Q15 Question": "Which statement about pole vault is correct?",
        "Q15 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q15 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q15 Mark": 1,
        "Q16 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q16 Candidate Answer": "B: 45 minutes",
        "Q16 Correct Key": "B: 45 minutes",
        "Q16 Mark": 1,
        "Q17 Question": "Lactose (milk sugar) is made of:",
        "Q17 Candidate Answer": "C: Glucose + Galactose",
        "Q17 Correct Key": "C: Glucose + Galactose",
        "Q17 Mark": 1,
        "Q18 Question": "How much energy does 1 g of fat give?",
        "Q18 Candidate Answer": "C: 9.1 kcal",
        "Q18 Correct Key": "C: 9.1 kcal",
        "Q18 Mark": 1,
        "Q19 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q19 Candidate Answer": "C: 20 m",
        "Q19 Correct Key": "C: 20 m",
        "Q19 Mark": 1,
        "Q20 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q20 Candidate Answer": "C: 2 minutes",
        "Q20 Correct Key": "C: 2 minutes",
        "Q20 Mark": 1,
        "Q21 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q21 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q21 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q21 Mark": 1,
        "Q22 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q22 Candidate Answer": "B: To hold or maintain",
        "Q22 Correct Key": "B: To hold or maintain",
        "Q22 Mark": 1,
        "Q23 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q23 Candidate Answer": "B: Glide method",
        "Q23 Correct Key": "B: Glide method",
        "Q23 Mark": 1,
        "Q24 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q24 Candidate Answer": "B: 1:2:1",
        "Q24 Correct Key": "B: 1:2:1",
        "Q24 Mark": 1,
        "Q25 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q25 Candidate Answer": "C: 11",
        "Q25 Correct Key": "C: 11",
        "Q25 Mark": 1,
        "Q26 Question": "A javelin throw is valid only if:",
        "Q26 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q26 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q26 Mark": 1,
        "Q27 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q27 Candidate Answer": "B: Swami Vivekananda",
        "Q27 Correct Key": "B: Swami Vivekananda",
        "Q27 Mark": 1,
        "Q28 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q28 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q28 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q28 Mark": 1,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "B: 7 mm",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 13,
      "registrationNumber": "KOP/2026/07/0353",
      "studentName": "JANMEJAYA SAHU",
      "mobileNumber": "9337916563",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18-Oct-2026, 01:09:26 pm",
      "startTime": "18-Oct-2026, 01:15:47 pm",
      "submissionTime": "18-Oct-2026, 01:51:11 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 13,
        "Registration ID": "KOP/2026/07/0353",
        "Candidate Name": "JANMEJAYA SAHU",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "If the shot lands on one of the sector lines:",
        "Q1 Candidate Answer": "C: It is called a foul and not measured",
        "Q1 Correct Key": "C: It is called a foul and not measured",
        "Q1 Mark": 1,
        "Q2 Question": "What are the dimensions of the take-off board in long jump?",
        "Q2 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q2 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q2 Mark": 1,
        "Q3 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q3 Candidate Answer": "C: 6",
        "Q3 Correct Key": "C: 6",
        "Q3 Mark": 1,
        "Q4 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q4 Candidate Answer": "C: Pratyahara",
        "Q4 Correct Key": "C: Pratyahara",
        "Q4 Mark": 1,
        "Q5 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q5 Candidate Answer": "B: Comparing their second-best performances",
        "Q5 Correct Key": "B: Comparing their second-best performances",
        "Q5 Mark": 1,
        "Q6 Question": "What is the minimum size of the high jump landing mat?",
        "Q6 Candidate Answer": "B: 5 m × 3 m",
        "Q6 Correct Key": "B: 5 m × 3 m",
        "Q6 Mark": 1,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 1,
        "Q8 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q8 Candidate Answer": "B: 1:2:1",
        "Q8 Correct Key": "B: 1:2:1",
        "Q8 Mark": 1,
        "Q9 Question": "How much energy does 1 g of fat give?",
        "Q9 Candidate Answer": "C: 9.1 kcal",
        "Q9 Correct Key": "C: 9.1 kcal",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's javelin?",
        "Q10 Candidate Answer": "C: 800 g",
        "Q10 Correct Key": "C: 800 g",
        "Q10 Mark": 1,
        "Q11 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q11 Candidate Answer": "C: 32 m/s",
        "Q11 Correct Key": "C: 32 m/s",
        "Q11 Mark": 1,
        "Q12 Question": "What is the javelin throwing sector angle?",
        "Q12 Candidate Answer": "A: 28.96°",
        "Q12 Correct Key": "A: 28.96°",
        "Q12 Mark": 1,
        "Q13 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q13 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q13 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q13 Mark": 1,
        "Q14 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q14 Candidate Answer": "D: Fosbury Flop",
        "Q14 Correct Key": "D: Fosbury Flop",
        "Q14 Mark": 1,
        "Q15 Question": "Lactose (milk sugar) is made of:",
        "Q15 Candidate Answer": "C: Glucose + Galactose",
        "Q15 Correct Key": "C: Glucose + Galactose",
        "Q15 Mark": 1,
        "Q16 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q16 Candidate Answer": "A: Laya Yoga",
        "Q16 Correct Key": "A: Laya Yoga",
        "Q16 Mark": 1,
        "Q17 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q17 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Mark": 1,
        "Q18 Question": "Which of the following is a Niyama?",
        "Q18 Candidate Answer": "C: Svadhyaya",
        "Q18 Correct Key": "C: Svadhyaya",
        "Q18 Mark": 1,
        "Q19 Question": "How is a triple jump measured?",
        "Q19 Candidate Answer": "D: Diagonally from the take-off board to the landing point",
        "Q19 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q19 Mark": 0,
        "Q20 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q20 Candidate Answer": "B: Glide method",
        "Q20 Correct Key": "B: Glide method",
        "Q20 Mark": 1,
        "Q21 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q21 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q21 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q21 Mark": 1,
        "Q22 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q22 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q22 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q23 Candidate Answer": "B: 45 minutes",
        "Q23 Correct Key": "B: 45 minutes",
        "Q23 Mark": 1,
        "Q24 Question": "In which throwing event are gloves allowed?",
        "Q24 Candidate Answer": "D: Hammer throw",
        "Q24 Correct Key": "D: Hammer throw",
        "Q24 Mark": 1,
        "Q25 Question": "What is the weight of the women's discus?",
        "Q25 Candidate Answer": "B: 1 kg",
        "Q25 Correct Key": "B: 1 kg",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's shot?",
        "Q26 Candidate Answer": "C: 7.260 kg",
        "Q26 Correct Key": "C: 7.260 kg",
        "Q26 Mark": 1,
        "Q27 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q27 Candidate Answer": "C: 2 minutes",
        "Q27 Correct Key": "C: 2 minutes",
        "Q27 Mark": 1,
        "Q28 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q28 Candidate Answer": "B: 45 mm",
        "Q28 Correct Key": "B: 45 mm",
        "Q28 Mark": 1,
        "Q29 Question": "What is the official distance of a marathon?",
        "Q29 Candidate Answer": "C: 42.195 km",
        "Q29 Correct Key": "C: 42.195 km",
        "Q29 Mark": 1,
        "Q30 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q30 Candidate Answer": "B: To hold or maintain",
        "Q30 Correct Key": "B: To hold or maintain",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 14,
      "registrationNumber": "KOP/2026/07/0354",
      "studentName": "SUBASINI BISWAL",
      "mobileNumber": "9178359069",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:13:33 pm",
      "startTime": "18 Oct 2026, 01:16:30 pm",
      "submissionTime": "18 Oct 2026, 01:45:30 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 14,
        "Registration ID": "KOP/2026/07/0354",
        "Candidate Name": "SUBASINI BISWAL",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q1 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Mark": 1,
        "Q2 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q2 Candidate Answer": "C: Disqualified",
        "Q2 Correct Key": "C: Disqualified",
        "Q2 Mark": 1,
        "Q3 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q3 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q3 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q3 Mark": 1,
        "Q4 Question": "What is the javelin throwing sector angle?",
        "Q4 Candidate Answer": "A: 28.96°",
        "Q4 Correct Key": "A: 28.96°",
        "Q4 Mark": 1,
        "Q5 Question": "In which throwing event are gloves allowed?",
        "Q5 Candidate Answer": "D: Hammer throw",
        "Q5 Correct Key": "D: Hammer throw",
        "Q5 Mark": 1,
        "Q6 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q6 Candidate Answer": "C: 3",
        "Q6 Correct Key": "C: 3",
        "Q6 Mark": 1,
        "Q7 Question": "In international competition, the pole vault landing area must be at least:",
        "Q7 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q7 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q7 Mark": 1,
        "Q8 Question": "Lactose (milk sugar) is made of:",
        "Q8 Candidate Answer": "C: Glucose + Galactose",
        "Q8 Correct Key": "C: Glucose + Galactose",
        "Q8 Mark": 1,
        "Q9 Question": "Which of the following is NOT a flight style in long jump?",
        "Q9 Candidate Answer": "A: Sail style",
        "Q9 Correct Key": "D: Fosbury flop",
        "Q9 Mark": 0,
        "Q10 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q10 Candidate Answer": "B: To hold or maintain",
        "Q10 Correct Key": "B: To hold or maintain",
        "Q10 Mark": 1,
        "Q11 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q11 Candidate Answer": "B: Scissors Jump",
        "Q11 Correct Key": "B: Scissors Jump",
        "Q11 Mark": 1,
        "Q12 Question": "How is a triple jump measured?",
        "Q12 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Mark": 1,
        "Q13 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q13 Candidate Answer": "C: 34.92°",
        "Q13 Correct Key": "C: 34.92°",
        "Q13 Mark": 1,
        "Q14 Question": "What is the diameter of the shot put circle?",
        "Q14 Candidate Answer": "B: 2.135 m",
        "Q14 Correct Key": "B: 2.135 m",
        "Q14 Mark": 1,
        "Q15 Question": "What is the diameter of the discus throwing circle?",
        "Q15 Candidate Answer": "B: 2.50 m",
        "Q15 Correct Key": "B: 2.50 m",
        "Q15 Mark": 1,
        "Q16 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q16 Candidate Answer": "B: Yama",
        "Q16 Correct Key": "B: Yama",
        "Q16 Mark": 1,
        "Q17 Question": "Which statement about pole vault is correct?",
        "Q17 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q17 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q17 Mark": 1,
        "Q18 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q18 Candidate Answer": "B: Swami Vivekananda",
        "Q18 Correct Key": "B: Swami Vivekananda",
        "Q18 Mark": 1,
        "Q19 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q19 Candidate Answer": "B: 45 mm",
        "Q19 Correct Key": "B: 45 mm",
        "Q19 Mark": 1,
        "Q20 Question": "How much energy does 1 g of fat give?",
        "Q20 Candidate Answer": "C: 9.1 kcal",
        "Q20 Correct Key": "C: 9.1 kcal",
        "Q20 Mark": 1,
        "Q21 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q21 Candidate Answer": "C: 32 m/s",
        "Q21 Correct Key": "C: 32 m/s",
        "Q21 Mark": 1,
        "Q22 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q22 Candidate Answer": "C: To join or unite",
        "Q22 Correct Key": "C: To join or unite",
        "Q22 Mark": 1,
        "Q23 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q23 Candidate Answer": "B: Comparing their second-best performances",
        "Q23 Correct Key": "B: Comparing their second-best performances",
        "Q23 Mark": 1,
        "Q24 Question": "In track and field, a green card is shown when:",
        "Q24 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q24 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q24 Mark": 1,
        "Q25 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q25 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q25 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's shot?",
        "Q26 Candidate Answer": "C: 7.260 kg",
        "Q26 Correct Key": "C: 7.260 kg",
        "Q26 Mark": 1,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "B: Glide method",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 1,
        "Q28 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q28 Candidate Answer": "D: Fosbury Flop",
        "Q28 Correct Key": "D: Fosbury Flop",
        "Q28 Mark": 1,
        "Q29 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q29 Candidate Answer": "C: Pratyahara",
        "Q29 Correct Key": "C: Pratyahara",
        "Q29 Mark": 1,
        "Q30 Question": "What is the weight of the women's discus?",
        "Q30 Candidate Answer": "B: 1 kg",
        "Q30 Correct Key": "B: 1 kg",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 15,
      "registrationNumber": "KOP/2026/07/0367",
      "studentName": "GIRISH BAG",
      "mobileNumber": "9692288745",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:04:22 pm",
      "startTime": "18 Oct 2026, 01:17:42 pm",
      "submissionTime": "18 Oct 2026, 01:42:27 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 15,
        "Registration ID": "KOP/2026/07/0367",
        "Candidate Name": "GIRISH BAG",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What are the dimensions of the take-off board in long jump?",
        "Q1 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q1 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q1 Mark": 0,
        "Q2 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q2 Candidate Answer": "C: Karma Yoga",
        "Q2 Correct Key": "C: Karma Yoga",
        "Q2 Mark": 1,
        "Q3 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q3 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q3 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q3 Mark": 1,
        "Q4 Question": "What is the weight of the women's discus?",
        "Q4 Candidate Answer": "B: 1 kg",
        "Q4 Correct Key": "B: 1 kg",
        "Q4 Mark": 1,
        "Q5 Question": "If the shot lands on one of the sector lines:",
        "Q5 Candidate Answer": "C: It is called a foul and not measured",
        "Q5 Correct Key": "C: It is called a foul and not measured",
        "Q5 Mark": 1,
        "Q6 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q6 Candidate Answer": "C: Disqualified",
        "Q6 Correct Key": "C: Disqualified",
        "Q6 Mark": 1,
        "Q7 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q7 Candidate Answer": "D: Orthodox grip",
        "Q7 Correct Key": "D: Orthodox grip",
        "Q7 Mark": 1,
        "Q8 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q8 Candidate Answer": "C: 6",
        "Q8 Correct Key": "C: 6",
        "Q8 Mark": 1,
        "Q9 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q9 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q9 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q9 Mark": 1,
        "Q10 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q10 Candidate Answer": "B: Swami Vivekananda",
        "Q10 Correct Key": "B: Swami Vivekananda",
        "Q10 Mark": 1,
        "Q11 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q11 Candidate Answer": "B: Comparing their second-best performances",
        "Q11 Correct Key": "B: Comparing their second-best performances",
        "Q11 Mark": 1,
        "Q12 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q12 Candidate Answer": "B: 45 minutes",
        "Q12 Correct Key": "B: 45 minutes",
        "Q12 Mark": 1,
        "Q13 Question": "How high is the plasticine indicator board?",
        "Q13 Candidate Answer": "B: 7 mm",
        "Q13 Correct Key": "B: 7 mm",
        "Q13 Mark": 1,
        "Q14 Question": "In international competition, the pole vault landing area must be at least:",
        "Q14 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q14 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q14 Mark": 1,
        "Q15 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q15 Candidate Answer": "B: To hold or maintain",
        "Q15 Correct Key": "B: To hold or maintain",
        "Q15 Mark": 1,
        "Q16 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q16 Candidate Answer": "C: 3",
        "Q16 Correct Key": "C: 3",
        "Q16 Mark": 1,
        "Q17 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q17 Candidate Answer": "A: Laya Yoga",
        "Q17 Correct Key": "A: Laya Yoga",
        "Q17 Mark": 1,
        "Q18 Question": "Lactose (milk sugar) is made of:",
        "Q18 Candidate Answer": "C: Glucose + Galactose",
        "Q18 Correct Key": "C: Glucose + Galactose",
        "Q18 Mark": 1,
        "Q19 Question": "What is the weight of the men's shot?",
        "Q19 Candidate Answer": "C: 7.260 kg",
        "Q19 Correct Key": "C: 7.260 kg",
        "Q19 Mark": 1,
        "Q20 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q20 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q20 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q20 Mark": 1,
        "Q21 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q21 Candidate Answer": "B: 45 mm",
        "Q21 Correct Key": "B: 45 mm",
        "Q21 Mark": 1,
        "Q22 Question": "What is the diameter of the shot put circle?",
        "Q22 Candidate Answer": "B: 2.135 m",
        "Q22 Correct Key": "B: 2.135 m",
        "Q22 Mark": 1,
        "Q23 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q23 Candidate Answer": "B: Scissors Jump",
        "Q23 Correct Key": "B: Scissors Jump",
        "Q23 Mark": 1,
        "Q24 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q24 Candidate Answer": "B: 1:2:1",
        "Q24 Correct Key": "B: 1:2:1",
        "Q24 Mark": 1,
        "Q25 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q25 Candidate Answer": "C: Pratyahara",
        "Q25 Correct Key": "C: Pratyahara",
        "Q25 Mark": 1,
        "Q26 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q26 Candidate Answer": "B: Yama",
        "Q26 Correct Key": "B: Yama",
        "Q26 Mark": 1,
        "Q27 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q27 Candidate Answer": "C: 20 m",
        "Q27 Correct Key": "C: 20 m",
        "Q27 Mark": 1,
        "Q28 Question": "How much energy does 1 g of fat give?",
        "Q28 Candidate Answer": "C: 9.1 kcal",
        "Q28 Correct Key": "C: 9.1 kcal",
        "Q28 Mark": 1,
        "Q29 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q29 Candidate Answer": "D: Fosbury Flop",
        "Q29 Correct Key": "D: Fosbury Flop",
        "Q29 Mark": 1,
        "Q30 Question": "In track and field, a green card is shown when:",
        "Q30 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q30 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 16,
      "registrationNumber": "KOP/2026/08/0516",
      "studentName": "GOBINDA BEHERA",
      "mobileNumber": "6371095696",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:10 pm",
      "startTime": "18 Oct 2026, 01:17:02 pm",
      "submissionTime": "18 Oct 2026, 01:44:50 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 16,
        "Registration ID": "KOP/2026/08/0516",
        "Candidate Name": "GOBINDA BEHERA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q1 Candidate Answer": "D: Fosbury Flop",
        "Q1 Correct Key": "D: Fosbury Flop",
        "Q1 Mark": 1,
        "Q2 Question": "What is the minimum size of the high jump landing mat?",
        "Q2 Candidate Answer": "B: 5 m × 3 m",
        "Q2 Correct Key": "B: 5 m × 3 m",
        "Q2 Mark": 1,
        "Q3 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q3 Candidate Answer": "B: 45 minutes",
        "Q3 Correct Key": "B: 45 minutes",
        "Q3 Mark": 1,
        "Q4 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q4 Candidate Answer": "B: Glide method",
        "Q4 Correct Key": "B: Glide method",
        "Q4 Mark": 1,
        "Q5 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q5 Candidate Answer": "B: Scissors Jump",
        "Q5 Correct Key": "B: Scissors Jump",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the women's discus?",
        "Q6 Candidate Answer": "B: 1 kg",
        "Q6 Correct Key": "B: 1 kg",
        "Q6 Mark": 1,
        "Q7 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q7 Candidate Answer": "B: Yama",
        "Q7 Correct Key": "B: Yama",
        "Q7 Mark": 1,
        "Q8 Question": "In which throwing event are gloves allowed?",
        "Q8 Candidate Answer": "D: Hammer throw",
        "Q8 Correct Key": "D: Hammer throw",
        "Q8 Mark": 1,
        "Q9 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q9 Candidate Answer": "B: 45 mm",
        "Q9 Correct Key": "B: 45 mm",
        "Q9 Mark": 1,
        "Q10 Question": "In international competition, the pole vault landing area must be at least:",
        "Q10 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q10 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q10 Mark": 1,
        "Q11 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q11 Candidate Answer": "C: 32 m/s",
        "Q11 Correct Key": "C: 32 m/s",
        "Q11 Mark": 1,
        "Q12 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q12 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q12 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q12 Mark": 1,
        "Q13 Question": "If the shot lands on one of the sector lines:",
        "Q13 Candidate Answer": "C: It is called a foul and not measured",
        "Q13 Correct Key": "C: It is called a foul and not measured",
        "Q13 Mark": 1,
        "Q14 Question": "How high is the plasticine indicator board?",
        "Q14 Candidate Answer": "B: 7 mm",
        "Q14 Correct Key": "B: 7 mm",
        "Q14 Mark": 1,
        "Q15 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q15 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q15 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q15 Mark": 1,
        "Q16 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q16 Candidate Answer": "C: 3",
        "Q16 Correct Key": "C: 3",
        "Q16 Mark": 1,
        "Q17 Question": "How is a triple jump measured?",
        "Q17 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q17 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q17 Mark": 1,
        "Q18 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q18 Candidate Answer": "B: Swami Vivekananda",
        "Q18 Correct Key": "B: Swami Vivekananda",
        "Q18 Mark": 1,
        "Q19 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q19 Candidate Answer": "C: 20 m",
        "Q19 Correct Key": "C: 20 m",
        "Q19 Mark": 1,
        "Q20 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q20 Candidate Answer": "C: Karma Yoga",
        "Q20 Correct Key": "C: Karma Yoga",
        "Q20 Mark": 1,
        "Q21 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q21 Candidate Answer": "B: To hold or maintain",
        "Q21 Correct Key": "B: To hold or maintain",
        "Q21 Mark": 1,
        "Q22 Question": "Which statement about pole vault is correct?",
        "Q22 Candidate Answer": "A: Gloves are not permitted",
        "Q22 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q22 Mark": 0,
        "Q23 Question": "Lactose (milk sugar) is made of:",
        "Q23 Candidate Answer": "C: Glucose + Galactose",
        "Q23 Correct Key": "C: Glucose + Galactose",
        "Q23 Mark": 1,
        "Q24 Question": "What is the diameter of the shot put circle?",
        "Q24 Candidate Answer": "B: 2.135 m",
        "Q24 Correct Key": "B: 2.135 m",
        "Q24 Mark": 1,
        "Q25 Question": "What is the weight of the men's javelin?",
        "Q25 Candidate Answer": "C: 800 g",
        "Q25 Correct Key": "C: 800 g",
        "Q25 Mark": 1,
        "Q26 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q26 Candidate Answer": "C: 2 minutes",
        "Q26 Correct Key": "C: 2 minutes",
        "Q26 Mark": 1,
        "Q27 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q27 Candidate Answer": "C: Disqualified",
        "Q27 Correct Key": "C: Disqualified",
        "Q27 Mark": 1,
        "Q28 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q28 Candidate Answer": "C: 34.92°",
        "Q28 Correct Key": "C: 34.92°",
        "Q28 Mark": 1,
        "Q29 Question": "Which of the following is a Niyama?",
        "Q29 Candidate Answer": "C: Svadhyaya",
        "Q29 Correct Key": "C: Svadhyaya",
        "Q29 Mark": 1,
        "Q30 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q30 Candidate Answer": "A: Laya Yoga",
        "Q30 Correct Key": "A: Laya Yoga",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 17,
      "registrationNumber": "KOP/2026/08/0549",
      "studentName": "JYOTISMITA JENA",
      "mobileNumber": "7326871102",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:35 pm",
      "startTime": "18 Oct 2026, 01:37:37 pm",
      "submissionTime": "18 Oct 2026, 02:09:59 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 17,
        "Registration ID": "KOP/2026/08/0549",
        "Candidate Name": "JYOTISMITA JENA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "D: Fosbury flop",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 1,
        "Q2 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q2 Candidate Answer": "D: Orthodox grip",
        "Q2 Correct Key": "D: Orthodox grip",
        "Q2 Mark": 1,
        "Q3 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q3 Candidate Answer": "C: 3",
        "Q3 Correct Key": "C: 3",
        "Q3 Mark": 1,
        "Q4 Question": "What is the correct sequence of phases in the triple jump?",
        "Q4 Candidate Answer": "C: Hop – Step – Jump",
        "Q4 Correct Key": "C: Hop – Step – Jump",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q5 Candidate Answer": "B: 45 mm",
        "Q5 Correct Key": "B: 45 mm",
        "Q5 Mark": 1,
        "Q6 Question": "Which of the following is a Niyama?",
        "Q6 Candidate Answer": "C: Svadhyaya",
        "Q6 Correct Key": "C: Svadhyaya",
        "Q6 Mark": 1,
        "Q7 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q7 Candidate Answer": "C: Pratyahara",
        "Q7 Correct Key": "C: Pratyahara",
        "Q7 Mark": 1,
        "Q8 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q8 Candidate Answer": "C: 11",
        "Q8 Correct Key": "C: 11",
        "Q8 Mark": 1,
        "Q9 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q9 Candidate Answer": "C: The athlete who started at the higher height",
        "Q9 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q9 Mark": 0,
        "Q10 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q10 Candidate Answer": "B: Glide method",
        "Q10 Correct Key": "B: Glide method",
        "Q10 Mark": 1,
        "Q11 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q11 Candidate Answer": "B: Yama",
        "Q11 Correct Key": "B: Yama",
        "Q11 Mark": 1,
        "Q12 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q12 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q12 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q12 Mark": 1,
        "Q13 Question": "What is the official distance of a marathon?",
        "Q13 Candidate Answer": "C: 42.195 km",
        "Q13 Correct Key": "C: 42.195 km",
        "Q13 Mark": 1,
        "Q14 Question": "If the shot lands on one of the sector lines:",
        "Q14 Candidate Answer": "C: It is called a foul and not measured",
        "Q14 Correct Key": "C: It is called a foul and not measured",
        "Q14 Mark": 1,
        "Q15 Question": "What is the diameter of the shot put circle?",
        "Q15 Candidate Answer": "B: 2.135 m",
        "Q15 Correct Key": "B: 2.135 m",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the discus throwing circle?",
        "Q16 Candidate Answer": "B: 2.50 m",
        "Q16 Correct Key": "B: 2.50 m",
        "Q16 Mark": 1,
        "Q17 Question": "Lactose (milk sugar) is made of:",
        "Q17 Candidate Answer": "C: Glucose + Galactose",
        "Q17 Correct Key": "C: Glucose + Galactose",
        "Q17 Mark": 1,
        "Q18 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q18 Candidate Answer": "B: Scissors Jump",
        "Q18 Correct Key": "B: Scissors Jump",
        "Q18 Mark": 1,
        "Q19 Question": "In which throwing event are gloves allowed?",
        "Q19 Candidate Answer": "D: Hammer throw",
        "Q19 Correct Key": "D: Hammer throw",
        "Q19 Mark": 1,
        "Q20 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q20 Candidate Answer": "B: Comparing their second-best performances",
        "Q20 Correct Key": "B: Comparing their second-best performances",
        "Q20 Mark": 1,
        "Q21 Question": "How much energy does 1 g of fat give?",
        "Q21 Candidate Answer": "C: 9.1 kcal",
        "Q21 Correct Key": "C: 9.1 kcal",
        "Q21 Mark": 1,
        "Q22 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q22 Candidate Answer": "C: Protein",
        "Q22 Correct Key": "C: Protein",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum size of the high jump landing mat?",
        "Q23 Candidate Answer": "B: 5 m × 3 m",
        "Q23 Correct Key": "B: 5 m × 3 m",
        "Q23 Mark": 1,
        "Q24 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q24 Candidate Answer": "C: 6",
        "Q24 Correct Key": "C: 6",
        "Q24 Mark": 1,
        "Q25 Question": "A javelin throw is valid only if:",
        "Q25 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q25 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q25 Mark": 1,
        "Q26 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q26 Candidate Answer": "C: 32 m/s",
        "Q26 Correct Key": "C: 32 m/s",
        "Q26 Mark": 1,
        "Q27 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q27 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q27 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q27 Mark": 1,
        "Q28 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q28 Candidate Answer": "D: Fosbury Flop",
        "Q28 Correct Key": "D: Fosbury Flop",
        "Q28 Mark": 1,
        "Q29 Question": "What is the weight of the men's shot?",
        "Q29 Candidate Answer": "C: 7.260 kg",
        "Q29 Correct Key": "C: 7.260 kg",
        "Q29 Mark": 1,
        "Q30 Question": "What are the dimensions of the take-off board in long jump?",
        "Q30 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 18,
      "registrationNumber": "KOP/2026/08/0550",
      "studentName": "HEMANTA KUMAR JENA",
      "mobileNumber": "9337541731",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:05:16 pm",
      "startTime": "18 Oct 2026, 01:21:39 pm",
      "submissionTime": "18 Oct 2026, 01:56:03 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 18,
        "Registration ID": "KOP/2026/08/0550",
        "Candidate Name": "HEMANTA KUMAR JENA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the diameter of the discus throwing circle?",
        "Q1 Candidate Answer": "B: 2.50 m",
        "Q1 Correct Key": "B: 2.50 m",
        "Q1 Mark": 1,
        "Q2 Question": "In track and field, a green card is shown when:",
        "Q2 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q2 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q2 Mark": 1,
        "Q3 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q3 Candidate Answer": "C: 2 minutes",
        "Q3 Correct Key": "C: 2 minutes",
        "Q3 Mark": 1,
        "Q4 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q4 Candidate Answer": "C: 34.92°",
        "Q4 Correct Key": "C: 34.92°",
        "Q4 Mark": 1,
        "Q5 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q5 Candidate Answer": "B: To hold or maintain",
        "Q5 Correct Key": "B: To hold or maintain",
        "Q5 Mark": 1,
        "Q6 Question": "What is the diameter of the shot put circle?",
        "Q6 Candidate Answer": "B: 2.135 m",
        "Q6 Correct Key": "B: 2.135 m",
        "Q6 Mark": 1,
        "Q7 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q7 Candidate Answer": "B: Comparing their second-best performances",
        "Q7 Correct Key": "B: Comparing their second-best performances",
        "Q7 Mark": 1,
        "Q8 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q8 Candidate Answer": "B: 1:2:1",
        "Q8 Correct Key": "B: 1:2:1",
        "Q8 Mark": 1,
        "Q9 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q9 Candidate Answer": "C: 6",
        "Q9 Correct Key": "C: 6",
        "Q9 Mark": 1,
        "Q10 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q10 Candidate Answer": "C: 11",
        "Q10 Correct Key": "C: 11",
        "Q10 Mark": 1,
        "Q11 Question": "In international competition, the pole vault landing area must be at least:",
        "Q11 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q11 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q11 Mark": 1,
        "Q12 Question": "Which of the following is NOT a flight style in long jump?",
        "Q12 Candidate Answer": "D: Fosbury flop",
        "Q12 Correct Key": "D: Fosbury flop",
        "Q12 Mark": 1,
        "Q13 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q13 Candidate Answer": "B: Glide method",
        "Q13 Correct Key": "B: Glide method",
        "Q13 Mark": 1,
        "Q14 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q14 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q14 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q14 Mark": 0,
        "Q15 Question": "A javelin throw is valid only if:",
        "Q15 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q15 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q15 Mark": 1,
        "Q16 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q16 Candidate Answer": "C: 32 m/s",
        "Q16 Correct Key": "C: 32 m/s",
        "Q16 Mark": 1,
        "Q17 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q17 Candidate Answer": "C: 20 m",
        "Q17 Correct Key": "C: 20 m",
        "Q17 Mark": 1,
        "Q18 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q18 Candidate Answer": "B: 45 mm",
        "Q18 Correct Key": "B: 45 mm",
        "Q18 Mark": 1,
        "Q19 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q19 Candidate Answer": "C: 3",
        "Q19 Correct Key": "C: 3",
        "Q19 Mark": 1,
        "Q20 Question": "What is the javelin throwing sector angle?",
        "Q20 Candidate Answer": "A: 28.96°",
        "Q20 Correct Key": "A: 28.96°",
        "Q20 Mark": 1,
        "Q21 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q21 Candidate Answer": "B: Scissors Jump",
        "Q21 Correct Key": "B: Scissors Jump",
        "Q21 Mark": 1,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "C: 800 g",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 1,
        "Q23 Question": "What is the correct sequence of phases in the triple jump?",
        "Q23 Candidate Answer": "C: Hop – Step – Jump",
        "Q23 Correct Key": "C: Hop – Step – Jump",
        "Q23 Mark": 1,
        "Q24 Question": "How much energy does 1 g of fat give?",
        "Q24 Candidate Answer": "C: 9.1 kcal",
        "Q24 Correct Key": "C: 9.1 kcal",
        "Q24 Mark": 1,
        "Q25 Question": "What is the weight of the men's shot?",
        "Q25 Candidate Answer": "C: 7.260 kg",
        "Q25 Correct Key": "C: 7.260 kg",
        "Q25 Mark": 1,
        "Q26 Question": "What is the official distance of a marathon?",
        "Q26 Candidate Answer": "C: 42.195 km",
        "Q26 Correct Key": "C: 42.195 km",
        "Q26 Mark": 1,
        "Q27 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q27 Candidate Answer": "B: 45 minutes",
        "Q27 Correct Key": "B: 45 minutes",
        "Q27 Mark": 1,
        "Q28 Question": "What is the weight of the women's discus?",
        "Q28 Candidate Answer": "B: 1 kg",
        "Q28 Correct Key": "B: 1 kg",
        "Q28 Mark": 1,
        "Q29 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q29 Candidate Answer": "D: Fosbury Flop",
        "Q29 Correct Key": "D: Fosbury Flop",
        "Q29 Mark": 1,
        "Q30 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q30 Candidate Answer": "B: Swami Vivekananda",
        "Q30 Correct Key": "B: Swami Vivekananda",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 19,
      "registrationNumber": "KOP/2026/08/0568",
      "studentName": "BISWESWAR BISHI",
      "mobileNumber": "7854983950",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:15 pm",
      "startTime": "13:15 IST",
      "submissionTime": "18 Oct 2026, 01:45:51 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 19,
        "Registration ID": "KOP/2026/08/0568",
        "Candidate Name": "BISWESWAR BISHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "C: Svadhyaya",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 1,
        "Q2 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q2 Candidate Answer": "B: 45 mm",
        "Q2 Correct Key": "B: 45 mm",
        "Q2 Mark": 1,
        "Q3 Question": "How high is the plasticine indicator board?",
        "Q3 Candidate Answer": "B: 7 mm",
        "Q3 Correct Key": "B: 7 mm",
        "Q3 Mark": 1,
        "Q4 Question": "What is the diameter of the discus throwing circle?",
        "Q4 Candidate Answer": "B: 2.50 m",
        "Q4 Correct Key": "B: 2.50 m",
        "Q4 Mark": 1,
        "Q5 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q5 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q5 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q5 Mark": 1,
        "Q6 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q6 Candidate Answer": "C: 34.92°",
        "Q6 Correct Key": "C: 34.92°",
        "Q6 Mark": 1,
        "Q7 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q7 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Mark": 1,
        "Q8 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q8 Candidate Answer": "C: To join or unite",
        "Q8 Correct Key": "C: To join or unite",
        "Q8 Mark": 1,
        "Q9 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q9 Candidate Answer": "B: 1:2:1",
        "Q9 Correct Key": "B: 1:2:1",
        "Q9 Mark": 1,
        "Q10 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q10 Candidate Answer": "A: Laya Yoga",
        "Q10 Correct Key": "A: Laya Yoga",
        "Q10 Mark": 1,
        "Q11 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q11 Candidate Answer": "B: To hold or maintain",
        "Q11 Correct Key": "B: To hold or maintain",
        "Q11 Mark": 1,
        "Q12 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q12 Candidate Answer": "C: Pratyahara",
        "Q12 Correct Key": "C: Pratyahara",
        "Q12 Mark": 1,
        "Q13 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q13 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q13 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q13 Mark": 1,
        "Q14 Question": "In international competition, the pole vault landing area must be at least:",
        "Q14 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q14 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q14 Mark": 1,
        "Q15 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q15 Candidate Answer": "B: 45 minutes",
        "Q15 Correct Key": "B: 45 minutes",
        "Q15 Mark": 1,
        "Q16 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q16 Candidate Answer": "B: Comparing their second-best performances",
        "Q16 Correct Key": "B: Comparing their second-best performances",
        "Q16 Mark": 1,
        "Q17 Question": "What is the weight of the men's shot?",
        "Q17 Candidate Answer": "C: 7.260 kg",
        "Q17 Correct Key": "C: 7.260 kg",
        "Q17 Mark": 1,
        "Q18 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q18 Candidate Answer": "C: 3",
        "Q18 Correct Key": "C: 3",
        "Q18 Mark": 1,
        "Q19 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q19 Candidate Answer": "B: Scissors Jump",
        "Q19 Correct Key": "B: Scissors Jump",
        "Q19 Mark": 1,
        "Q20 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q20 Candidate Answer": "C: 6",
        "Q20 Correct Key": "C: 6",
        "Q20 Mark": 1,
        "Q21 Question": "What is the official distance of a marathon?",
        "Q21 Candidate Answer": "C: 42.195 km",
        "Q21 Correct Key": "C: 42.195 km",
        "Q21 Mark": 1,
        "Q22 Question": "Which statement about pole vault is correct?",
        "Q22 Candidate Answer": "A: Gloves are not permitted",
        "Q22 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q22 Mark": 0,
        "Q23 Question": "What is the correct sequence of phases in the triple jump?",
        "Q23 Candidate Answer": "C: Hop – Step – Jump",
        "Q23 Correct Key": "C: Hop – Step – Jump",
        "Q23 Mark": 1,
        "Q24 Question": "If the shot lands on one of the sector lines:",
        "Q24 Candidate Answer": "C: It is called a foul and not measured",
        "Q24 Correct Key": "C: It is called a foul and not measured",
        "Q24 Mark": 1,
        "Q25 Question": "What is the diameter of the shot put circle?",
        "Q25 Candidate Answer": "B: 2.135 m",
        "Q25 Correct Key": "B: 2.135 m",
        "Q25 Mark": 1,
        "Q26 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q26 Candidate Answer": "C: 20 m",
        "Q26 Correct Key": "C: 20 m",
        "Q26 Mark": 1,
        "Q27 Question": "Which of the following is NOT a flight style in long jump?",
        "Q27 Candidate Answer": "D: Fosbury flop",
        "Q27 Correct Key": "D: Fosbury flop",
        "Q27 Mark": 1,
        "Q28 Question": "What is the weight of the men's javelin?",
        "Q28 Candidate Answer": "C: 800 g",
        "Q28 Correct Key": "C: 800 g",
        "Q28 Mark": 1,
        "Q29 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q29 Candidate Answer": "C: Protein",
        "Q29 Correct Key": "C: Protein",
        "Q29 Mark": 1,
        "Q30 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q30 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 20,
      "registrationNumber": "KOP/2026/08/0582",
      "studentName": "MANAS KUMAR NANDA",
      "mobileNumber": "9861648535",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:08 pm",
      "startTime": "18 Oct 2026, 01:15:50 pm",
      "submissionTime": "18 Oct 2026, 01:43:06 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 20,
        "Registration ID": "KOP/2026/08/0582",
        "Candidate Name": "MANAS KUMAR NANDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "C: Svadhyaya",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 1,
        "Q2 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q2 Candidate Answer": "B: Yama",
        "Q2 Correct Key": "B: Yama",
        "Q2 Mark": 1,
        "Q3 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q3 Candidate Answer": "A: Laya Yoga",
        "Q3 Correct Key": "A: Laya Yoga",
        "Q3 Mark": 1,
        "Q4 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q4 Candidate Answer": "C: Pratyahara",
        "Q4 Correct Key": "C: Pratyahara",
        "Q4 Mark": 1,
        "Q5 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q5 Candidate Answer": "C: 20 m",
        "Q5 Correct Key": "C: 20 m",
        "Q5 Mark": 1,
        "Q6 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q6 Candidate Answer": "C: 11",
        "Q6 Correct Key": "C: 11",
        "Q6 Mark": 1,
        "Q7 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q7 Candidate Answer": "B: Scissors Jump",
        "Q7 Correct Key": "B: Scissors Jump",
        "Q7 Mark": 1,
        "Q8 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q8 Candidate Answer": "B: To hold or maintain",
        "Q8 Correct Key": "B: To hold or maintain",
        "Q8 Mark": 1,
        "Q9 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q9 Candidate Answer": "C: 32 m/s",
        "Q9 Correct Key": "C: 32 m/s",
        "Q9 Mark": 1,
        "Q10 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q10 Candidate Answer": "C: Karma Yoga",
        "Q10 Correct Key": "C: Karma Yoga",
        "Q10 Mark": 1,
        "Q11 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q11 Candidate Answer": "B: 45 minutes",
        "Q11 Correct Key": "B: 45 minutes",
        "Q11 Mark": 1,
        "Q12 Question": "What is the minimum size of the high jump landing mat?",
        "Q12 Candidate Answer": "B: 5 m × 3 m",
        "Q12 Correct Key": "B: 5 m × 3 m",
        "Q12 Mark": 1,
        "Q13 Question": "How much energy does 1 g of fat give?",
        "Q13 Candidate Answer": "C: 9.1 kcal",
        "Q13 Correct Key": "C: 9.1 kcal",
        "Q13 Mark": 1,
        "Q14 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q14 Candidate Answer": "B: 45 mm",
        "Q14 Correct Key": "B: 45 mm",
        "Q14 Mark": 1,
        "Q15 Question": "What is the weight of the women's discus?",
        "Q15 Candidate Answer": "D: 2 kg",
        "Q15 Correct Key": "B: 1 kg",
        "Q15 Mark": 0,
        "Q16 Question": "What is the diameter of the shot put circle?",
        "Q16 Candidate Answer": "B: 2.135 m",
        "Q16 Correct Key": "B: 2.135 m",
        "Q16 Mark": 1,
        "Q17 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q17 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's javelin?",
        "Q18 Candidate Answer": "C: 800 g",
        "Q18 Correct Key": "C: 800 g",
        "Q18 Mark": 1,
        "Q19 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q19 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q19 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q19 Mark": 1,
        "Q20 Question": "A javelin throw is valid only if:",
        "Q20 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q20 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q20 Mark": 1,
        "Q21 Question": "What is the correct sequence of phases in the triple jump?",
        "Q21 Candidate Answer": "C: Hop – Step – Jump",
        "Q21 Correct Key": "C: Hop – Step – Jump",
        "Q21 Mark": 1,
        "Q22 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q22 Candidate Answer": "C: 3",
        "Q22 Correct Key": "C: 3",
        "Q22 Mark": 1,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 1,
        "Q24 Question": "If the shot lands on one of the sector lines:",
        "Q24 Candidate Answer": "C: It is called a foul and not measured",
        "Q24 Correct Key": "C: It is called a foul and not measured",
        "Q24 Mark": 1,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 1,
        "Q26 Question": "In which throwing event are gloves allowed?",
        "Q26 Candidate Answer": "D: Hammer throw",
        "Q26 Correct Key": "D: Hammer throw",
        "Q26 Mark": 1,
        "Q27 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q27 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q27 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q27 Mark": 1,
        "Q28 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q28 Candidate Answer": "B: Swami Vivekananda",
        "Q28 Correct Key": "B: Swami Vivekananda",
        "Q28 Mark": 1,
        "Q29 Question": "In track and field, a green card is shown when:",
        "Q29 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q29 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q29 Mark": 1,
        "Q30 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q30 Candidate Answer": "C: Disqualified",
        "Q30 Correct Key": "C: Disqualified",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 21,
      "registrationNumber": "KOP/2026/08/0659",
      "studentName": "MISHA DEB PUNJI",
      "mobileNumber": "7735371805",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:05:55 pm",
      "startTime": "18 Oct 2026, 01:17:34 pm",
      "submissionTime": "18 Oct 2026, 01:25:24 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 21,
        "Registration ID": "KOP/2026/08/0659",
        "Candidate Name": "MISHA DEB PUNJI",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the correct sequence of phases in the triple jump?",
        "Q1 Candidate Answer": "C: Hop – Step – Jump",
        "Q1 Correct Key": "C: Hop – Step – Jump",
        "Q1 Mark": 1,
        "Q2 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q2 Candidate Answer": "B: 1:2:1",
        "Q2 Correct Key": "B: 1:2:1",
        "Q2 Mark": 1,
        "Q3 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q3 Candidate Answer": "C: Karma Yoga",
        "Q3 Correct Key": "C: Karma Yoga",
        "Q3 Mark": 1,
        "Q4 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q4 Candidate Answer": "C: 2 minutes",
        "Q4 Correct Key": "C: 2 minutes",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q5 Candidate Answer": "B: 45 mm",
        "Q5 Correct Key": "B: 45 mm",
        "Q5 Mark": 1,
        "Q6 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q6 Candidate Answer": "B: Comparing their second-best performances",
        "Q6 Correct Key": "B: Comparing their second-best performances",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum size of the high jump landing mat?",
        "Q7 Candidate Answer": "B: 5 m × 3 m",
        "Q7 Correct Key": "B: 5 m × 3 m",
        "Q7 Mark": 1,
        "Q8 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q8 Candidate Answer": "C: 11",
        "Q8 Correct Key": "C: 11",
        "Q8 Mark": 1,
        "Q9 Question": "Which statement about pole vault is correct?",
        "Q9 Candidate Answer": "A: Gloves are not permitted",
        "Q9 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Mark": 0,
        "Q10 Question": "How much energy does 1 g of fat give?",
        "Q10 Candidate Answer": "C: 9.1 kcal",
        "Q10 Correct Key": "C: 9.1 kcal",
        "Q10 Mark": 1,
        "Q11 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q11 Candidate Answer": "C: To join or unite",
        "Q11 Correct Key": "C: To join or unite",
        "Q11 Mark": 1,
        "Q12 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q12 Candidate Answer": "C: 32 m/s",
        "Q12 Correct Key": "C: 32 m/s",
        "Q12 Mark": 1,
        "Q13 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q13 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q13 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q13 Mark": 1,
        "Q14 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q14 Candidate Answer": "C: 34.92°",
        "Q14 Correct Key": "C: 34.92°",
        "Q14 Mark": 1,
        "Q15 Question": "What is the diameter of the shot put circle?",
        "Q15 Candidate Answer": "B: 2.135 m",
        "Q15 Correct Key": "B: 2.135 m",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "B: Swami Vivekananda",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 1,
        "Q17 Question": "A javelin throw is valid only if:",
        "Q17 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q17 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q17 Mark": 1,
        "Q18 Question": "How high is the plasticine indicator board?",
        "Q18 Candidate Answer": "B: 7 mm",
        "Q18 Correct Key": "B: 7 mm",
        "Q18 Mark": 1,
        "Q19 Question": "In which throwing event are gloves allowed?",
        "Q19 Candidate Answer": "D: Hammer throw",
        "Q19 Correct Key": "D: Hammer throw",
        "Q19 Mark": 1,
        "Q20 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q20 Candidate Answer": "C: Pratyahara",
        "Q20 Correct Key": "C: Pratyahara",
        "Q20 Mark": 1,
        "Q21 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q21 Candidate Answer": "B: Yama",
        "Q21 Correct Key": "B: Yama",
        "Q21 Mark": 1,
        "Q22 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q22 Candidate Answer": "C: 20 m",
        "Q22 Correct Key": "C: 20 m",
        "Q22 Mark": 1,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 1,
        "Q24 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q24 Candidate Answer": "C: 3",
        "Q24 Correct Key": "C: 3",
        "Q24 Mark": 1,
        "Q25 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q25 Candidate Answer": "C: 6",
        "Q25 Correct Key": "C: 6",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's javelin?",
        "Q26 Candidate Answer": "C: 800 g",
        "Q26 Correct Key": "C: 800 g",
        "Q26 Mark": 1,
        "Q27 Question": "What is the weight of the men's shot?",
        "Q27 Candidate Answer": "C: 7.260 kg",
        "Q27 Correct Key": "C: 7.260 kg",
        "Q27 Mark": 1,
        "Q28 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q28 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q28 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q28 Mark": 1,
        "Q29 Question": "Lactose (milk sugar) is made of:",
        "Q29 Candidate Answer": "C: Glucose + Galactose",
        "Q29 Correct Key": "C: Glucose + Galactose",
        "Q29 Mark": 1,
        "Q30 Question": "What is the diameter of the discus throwing circle?",
        "Q30 Candidate Answer": "B: 2.50 m",
        "Q30 Correct Key": "B: 2.50 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 22,
      "registrationNumber": "KOP/2026/09/0023",
      "studentName": "SANDHYARANI MAHAPATRA",
      "mobileNumber": "9078990233",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:02:21 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 22,
        "Registration ID": "KOP/2026/09/0023",
        "Candidate Name": "SANDHYARANI MAHAPATRA",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "In which throwing event are gloves allowed?",
        "Q1 Candidate Answer": "D: Hammer throw",
        "Q1 Correct Key": "D: Hammer throw",
        "Q1 Mark": 1,
        "Q2 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q2 Candidate Answer": "B: To hold or maintain",
        "Q2 Correct Key": "B: To hold or maintain",
        "Q2 Mark": 1,
        "Q3 Question": "What is the official distance of a marathon?",
        "Q3 Candidate Answer": "C: 42.195 km",
        "Q3 Correct Key": "C: 42.195 km",
        "Q3 Mark": 1,
        "Q4 Question": "What is the diameter of the shot put circle?",
        "Q4 Candidate Answer": "B: 2.135 m",
        "Q4 Correct Key": "B: 2.135 m",
        "Q4 Mark": 1,
        "Q5 Question": "What is the weight of the men's javelin?",
        "Q5 Candidate Answer": "C: 800 g",
        "Q5 Correct Key": "C: 800 g",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the women's discus?",
        "Q6 Candidate Answer": "B: 1 kg",
        "Q6 Correct Key": "B: 1 kg",
        "Q6 Mark": 1,
        "Q7 Question": "What is the diameter of the discus throwing circle?",
        "Q7 Candidate Answer": "B: 2.50 m",
        "Q7 Correct Key": "B: 2.50 m",
        "Q7 Mark": 1,
        "Q8 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q8 Candidate Answer": "B: Glide method",
        "Q8 Correct Key": "B: Glide method",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's shot?",
        "Q9 Candidate Answer": "C: 7.260 kg",
        "Q9 Correct Key": "C: 7.260 kg",
        "Q9 Mark": 1,
        "Q10 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q10 Candidate Answer": "B: Scissors Jump",
        "Q10 Correct Key": "B: Scissors Jump",
        "Q10 Mark": 1,
        "Q11 Question": "What is the minimum size of the high jump landing mat?",
        "Q11 Candidate Answer": "B: 5 m × 3 m",
        "Q11 Correct Key": "B: 5 m × 3 m",
        "Q11 Mark": 1,
        "Q12 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q12 Candidate Answer": "C: Protein",
        "Q12 Correct Key": "C: Protein",
        "Q12 Mark": 1,
        "Q13 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q13 Candidate Answer": "C: 2 minutes",
        "Q13 Correct Key": "C: 2 minutes",
        "Q13 Mark": 1,
        "Q14 Question": "How much energy does 1 g of fat give?",
        "Q14 Candidate Answer": "C: 9.1 kcal",
        "Q14 Correct Key": "C: 9.1 kcal",
        "Q14 Mark": 1,
        "Q15 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q15 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q15 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q15 Mark": 1,
        "Q16 Question": "Which of the following is a Niyama?",
        "Q16 Candidate Answer": "C: Svadhyaya",
        "Q16 Correct Key": "C: Svadhyaya",
        "Q16 Mark": 1,
        "Q17 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q17 Candidate Answer": "C: 6",
        "Q17 Correct Key": "C: 6",
        "Q17 Mark": 1,
        "Q18 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q18 Candidate Answer": "B: 1:2:1",
        "Q18 Correct Key": "B: 1:2:1",
        "Q18 Mark": 1,
        "Q19 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q19 Candidate Answer": "C: 34.92°",
        "Q19 Correct Key": "C: 34.92°",
        "Q19 Mark": 1,
        "Q20 Question": "If the shot lands on one of the sector lines:",
        "Q20 Candidate Answer": "C: It is called a foul and not measured",
        "Q20 Correct Key": "C: It is called a foul and not measured",
        "Q20 Mark": 1,
        "Q21 Question": "In international competition, the pole vault landing area must be at least:",
        "Q21 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q21 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q21 Mark": 1,
        "Q22 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q22 Candidate Answer": "C: 11",
        "Q22 Correct Key": "C: 11",
        "Q22 Mark": 1,
        "Q23 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q23 Candidate Answer": "D: Fosbury Flop",
        "Q23 Correct Key": "D: Fosbury Flop",
        "Q23 Mark": 1,
        "Q24 Question": "A javelin throw is valid only if:",
        "Q24 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q24 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q24 Mark": 1,
        "Q25 Question": "Which statement about pole vault is correct?",
        "Q25 Candidate Answer": "A: Gloves are not permitted",
        "Q25 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Mark": 0,
        "Q26 Question": "Lactose (milk sugar) is made of:",
        "Q26 Candidate Answer": "C: Glucose + Galactose",
        "Q26 Correct Key": "C: Glucose + Galactose",
        "Q26 Mark": 1,
        "Q27 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q27 Candidate Answer": "C: 3",
        "Q27 Correct Key": "C: 3",
        "Q27 Mark": 1,
        "Q28 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q28 Candidate Answer": "C: Karma Yoga",
        "Q28 Correct Key": "C: Karma Yoga",
        "Q28 Mark": 1,
        "Q29 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q29 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q29 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q29 Mark": 1,
        "Q30 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q30 Candidate Answer": "C: To join or unite",
        "Q30 Correct Key": "C: To join or unite",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 23,
      "registrationNumber": "KOP/2026/09/0056",
      "studentName": "INIT PRABIN KUMAR",
      "mobileNumber": "8249384417",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:07:25 pm",
      "startTime": "18 Oct 2026, 01:15:50 pm",
      "submissionTime": "18 Oct 2026, 01:39:37 pm",
      "questionsAnswered": "30 / 30",
      "score": 29,
      "totalMarks": 30,
      "percentage": 96.7,
      "correctCount": 29,
      "wrongCount": 1,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 23,
        "Registration ID": "KOP/2026/09/0056",
        "Candidate Name": "INIT PRABIN KUMAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "29 / 30",
        "Percentage": "96.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "How high is the plasticine indicator board?",
        "Q1 Candidate Answer": "B: 7 mm",
        "Q1 Correct Key": "B: 7 mm",
        "Q1 Mark": 1,
        "Q2 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q2 Candidate Answer": "C: 32 m/s",
        "Q2 Correct Key": "C: 32 m/s",
        "Q2 Mark": 1,
        "Q3 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q3 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q3 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q3 Mark": 1,
        "Q4 Question": "What are the dimensions of the take-off board in long jump?",
        "Q4 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q4 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q4 Mark": 1,
        "Q5 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q5 Candidate Answer": "C: Pratyahara",
        "Q5 Correct Key": "C: Pratyahara",
        "Q5 Mark": 1,
        "Q6 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q6 Candidate Answer": "B: 1:2:1",
        "Q6 Correct Key": "B: 1:2:1",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q7 Candidate Answer": "B: 45 minutes",
        "Q7 Correct Key": "B: 45 minutes",
        "Q7 Mark": 1,
        "Q8 Question": "What is the javelin throwing sector angle?",
        "Q8 Candidate Answer": "A: 28.96°",
        "Q8 Correct Key": "A: 28.96°",
        "Q8 Mark": 1,
        "Q9 Question": "What is the diameter of the discus throwing circle?",
        "Q9 Candidate Answer": "B: 2.50 m",
        "Q9 Correct Key": "B: 2.50 m",
        "Q9 Mark": 1,
        "Q10 Question": "How is a triple jump measured?",
        "Q10 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q10 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q10 Mark": 1,
        "Q11 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q11 Candidate Answer": "C: 3",
        "Q11 Correct Key": "C: 3",
        "Q11 Mark": 1,
        "Q12 Question": "A javelin throw is valid only if:",
        "Q12 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q12 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q12 Mark": 1,
        "Q13 Question": "What is the weight of the men's javelin?",
        "Q13 Candidate Answer": "C: 800 g",
        "Q13 Correct Key": "C: 800 g",
        "Q13 Mark": 1,
        "Q14 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q14 Candidate Answer": "C: Polish grip",
        "Q14 Correct Key": "D: Orthodox grip",
        "Q14 Mark": 0,
        "Q15 Question": "In international competition, the pole vault landing area must be at least:",
        "Q15 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q15 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q15 Mark": 1,
        "Q16 Question": "What is the minimum size of the high jump landing mat?",
        "Q16 Candidate Answer": "B: 5 m × 3 m",
        "Q16 Correct Key": "B: 5 m × 3 m",
        "Q16 Mark": 1,
        "Q17 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q17 Candidate Answer": "B: Scissors Jump",
        "Q17 Correct Key": "B: Scissors Jump",
        "Q17 Mark": 1,
        "Q18 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q18 Candidate Answer": "B: 45 mm",
        "Q18 Correct Key": "B: 45 mm",
        "Q18 Mark": 1,
        "Q19 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q19 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Mark": 1,
        "Q20 Question": "Lactose (milk sugar) is made of:",
        "Q20 Candidate Answer": "C: Glucose + Galactose",
        "Q20 Correct Key": "C: Glucose + Galactose",
        "Q20 Mark": 1,
        "Q21 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q21 Candidate Answer": "C: To join or unite",
        "Q21 Correct Key": "C: To join or unite",
        "Q21 Mark": 1,
        "Q22 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q22 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q22 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q22 Mark": 1,
        "Q23 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q23 Candidate Answer": "B: Yama",
        "Q23 Correct Key": "B: Yama",
        "Q23 Mark": 1,
        "Q24 Question": "Which of the following is NOT a flight style in long jump?",
        "Q24 Candidate Answer": "D: Fosbury flop",
        "Q24 Correct Key": "D: Fosbury flop",
        "Q24 Mark": 1,
        "Q25 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q25 Candidate Answer": "C: Disqualified",
        "Q25 Correct Key": "C: Disqualified",
        "Q25 Mark": 1,
        "Q26 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q26 Candidate Answer": "C: Protein",
        "Q26 Correct Key": "C: Protein",
        "Q26 Mark": 1,
        "Q27 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q27 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q27 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q27 Mark": 1,
        "Q28 Question": "If the shot lands on one of the sector lines:",
        "Q28 Candidate Answer": "C: It is called a foul and not measured",
        "Q28 Correct Key": "C: It is called a foul and not measured",
        "Q28 Mark": 1,
        "Q29 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q29 Candidate Answer": "B: To hold or maintain",
        "Q29 Correct Key": "B: To hold or maintain",
        "Q29 Mark": 1,
        "Q30 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q30 Candidate Answer": "B: Swami Vivekananda",
        "Q30 Correct Key": "B: Swami Vivekananda",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 24,
      "registrationNumber": "KOP/2026/06/0154",
      "studentName": "NIRAJA RANI PRADHAN",
      "mobileNumber": "7735259118",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:10:25 pm",
      "startTime": "18 Oct 2026, 01:16:19 pm",
      "submissionTime": "18 Oct 2026, 01:43:56 pm",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 24,
        "Registration ID": "KOP/2026/06/0154",
        "Candidate Name": "NIRAJA RANI PRADHAN",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "C: Svadhyaya",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 1,
        "Q2 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q2 Candidate Answer": "C: Karma Yoga",
        "Q2 Correct Key": "C: Karma Yoga",
        "Q2 Mark": 1,
        "Q3 Question": "What is the javelin throwing sector angle?",
        "Q3 Candidate Answer": "A: 28.96°",
        "Q3 Correct Key": "A: 28.96°",
        "Q3 Mark": 1,
        "Q4 Question": "What are the dimensions of the take-off board in long jump?",
        "Q4 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q4 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q4 Mark": 1,
        "Q5 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q5 Candidate Answer": "B: 1:2:1",
        "Q5 Correct Key": "B: 1:2:1",
        "Q5 Mark": 1,
        "Q6 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q6 Candidate Answer": "D: Orthodox grip",
        "Q6 Correct Key": "D: Orthodox grip",
        "Q6 Mark": 1,
        "Q7 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q7 Candidate Answer": "C: 32 m/s",
        "Q7 Correct Key": "C: 32 m/s",
        "Q7 Mark": 1,
        "Q8 Question": "What is the minimum size of the high jump landing mat?",
        "Q8 Candidate Answer": "B: 5 m × 3 m",
        "Q8 Correct Key": "B: 5 m × 3 m",
        "Q8 Mark": 1,
        "Q9 Question": "A javelin throw is valid only if:",
        "Q9 Candidate Answer": "A: The tail touches the ground first",
        "Q9 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q9 Mark": 0,
        "Q10 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q10 Candidate Answer": "C: 11",
        "Q10 Correct Key": "C: 11",
        "Q10 Mark": 1,
        "Q11 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q11 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q11 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q11 Mark": 1,
        "Q12 Question": "What is the diameter of the discus throwing circle?",
        "Q12 Candidate Answer": "B: 2.50 m",
        "Q12 Correct Key": "B: 2.50 m",
        "Q12 Mark": 1,
        "Q13 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q13 Candidate Answer": "B: Yama",
        "Q13 Correct Key": "B: Yama",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the women's discus?",
        "Q14 Candidate Answer": "B: 1 kg",
        "Q14 Correct Key": "B: 1 kg",
        "Q14 Mark": 1,
        "Q15 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q15 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q15 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "B: Swami Vivekananda",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 1,
        "Q17 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q17 Candidate Answer": "D: Fosbury Flop",
        "Q17 Correct Key": "D: Fosbury Flop",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's javelin?",
        "Q18 Candidate Answer": "C: 800 g",
        "Q18 Correct Key": "C: 800 g",
        "Q18 Mark": 1,
        "Q19 Question": "What is the correct sequence of phases in the triple jump?",
        "Q19 Candidate Answer": "C: Hop – Step – Jump",
        "Q19 Correct Key": "C: Hop – Step – Jump",
        "Q19 Mark": 1,
        "Q20 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q20 Candidate Answer": "B: Scissors Jump",
        "Q20 Correct Key": "B: Scissors Jump",
        "Q20 Mark": 1,
        "Q21 Question": "In which throwing event are gloves allowed?",
        "Q21 Candidate Answer": "D: Hammer throw",
        "Q21 Correct Key": "D: Hammer throw",
        "Q21 Mark": 1,
        "Q22 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q22 Candidate Answer": "C: 6",
        "Q22 Correct Key": "C: 6",
        "Q22 Mark": 1,
        "Q23 Question": "In international competition, the pole vault landing area must be at least:",
        "Q23 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q23 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q23 Mark": 1,
        "Q24 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q24 Candidate Answer": "B: Glide method",
        "Q24 Correct Key": "B: Glide method",
        "Q24 Mark": 1,
        "Q25 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q25 Candidate Answer": "C: 20 m",
        "Q25 Correct Key": "C: 20 m",
        "Q25 Mark": 1,
        "Q26 Question": "Lactose (milk sugar) is made of:",
        "Q26 Candidate Answer": "C: Glucose + Galactose",
        "Q26 Correct Key": "C: Glucose + Galactose",
        "Q26 Mark": 1,
        "Q27 Question": "How is a triple jump measured?",
        "Q27 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q27 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q27 Mark": 1,
        "Q28 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q28 Candidate Answer": "C: 50 mm",
        "Q28 Correct Key": "B: 45 mm",
        "Q28 Mark": 0,
        "Q29 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q29 Candidate Answer": "C: 34.92°",
        "Q29 Correct Key": "C: 34.92°",
        "Q29 Mark": 1,
        "Q30 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q30 Candidate Answer": "C: Protein",
        "Q30 Correct Key": "C: Protein",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 25,
      "registrationNumber": "KOP/2026/06/0210",
      "studentName": "BIBHUTI BHOOSAN PADHAN",
      "mobileNumber": "9692861909",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:04:27 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 25,
        "Registration ID": "KOP/2026/06/0210",
        "Candidate Name": "BIBHUTI BHOOSAN PADHAN",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "A: An athlete is warned",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 0,
        "Q2 Question": "What is the javelin throwing sector angle?",
        "Q2 Candidate Answer": "A: 28.96°",
        "Q2 Correct Key": "A: 28.96°",
        "Q2 Mark": 1,
        "Q3 Question": "Which statement about pole vault is correct?",
        "Q3 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q3 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q3 Mark": 1,
        "Q4 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q4 Candidate Answer": "C: 6",
        "Q4 Correct Key": "C: 6",
        "Q4 Mark": 1,
        "Q5 Question": "Which of the following is NOT a flight style in long jump?",
        "Q5 Candidate Answer": "D: Fosbury flop",
        "Q5 Correct Key": "D: Fosbury flop",
        "Q5 Mark": 1,
        "Q6 Question": "What is the diameter of the discus throwing circle?",
        "Q6 Candidate Answer": "B: 2.50 m",
        "Q6 Correct Key": "B: 2.50 m",
        "Q6 Mark": 1,
        "Q7 Question": "What is the correct sequence of phases in the triple jump?",
        "Q7 Candidate Answer": "C: Hop – Step – Jump",
        "Q7 Correct Key": "C: Hop – Step – Jump",
        "Q7 Mark": 1,
        "Q8 Question": "In international competition, the pole vault landing area must be at least:",
        "Q8 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q8 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q8 Mark": 1,
        "Q9 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q9 Candidate Answer": "B: Swami Vivekananda",
        "Q9 Correct Key": "B: Swami Vivekananda",
        "Q9 Mark": 1,
        "Q10 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q10 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Mark": 1,
        "Q11 Question": "Which of the following is a Niyama?",
        "Q11 Candidate Answer": "C: Svadhyaya",
        "Q11 Correct Key": "C: Svadhyaya",
        "Q11 Mark": 1,
        "Q12 Question": "Lactose (milk sugar) is made of:",
        "Q12 Candidate Answer": "C: Glucose + Galactose",
        "Q12 Correct Key": "C: Glucose + Galactose",
        "Q12 Mark": 1,
        "Q13 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q13 Candidate Answer": "B: 1:2:1",
        "Q13 Correct Key": "B: 1:2:1",
        "Q13 Mark": 1,
        "Q14 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q14 Candidate Answer": "D: Fosbury Flop",
        "Q14 Correct Key": "D: Fosbury Flop",
        "Q14 Mark": 1,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 1,
        "Q16 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q16 Candidate Answer": "C: 32 m/s",
        "Q16 Correct Key": "C: 32 m/s",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the shot put circle?",
        "Q17 Candidate Answer": "B: 2.135 m",
        "Q17 Correct Key": "B: 2.135 m",
        "Q17 Mark": 1,
        "Q18 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q18 Candidate Answer": "C: 20 m",
        "Q18 Correct Key": "C: 20 m",
        "Q18 Mark": 1,
        "Q19 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q19 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Mark": 1,
        "Q20 Question": "What is the minimum size of the high jump landing mat?",
        "Q20 Candidate Answer": "B: 5 m × 3 m",
        "Q20 Correct Key": "B: 5 m × 3 m",
        "Q20 Mark": 1,
        "Q21 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q21 Candidate Answer": "C: Asana",
        "Q21 Correct Key": "B: Yama",
        "Q21 Mark": 0,
        "Q22 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q22 Candidate Answer": "C: 11",
        "Q22 Correct Key": "C: 11",
        "Q22 Mark": 1,
        "Q23 Question": "A javelin throw is valid only if:",
        "Q23 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q23 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q23 Mark": 1,
        "Q24 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q24 Candidate Answer": "C: To join or unite",
        "Q24 Correct Key": "C: To join or unite",
        "Q24 Mark": 1,
        "Q25 Question": "What is the weight of the men's shot?",
        "Q25 Candidate Answer": "C: 7.260 kg",
        "Q25 Correct Key": "C: 7.260 kg",
        "Q25 Mark": 1,
        "Q26 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q26 Candidate Answer": "C: Protein",
        "Q26 Correct Key": "C: Protein",
        "Q26 Mark": 1,
        "Q27 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q27 Candidate Answer": "B: 45 minutes",
        "Q27 Correct Key": "B: 45 minutes",
        "Q27 Mark": 1,
        "Q28 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q28 Candidate Answer": "C: 2 minutes",
        "Q28 Correct Key": "C: 2 minutes",
        "Q28 Mark": 1,
        "Q29 Question": "How much energy does 1 g of fat give?",
        "Q29 Candidate Answer": "C: 9.1 kcal",
        "Q29 Correct Key": "C: 9.1 kcal",
        "Q29 Mark": 1,
        "Q30 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q30 Candidate Answer": "C: Karma Yoga",
        "Q30 Correct Key": "C: Karma Yoga",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 26,
      "registrationNumber": "KOP/2026/06/0227",
      "studentName": "SUVAM SAHOO",
      "mobileNumber": "7854904120",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:03:06 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 26,
        "Registration ID": "KOP/2026/06/0227",
        "Candidate Name": "SUVAM SAHOO",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In international competition, the pole vault landing area must be at least:",
        "Q1 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q1 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q1 Mark": 1,
        "Q2 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q2 Candidate Answer": "C: Karma Yoga",
        "Q2 Correct Key": "C: Karma Yoga",
        "Q2 Mark": 1,
        "Q3 Question": "In track and field, a green card is shown when:",
        "Q3 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q3 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q3 Mark": 1,
        "Q4 Question": "How is a triple jump measured?",
        "Q4 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Mark": 1,
        "Q5 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q5 Candidate Answer": "C: 34.92°",
        "Q5 Correct Key": "C: 34.92°",
        "Q5 Mark": 1,
        "Q6 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q6 Candidate Answer": "C: Pratyahara",
        "Q6 Correct Key": "C: Pratyahara",
        "Q6 Mark": 1,
        "Q7 Question": "Which of the following is a Niyama?",
        "Q7 Candidate Answer": "C: Svadhyaya",
        "Q7 Correct Key": "C: Svadhyaya",
        "Q7 Mark": 1,
        "Q8 Question": "How much energy does 1 g of fat give?",
        "Q8 Candidate Answer": "C: 9.1 kcal",
        "Q8 Correct Key": "C: 9.1 kcal",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's javelin?",
        "Q9 Candidate Answer": "C: 800 g",
        "Q9 Correct Key": "C: 800 g",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's shot?",
        "Q10 Candidate Answer": "C: 7.260 kg",
        "Q10 Correct Key": "C: 7.260 kg",
        "Q10 Mark": 1,
        "Q11 Question": "Which statement about pole vault is correct?",
        "Q11 Candidate Answer": "A: Gloves are not permitted",
        "Q11 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q11 Mark": 0,
        "Q12 Question": "What are the dimensions of the take-off board in long jump?",
        "Q12 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q12 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q12 Mark": 1,
        "Q13 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q13 Candidate Answer": "B: 45 mm",
        "Q13 Correct Key": "B: 45 mm",
        "Q13 Mark": 1,
        "Q14 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q14 Candidate Answer": "B: Glide method",
        "Q14 Correct Key": "B: Glide method",
        "Q14 Mark": 1,
        "Q15 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q15 Candidate Answer": "A: 4",
        "Q15 Correct Key": "C: 6",
        "Q15 Mark": 0,
        "Q16 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q16 Candidate Answer": "C: To join or unite",
        "Q16 Correct Key": "C: To join or unite",
        "Q16 Mark": 1,
        "Q17 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q17 Candidate Answer": "C: 2 minutes",
        "Q17 Correct Key": "C: 2 minutes",
        "Q17 Mark": 1,
        "Q18 Question": "What is the correct sequence of phases in the triple jump?",
        "Q18 Candidate Answer": "C: Hop – Step – Jump",
        "Q18 Correct Key": "C: Hop – Step – Jump",
        "Q18 Mark": 1,
        "Q19 Question": "What is the official distance of a marathon?",
        "Q19 Candidate Answer": "C: 42.195 km",
        "Q19 Correct Key": "C: 42.195 km",
        "Q19 Mark": 1,
        "Q20 Question": "What is the diameter of the discus throwing circle?",
        "Q20 Candidate Answer": "B: 2.50 m",
        "Q20 Correct Key": "B: 2.50 m",
        "Q20 Mark": 1,
        "Q21 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q21 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q21 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q21 Mark": 1,
        "Q22 Question": "Which of the following is NOT a flight style in long jump?",
        "Q22 Candidate Answer": "D: Fosbury flop",
        "Q22 Correct Key": "D: Fosbury flop",
        "Q22 Mark": 1,
        "Q23 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q23 Candidate Answer": "C: 3",
        "Q23 Correct Key": "C: 3",
        "Q23 Mark": 1,
        "Q24 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q24 Candidate Answer": "B: Comparing their second-best performances",
        "Q24 Correct Key": "B: Comparing their second-best performances",
        "Q24 Mark": 1,
        "Q25 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q25 Candidate Answer": "C: 11",
        "Q25 Correct Key": "C: 11",
        "Q25 Mark": 1,
        "Q26 Question": "How high is the plasticine indicator board?",
        "Q26 Candidate Answer": "B: 7 mm",
        "Q26 Correct Key": "B: 7 mm",
        "Q26 Mark": 1,
        "Q27 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q27 Candidate Answer": "B: 1:2:1",
        "Q27 Correct Key": "B: 1:2:1",
        "Q27 Mark": 1,
        "Q28 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q28 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q28 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q28 Mark": 1,
        "Q29 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q29 Candidate Answer": "B: Scissors Jump",
        "Q29 Correct Key": "B: Scissors Jump",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 27,
      "registrationNumber": "KOP/2026/08/0526",
      "studentName": "KOUTULYA CHHURA",
      "mobileNumber": "9348506899",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:09 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 27,
        "Registration ID": "KOP/2026/08/0526",
        "Candidate Name": "KOUTULYA CHHURA",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q1 Candidate Answer": "B: Swami Vivekananda",
        "Q1 Correct Key": "B: Swami Vivekananda",
        "Q1 Mark": 1,
        "Q2 Question": "In international competition, the pole vault landing area must be at least:",
        "Q2 Candidate Answer": "A: 5 m × 5 m × 0.8 m",
        "Q2 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q2 Mark": 0,
        "Q3 Question": "What is the correct sequence of phases in the triple jump?",
        "Q3 Candidate Answer": "C: Hop – Step – Jump",
        "Q3 Correct Key": "C: Hop – Step – Jump",
        "Q3 Mark": 1,
        "Q4 Question": "What is the weight of the women's discus?",
        "Q4 Candidate Answer": "B: 1 kg",
        "Q4 Correct Key": "B: 1 kg",
        "Q4 Mark": 1,
        "Q5 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q5 Candidate Answer": "C: Disqualified",
        "Q5 Correct Key": "C: Disqualified",
        "Q5 Mark": 1,
        "Q6 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q6 Candidate Answer": "D: Orthodox grip",
        "Q6 Correct Key": "D: Orthodox grip",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q7 Candidate Answer": "C: 11",
        "Q7 Correct Key": "C: 11",
        "Q7 Mark": 1,
        "Q8 Question": "Lactose (milk sugar) is made of:",
        "Q8 Candidate Answer": "C: Glucose + Galactose",
        "Q8 Correct Key": "C: Glucose + Galactose",
        "Q8 Mark": 1,
        "Q9 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q9 Candidate Answer": "C: 32 m/s",
        "Q9 Correct Key": "C: 32 m/s",
        "Q9 Mark": 1,
        "Q10 Question": "In which throwing event are gloves allowed?",
        "Q10 Candidate Answer": "D: Hammer throw",
        "Q10 Correct Key": "D: Hammer throw",
        "Q10 Mark": 1,
        "Q11 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q11 Candidate Answer": "C: 3",
        "Q11 Correct Key": "C: 3",
        "Q11 Mark": 1,
        "Q12 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q12 Candidate Answer": "B: Yama",
        "Q12 Correct Key": "B: Yama",
        "Q12 Mark": 1,
        "Q13 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q13 Candidate Answer": "B: 45 minutes",
        "Q13 Correct Key": "B: 45 minutes",
        "Q13 Mark": 1,
        "Q14 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q14 Candidate Answer": "C: 34.92°",
        "Q14 Correct Key": "C: 34.92°",
        "Q14 Mark": 1,
        "Q15 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q15 Candidate Answer": "B: To hold or maintain",
        "Q15 Correct Key": "B: To hold or maintain",
        "Q15 Mark": 1,
        "Q16 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q16 Candidate Answer": "D: Fosbury Flop",
        "Q16 Correct Key": "D: Fosbury Flop",
        "Q16 Mark": 1,
        "Q17 Question": "How much energy does 1 g of fat give?",
        "Q17 Candidate Answer": "C: 9.1 kcal",
        "Q17 Correct Key": "C: 9.1 kcal",
        "Q17 Mark": 1,
        "Q18 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q18 Candidate Answer": "A: Laya Yoga",
        "Q18 Correct Key": "A: Laya Yoga",
        "Q18 Mark": 1,
        "Q19 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q19 Candidate Answer": "C: Karma Yoga",
        "Q19 Correct Key": "C: Karma Yoga",
        "Q19 Mark": 1,
        "Q20 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q20 Candidate Answer": "B: Scissors Jump",
        "Q20 Correct Key": "B: Scissors Jump",
        "Q20 Mark": 1,
        "Q21 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q21 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q21 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q21 Mark": 1,
        "Q22 Question": "In track and field, a green card is shown when:",
        "Q22 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q22 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q22 Mark": 1,
        "Q23 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q23 Candidate Answer": "C: To join or unite",
        "Q23 Correct Key": "C: To join or unite",
        "Q23 Mark": 1,
        "Q24 Question": "What is the javelin throwing sector angle?",
        "Q24 Candidate Answer": "A: 28.96°",
        "Q24 Correct Key": "A: 28.96°",
        "Q24 Mark": 1,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's shot?",
        "Q26 Candidate Answer": "C: 7.260 kg",
        "Q26 Correct Key": "C: 7.260 kg",
        "Q26 Mark": 1,
        "Q27 Question": "What is the diameter of the discus throwing circle?",
        "Q27 Candidate Answer": "B: 2.50 m",
        "Q27 Correct Key": "B: 2.50 m",
        "Q27 Mark": 1,
        "Q28 Question": "How is a triple jump measured?",
        "Q28 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q28 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q28 Mark": 1,
        "Q29 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q29 Candidate Answer": "D: 3 minutes",
        "Q29 Correct Key": "C: 2 minutes",
        "Q29 Mark": 0,
        "Q30 Question": "Which of the following is a Niyama?",
        "Q30 Candidate Answer": "C: Svadhyaya",
        "Q30 Correct Key": "C: Svadhyaya",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 28,
      "registrationNumber": "KOP/2026/08/0534",
      "studentName": "NANDINEE DANDASENA",
      "mobileNumber": "9556281949",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:09 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 28,
        "Registration ID": "KOP/2026/08/0534",
        "Candidate Name": "NANDINEE DANDASENA",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "D: Fosbury flop",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 1,
        "Q2 Question": "What is the weight of the women's discus?",
        "Q2 Candidate Answer": "B: 1 kg",
        "Q2 Correct Key": "B: 1 kg",
        "Q2 Mark": 1,
        "Q3 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q3 Candidate Answer": "D: Averaging all throws",
        "Q3 Correct Key": "B: Comparing their second-best performances",
        "Q3 Mark": 0,
        "Q4 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q4 Candidate Answer": "C: To join or unite",
        "Q4 Correct Key": "C: To join or unite",
        "Q4 Mark": 1,
        "Q5 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q5 Candidate Answer": "C: 6",
        "Q5 Correct Key": "C: 6",
        "Q5 Mark": 1,
        "Q6 Question": "In which throwing event are gloves allowed?",
        "Q6 Candidate Answer": "D: Hammer throw",
        "Q6 Correct Key": "D: Hammer throw",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "C: 42.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 1,
        "Q8 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q8 Candidate Answer": "B: Glide method",
        "Q8 Correct Key": "B: Glide method",
        "Q8 Mark": 1,
        "Q9 Question": "A javelin throw is valid only if:",
        "Q9 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q9 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q9 Mark": 1,
        "Q10 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q10 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q10 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q10 Mark": 1,
        "Q11 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q11 Candidate Answer": "B: Swami Vivekananda",
        "Q11 Correct Key": "B: Swami Vivekananda",
        "Q11 Mark": 1,
        "Q12 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q12 Candidate Answer": "B: 45 mm",
        "Q12 Correct Key": "B: 45 mm",
        "Q12 Mark": 1,
        "Q13 Question": "What is the javelin throwing sector angle?",
        "Q13 Candidate Answer": "A: 28.96°",
        "Q13 Correct Key": "A: 28.96°",
        "Q13 Mark": 1,
        "Q14 Question": "How is a triple jump measured?",
        "Q14 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q14 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q14 Mark": 1,
        "Q15 Question": "What is the correct sequence of phases in the triple jump?",
        "Q15 Candidate Answer": "C: Hop – Step – Jump",
        "Q15 Correct Key": "C: Hop – Step – Jump",
        "Q15 Mark": 1,
        "Q16 Question": "How high is the plasticine indicator board?",
        "Q16 Candidate Answer": "B: 7 mm",
        "Q16 Correct Key": "B: 7 mm",
        "Q16 Mark": 1,
        "Q17 Question": "In international competition, the pole vault landing area must be at least:",
        "Q17 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q17 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q17 Mark": 1,
        "Q18 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q18 Candidate Answer": "B: Scissors Jump",
        "Q18 Correct Key": "B: Scissors Jump",
        "Q18 Mark": 1,
        "Q19 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q19 Candidate Answer": "C: Disqualified",
        "Q19 Correct Key": "C: Disqualified",
        "Q19 Mark": 1,
        "Q20 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q20 Candidate Answer": "C: 20 m",
        "Q20 Correct Key": "C: 20 m",
        "Q20 Mark": 1,
        "Q21 Question": "Which statement about pole vault is correct?",
        "Q21 Candidate Answer": "A: Gloves are not permitted",
        "Q21 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q21 Mark": 0,
        "Q22 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q22 Candidate Answer": "B: Yama",
        "Q22 Correct Key": "B: Yama",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q23 Candidate Answer": "B: 45 minutes",
        "Q23 Correct Key": "B: 45 minutes",
        "Q23 Mark": 1,
        "Q24 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q24 Candidate Answer": "C: Karma Yoga",
        "Q24 Correct Key": "C: Karma Yoga",
        "Q24 Mark": 1,
        "Q25 Question": "How much energy does 1 g of fat give?",
        "Q25 Candidate Answer": "C: 9.1 kcal",
        "Q25 Correct Key": "C: 9.1 kcal",
        "Q25 Mark": 1,
        "Q26 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q26 Candidate Answer": "D: Fosbury Flop",
        "Q26 Correct Key": "D: Fosbury Flop",
        "Q26 Mark": 1,
        "Q27 Question": "What is the diameter of the shot put circle?",
        "Q27 Candidate Answer": "B: 2.135 m",
        "Q27 Correct Key": "B: 2.135 m",
        "Q27 Mark": 1,
        "Q28 Question": "If the shot lands on one of the sector lines:",
        "Q28 Candidate Answer": "C: It is called a foul and not measured",
        "Q28 Correct Key": "C: It is called a foul and not measured",
        "Q28 Mark": 1,
        "Q29 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q29 Candidate Answer": "C: Protein",
        "Q29 Correct Key": "C: Protein",
        "Q29 Mark": 1,
        "Q30 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q30 Candidate Answer": "B: 1:2:1",
        "Q30 Correct Key": "B: 1:2:1",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 29,
      "registrationNumber": "KOP/2026/09/0291",
      "studentName": "HARISH HANS",
      "mobileNumber": "7205785085",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:07 pm",
      "startTime": "18 Oct 2026, 01:16:20 pm",
      "submissionTime": "18 Oct 2026, 01:29:50 pm",
      "questionsAnswered": "30 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 2,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 29,
        "Registration ID": "KOP/2026/09/0291",
        "Candidate Name": "HARISH HANS",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "How is a triple jump measured?",
        "Q1 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q1 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q1 Mark": 1,
        "Q2 Question": "Which of the following is a Niyama?",
        "Q2 Candidate Answer": "C: Svadhyaya",
        "Q2 Correct Key": "C: Svadhyaya",
        "Q2 Mark": 1,
        "Q3 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q3 Candidate Answer": "C: 32 m/s",
        "Q3 Correct Key": "C: 32 m/s",
        "Q3 Mark": 1,
        "Q4 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q4 Candidate Answer": "B: 1:2:1",
        "Q4 Correct Key": "B: 1:2:1",
        "Q4 Mark": 1,
        "Q5 Question": "A javelin throw is valid only if:",
        "Q5 Candidate Answer": "A: The tail touches the ground first",
        "Q5 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q5 Mark": 0,
        "Q6 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q6 Candidate Answer": "B: 45 mm",
        "Q6 Correct Key": "B: 45 mm",
        "Q6 Mark": 1,
        "Q7 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q7 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Mark": 1,
        "Q8 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q8 Candidate Answer": "C: 11",
        "Q8 Correct Key": "C: 11",
        "Q8 Mark": 1,
        "Q9 Question": "If the shot lands on one of the sector lines:",
        "Q9 Candidate Answer": "C: It is called a foul and not measured",
        "Q9 Correct Key": "C: It is called a foul and not measured",
        "Q9 Mark": 1,
        "Q10 Question": "How much energy does 1 g of fat give?",
        "Q10 Candidate Answer": "C: 9.1 kcal",
        "Q10 Correct Key": "C: 9.1 kcal",
        "Q10 Mark": 1,
        "Q11 Question": "What is the javelin throwing sector angle?",
        "Q11 Candidate Answer": "A: 28.96°",
        "Q11 Correct Key": "A: 28.96°",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the men's javelin?",
        "Q12 Candidate Answer": "C: 800 g",
        "Q12 Correct Key": "C: 800 g",
        "Q12 Mark": 1,
        "Q13 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q13 Candidate Answer": "D: Fosbury Flop",
        "Q13 Correct Key": "D: Fosbury Flop",
        "Q13 Mark": 1,
        "Q14 Question": "What is the correct sequence of phases in the triple jump?",
        "Q14 Candidate Answer": "C: Hop – Step – Jump",
        "Q14 Correct Key": "C: Hop – Step – Jump",
        "Q14 Mark": 1,
        "Q15 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q15 Candidate Answer": "C: Disqualified",
        "Q15 Correct Key": "C: Disqualified",
        "Q15 Mark": 1,
        "Q16 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q16 Candidate Answer": "C: Polish grip",
        "Q16 Correct Key": "D: Orthodox grip",
        "Q16 Mark": 0,
        "Q17 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q17 Candidate Answer": "B: Scissors Jump",
        "Q17 Correct Key": "B: Scissors Jump",
        "Q17 Mark": 1,
        "Q18 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q18 Candidate Answer": "B: Glide method",
        "Q18 Correct Key": "B: Glide method",
        "Q18 Mark": 1,
        "Q19 Question": "In which throwing event are gloves allowed?",
        "Q19 Candidate Answer": "D: Hammer throw",
        "Q19 Correct Key": "D: Hammer throw",
        "Q19 Mark": 1,
        "Q20 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q20 Candidate Answer": "C: 3",
        "Q20 Correct Key": "C: 3",
        "Q20 Mark": 1,
        "Q21 Question": "Which of the following is NOT a flight style in long jump?",
        "Q21 Candidate Answer": "D: Fosbury flop",
        "Q21 Correct Key": "D: Fosbury flop",
        "Q21 Mark": 1,
        "Q22 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q22 Candidate Answer": "C: 6",
        "Q22 Correct Key": "C: 6",
        "Q22 Mark": 1,
        "Q23 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q23 Candidate Answer": "C: 20 m",
        "Q23 Correct Key": "C: 20 m",
        "Q23 Mark": 1,
        "Q24 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q24 Candidate Answer": "C: 34.92°",
        "Q24 Correct Key": "C: 34.92°",
        "Q24 Mark": 1,
        "Q25 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q25 Candidate Answer": "B: 45 minutes",
        "Q25 Correct Key": "B: 45 minutes",
        "Q25 Mark": 1,
        "Q26 Question": "In international competition, the pole vault landing area must be at least:",
        "Q26 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q26 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q26 Mark": 1,
        "Q27 Question": "What is the diameter of the shot put circle?",
        "Q27 Candidate Answer": "B: 2.135 m",
        "Q27 Correct Key": "B: 2.135 m",
        "Q27 Mark": 1,
        "Q28 Question": "In track and field, a green card is shown when:",
        "Q28 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q28 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q28 Mark": 1,
        "Q29 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q29 Candidate Answer": "A: Laya Yoga",
        "Q29 Correct Key": "A: Laya Yoga",
        "Q29 Mark": 1,
        "Q30 Question": "What are the dimensions of the take-off board in long jump?",
        "Q30 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 30,
      "registrationNumber": "KOP/2026/06/0241",
      "studentName": "SAGAR MAHANKUDA",
      "mobileNumber": "7735286162",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:10 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "29 / 30",
      "score": 28,
      "totalMarks": 30,
      "percentage": 93.3,
      "correctCount": 28,
      "wrongCount": 1,
      "unattemptedCount": 1,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 30,
        "Registration ID": "KOP/2026/06/0241",
        "Candidate Name": "SAGAR MAHANKUDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "28 / 30",
        "Percentage": "93.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q1 Candidate Answer": "C: Pratyahara",
        "Q1 Correct Key": "C: Pratyahara",
        "Q1 Mark": 1,
        "Q2 Question": "What is the minimum size of the high jump landing mat?",
        "Q2 Candidate Answer": "B: 5 m × 3 m",
        "Q2 Correct Key": "B: 5 m × 3 m",
        "Q2 Mark": 1,
        "Q3 Question": "In track and field, a green card is shown when:",
        "Q3 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q3 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q3 Mark": 1,
        "Q4 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q4 Candidate Answer": "C: 6",
        "Q4 Correct Key": "C: 6",
        "Q4 Mark": 1,
        "Q5 Question": "What are the dimensions of the take-off board in long jump?",
        "Q5 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Mark": 1,
        "Q6 Question": "What is the correct sequence of phases in the triple jump?",
        "Q6 Candidate Answer": "C: Hop – Step – Jump",
        "Q6 Correct Key": "C: Hop – Step – Jump",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "C: 42.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 1,
        "Q8 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q8 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q8 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q8 Mark": 1,
        "Q9 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q9 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q9 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q9 Mark": 1,
        "Q10 Question": "A javelin throw is valid only if:",
        "Q10 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q10 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q10 Mark": 1,
        "Q11 Question": "How high is the plasticine indicator board?",
        "Q11 Candidate Answer": "B: 7 mm",
        "Q11 Correct Key": "B: 7 mm",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the women's discus?",
        "Q12 Candidate Answer": "B: 1 kg",
        "Q12 Correct Key": "B: 1 kg",
        "Q12 Mark": 1,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "B: Scissors Jump",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 1,
        "Q14 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q14 Candidate Answer": "C: 32 m/s",
        "Q14 Correct Key": "C: 32 m/s",
        "Q14 Mark": 1,
        "Q15 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q15 Candidate Answer": "B: 1:2:1",
        "Q15 Correct Key": "B: 1:2:1",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the discus throwing circle?",
        "Q16 Candidate Answer": "B: 2.50 m",
        "Q16 Correct Key": "B: 2.50 m",
        "Q16 Mark": 1,
        "Q17 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q17 Candidate Answer": "C: Disqualified",
        "Q17 Correct Key": "C: Disqualified",
        "Q17 Mark": 1,
        "Q18 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q18 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q18 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q18 Mark": 1,
        "Q19 Question": "What is the weight of the men's shot?",
        "Q19 Candidate Answer": "C: 7.260 kg",
        "Q19 Correct Key": "C: 7.260 kg",
        "Q19 Mark": 1,
        "Q20 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q20 Candidate Answer": "B: 45 mm",
        "Q20 Correct Key": "B: 45 mm",
        "Q20 Mark": 1,
        "Q21 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q21 Candidate Answer": "B: 45 minutes",
        "Q21 Correct Key": "B: 45 minutes",
        "Q21 Mark": 1,
        "Q22 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q22 Candidate Answer": "C: 20 m",
        "Q22 Correct Key": "C: 20 m",
        "Q22 Mark": 1,
        "Q23 Question": "Which of the following is NOT a flight style in long jump?",
        "Q23 Candidate Answer": "D: Fosbury flop",
        "Q23 Correct Key": "D: Fosbury flop",
        "Q23 Mark": 1,
        "Q24 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q24 Candidate Answer": "C: To join or unite",
        "Q24 Correct Key": "C: To join or unite",
        "Q24 Mark": 1,
        "Q25 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q25 Candidate Answer": "A: Laya Yoga",
        "Q25 Correct Key": "A: Laya Yoga",
        "Q25 Mark": 1,
        "Q26 Question": "What is the javelin throwing sector angle?",
        "Q26 Candidate Answer": "A: 28.96°",
        "Q26 Correct Key": "A: 28.96°",
        "Q26 Mark": 1,
        "Q27 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q27 Candidate Answer": "C: 11",
        "Q27 Correct Key": "C: 11",
        "Q27 Mark": 1,
        "Q28 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "D: Fosbury Flop",
        "Q28 Mark": 0,
        "Q29 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q29 Candidate Answer": "A: Maharishi Patanjali",
        "Q29 Correct Key": "B: Swami Vivekananda",
        "Q29 Mark": 0,
        "Q30 Question": "Which statement about pole vault is correct?",
        "Q30 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q30 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 31,
      "registrationNumber": "HD/KOP/2026/0721",
      "studentName": "PAPAN MEHER",
      "mobileNumber": "8658869922",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:14 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 31,
        "Registration ID": "HD/KOP/2026/0721",
        "Candidate Name": "PAPAN MEHER",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q1 Candidate Answer": "C: Pratyahara",
        "Q1 Correct Key": "C: Pratyahara",
        "Q1 Mark": 1,
        "Q2 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q2 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q2 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q2 Mark": 1,
        "Q3 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q3 Candidate Answer": "B: Scissors Jump",
        "Q3 Correct Key": "B: Scissors Jump",
        "Q3 Mark": 1,
        "Q4 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q4 Candidate Answer": "C: Disqualified",
        "Q4 Correct Key": "C: Disqualified",
        "Q4 Mark": 1,
        "Q5 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q5 Candidate Answer": "C: 2 minutes",
        "Q5 Correct Key": "C: 2 minutes",
        "Q5 Mark": 1,
        "Q6 Question": "What is the official distance of a marathon?",
        "Q6 Candidate Answer": "C: 42.195 km",
        "Q6 Correct Key": "C: 42.195 km",
        "Q6 Mark": 1,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q8 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Mark": 1,
        "Q9 Question": "What is the javelin throwing sector angle?",
        "Q9 Candidate Answer": "A: 28.96°",
        "Q9 Correct Key": "A: 28.96°",
        "Q9 Mark": 1,
        "Q10 Question": "Which of the following is a Niyama?",
        "Q10 Candidate Answer": "D: Aparigraha",
        "Q10 Correct Key": "C: Svadhyaya",
        "Q10 Mark": 0,
        "Q11 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q11 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q11 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q11 Mark": 1,
        "Q12 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q12 Candidate Answer": "B: Swami Vivekananda",
        "Q12 Correct Key": "B: Swami Vivekananda",
        "Q12 Mark": 1,
        "Q13 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q13 Candidate Answer": "B: To hold or maintain",
        "Q13 Correct Key": "B: To hold or maintain",
        "Q13 Mark": 1,
        "Q14 Question": "In international competition, the pole vault landing area must be at least:",
        "Q14 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q14 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q14 Mark": 1,
        "Q15 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q15 Candidate Answer": "C: Protein",
        "Q15 Correct Key": "C: Protein",
        "Q15 Mark": 1,
        "Q16 Question": "What is the weight of the men's shot?",
        "Q16 Candidate Answer": "C: 7.260 kg",
        "Q16 Correct Key": "C: 7.260 kg",
        "Q16 Mark": 1,
        "Q17 Question": "How much energy does 1 g of fat give?",
        "Q17 Candidate Answer": "C: 9.1 kcal",
        "Q17 Correct Key": "C: 9.1 kcal",
        "Q17 Mark": 1,
        "Q18 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q18 Candidate Answer": "C: 6",
        "Q18 Correct Key": "C: 6",
        "Q18 Mark": 1,
        "Q19 Question": "Lactose (milk sugar) is made of:",
        "Q19 Candidate Answer": "C: Glucose + Galactose",
        "Q19 Correct Key": "C: Glucose + Galactose",
        "Q19 Mark": 1,
        "Q20 Question": "If the shot lands on one of the sector lines:",
        "Q20 Candidate Answer": "C: It is called a foul and not measured",
        "Q20 Correct Key": "C: It is called a foul and not measured",
        "Q20 Mark": 1,
        "Q21 Question": "In which throwing event are gloves allowed?",
        "Q21 Candidate Answer": "D: Hammer throw",
        "Q21 Correct Key": "D: Hammer throw",
        "Q21 Mark": 1,
        "Q22 Question": "Which statement about pole vault is correct?",
        "Q22 Candidate Answer": "A: Gloves are not permitted",
        "Q22 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q22 Mark": 0,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 1,
        "Q24 Question": "What is the correct sequence of phases in the triple jump?",
        "Q24 Candidate Answer": "C: Hop – Step – Jump",
        "Q24 Correct Key": "C: Hop – Step – Jump",
        "Q24 Mark": 1,
        "Q25 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q25 Candidate Answer": "B: Glide method",
        "Q25 Correct Key": "B: Glide method",
        "Q25 Mark": 1,
        "Q26 Question": "What is the diameter of the discus throwing circle?",
        "Q26 Candidate Answer": "B: 2.50 m",
        "Q26 Correct Key": "B: 2.50 m",
        "Q26 Mark": 1,
        "Q27 Question": "What is the minimum size of the high jump landing mat?",
        "Q27 Candidate Answer": "B: 5 m × 3 m",
        "Q27 Correct Key": "B: 5 m × 3 m",
        "Q27 Mark": 1,
        "Q28 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q28 Candidate Answer": "C: 34.92°",
        "Q28 Correct Key": "C: 34.92°",
        "Q28 Mark": 1,
        "Q29 Question": "In track and field, a green card is shown when:",
        "Q29 Candidate Answer": "D: An athlete leaves the track voluntarily",
        "Q29 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q29 Mark": 0,
        "Q30 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q30 Candidate Answer": "B: 45 minutes",
        "Q30 Correct Key": "B: 45 minutes",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 32,
      "registrationNumber": "KOP/2026/06/0142",
      "studentName": "PRIYARANJAN DASH",
      "mobileNumber": "8018040275",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:07:16 pm",
      "startTime": "18 Oct 2026, 01:15:53 pm",
      "submissionTime": "18 Oct 2026, 01:54:39 pm",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 32,
        "Registration ID": "KOP/2026/06/0142",
        "Candidate Name": "PRIYARANJAN DASH",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q1 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Mark": 1,
        "Q2 Question": "In track and field, a green card is shown when:",
        "Q2 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q2 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q2 Mark": 1,
        "Q3 Question": "How is a triple jump measured?",
        "Q3 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q3 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q3 Mark": 1,
        "Q4 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q4 Candidate Answer": "B: Comparing their second-best performances",
        "Q4 Correct Key": "B: Comparing their second-best performances",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "C: 11",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 1,
        "Q6 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q6 Candidate Answer": "B: Glide method",
        "Q6 Correct Key": "B: Glide method",
        "Q6 Mark": 1,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q8 Candidate Answer": "C: 3",
        "Q8 Correct Key": "C: 3",
        "Q8 Mark": 1,
        "Q9 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q9 Candidate Answer": "A: Laya Yoga",
        "Q9 Correct Key": "A: Laya Yoga",
        "Q9 Mark": 1,
        "Q10 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q10 Candidate Answer": "C: Karma Yoga",
        "Q10 Correct Key": "C: Karma Yoga",
        "Q10 Mark": 1,
        "Q11 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q11 Candidate Answer": "B: Swami Vivekananda",
        "Q11 Correct Key": "B: Swami Vivekananda",
        "Q11 Mark": 1,
        "Q12 Question": "A javelin throw is valid only if:",
        "Q12 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q12 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q12 Mark": 1,
        "Q13 Question": "What is the weight of the men's shot?",
        "Q13 Candidate Answer": "C: 7.260 kg",
        "Q13 Correct Key": "C: 7.260 kg",
        "Q13 Mark": 1,
        "Q14 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q14 Candidate Answer": "C: 34.92°",
        "Q14 Correct Key": "C: 34.92°",
        "Q14 Mark": 1,
        "Q15 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q15 Candidate Answer": "B: 45 mm",
        "Q15 Correct Key": "B: 45 mm",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the shot put circle?",
        "Q16 Candidate Answer": "B: 2.135 m",
        "Q16 Correct Key": "B: 2.135 m",
        "Q16 Mark": 1,
        "Q17 Question": "What is the minimum size of the high jump landing mat?",
        "Q17 Candidate Answer": "B: 5 m × 3 m",
        "Q17 Correct Key": "B: 5 m × 3 m",
        "Q17 Mark": 1,
        "Q18 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q18 Candidate Answer": "D: Fosbury Flop",
        "Q18 Correct Key": "D: Fosbury Flop",
        "Q18 Mark": 1,
        "Q19 Question": "What is the diameter of the discus throwing circle?",
        "Q19 Candidate Answer": "A: 2.135 m",
        "Q19 Correct Key": "B: 2.50 m",
        "Q19 Mark": 0,
        "Q20 Question": "What is the javelin throwing sector angle?",
        "Q20 Candidate Answer": "C: 34.92°",
        "Q20 Correct Key": "A: 28.96°",
        "Q20 Mark": 0,
        "Q21 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q21 Candidate Answer": "C: 6",
        "Q21 Correct Key": "C: 6",
        "Q21 Mark": 1,
        "Q22 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q22 Candidate Answer": "B: Scissors Jump",
        "Q22 Correct Key": "B: Scissors Jump",
        "Q22 Mark": 1,
        "Q23 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q23 Candidate Answer": "C: Protein",
        "Q23 Correct Key": "C: Protein",
        "Q23 Mark": 1,
        "Q24 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q24 Candidate Answer": "B: Yama",
        "Q24 Correct Key": "B: Yama",
        "Q24 Mark": 1,
        "Q25 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q25 Candidate Answer": "C: To join or unite",
        "Q25 Correct Key": "C: To join or unite",
        "Q25 Mark": 1,
        "Q26 Question": "What is the correct sequence of phases in the triple jump?",
        "Q26 Candidate Answer": "C: Hop – Step – Jump",
        "Q26 Correct Key": "C: Hop – Step – Jump",
        "Q26 Mark": 1,
        "Q27 Question": "What is the official distance of a marathon?",
        "Q27 Candidate Answer": "C: 42.195 km",
        "Q27 Correct Key": "C: 42.195 km",
        "Q27 Mark": 1,
        "Q28 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q28 Candidate Answer": "C: Pratyahara",
        "Q28 Correct Key": "C: Pratyahara",
        "Q28 Mark": 1,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "B: 7 mm",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 1,
        "Q30 Question": "If the shot lands on one of the sector lines:",
        "Q30 Candidate Answer": "B: A re-throw is given",
        "Q30 Correct Key": "C: It is called a foul and not measured",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 33,
      "registrationNumber": "KOP/2026/06/0172",
      "studentName": "BULU NAIK",
      "mobileNumber": "9348363473",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:13 pm",
      "startTime": "18 Oct 2026, 01:16:01 pm",
      "submissionTime": "18 Oct 2026, 01:51:37 pm",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 33,
        "Registration ID": "KOP/2026/06/0172",
        "Candidate Name": "BULU NAIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q1 Candidate Answer": "C: 6",
        "Q1 Correct Key": "C: 6",
        "Q1 Mark": 1,
        "Q2 Question": "How much energy does 1 g of fat give?",
        "Q2 Candidate Answer": "C: 9.1 kcal",
        "Q2 Correct Key": "C: 9.1 kcal",
        "Q2 Mark": 1,
        "Q3 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q3 Candidate Answer": "C: 11",
        "Q3 Correct Key": "C: 11",
        "Q3 Mark": 1,
        "Q4 Question": "Which of the following is NOT a flight style in long jump?",
        "Q4 Candidate Answer": "D: Fosbury flop",
        "Q4 Correct Key": "D: Fosbury flop",
        "Q4 Mark": 1,
        "Q5 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q5 Candidate Answer": "C: 34.92°",
        "Q5 Correct Key": "C: 34.92°",
        "Q5 Mark": 1,
        "Q6 Question": "What are the dimensions of the take-off board in long jump?",
        "Q6 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q6 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum size of the high jump landing mat?",
        "Q7 Candidate Answer": "D: 9 m × 2.75 m",
        "Q7 Correct Key": "B: 5 m × 3 m",
        "Q7 Mark": 0,
        "Q8 Question": "What is the weight of the men's shot?",
        "Q8 Candidate Answer": "C: 7.260 kg",
        "Q8 Correct Key": "C: 7.260 kg",
        "Q8 Mark": 1,
        "Q9 Question": "What is the javelin throwing sector angle?",
        "Q9 Candidate Answer": "A: 28.96°",
        "Q9 Correct Key": "A: 28.96°",
        "Q9 Mark": 1,
        "Q10 Question": "Lactose (milk sugar) is made of:",
        "Q10 Candidate Answer": "C: Glucose + Galactose",
        "Q10 Correct Key": "C: Glucose + Galactose",
        "Q10 Mark": 1,
        "Q11 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q11 Candidate Answer": "C: 20 m",
        "Q11 Correct Key": "C: 20 m",
        "Q11 Mark": 1,
        "Q12 Question": "What is the correct sequence of phases in the triple jump?",
        "Q12 Candidate Answer": "C: Hop – Step – Jump",
        "Q12 Correct Key": "C: Hop – Step – Jump",
        "Q12 Mark": 1,
        "Q13 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q13 Candidate Answer": "A: Laya Yoga",
        "Q13 Correct Key": "A: Laya Yoga",
        "Q13 Mark": 1,
        "Q14 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q14 Candidate Answer": "C: Disqualified",
        "Q14 Correct Key": "C: Disqualified",
        "Q14 Mark": 1,
        "Q15 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q15 Candidate Answer": "B: To hold or maintain",
        "Q15 Correct Key": "B: To hold or maintain",
        "Q15 Mark": 1,
        "Q16 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q16 Candidate Answer": "A: 1 minute",
        "Q16 Correct Key": "C: 2 minutes",
        "Q16 Mark": 0,
        "Q17 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q17 Candidate Answer": "B: 45 mm",
        "Q17 Correct Key": "B: 45 mm",
        "Q17 Mark": 1,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 1,
        "Q19 Question": "In which throwing event are gloves allowed?",
        "Q19 Candidate Answer": "D: Hammer throw",
        "Q19 Correct Key": "D: Hammer throw",
        "Q19 Mark": 1,
        "Q20 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q20 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q20 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q20 Mark": 1,
        "Q21 Question": "What is the weight of the men's javelin?",
        "Q21 Candidate Answer": "C: 800 g",
        "Q21 Correct Key": "C: 800 g",
        "Q21 Mark": 1,
        "Q22 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q22 Candidate Answer": "B: Glide method",
        "Q22 Correct Key": "B: Glide method",
        "Q22 Mark": 1,
        "Q23 Question": "How high is the plasticine indicator board?",
        "Q23 Candidate Answer": "B: 7 mm",
        "Q23 Correct Key": "B: 7 mm",
        "Q23 Mark": 1,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 1,
        "Q26 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q26 Candidate Answer": "D: Fosbury Flop",
        "Q26 Correct Key": "D: Fosbury Flop",
        "Q26 Mark": 1,
        "Q27 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q27 Candidate Answer": "C: To join or unite",
        "Q27 Correct Key": "C: To join or unite",
        "Q27 Mark": 1,
        "Q28 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q28 Candidate Answer": "C: Karma Yoga",
        "Q28 Correct Key": "C: Karma Yoga",
        "Q28 Mark": 1,
        "Q29 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q29 Candidate Answer": "B: 1:2:1",
        "Q29 Correct Key": "B: 1:2:1",
        "Q29 Mark": 1,
        "Q30 Question": "In track and field, a green card is shown when:",
        "Q30 Candidate Answer": "B: An athlete is disqualified",
        "Q30 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 34,
      "registrationNumber": "KOP/2026/08/0473",
      "studentName": "BIKRAM CHHATRIA",
      "mobileNumber": "7847836460",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:33 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 34,
        "Registration ID": "KOP/2026/08/0473",
        "Candidate Name": "BIKRAM CHHATRIA",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the javelin throwing sector angle?",
        "Q1 Candidate Answer": "C: 34.92°",
        "Q1 Correct Key": "A: 28.96°",
        "Q1 Mark": 0,
        "Q2 Question": "What is the official distance of a marathon?",
        "Q2 Candidate Answer": "C: 42.195 km",
        "Q2 Correct Key": "C: 42.195 km",
        "Q2 Mark": 1,
        "Q3 Question": "What is the diameter of the shot put circle?",
        "Q3 Candidate Answer": "B: 2.135 m",
        "Q3 Correct Key": "B: 2.135 m",
        "Q3 Mark": 1,
        "Q4 Question": "A javelin throw is valid only if:",
        "Q4 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q4 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q4 Mark": 1,
        "Q5 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q5 Candidate Answer": "C: Karma Yoga",
        "Q5 Correct Key": "C: Karma Yoga",
        "Q5 Mark": 1,
        "Q6 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q6 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q6 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q6 Mark": 1,
        "Q7 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q7 Candidate Answer": "D: Fosbury Flop",
        "Q7 Correct Key": "D: Fosbury Flop",
        "Q7 Mark": 1,
        "Q8 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q8 Candidate Answer": "C: 3",
        "Q8 Correct Key": "C: 3",
        "Q8 Mark": 1,
        "Q9 Question": "Which statement about pole vault is correct?",
        "Q9 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Mark": 1,
        "Q10 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q10 Candidate Answer": "B: Comparing their second-best performances",
        "Q10 Correct Key": "B: Comparing their second-best performances",
        "Q10 Mark": 1,
        "Q11 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q11 Candidate Answer": "B: Fat",
        "Q11 Correct Key": "C: Protein",
        "Q11 Mark": 0,
        "Q12 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q12 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Mark": 1,
        "Q13 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q13 Candidate Answer": "C: 2 minutes",
        "Q13 Correct Key": "C: 2 minutes",
        "Q13 Mark": 1,
        "Q14 Question": "Lactose (milk sugar) is made of:",
        "Q14 Candidate Answer": "C: Glucose + Galactose",
        "Q14 Correct Key": "C: Glucose + Galactose",
        "Q14 Mark": 1,
        "Q15 Question": "In track and field, a green card is shown when:",
        "Q15 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q15 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q15 Mark": 1,
        "Q16 Question": "Which of the following is NOT a flight style in long jump?",
        "Q16 Candidate Answer": "D: Fosbury flop",
        "Q16 Correct Key": "D: Fosbury flop",
        "Q16 Mark": 1,
        "Q17 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q17 Candidate Answer": "A: Maharishi Patanjali",
        "Q17 Correct Key": "B: Swami Vivekananda",
        "Q17 Mark": 0,
        "Q18 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q18 Candidate Answer": "B: Scissors Jump",
        "Q18 Correct Key": "B: Scissors Jump",
        "Q18 Mark": 1,
        "Q19 Question": "How is a triple jump measured?",
        "Q19 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q19 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q19 Mark": 1,
        "Q20 Question": "Which of the following is a Niyama?",
        "Q20 Candidate Answer": "C: Svadhyaya",
        "Q20 Correct Key": "C: Svadhyaya",
        "Q20 Mark": 1,
        "Q21 Question": "How much energy does 1 g of fat give?",
        "Q21 Candidate Answer": "C: 9.1 kcal",
        "Q21 Correct Key": "C: 9.1 kcal",
        "Q21 Mark": 1,
        "Q22 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q22 Candidate Answer": "B: 45 mm",
        "Q22 Correct Key": "B: 45 mm",
        "Q22 Mark": 1,
        "Q23 Question": "What is the diameter of the discus throwing circle?",
        "Q23 Candidate Answer": "B: 2.50 m",
        "Q23 Correct Key": "B: 2.50 m",
        "Q23 Mark": 1,
        "Q24 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q24 Candidate Answer": "B: To hold or maintain",
        "Q24 Correct Key": "B: To hold or maintain",
        "Q24 Mark": 1,
        "Q25 Question": "In international competition, the pole vault landing area must be at least:",
        "Q25 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q25 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's shot?",
        "Q26 Candidate Answer": "C: 7.260 kg",
        "Q26 Correct Key": "C: 7.260 kg",
        "Q26 Mark": 1,
        "Q27 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q27 Candidate Answer": "C: 34.92°",
        "Q27 Correct Key": "C: 34.92°",
        "Q27 Mark": 1,
        "Q28 Question": "If the shot lands on one of the sector lines:",
        "Q28 Candidate Answer": "C: It is called a foul and not measured",
        "Q28 Correct Key": "C: It is called a foul and not measured",
        "Q28 Mark": 1,
        "Q29 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q29 Candidate Answer": "C: 11",
        "Q29 Correct Key": "C: 11",
        "Q29 Mark": 1,
        "Q30 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q30 Candidate Answer": "C: Pratyahara",
        "Q30 Correct Key": "C: Pratyahara",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 35,
      "registrationNumber": "KOP/2026/09/0053",
      "studentName": "NAROTTAM BISWAL",
      "mobileNumber": "9776524337",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:04:17 pm",
      "startTime": "18 Oct 2026, 01:15:47 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 35,
        "Registration ID": "KOP/2026/09/0053",
        "Candidate Name": "NAROTTAM BISWAL",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q1 Candidate Answer": "B: Glide method",
        "Q1 Correct Key": "B: Glide method",
        "Q1 Mark": 1,
        "Q2 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q2 Candidate Answer": "B: Yama",
        "Q2 Correct Key": "B: Yama",
        "Q2 Mark": 1,
        "Q3 Question": "What is the diameter of the shot put circle?",
        "Q3 Candidate Answer": "B: 2.135 m",
        "Q3 Correct Key": "B: 2.135 m",
        "Q3 Mark": 1,
        "Q4 Question": "Which of the following is a Niyama?",
        "Q4 Candidate Answer": "C: Svadhyaya",
        "Q4 Correct Key": "C: Svadhyaya",
        "Q4 Mark": 1,
        "Q5 Question": "What is the diameter of the discus throwing circle?",
        "Q5 Candidate Answer": "B: 2.50 m",
        "Q5 Correct Key": "B: 2.50 m",
        "Q5 Mark": 1,
        "Q6 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q6 Candidate Answer": "A: 30 minutes",
        "Q6 Correct Key": "B: 45 minutes",
        "Q6 Mark": 0,
        "Q7 Question": "In international competition, the pole vault landing area must be at least:",
        "Q7 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q7 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q7 Mark": 1,
        "Q8 Question": "Which of the following is NOT a flight style in long jump?",
        "Q8 Candidate Answer": "D: Fosbury flop",
        "Q8 Correct Key": "D: Fosbury flop",
        "Q8 Mark": 1,
        "Q9 Question": "What are the dimensions of the take-off board in long jump?",
        "Q9 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q9 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q9 Mark": 1,
        "Q10 Question": "In which throwing event are gloves allowed?",
        "Q10 Candidate Answer": "D: Hammer throw",
        "Q10 Correct Key": "D: Hammer throw",
        "Q10 Mark": 1,
        "Q11 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q11 Candidate Answer": "C: Polish grip",
        "Q11 Correct Key": "D: Orthodox grip",
        "Q11 Mark": 0,
        "Q12 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q12 Candidate Answer": "C: Pratyahara",
        "Q12 Correct Key": "C: Pratyahara",
        "Q12 Mark": 1,
        "Q13 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q13 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q13 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q13 Mark": 1,
        "Q14 Question": "What is the minimum size of the high jump landing mat?",
        "Q14 Candidate Answer": "B: 5 m × 3 m",
        "Q14 Correct Key": "B: 5 m × 3 m",
        "Q14 Mark": 1,
        "Q15 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q15 Candidate Answer": "A: Laya Yoga",
        "Q15 Correct Key": "A: Laya Yoga",
        "Q15 Mark": 1,
        "Q16 Question": "If the shot lands on one of the sector lines:",
        "Q16 Candidate Answer": "C: It is called a foul and not measured",
        "Q16 Correct Key": "C: It is called a foul and not measured",
        "Q16 Mark": 1,
        "Q17 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q17 Candidate Answer": "C: 6",
        "Q17 Correct Key": "C: 6",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's shot?",
        "Q18 Candidate Answer": "C: 7.260 kg",
        "Q18 Correct Key": "C: 7.260 kg",
        "Q18 Mark": 1,
        "Q19 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q19 Candidate Answer": "B: To hold or maintain",
        "Q19 Correct Key": "B: To hold or maintain",
        "Q19 Mark": 1,
        "Q20 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q20 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q20 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q20 Mark": 1,
        "Q21 Question": "In track and field, a green card is shown when:",
        "Q21 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q21 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q21 Mark": 1,
        "Q22 Question": "What is the javelin throwing sector angle?",
        "Q22 Candidate Answer": "C: 34.92°",
        "Q22 Correct Key": "A: 28.96°",
        "Q22 Mark": 0,
        "Q23 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q23 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q23 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q23 Mark": 1,
        "Q24 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q24 Candidate Answer": "C: 34.92°",
        "Q24 Correct Key": "C: 34.92°",
        "Q24 Mark": 1,
        "Q25 Question": "Which statement about pole vault is correct?",
        "Q25 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Mark": 1,
        "Q26 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q26 Candidate Answer": "B: Scissors Jump",
        "Q26 Correct Key": "B: Scissors Jump",
        "Q26 Mark": 1,
        "Q27 Question": "How much energy does 1 g of fat give?",
        "Q27 Candidate Answer": "C: 9.1 kcal",
        "Q27 Correct Key": "C: 9.1 kcal",
        "Q27 Mark": 1,
        "Q28 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q28 Candidate Answer": "C: 20 m",
        "Q28 Correct Key": "C: 20 m",
        "Q28 Mark": 1,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "B: 7 mm",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 1,
        "Q30 Question": "What is the correct sequence of phases in the triple jump?",
        "Q30 Candidate Answer": "C: Hop – Step – Jump",
        "Q30 Correct Key": "C: Hop – Step – Jump",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 36,
      "registrationNumber": "KOP/2026/09/0267",
      "studentName": "PRITIRANJAN PARIDA",
      "mobileNumber": "7978956139",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:50 pm",
      "startTime": "18 Oct 2026, 01:16:30 pm",
      "submissionTime": "18 Oct 2026, 01:59:32 pm",
      "questionsAnswered": "30 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 3,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 36,
        "Registration ID": "KOP/2026/09/0267",
        "Candidate Name": "PRITIRANJAN PARIDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "If the shot lands on one of the sector lines:",
        "Q1 Candidate Answer": "C: It is called a foul and not measured",
        "Q1 Correct Key": "C: It is called a foul and not measured",
        "Q1 Mark": 1,
        "Q2 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q2 Candidate Answer": "B: Comparing their second-best performances",
        "Q2 Correct Key": "B: Comparing their second-best performances",
        "Q2 Mark": 1,
        "Q3 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q3 Candidate Answer": "C: Karma Yoga",
        "Q3 Correct Key": "C: Karma Yoga",
        "Q3 Mark": 1,
        "Q4 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q4 Candidate Answer": "B: Eastern Roll",
        "Q4 Correct Key": "D: Fosbury Flop",
        "Q4 Mark": 0,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "B: Swami Vivekananda",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 1,
        "Q6 Question": "What are the dimensions of the take-off board in long jump?",
        "Q6 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q6 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q6 Mark": 1,
        "Q7 Question": "Lactose (milk sugar) is made of:",
        "Q7 Candidate Answer": "C: Glucose + Galactose",
        "Q7 Correct Key": "C: Glucose + Galactose",
        "Q7 Mark": 1,
        "Q8 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q8 Candidate Answer": "A: Laya Yoga",
        "Q8 Correct Key": "A: Laya Yoga",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's javelin?",
        "Q9 Candidate Answer": "C: 800 g",
        "Q9 Correct Key": "C: 800 g",
        "Q9 Mark": 1,
        "Q10 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q10 Candidate Answer": "C: 2 minutes",
        "Q10 Correct Key": "C: 2 minutes",
        "Q10 Mark": 1,
        "Q11 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q11 Candidate Answer": "C: Pratyahara",
        "Q11 Correct Key": "C: Pratyahara",
        "Q11 Mark": 1,
        "Q12 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q12 Candidate Answer": "C: 3",
        "Q12 Correct Key": "C: 3",
        "Q12 Mark": 1,
        "Q13 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q13 Candidate Answer": "B: To hold or maintain",
        "Q13 Correct Key": "B: To hold or maintain",
        "Q13 Mark": 1,
        "Q14 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q14 Candidate Answer": "B: Scissors Jump",
        "Q14 Correct Key": "B: Scissors Jump",
        "Q14 Mark": 1,
        "Q15 Question": "Which of the following is a Niyama?",
        "Q15 Candidate Answer": "C: Svadhyaya",
        "Q15 Correct Key": "C: Svadhyaya",
        "Q15 Mark": 1,
        "Q16 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q16 Candidate Answer": "C: 50 mm",
        "Q16 Correct Key": "B: 45 mm",
        "Q16 Mark": 0,
        "Q17 Question": "In international competition, the pole vault landing area must be at least:",
        "Q17 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q17 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the women's discus?",
        "Q18 Candidate Answer": "B: 1 kg",
        "Q18 Correct Key": "B: 1 kg",
        "Q18 Mark": 1,
        "Q19 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q19 Candidate Answer": "C: To join or unite",
        "Q19 Correct Key": "C: To join or unite",
        "Q19 Mark": 1,
        "Q20 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q20 Candidate Answer": "D: Orthodox grip",
        "Q20 Correct Key": "D: Orthodox grip",
        "Q20 Mark": 1,
        "Q21 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q21 Candidate Answer": "C: Disqualified",
        "Q21 Correct Key": "C: Disqualified",
        "Q21 Mark": 1,
        "Q22 Question": "A javelin throw is valid only if:",
        "Q22 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q22 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q22 Mark": 1,
        "Q23 Question": "What is the javelin throwing sector angle?",
        "Q23 Candidate Answer": "B: 30°",
        "Q23 Correct Key": "A: 28.96°",
        "Q23 Mark": 0,
        "Q24 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q24 Candidate Answer": "B: 45 minutes",
        "Q24 Correct Key": "B: 45 minutes",
        "Q24 Mark": 1,
        "Q25 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q25 Candidate Answer": "B: Yama",
        "Q25 Correct Key": "B: Yama",
        "Q25 Mark": 1,
        "Q26 Question": "In track and field, a green card is shown when:",
        "Q26 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q26 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q26 Mark": 1,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "B: Glide method",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 1,
        "Q28 Question": "What is the diameter of the shot put circle?",
        "Q28 Candidate Answer": "B: 2.135 m",
        "Q28 Correct Key": "B: 2.135 m",
        "Q28 Mark": 1,
        "Q29 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q29 Candidate Answer": "C: 11",
        "Q29 Correct Key": "C: 11",
        "Q29 Mark": 1,
        "Q30 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q30 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 37,
      "registrationNumber": "KOP/2026/09/0050",
      "studentName": "ITISHREE PADHAN",
      "mobileNumber": "6371835278",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18-Oct-2026, 01:00:43 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "29 / 30",
      "score": 27,
      "totalMarks": 30,
      "percentage": 90,
      "correctCount": 27,
      "wrongCount": 2,
      "unattemptedCount": 1,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 37,
        "Registration ID": "KOP/2026/09/0050",
        "Candidate Name": "ITISHREE PADHAN",
        "Actually Gave Exam?": "YES",
        "Total Score": "27 / 30",
        "Percentage": "90%",
        "Result": "QUALIFIED",
        "Q1 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q1 Candidate Answer": "B: Yama",
        "Q1 Correct Key": "B: Yama",
        "Q1 Mark": 1,
        "Q2 Question": "What is the javelin throwing sector angle?",
        "Q2 Candidate Answer": "A: 28.96°",
        "Q2 Correct Key": "A: 28.96°",
        "Q2 Mark": 1,
        "Q3 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q3 Candidate Answer": "C: 32 m/s",
        "Q3 Correct Key": "C: 32 m/s",
        "Q3 Mark": 1,
        "Q4 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: Disqualified",
        "Q4 Mark": 0,
        "Q5 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q5 Candidate Answer": "C: 2 minutes",
        "Q5 Correct Key": "C: 2 minutes",
        "Q5 Mark": 1,
        "Q6 Question": "What are the dimensions of the take-off board in long jump?",
        "Q6 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q6 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q6 Mark": 0,
        "Q7 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q7 Candidate Answer": "B: Glide method",
        "Q7 Correct Key": "B: Glide method",
        "Q7 Mark": 1,
        "Q8 Question": "What is the diameter of the discus throwing circle?",
        "Q8 Candidate Answer": "B: 2.50 m",
        "Q8 Correct Key": "B: 2.50 m",
        "Q8 Mark": 1,
        "Q9 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q9 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q9 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q9 Mark": 1,
        "Q10 Question": "In track and field, a green card is shown when:",
        "Q10 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q10 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q10 Mark": 1,
        "Q11 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q11 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q11 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q11 Mark": 1,
        "Q12 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q12 Candidate Answer": "B: To hold or maintain",
        "Q12 Correct Key": "B: To hold or maintain",
        "Q12 Mark": 1,
        "Q13 Question": "What is the diameter of the shot put circle?",
        "Q13 Candidate Answer": "B: 2.135 m",
        "Q13 Correct Key": "B: 2.135 m",
        "Q13 Mark": 1,
        "Q14 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q14 Candidate Answer": "B: Comparing their second-best performances",
        "Q14 Correct Key": "B: Comparing their second-best performances",
        "Q14 Mark": 1,
        "Q15 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q15 Candidate Answer": "D: Orthodox grip",
        "Q15 Correct Key": "D: Orthodox grip",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "A: Maharishi Patanjali",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 0,
        "Q17 Question": "How much energy does 1 g of fat give?",
        "Q17 Candidate Answer": "C: 9.1 kcal",
        "Q17 Correct Key": "C: 9.1 kcal",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's javelin?",
        "Q18 Candidate Answer": "C: 800 g",
        "Q18 Correct Key": "C: 800 g",
        "Q18 Mark": 1,
        "Q19 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q19 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q19 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q19 Mark": 1,
        "Q20 Question": "In which throwing event are gloves allowed?",
        "Q20 Candidate Answer": "D: Hammer throw",
        "Q20 Correct Key": "D: Hammer throw",
        "Q20 Mark": 1,
        "Q21 Question": "What is the weight of the men's shot?",
        "Q21 Candidate Answer": "C: 7.260 kg",
        "Q21 Correct Key": "C: 7.260 kg",
        "Q21 Mark": 1,
        "Q22 Question": "What is the correct sequence of phases in the triple jump?",
        "Q22 Candidate Answer": "C: Hop – Step – Jump",
        "Q22 Correct Key": "C: Hop – Step – Jump",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum size of the high jump landing mat?",
        "Q23 Candidate Answer": "B: 5 m × 3 m",
        "Q23 Correct Key": "B: 5 m × 3 m",
        "Q23 Mark": 1,
        "Q24 Question": "Which of the following is a Niyama?",
        "Q24 Candidate Answer": "C: Svadhyaya",
        "Q24 Correct Key": "C: Svadhyaya",
        "Q24 Mark": 1,
        "Q25 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q25 Candidate Answer": "B: 45 mm",
        "Q25 Correct Key": "B: 45 mm",
        "Q25 Mark": 1,
        "Q26 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q26 Candidate Answer": "A: Laya Yoga",
        "Q26 Correct Key": "A: Laya Yoga",
        "Q26 Mark": 1,
        "Q27 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q27 Candidate Answer": "C: Karma Yoga",
        "Q27 Correct Key": "C: Karma Yoga",
        "Q27 Mark": 1,
        "Q28 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q28 Candidate Answer": "C: 3",
        "Q28 Correct Key": "C: 3",
        "Q28 Mark": 1,
        "Q29 Question": "A javelin throw is valid only if:",
        "Q29 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q29 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q29 Mark": 1,
        "Q30 Question": "How is a triple jump measured?",
        "Q30 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q30 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 38,
      "registrationNumber": "HD/KOP/2026/0713",
      "studentName": "HITESH JAGAT",
      "mobileNumber": "7894555437",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:14 pm",
      "startTime": "18 Oct 2026, 01:16:06 pm",
      "submissionTime": "18 Oct 2026, 01:47:05 pm",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 38,
        "Registration ID": "HD/KOP/2026/0713",
        "Candidate Name": "HITESH JAGAT",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q1 Candidate Answer": "B: To hold or maintain",
        "Q1 Correct Key": "B: To hold or maintain",
        "Q1 Mark": 1,
        "Q2 Question": "What is the official distance of a marathon?",
        "Q2 Candidate Answer": "C: 42.195 km",
        "Q2 Correct Key": "C: 42.195 km",
        "Q2 Mark": 1,
        "Q3 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q3 Candidate Answer": "B: Scissors Jump",
        "Q3 Correct Key": "B: Scissors Jump",
        "Q3 Mark": 1,
        "Q4 Question": "What is the javelin throwing sector angle?",
        "Q4 Candidate Answer": "A: 28.96°",
        "Q4 Correct Key": "A: 28.96°",
        "Q4 Mark": 1,
        "Q5 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q5 Candidate Answer": "D: Fosbury Flop",
        "Q5 Correct Key": "D: Fosbury Flop",
        "Q5 Mark": 1,
        "Q6 Question": "A javelin throw is valid only if:",
        "Q6 Candidate Answer": "A: The tail touches the ground first",
        "Q6 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q6 Mark": 0,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q8 Candidate Answer": "C: Pratyahara",
        "Q8 Correct Key": "C: Pratyahara",
        "Q8 Mark": 1,
        "Q9 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q9 Candidate Answer": "B: Yama",
        "Q9 Correct Key": "B: Yama",
        "Q9 Mark": 1,
        "Q10 Question": "Which of the following is a Niyama?",
        "Q10 Candidate Answer": "C: Svadhyaya",
        "Q10 Correct Key": "C: Svadhyaya",
        "Q10 Mark": 1,
        "Q11 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q11 Candidate Answer": "B: Comparing their second-best performances",
        "Q11 Correct Key": "B: Comparing their second-best performances",
        "Q11 Mark": 1,
        "Q12 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q12 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Mark": 1,
        "Q13 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q13 Candidate Answer": "A: Finnish grip",
        "Q13 Correct Key": "D: Orthodox grip",
        "Q13 Mark": 0,
        "Q14 Question": "What is the correct sequence of phases in the triple jump?",
        "Q14 Candidate Answer": "C: Hop – Step – Jump",
        "Q14 Correct Key": "C: Hop – Step – Jump",
        "Q14 Mark": 1,
        "Q15 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q15 Candidate Answer": "B: Swami Vivekananda",
        "Q15 Correct Key": "B: Swami Vivekananda",
        "Q15 Mark": 1,
        "Q16 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q16 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q16 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q16 Mark": 1,
        "Q17 Question": "In track and field, a green card is shown when:",
        "Q17 Candidate Answer": "A: An athlete is warned",
        "Q17 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q17 Mark": 0,
        "Q18 Question": "How high is the plasticine indicator board?",
        "Q18 Candidate Answer": "B: 7 mm",
        "Q18 Correct Key": "B: 7 mm",
        "Q18 Mark": 1,
        "Q19 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q19 Candidate Answer": "C: 34.92°",
        "Q19 Correct Key": "C: 34.92°",
        "Q19 Mark": 1,
        "Q20 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q20 Candidate Answer": "A: 1 minute",
        "Q20 Correct Key": "C: 2 minutes",
        "Q20 Mark": 0,
        "Q21 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q21 Candidate Answer": "C: Karma Yoga",
        "Q21 Correct Key": "C: Karma Yoga",
        "Q21 Mark": 1,
        "Q22 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q22 Candidate Answer": "C: 32 m/s",
        "Q22 Correct Key": "C: 32 m/s",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q23 Candidate Answer": "B: 45 minutes",
        "Q23 Correct Key": "B: 45 minutes",
        "Q23 Mark": 1,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 1,
        "Q25 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q25 Candidate Answer": "C: To join or unite",
        "Q25 Correct Key": "C: To join or unite",
        "Q25 Mark": 1,
        "Q26 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q26 Candidate Answer": "C: 20 m",
        "Q26 Correct Key": "C: 20 m",
        "Q26 Mark": 1,
        "Q27 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q27 Candidate Answer": "C: 6",
        "Q27 Correct Key": "C: 6",
        "Q27 Mark": 1,
        "Q28 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q28 Candidate Answer": "C: 11",
        "Q28 Correct Key": "C: 11",
        "Q28 Mark": 1,
        "Q29 Question": "In which throwing event are gloves allowed?",
        "Q29 Candidate Answer": "D: Hammer throw",
        "Q29 Correct Key": "D: Hammer throw",
        "Q29 Mark": 1,
        "Q30 Question": "Lactose (milk sugar) is made of:",
        "Q30 Candidate Answer": "C: Glucose + Galactose",
        "Q30 Correct Key": "C: Glucose + Galactose",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 39,
      "registrationNumber": "KOP/2026/05/0103",
      "studentName": "Sanjib Kumar Dehuri",
      "mobileNumber": "9938271100",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:26 pm",
      "startTime": "18 Oct 2026, 01:19:50 pm",
      "submissionTime": "18 Oct 2026, 01:57:43 pm",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 39,
        "Registration ID": "KOP/2026/05/0103",
        "Candidate Name": "Sanjib Kumar Dehuri",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 1,
        "Q2 Question": "Which of the following is a Niyama?",
        "Q2 Candidate Answer": "C: Svadhyaya",
        "Q2 Correct Key": "C: Svadhyaya",
        "Q2 Mark": 1,
        "Q3 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q3 Candidate Answer": "B: Swami Vivekananda",
        "Q3 Correct Key": "B: Swami Vivekananda",
        "Q3 Mark": 1,
        "Q4 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q4 Candidate Answer": "B: 1:2:1",
        "Q4 Correct Key": "B: 1:2:1",
        "Q4 Mark": 1,
        "Q5 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q5 Candidate Answer": "C: To join or unite",
        "Q5 Correct Key": "C: To join or unite",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the men's javelin?",
        "Q6 Candidate Answer": "C: 800 g",
        "Q6 Correct Key": "C: 800 g",
        "Q6 Mark": 1,
        "Q7 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q7 Candidate Answer": "C: Protein",
        "Q7 Correct Key": "C: Protein",
        "Q7 Mark": 1,
        "Q8 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q8 Candidate Answer": "B: Glide method",
        "Q8 Correct Key": "B: Glide method",
        "Q8 Mark": 1,
        "Q9 Question": "In international competition, the pole vault landing area must be at least:",
        "Q9 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q9 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q9 Mark": 1,
        "Q10 Question": "What is the minimum size of the high jump landing mat?",
        "Q10 Candidate Answer": "B: 5 m × 3 m",
        "Q10 Correct Key": "B: 5 m × 3 m",
        "Q10 Mark": 1,
        "Q11 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q11 Candidate Answer": "C: Disqualified",
        "Q11 Correct Key": "C: Disqualified",
        "Q11 Mark": 1,
        "Q12 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q12 Candidate Answer": "A: 9",
        "Q12 Correct Key": "C: 11",
        "Q12 Mark": 0,
        "Q13 Question": "How is a triple jump measured?",
        "Q13 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q13 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q13 Mark": 1,
        "Q14 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q14 Candidate Answer": "A: Laya Yoga",
        "Q14 Correct Key": "A: Laya Yoga",
        "Q14 Mark": 1,
        "Q15 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q15 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q15 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q15 Mark": 1,
        "Q16 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q16 Candidate Answer": "C: Karma Yoga",
        "Q16 Correct Key": "C: Karma Yoga",
        "Q16 Mark": 1,
        "Q17 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q17 Candidate Answer": "B: 45 mm",
        "Q17 Correct Key": "B: 45 mm",
        "Q17 Mark": 1,
        "Q18 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q18 Candidate Answer": "D: Fosbury Flop",
        "Q18 Correct Key": "D: Fosbury Flop",
        "Q18 Mark": 1,
        "Q19 Question": "What is the weight of the men's shot?",
        "Q19 Candidate Answer": "C: 7.260 kg",
        "Q19 Correct Key": "C: 7.260 kg",
        "Q19 Mark": 1,
        "Q20 Question": "How high is the plasticine indicator board?",
        "Q20 Candidate Answer": "B: 7 mm",
        "Q20 Correct Key": "B: 7 mm",
        "Q20 Mark": 1,
        "Q21 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q21 Candidate Answer": "D: 3 minutes",
        "Q21 Correct Key": "C: 2 minutes",
        "Q21 Mark": 0,
        "Q22 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q22 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q22 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q22 Mark": 1,
        "Q23 Question": "If the shot lands on one of the sector lines:",
        "Q23 Candidate Answer": "A: It is measured normally",
        "Q23 Correct Key": "C: It is called a foul and not measured",
        "Q23 Mark": 0,
        "Q24 Question": "Which of the following is NOT a flight style in long jump?",
        "Q24 Candidate Answer": "D: Fosbury flop",
        "Q24 Correct Key": "D: Fosbury flop",
        "Q24 Mark": 1,
        "Q25 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q25 Candidate Answer": "D: Fosbury Flop",
        "Q25 Correct Key": "B: Scissors Jump",
        "Q25 Mark": 0,
        "Q26 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q26 Candidate Answer": "B: 45 minutes",
        "Q26 Correct Key": "B: 45 minutes",
        "Q26 Mark": 1,
        "Q27 Question": "Lactose (milk sugar) is made of:",
        "Q27 Candidate Answer": "C: Glucose + Galactose",
        "Q27 Correct Key": "C: Glucose + Galactose",
        "Q27 Mark": 1,
        "Q28 Question": "What is the diameter of the shot put circle?",
        "Q28 Candidate Answer": "B: 2.135 m",
        "Q28 Correct Key": "B: 2.135 m",
        "Q28 Mark": 1,
        "Q29 Question": "A javelin throw is valid only if:",
        "Q29 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q29 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q29 Mark": 1,
        "Q30 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q30 Candidate Answer": "B: Yama",
        "Q30 Correct Key": "B: Yama",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 40,
      "registrationNumber": "KOP/2026/07/0358",
      "studentName": "ARCHANA BAITHARU",
      "mobileNumber": "7682979856",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:08:44 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 40,
        "Registration ID": "KOP/2026/07/0358",
        "Candidate Name": "ARCHANA BAITHARU",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q1 Candidate Answer": "D: Orthodox grip",
        "Q1 Correct Key": "D: Orthodox grip",
        "Q1 Mark": 1,
        "Q2 Question": "If the shot lands on one of the sector lines:",
        "Q2 Candidate Answer": "C: It is called a foul and not measured",
        "Q2 Correct Key": "C: It is called a foul and not measured",
        "Q2 Mark": 1,
        "Q3 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q3 Candidate Answer": "B: 15 m",
        "Q3 Correct Key": "C: 20 m",
        "Q3 Mark": 0,
        "Q4 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q4 Candidate Answer": "B: 1:2:1",
        "Q4 Correct Key": "B: 1:2:1",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "B: 10",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 0,
        "Q6 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q6 Candidate Answer": "A: 28.96°",
        "Q6 Correct Key": "C: 34.92°",
        "Q6 Mark": 0,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q8 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Mark": 1,
        "Q9 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q9 Candidate Answer": "A: Takes off from one foot and lands on the opposite foot",
        "Q9 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q9 Mark": 0,
        "Q10 Question": "In track and field, a green card is shown when:",
        "Q10 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q10 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q10 Mark": 1,
        "Q11 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q11 Candidate Answer": "C: Protein",
        "Q11 Correct Key": "C: Protein",
        "Q11 Mark": 1,
        "Q12 Question": "Which of the following is a Niyama?",
        "Q12 Candidate Answer": "C: Svadhyaya",
        "Q12 Correct Key": "C: Svadhyaya",
        "Q12 Mark": 1,
        "Q13 Question": "Which statement about pole vault is correct?",
        "Q13 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q13 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q13 Mark": 1,
        "Q14 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q14 Candidate Answer": "C: 3",
        "Q14 Correct Key": "C: 3",
        "Q14 Mark": 1,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "B: Swami Vivekananda",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 1,
        "Q17 Question": "In international competition, the pole vault landing area must be at least:",
        "Q17 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q17 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q17 Mark": 1,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 1,
        "Q19 Question": "How much energy does 1 g of fat give?",
        "Q19 Candidate Answer": "C: 9.1 kcal",
        "Q19 Correct Key": "C: 9.1 kcal",
        "Q19 Mark": 1,
        "Q20 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q20 Candidate Answer": "A: Laya Yoga",
        "Q20 Correct Key": "A: Laya Yoga",
        "Q20 Mark": 1,
        "Q21 Question": "What is the weight of the men's shot?",
        "Q21 Candidate Answer": "C: 7.260 kg",
        "Q21 Correct Key": "C: 7.260 kg",
        "Q21 Mark": 1,
        "Q22 Question": "A javelin throw is valid only if:",
        "Q22 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q22 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q22 Mark": 1,
        "Q23 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q23 Candidate Answer": "B: Scissors Jump",
        "Q23 Correct Key": "B: Scissors Jump",
        "Q23 Mark": 1,
        "Q24 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q24 Candidate Answer": "B: To hold or maintain",
        "Q24 Correct Key": "B: To hold or maintain",
        "Q24 Mark": 1,
        "Q25 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q25 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q25 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q25 Mark": 1,
        "Q26 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q26 Candidate Answer": "C: Pratyahara",
        "Q26 Correct Key": "C: Pratyahara",
        "Q26 Mark": 1,
        "Q27 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q27 Candidate Answer": "B: 45 minutes",
        "Q27 Correct Key": "B: 45 minutes",
        "Q27 Mark": 1,
        "Q28 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q28 Candidate Answer": "C: 32 m/s",
        "Q28 Correct Key": "C: 32 m/s",
        "Q28 Mark": 1,
        "Q29 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q29 Candidate Answer": "C: 2 minutes",
        "Q29 Correct Key": "C: 2 minutes",
        "Q29 Mark": 1,
        "Q30 Question": "How high is the plasticine indicator board?",
        "Q30 Candidate Answer": "B: 7 mm",
        "Q30 Correct Key": "B: 7 mm",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 41,
      "registrationNumber": "KOP/2026/08/0495",
      "studentName": "MAHESH KUMAR SA",
      "mobileNumber": "9556316856",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:14:06 pm",
      "startTime": "18 Oct 2026, 02:14:19 pm",
      "submissionTime": "18 Oct 2026, 02:17:30 pm",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 41,
        "Registration ID": "KOP/2026/08/0495",
        "Candidate Name": "MAHESH KUMAR SA",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q1 Candidate Answer": "A: Laya Yoga",
        "Q1 Correct Key": "A: Laya Yoga",
        "Q1 Mark": 1,
        "Q2 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q2 Candidate Answer": "B: 45 mm",
        "Q2 Correct Key": "B: 45 mm",
        "Q2 Mark": 1,
        "Q3 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q3 Candidate Answer": "C: 3",
        "Q3 Correct Key": "C: 3",
        "Q3 Mark": 1,
        "Q4 Question": "Which of the following is NOT a flight style in long jump?",
        "Q4 Candidate Answer": "D: Fosbury flop",
        "Q4 Correct Key": "D: Fosbury flop",
        "Q4 Mark": 1,
        "Q5 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q5 Candidate Answer": "D: Orthodox grip",
        "Q5 Correct Key": "D: Orthodox grip",
        "Q5 Mark": 1,
        "Q6 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q6 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q6 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q6 Mark": 0,
        "Q7 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q7 Candidate Answer": "B: Swami Vivekananda",
        "Q7 Correct Key": "B: Swami Vivekananda",
        "Q7 Mark": 1,
        "Q8 Question": "What is the diameter of the discus throwing circle?",
        "Q8 Candidate Answer": "A: 2.135 m",
        "Q8 Correct Key": "B: 2.50 m",
        "Q8 Mark": 0,
        "Q9 Question": "What is the weight of the men's javelin?",
        "Q9 Candidate Answer": "C: 800 g",
        "Q9 Correct Key": "C: 800 g",
        "Q9 Mark": 1,
        "Q10 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q10 Candidate Answer": "C: 6",
        "Q10 Correct Key": "C: 6",
        "Q10 Mark": 1,
        "Q11 Question": "What is the official distance of a marathon?",
        "Q11 Candidate Answer": "C: 42.195 km",
        "Q11 Correct Key": "C: 42.195 km",
        "Q11 Mark": 1,
        "Q12 Question": "In track and field, a green card is shown when:",
        "Q12 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q12 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q12 Mark": 1,
        "Q13 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q13 Candidate Answer": "B: 1:2:1",
        "Q13 Correct Key": "B: 1:2:1",
        "Q13 Mark": 1,
        "Q14 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q14 Candidate Answer": "C: 11",
        "Q14 Correct Key": "C: 11",
        "Q14 Mark": 1,
        "Q15 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q15 Candidate Answer": "C: To join or unite",
        "Q15 Correct Key": "C: To join or unite",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the shot put circle?",
        "Q16 Candidate Answer": "B: 2.135 m",
        "Q16 Correct Key": "B: 2.135 m",
        "Q16 Mark": 1,
        "Q17 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q17 Candidate Answer": "B: Comparing their second-best performances",
        "Q17 Correct Key": "B: Comparing their second-best performances",
        "Q17 Mark": 1,
        "Q18 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q18 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q18 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q18 Mark": 1,
        "Q19 Question": "A javelin throw is valid only if:",
        "Q19 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q19 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q19 Mark": 1,
        "Q20 Question": "In which throwing event are gloves allowed?",
        "Q20 Candidate Answer": "D: Hammer throw",
        "Q20 Correct Key": "D: Hammer throw",
        "Q20 Mark": 1,
        "Q21 Question": "How much energy does 1 g of fat give?",
        "Q21 Candidate Answer": "C: 9.1 kcal",
        "Q21 Correct Key": "C: 9.1 kcal",
        "Q21 Mark": 1,
        "Q22 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q22 Candidate Answer": "B: To hold or maintain",
        "Q22 Correct Key": "B: To hold or maintain",
        "Q22 Mark": 1,
        "Q23 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q23 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q23 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q23 Mark": 1,
        "Q24 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q24 Candidate Answer": "B: Glide method",
        "Q24 Correct Key": "B: Glide method",
        "Q24 Mark": 1,
        "Q25 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q25 Candidate Answer": "C: 34.92°",
        "Q25 Correct Key": "C: 34.92°",
        "Q25 Mark": 1,
        "Q26 Question": "Lactose (milk sugar) is made of:",
        "Q26 Candidate Answer": "C: Glucose + Galactose",
        "Q26 Correct Key": "C: Glucose + Galactose",
        "Q26 Mark": 1,
        "Q27 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q27 Candidate Answer": "C: Protein",
        "Q27 Correct Key": "C: Protein",
        "Q27 Mark": 1,
        "Q28 Question": "What is the javelin throwing sector angle?",
        "Q28 Candidate Answer": "C: 34.92°",
        "Q28 Correct Key": "A: 28.96°",
        "Q28 Mark": 0,
        "Q29 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q29 Candidate Answer": "C: 32 m/s",
        "Q29 Correct Key": "C: 32 m/s",
        "Q29 Mark": 1,
        "Q30 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q30 Candidate Answer": "D: 3 minutes",
        "Q30 Correct Key": "C: 2 minutes",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 42,
      "registrationNumber": "KOP/2026/08/0627",
      "studentName": "PADMARAJ DANDSENA",
      "mobileNumber": "6372272801",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:18 pm",
      "startTime": "18 Oct 2026, 01:16:23 pm",
      "submissionTime": "18 Oct 2026, 01:36:24 pm",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 42,
        "Registration ID": "KOP/2026/08/0627",
        "Candidate Name": "PADMARAJ DANDSENA",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q1 Candidate Answer": "B: Yama",
        "Q1 Correct Key": "B: Yama",
        "Q1 Mark": 1,
        "Q2 Question": "How is a triple jump measured?",
        "Q2 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q2 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q2 Mark": 1,
        "Q3 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q3 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q3 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q3 Mark": 1,
        "Q4 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q4 Candidate Answer": "B: Glide method",
        "Q4 Correct Key": "B: Glide method",
        "Q4 Mark": 1,
        "Q5 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q5 Candidate Answer": "B: 45 minutes",
        "Q5 Correct Key": "B: 45 minutes",
        "Q5 Mark": 1,
        "Q6 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q6 Candidate Answer": "B: 1:2:1",
        "Q6 Correct Key": "B: 1:2:1",
        "Q6 Mark": 1,
        "Q7 Question": "Which of the following is a Niyama?",
        "Q7 Candidate Answer": "C: Svadhyaya",
        "Q7 Correct Key": "C: Svadhyaya",
        "Q7 Mark": 1,
        "Q8 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q8 Candidate Answer": "D: Fosbury Flop",
        "Q8 Correct Key": "D: Fosbury Flop",
        "Q8 Mark": 1,
        "Q9 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q9 Candidate Answer": "C: Protein",
        "Q9 Correct Key": "C: Protein",
        "Q9 Mark": 1,
        "Q10 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q10 Candidate Answer": "C: 32 m/s",
        "Q10 Correct Key": "C: 32 m/s",
        "Q10 Mark": 1,
        "Q11 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q11 Candidate Answer": "B: To hold or maintain",
        "Q11 Correct Key": "B: To hold or maintain",
        "Q11 Mark": 1,
        "Q12 Question": "What is the correct sequence of phases in the triple jump?",
        "Q12 Candidate Answer": "C: Hop – Step – Jump",
        "Q12 Correct Key": "C: Hop – Step – Jump",
        "Q12 Mark": 1,
        "Q13 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q13 Candidate Answer": "C: 11",
        "Q13 Correct Key": "C: 11",
        "Q13 Mark": 1,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 1,
        "Q15 Question": "In international competition, the pole vault landing area must be at least:",
        "Q15 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q15 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the shot put circle?",
        "Q16 Candidate Answer": "B: 2.135 m",
        "Q16 Correct Key": "B: 2.135 m",
        "Q16 Mark": 1,
        "Q17 Question": "Which of the following is NOT a flight style in long jump?",
        "Q17 Candidate Answer": "D: Fosbury flop",
        "Q17 Correct Key": "D: Fosbury flop",
        "Q17 Mark": 1,
        "Q18 Question": "What are the dimensions of the take-off board in long jump?",
        "Q18 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q18 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q18 Mark": 0,
        "Q19 Question": "How high is the plasticine indicator board?",
        "Q19 Candidate Answer": "B: 7 mm",
        "Q19 Correct Key": "B: 7 mm",
        "Q19 Mark": 1,
        "Q20 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q20 Candidate Answer": "C: 20 m",
        "Q20 Correct Key": "C: 20 m",
        "Q20 Mark": 1,
        "Q21 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q21 Candidate Answer": "C: To join or unite",
        "Q21 Correct Key": "C: To join or unite",
        "Q21 Mark": 1,
        "Q22 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q22 Candidate Answer": "C: Polish grip",
        "Q22 Correct Key": "D: Orthodox grip",
        "Q22 Mark": 0,
        "Q23 Question": "Which statement about pole vault is correct?",
        "Q23 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q23 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q23 Mark": 0,
        "Q24 Question": "What is the weight of the women's discus?",
        "Q24 Candidate Answer": "B: 1 kg",
        "Q24 Correct Key": "B: 1 kg",
        "Q24 Mark": 1,
        "Q25 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q25 Candidate Answer": "B: Scissors Jump",
        "Q25 Correct Key": "B: Scissors Jump",
        "Q25 Mark": 1,
        "Q26 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q26 Candidate Answer": "B: 45 mm",
        "Q26 Correct Key": "B: 45 mm",
        "Q26 Mark": 1,
        "Q27 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q27 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q27 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q27 Mark": 1,
        "Q28 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q28 Candidate Answer": "C: 3",
        "Q28 Correct Key": "C: 3",
        "Q28 Mark": 1,
        "Q29 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q29 Candidate Answer": "A: 1 minute",
        "Q29 Correct Key": "C: 2 minutes",
        "Q29 Mark": 0,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 43,
      "registrationNumber": "KOP/2026/09/0022",
      "studentName": "MANAS KUMAR MAHARANA",
      "mobileNumber": "7328044039",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:14 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 4,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 43,
        "Registration ID": "KOP/2026/09/0022",
        "Candidate Name": "MANAS KUMAR MAHARANA",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which statement about pole vault is correct?",
        "Q1 Candidate Answer": "A: Gloves are not permitted",
        "Q1 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q1 Mark": 0,
        "Q2 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q2 Candidate Answer": "C: 11",
        "Q2 Correct Key": "C: 11",
        "Q2 Mark": 1,
        "Q3 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q3 Candidate Answer": "C: Protein",
        "Q3 Correct Key": "C: Protein",
        "Q3 Mark": 1,
        "Q4 Question": "How high is the plasticine indicator board?",
        "Q4 Candidate Answer": "B: 7 mm",
        "Q4 Correct Key": "B: 7 mm",
        "Q4 Mark": 1,
        "Q5 Question": "What is the official distance of a marathon?",
        "Q5 Candidate Answer": "C: 42.195 km",
        "Q5 Correct Key": "C: 42.195 km",
        "Q5 Mark": 1,
        "Q6 Question": "Which of the following is NOT a flight style in long jump?",
        "Q6 Candidate Answer": "D: Fosbury flop",
        "Q6 Correct Key": "D: Fosbury flop",
        "Q6 Mark": 1,
        "Q7 Question": "What is the correct sequence of phases in the triple jump?",
        "Q7 Candidate Answer": "C: Hop – Step – Jump",
        "Q7 Correct Key": "C: Hop – Step – Jump",
        "Q7 Mark": 1,
        "Q8 Question": "What is the javelin throwing sector angle?",
        "Q8 Candidate Answer": "C: 34.92°",
        "Q8 Correct Key": "A: 28.96°",
        "Q8 Mark": 0,
        "Q9 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q9 Candidate Answer": "A: Laya Yoga",
        "Q9 Correct Key": "A: Laya Yoga",
        "Q9 Mark": 1,
        "Q10 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q10 Candidate Answer": "D: Fosbury Flop",
        "Q10 Correct Key": "D: Fosbury Flop",
        "Q10 Mark": 1,
        "Q11 Question": "Lactose (milk sugar) is made of:",
        "Q11 Candidate Answer": "C: Glucose + Galactose",
        "Q11 Correct Key": "C: Glucose + Galactose",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the men's shot?",
        "Q12 Candidate Answer": "C: 7.260 kg",
        "Q12 Correct Key": "C: 7.260 kg",
        "Q12 Mark": 1,
        "Q13 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q13 Candidate Answer": "B: 45 minutes",
        "Q13 Correct Key": "B: 45 minutes",
        "Q13 Mark": 1,
        "Q14 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q14 Candidate Answer": "B: To hold or maintain",
        "Q14 Correct Key": "B: To hold or maintain",
        "Q14 Mark": 1,
        "Q15 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q15 Candidate Answer": "D: 40 m",
        "Q15 Correct Key": "C: 20 m",
        "Q15 Mark": 0,
        "Q16 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q16 Candidate Answer": "C: To join or unite",
        "Q16 Correct Key": "C: To join or unite",
        "Q16 Mark": 1,
        "Q17 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q17 Candidate Answer": "B: Comparing their second-best performances",
        "Q17 Correct Key": "B: Comparing their second-best performances",
        "Q17 Mark": 1,
        "Q18 Question": "What is the minimum size of the high jump landing mat?",
        "Q18 Candidate Answer": "B: 5 m × 3 m",
        "Q18 Correct Key": "B: 5 m × 3 m",
        "Q18 Mark": 1,
        "Q19 Question": "In which throwing event are gloves allowed?",
        "Q19 Candidate Answer": "D: Hammer throw",
        "Q19 Correct Key": "D: Hammer throw",
        "Q19 Mark": 1,
        "Q20 Question": "If the shot lands on one of the sector lines:",
        "Q20 Candidate Answer": "C: It is called a foul and not measured",
        "Q20 Correct Key": "C: It is called a foul and not measured",
        "Q20 Mark": 1,
        "Q21 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q21 Candidate Answer": "B: 29°",
        "Q21 Correct Key": "C: 34.92°",
        "Q21 Mark": 0,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "C: 800 g",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 1,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 1,
        "Q24 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q24 Candidate Answer": "C: 6",
        "Q24 Correct Key": "C: 6",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 1,
        "Q26 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q26 Candidate Answer": "C: 2 minutes",
        "Q26 Correct Key": "C: 2 minutes",
        "Q26 Mark": 1,
        "Q27 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q27 Candidate Answer": "C: Disqualified",
        "Q27 Correct Key": "C: Disqualified",
        "Q27 Mark": 1,
        "Q28 Question": "How much energy does 1 g of fat give?",
        "Q28 Candidate Answer": "C: 9.1 kcal",
        "Q28 Correct Key": "C: 9.1 kcal",
        "Q28 Mark": 1,
        "Q29 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q29 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q29 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q29 Mark": 1,
        "Q30 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q30 Candidate Answer": "C: 3",
        "Q30 Correct Key": "C: 3",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 44,
      "registrationNumber": "KOP/2026/06/0230",
      "studentName": "LIPSITA PUROHIT",
      "mobileNumber": "9178124301",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:14:07 pm",
      "startTime": "18 Oct 2026, 02:18:23 pm",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "27 / 30",
      "score": 26,
      "totalMarks": 30,
      "percentage": 86.7,
      "correctCount": 26,
      "wrongCount": 1,
      "unattemptedCount": 3,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 44,
        "Registration ID": "KOP/2026/06/0230",
        "Candidate Name": "LIPSITA PUROHIT",
        "Actually Gave Exam?": "YES",
        "Total Score": "26 / 30",
        "Percentage": "86.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q1 Candidate Answer": "C: 34.92°",
        "Q1 Correct Key": "C: 34.92°",
        "Q1 Mark": 1,
        "Q2 Question": "What is the diameter of the shot put circle?",
        "Q2 Candidate Answer": "B: 2.135 m",
        "Q2 Correct Key": "B: 2.135 m",
        "Q2 Mark": 1,
        "Q3 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q3 Candidate Answer": "C: 32 m/s",
        "Q3 Correct Key": "C: 32 m/s",
        "Q3 Mark": 1,
        "Q4 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: Protein",
        "Q4 Mark": 0,
        "Q5 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q5 Candidate Answer": "B: Yama",
        "Q5 Correct Key": "B: Yama",
        "Q5 Mark": 1,
        "Q6 Question": "If the shot lands on one of the sector lines:",
        "Q6 Candidate Answer": "C: It is called a foul and not measured",
        "Q6 Correct Key": "C: It is called a foul and not measured",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q7 Candidate Answer": "B: 45 minutes",
        "Q7 Correct Key": "B: 45 minutes",
        "Q7 Mark": 1,
        "Q8 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q8 Candidate Answer": "B: Scissors Jump",
        "Q8 Correct Key": "B: Scissors Jump",
        "Q8 Mark": 1,
        "Q9 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q9 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q9 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q9 Mark": 1,
        "Q10 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q10 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q10 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q10 Mark": 1,
        "Q11 Question": "A javelin throw is valid only if:",
        "Q11 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q11 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q11 Mark": 1,
        "Q12 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q12 Candidate Answer": "B: To hold or maintain",
        "Q12 Correct Key": "B: To hold or maintain",
        "Q12 Mark": 1,
        "Q13 Question": "What is the weight of the women's discus?",
        "Q13 Candidate Answer": "B: 1 kg",
        "Q13 Correct Key": "B: 1 kg",
        "Q13 Mark": 1,
        "Q14 Question": "What is the javelin throwing sector angle?",
        "Q14 Candidate Answer": "A: 28.96°",
        "Q14 Correct Key": "A: 28.96°",
        "Q14 Mark": 1,
        "Q15 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q15 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q15 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q15 Mark": 1,
        "Q16 Question": "Which statement about pole vault is correct?",
        "Q16 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q16 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q16 Mark": 1,
        "Q17 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q17 Candidate Answer": "B: 1:2:1",
        "Q17 Correct Key": "B: 1:2:1",
        "Q17 Mark": 1,
        "Q18 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q18 Candidate Answer": "C: 20 m",
        "Q18 Correct Key": "C: 20 m",
        "Q18 Mark": 1,
        "Q19 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Disqualified",
        "Q19 Mark": 0,
        "Q20 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q20 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Mark": 1,
        "Q21 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q21 Candidate Answer": "C: Polish grip",
        "Q21 Correct Key": "D: Orthodox grip",
        "Q21 Mark": 0,
        "Q22 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q22 Candidate Answer": "B: Comparing their second-best performances",
        "Q22 Correct Key": "B: Comparing their second-best performances",
        "Q22 Mark": 1,
        "Q23 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q23 Candidate Answer": "C: To join or unite",
        "Q23 Correct Key": "C: To join or unite",
        "Q23 Mark": 1,
        "Q24 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q24 Candidate Answer": "C: 11",
        "Q24 Correct Key": "C: 11",
        "Q24 Mark": 1,
        "Q25 Question": "What is the official distance of a marathon?",
        "Q25 Candidate Answer": "C: 42.195 km",
        "Q25 Correct Key": "C: 42.195 km",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the men's shot?",
        "Q26 Candidate Answer": "C: 7.260 kg",
        "Q26 Correct Key": "C: 7.260 kg",
        "Q26 Mark": 1,
        "Q27 Question": "How high is the plasticine indicator board?",
        "Q27 Candidate Answer": "B: 7 mm",
        "Q27 Correct Key": "B: 7 mm",
        "Q27 Mark": 1,
        "Q28 Question": "In track and field, a green card is shown when:",
        "Q28 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q28 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q28 Mark": 1,
        "Q29 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q29 Candidate Answer": "C: Pratyahara",
        "Q29 Correct Key": "C: Pratyahara",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 45,
      "registrationNumber": "HD/KOP/2026/0733",
      "studentName": "RANJAN KU. PATEL",
      "mobileNumber": "9178981373",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:19 pm",
      "startTime": "18 Oct 2026, 01:15:46 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "30 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 5,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 45,
        "Registration ID": "HD/KOP/2026/0733",
        "Candidate Name": "RANJAN KU. PATEL",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q1 Candidate Answer": "C: To join or unite",
        "Q1 Correct Key": "C: To join or unite",
        "Q1 Mark": 1,
        "Q2 Question": "In which throwing event are gloves allowed?",
        "Q2 Candidate Answer": "D: Hammer throw",
        "Q2 Correct Key": "D: Hammer throw",
        "Q2 Mark": 1,
        "Q3 Question": "What is the minimum size of the high jump landing mat?",
        "Q3 Candidate Answer": "B: 5 m × 3 m",
        "Q3 Correct Key": "B: 5 m × 3 m",
        "Q3 Mark": 1,
        "Q4 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q4 Candidate Answer": "C: Karma Yoga",
        "Q4 Correct Key": "C: Karma Yoga",
        "Q4 Mark": 1,
        "Q5 Question": "Which statement about pole vault is correct?",
        "Q5 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q5 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q5 Mark": 0,
        "Q6 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q6 Candidate Answer": "C: Scissors Jump",
        "Q6 Correct Key": "D: Fosbury Flop",
        "Q6 Mark": 0,
        "Q7 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q7 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q7 Mark": 1,
        "Q8 Question": "Which of the following is NOT a flight style in long jump?",
        "Q8 Candidate Answer": "D: Fosbury flop",
        "Q8 Correct Key": "D: Fosbury flop",
        "Q8 Mark": 1,
        "Q9 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q9 Candidate Answer": "D: 12",
        "Q9 Correct Key": "C: 11",
        "Q9 Mark": 0,
        "Q10 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q10 Candidate Answer": "A: Laya Yoga",
        "Q10 Correct Key": "A: Laya Yoga",
        "Q10 Mark": 1,
        "Q11 Question": "What is the weight of the men's shot?",
        "Q11 Candidate Answer": "C: 7.260 kg",
        "Q11 Correct Key": "C: 7.260 kg",
        "Q11 Mark": 1,
        "Q12 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q12 Candidate Answer": "D: Averaging all throws",
        "Q12 Correct Key": "B: Comparing their second-best performances",
        "Q12 Mark": 0,
        "Q13 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q13 Candidate Answer": "C: 34.92°",
        "Q13 Correct Key": "C: 34.92°",
        "Q13 Mark": 1,
        "Q14 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q14 Candidate Answer": "B: Scissors Jump",
        "Q14 Correct Key": "B: Scissors Jump",
        "Q14 Mark": 1,
        "Q15 Question": "What is the weight of the women's discus?",
        "Q15 Candidate Answer": "B: 1 kg",
        "Q15 Correct Key": "B: 1 kg",
        "Q15 Mark": 1,
        "Q16 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q16 Candidate Answer": "B: 1:2:1",
        "Q16 Correct Key": "B: 1:2:1",
        "Q16 Mark": 1,
        "Q17 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q17 Candidate Answer": "B: Glide method",
        "Q17 Correct Key": "B: Glide method",
        "Q17 Mark": 1,
        "Q18 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q18 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q18 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q18 Mark": 1,
        "Q19 Question": "What is the official distance of a marathon?",
        "Q19 Candidate Answer": "C: 42.195 km",
        "Q19 Correct Key": "C: 42.195 km",
        "Q19 Mark": 1,
        "Q20 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q20 Candidate Answer": "B: 45 minutes",
        "Q20 Correct Key": "B: 45 minutes",
        "Q20 Mark": 1,
        "Q21 Question": "What is the javelin throwing sector angle?",
        "Q21 Candidate Answer": "A: 28.96°",
        "Q21 Correct Key": "A: 28.96°",
        "Q21 Mark": 1,
        "Q22 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q22 Candidate Answer": "B: Swami Vivekananda",
        "Q22 Correct Key": "B: Swami Vivekananda",
        "Q22 Mark": 1,
        "Q23 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q23 Candidate Answer": "B: Yama",
        "Q23 Correct Key": "B: Yama",
        "Q23 Mark": 1,
        "Q24 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q24 Candidate Answer": "C: Pratyahara",
        "Q24 Correct Key": "C: Pratyahara",
        "Q24 Mark": 1,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 1,
        "Q26 Question": "What is the diameter of the shot put circle?",
        "Q26 Candidate Answer": "B: 2.135 m",
        "Q26 Correct Key": "B: 2.135 m",
        "Q26 Mark": 1,
        "Q27 Question": "How high is the plasticine indicator board?",
        "Q27 Candidate Answer": "A: 5 mm",
        "Q27 Correct Key": "B: 7 mm",
        "Q27 Mark": 0,
        "Q28 Question": "In track and field, a green card is shown when:",
        "Q28 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q28 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q28 Mark": 1,
        "Q29 Question": "What is the diameter of the discus throwing circle?",
        "Q29 Candidate Answer": "B: 2.50 m",
        "Q29 Correct Key": "B: 2.50 m",
        "Q29 Mark": 1,
        "Q30 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q30 Candidate Answer": "C: Protein",
        "Q30 Correct Key": "C: Protein",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 46,
      "registrationNumber": "KOP/2026/09/0033",
      "studentName": "PARESH KUMAR SAHU",
      "mobileNumber": "9348803265",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:10 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 5,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 46,
        "Registration ID": "KOP/2026/09/0033",
        "Candidate Name": "PARESH KUMAR SAHU",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In international competition, the pole vault landing area must be at least:",
        "Q1 Candidate Answer": "C: 6 m × 5 m × 0.7 m",
        "Q1 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q1 Mark": 0,
        "Q2 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q2 Candidate Answer": "C: 3",
        "Q2 Correct Key": "C: 3",
        "Q2 Mark": 1,
        "Q3 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q3 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q3 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q3 Mark": 1,
        "Q4 Question": "How high is the plasticine indicator board?",
        "Q4 Candidate Answer": "B: 7 mm",
        "Q4 Correct Key": "B: 7 mm",
        "Q4 Mark": 1,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "B: Swami Vivekananda",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 1,
        "Q6 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q6 Candidate Answer": "A: Laya Yoga",
        "Q6 Correct Key": "A: Laya Yoga",
        "Q6 Mark": 1,
        "Q7 Question": "How much energy does 1 g of fat give?",
        "Q7 Candidate Answer": "C: 9.1 kcal",
        "Q7 Correct Key": "C: 9.1 kcal",
        "Q7 Mark": 1,
        "Q8 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q8 Candidate Answer": "C: Disqualified",
        "Q8 Correct Key": "C: Disqualified",
        "Q8 Mark": 1,
        "Q9 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q9 Candidate Answer": "C: 50 mm",
        "Q9 Correct Key": "B: 45 mm",
        "Q9 Mark": 0,
        "Q10 Question": "What are the dimensions of the take-off board in long jump?",
        "Q10 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Mark": 1,
        "Q11 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q11 Candidate Answer": "C: Pratyahara",
        "Q11 Correct Key": "C: Pratyahara",
        "Q11 Mark": 1,
        "Q12 Question": "How is a triple jump measured?",
        "Q12 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Mark": 1,
        "Q13 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q13 Candidate Answer": "C: 60 minutes",
        "Q13 Correct Key": "B: 45 minutes",
        "Q13 Mark": 0,
        "Q14 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q14 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q14 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q14 Mark": 1,
        "Q15 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q15 Candidate Answer": "C: Karma Yoga",
        "Q15 Correct Key": "C: Karma Yoga",
        "Q15 Mark": 1,
        "Q16 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q16 Candidate Answer": "D: Orthodox grip",
        "Q16 Correct Key": "D: Orthodox grip",
        "Q16 Mark": 1,
        "Q17 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q17 Candidate Answer": "C: 2 minutes",
        "Q17 Correct Key": "C: 2 minutes",
        "Q17 Mark": 1,
        "Q18 Question": "What is the official distance of a marathon?",
        "Q18 Candidate Answer": "C: 42.195 km",
        "Q18 Correct Key": "C: 42.195 km",
        "Q18 Mark": 1,
        "Q19 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q19 Candidate Answer": "C: 32 m/s",
        "Q19 Correct Key": "C: 32 m/s",
        "Q19 Mark": 1,
        "Q20 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q20 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Mark": 1,
        "Q21 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q21 Candidate Answer": "B: 10",
        "Q21 Correct Key": "C: 11",
        "Q21 Mark": 0,
        "Q22 Question": "What is the minimum size of the high jump landing mat?",
        "Q22 Candidate Answer": "B: 5 m × 3 m",
        "Q22 Correct Key": "B: 5 m × 3 m",
        "Q22 Mark": 1,
        "Q23 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q23 Candidate Answer": "B: 1:2:1",
        "Q23 Correct Key": "B: 1:2:1",
        "Q23 Mark": 1,
        "Q24 Question": "What is the javelin throwing sector angle?",
        "Q24 Candidate Answer": "A: 28.96°",
        "Q24 Correct Key": "A: 28.96°",
        "Q24 Mark": 1,
        "Q25 Question": "What is the weight of the women's discus?",
        "Q25 Candidate Answer": "B: 1 kg",
        "Q25 Correct Key": "B: 1 kg",
        "Q25 Mark": 1,
        "Q26 Question": "Which of the following is NOT a flight style in long jump?",
        "Q26 Candidate Answer": "D: Fosbury flop",
        "Q26 Correct Key": "D: Fosbury flop",
        "Q26 Mark": 1,
        "Q27 Question": "In track and field, a green card is shown when:",
        "Q27 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q27 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q27 Mark": 1,
        "Q28 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q28 Candidate Answer": "B: To hold or maintain",
        "Q28 Correct Key": "B: To hold or maintain",
        "Q28 Mark": 1,
        "Q29 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q29 Candidate Answer": "B: 15 m",
        "Q29 Correct Key": "C: 20 m",
        "Q29 Mark": 0,
        "Q30 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q30 Candidate Answer": "B: Comparing their second-best performances",
        "Q30 Correct Key": "B: Comparing their second-best performances",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 47,
      "registrationNumber": "KOP/2026/09/0097",
      "studentName": "JIBANYAS PUJHARI",
      "mobileNumber": "9583706356",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:18 pm",
      "startTime": "18 Oct 2026, 01:15:13 pm",
      "submissionTime": "18 Oct 2026, 01:49:45 pm",
      "questionsAnswered": "30 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 5,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 47,
        "Registration ID": "KOP/2026/09/0097",
        "Candidate Name": "JIBANYAS PUJHARI",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q1 Candidate Answer": "B: 1:2:1",
        "Q1 Correct Key": "B: 1:2:1",
        "Q1 Mark": 1,
        "Q2 Question": "How much energy does 1 g of fat give?",
        "Q2 Candidate Answer": "C: 9.1 kcal",
        "Q2 Correct Key": "C: 9.1 kcal",
        "Q2 Mark": 1,
        "Q3 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q3 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q3 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q3 Mark": 1,
        "Q4 Question": "If the shot lands on one of the sector lines:",
        "Q4 Candidate Answer": "C: It is called a foul and not measured",
        "Q4 Correct Key": "C: It is called a foul and not measured",
        "Q4 Mark": 1,
        "Q5 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q5 Candidate Answer": "B: To meditate",
        "Q5 Correct Key": "C: To join or unite",
        "Q5 Mark": 0,
        "Q6 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q6 Candidate Answer": "B: 45 minutes",
        "Q6 Correct Key": "B: 45 minutes",
        "Q6 Mark": 1,
        "Q7 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q7 Candidate Answer": "B: Hatha Yoga",
        "Q7 Correct Key": "A: Laya Yoga",
        "Q7 Mark": 0,
        "Q8 Question": "What is the minimum size of the high jump landing mat?",
        "Q8 Candidate Answer": "B: 5 m × 3 m",
        "Q8 Correct Key": "B: 5 m × 3 m",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the women's discus?",
        "Q9 Candidate Answer": "D: 2 kg",
        "Q9 Correct Key": "B: 1 kg",
        "Q9 Mark": 0,
        "Q10 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q10 Candidate Answer": "C: 32 m/s",
        "Q10 Correct Key": "C: 32 m/s",
        "Q10 Mark": 1,
        "Q11 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q11 Candidate Answer": "C: Disqualified",
        "Q11 Correct Key": "C: Disqualified",
        "Q11 Mark": 1,
        "Q12 Question": "How is a triple jump measured?",
        "Q12 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Mark": 1,
        "Q13 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q13 Candidate Answer": "C: 3",
        "Q13 Correct Key": "C: 3",
        "Q13 Mark": 1,
        "Q14 Question": "Which of the following is NOT a flight style in long jump?",
        "Q14 Candidate Answer": "D: Fosbury flop",
        "Q14 Correct Key": "D: Fosbury flop",
        "Q14 Mark": 1,
        "Q15 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q15 Candidate Answer": "B: Swami Vivekananda",
        "Q15 Correct Key": "B: Swami Vivekananda",
        "Q15 Mark": 1,
        "Q16 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q16 Candidate Answer": "C: Protein",
        "Q16 Correct Key": "C: Protein",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the discus throwing circle?",
        "Q17 Candidate Answer": "B: 2.50 m",
        "Q17 Correct Key": "B: 2.50 m",
        "Q17 Mark": 1,
        "Q18 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q18 Candidate Answer": "C: 2 minutes",
        "Q18 Correct Key": "C: 2 minutes",
        "Q18 Mark": 1,
        "Q19 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q19 Candidate Answer": "D: Fosbury Flop",
        "Q19 Correct Key": "D: Fosbury Flop",
        "Q19 Mark": 1,
        "Q20 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q20 Candidate Answer": "B: Glide method",
        "Q20 Correct Key": "B: Glide method",
        "Q20 Mark": 1,
        "Q21 Question": "In international competition, the pole vault landing area must be at least:",
        "Q21 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q21 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q21 Mark": 1,
        "Q22 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q22 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q22 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q22 Mark": 1,
        "Q23 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q23 Candidate Answer": "A: 4",
        "Q23 Correct Key": "C: 6",
        "Q23 Mark": 0,
        "Q24 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q24 Candidate Answer": "A: 10 m",
        "Q24 Correct Key": "C: 20 m",
        "Q24 Mark": 0,
        "Q25 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q25 Candidate Answer": "B: 45 mm",
        "Q25 Correct Key": "B: 45 mm",
        "Q25 Mark": 1,
        "Q26 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q26 Candidate Answer": "B: Comparing their second-best performances",
        "Q26 Correct Key": "B: Comparing their second-best performances",
        "Q26 Mark": 1,
        "Q27 Question": "In track and field, a green card is shown when:",
        "Q27 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q27 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q27 Mark": 1,
        "Q28 Question": "How high is the plasticine indicator board?",
        "Q28 Candidate Answer": "B: 7 mm",
        "Q28 Correct Key": "B: 7 mm",
        "Q28 Mark": 1,
        "Q29 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q29 Candidate Answer": "C: Pratyahara",
        "Q29 Correct Key": "C: Pratyahara",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 48,
      "registrationNumber": "KOP/2026/09/0301",
      "studentName": "GRIDHAR SABAR",
      "mobileNumber": "7849049156",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:47 pm",
      "startTime": "18 Oct 2026, 01:49:38 pm",
      "submissionTime": "18 Oct 2026, 01:55:16 pm",
      "questionsAnswered": "30 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 5,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 48,
        "Registration ID": "KOP/2026/09/0301",
        "Candidate Name": "GRIDHAR SABAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 1,
        "Q2 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q2 Candidate Answer": "A: Western Roll",
        "Q2 Correct Key": "D: Fosbury Flop",
        "Q2 Mark": 0,
        "Q3 Question": "How high is the plasticine indicator board?",
        "Q3 Candidate Answer": "B: 7 mm",
        "Q3 Correct Key": "B: 7 mm",
        "Q3 Mark": 1,
        "Q4 Question": "What is the official distance of a marathon?",
        "Q4 Candidate Answer": "A: 40.195 km",
        "Q4 Correct Key": "C: 42.195 km",
        "Q4 Mark": 0,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "B: Swami Vivekananda",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 1,
        "Q6 Question": "Which of the following is a Niyama?",
        "Q6 Candidate Answer": "C: Svadhyaya",
        "Q6 Correct Key": "C: Svadhyaya",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q7 Candidate Answer": "D: 12",
        "Q7 Correct Key": "C: 11",
        "Q7 Mark": 0,
        "Q8 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q8 Candidate Answer": "C: Karma Yoga",
        "Q8 Correct Key": "C: Karma Yoga",
        "Q8 Mark": 1,
        "Q9 Question": "What are the dimensions of the take-off board in long jump?",
        "Q9 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q9 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q9 Mark": 1,
        "Q10 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q10 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Mark": 1,
        "Q11 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q11 Candidate Answer": "C: Pratyahara",
        "Q11 Correct Key": "C: Pratyahara",
        "Q11 Mark": 1,
        "Q12 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q12 Candidate Answer": "C: 2 minutes",
        "Q12 Correct Key": "C: 2 minutes",
        "Q12 Mark": 1,
        "Q13 Question": "A javelin throw is valid only if:",
        "Q13 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q13 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the men's javelin?",
        "Q14 Candidate Answer": "B: 700 g",
        "Q14 Correct Key": "C: 800 g",
        "Q14 Mark": 0,
        "Q15 Question": "What is the weight of the women's discus?",
        "Q15 Candidate Answer": "C: 1.5 kg",
        "Q15 Correct Key": "B: 1 kg",
        "Q15 Mark": 0,
        "Q16 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q16 Candidate Answer": "B: Scissors Jump",
        "Q16 Correct Key": "B: Scissors Jump",
        "Q16 Mark": 1,
        "Q17 Question": "How much energy does 1 g of fat give?",
        "Q17 Candidate Answer": "C: 9.1 kcal",
        "Q17 Correct Key": "C: 9.1 kcal",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's shot?",
        "Q18 Candidate Answer": "C: 7.260 kg",
        "Q18 Correct Key": "C: 7.260 kg",
        "Q18 Mark": 1,
        "Q19 Question": "How is a triple jump measured?",
        "Q19 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q19 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q19 Mark": 1,
        "Q20 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q20 Candidate Answer": "B: 1:2:1",
        "Q20 Correct Key": "B: 1:2:1",
        "Q20 Mark": 1,
        "Q21 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q21 Candidate Answer": "C: Disqualified",
        "Q21 Correct Key": "C: Disqualified",
        "Q21 Mark": 1,
        "Q22 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q22 Candidate Answer": "A: Laya Yoga",
        "Q22 Correct Key": "A: Laya Yoga",
        "Q22 Mark": 1,
        "Q23 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q23 Candidate Answer": "C: 20 m",
        "Q23 Correct Key": "C: 20 m",
        "Q23 Mark": 1,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 1,
        "Q25 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q25 Candidate Answer": "C: Protein",
        "Q25 Correct Key": "C: Protein",
        "Q25 Mark": 1,
        "Q26 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q26 Candidate Answer": "D: Orthodox grip",
        "Q26 Correct Key": "D: Orthodox grip",
        "Q26 Mark": 1,
        "Q27 Question": "What is the correct sequence of phases in the triple jump?",
        "Q27 Candidate Answer": "C: Hop – Step – Jump",
        "Q27 Correct Key": "C: Hop – Step – Jump",
        "Q27 Mark": 1,
        "Q28 Question": "What is the diameter of the discus throwing circle?",
        "Q28 Candidate Answer": "B: 2.50 m",
        "Q28 Correct Key": "B: 2.50 m",
        "Q28 Mark": 1,
        "Q29 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q29 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q29 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q29 Mark": 1,
        "Q30 Question": "What is the javelin throwing sector angle?",
        "Q30 Candidate Answer": "A: 28.96°",
        "Q30 Correct Key": "A: 28.96°",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 49,
      "registrationNumber": "KOP/2026/09/0305",
      "studentName": "SUMANTA KUMAR NAIK",
      "mobileNumber": "9861362085",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:10 pm",
      "startTime": "18 Oct 2026, 01:15:34 pm",
      "submissionTime": "18 Oct 2026, 01:47:40 pm",
      "questionsAnswered": "30 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 5,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 49,
        "Registration ID": "KOP/2026/09/0305",
        "Candidate Name": "SUMANTA KUMAR NAIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q1 Candidate Answer": "C: To join or unite",
        "Q1 Correct Key": "C: To join or unite",
        "Q1 Mark": 1,
        "Q2 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q2 Candidate Answer": "D: Orthodox grip",
        "Q2 Correct Key": "D: Orthodox grip",
        "Q2 Mark": 1,
        "Q3 Question": "Lactose (milk sugar) is made of:",
        "Q3 Candidate Answer": "C: Glucose + Galactose",
        "Q3 Correct Key": "C: Glucose + Galactose",
        "Q3 Mark": 1,
        "Q4 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q4 Candidate Answer": "C: 34.92°",
        "Q4 Correct Key": "C: 34.92°",
        "Q4 Mark": 1,
        "Q5 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q5 Candidate Answer": "B: 15 m",
        "Q5 Correct Key": "C: 20 m",
        "Q5 Mark": 0,
        "Q6 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q6 Candidate Answer": "D: Standing method",
        "Q6 Correct Key": "B: Glide method",
        "Q6 Mark": 0,
        "Q7 Question": "How is a triple jump measured?",
        "Q7 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q7 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q7 Mark": 1,
        "Q8 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q8 Candidate Answer": "B: To hold or maintain",
        "Q8 Correct Key": "B: To hold or maintain",
        "Q8 Mark": 1,
        "Q9 Question": "In which throwing event are gloves allowed?",
        "Q9 Candidate Answer": "D: Hammer throw",
        "Q9 Correct Key": "D: Hammer throw",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's shot?",
        "Q10 Candidate Answer": "C: 7.260 kg",
        "Q10 Correct Key": "C: 7.260 kg",
        "Q10 Mark": 1,
        "Q11 Question": "A javelin throw is valid only if:",
        "Q11 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q11 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q11 Mark": 1,
        "Q12 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q12 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q12 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q12 Mark": 1,
        "Q13 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q13 Candidate Answer": "C: 2 minutes",
        "Q13 Correct Key": "C: 2 minutes",
        "Q13 Mark": 1,
        "Q14 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q14 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q14 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q14 Mark": 1,
        "Q15 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q15 Candidate Answer": "B: 1:2:1",
        "Q15 Correct Key": "B: 1:2:1",
        "Q15 Mark": 1,
        "Q16 Question": "Which of the following is a Niyama?",
        "Q16 Candidate Answer": "C: Svadhyaya",
        "Q16 Correct Key": "C: Svadhyaya",
        "Q16 Mark": 1,
        "Q17 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q17 Candidate Answer": "B: Scissors Jump",
        "Q17 Correct Key": "B: Scissors Jump",
        "Q17 Mark": 1,
        "Q18 Question": "What is the weight of the men's javelin?",
        "Q18 Candidate Answer": "C: 800 g",
        "Q18 Correct Key": "C: 800 g",
        "Q18 Mark": 1,
        "Q19 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q19 Candidate Answer": "C: 6",
        "Q19 Correct Key": "C: 6",
        "Q19 Mark": 1,
        "Q20 Question": "How high is the plasticine indicator board?",
        "Q20 Candidate Answer": "B: 7 mm",
        "Q20 Correct Key": "B: 7 mm",
        "Q20 Mark": 1,
        "Q21 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q21 Candidate Answer": "C: 32 m/s",
        "Q21 Correct Key": "C: 32 m/s",
        "Q21 Mark": 1,
        "Q22 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q22 Candidate Answer": "A: Laya Yoga",
        "Q22 Correct Key": "A: Laya Yoga",
        "Q22 Mark": 1,
        "Q23 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q23 Candidate Answer": "B: 10",
        "Q23 Correct Key": "C: 11",
        "Q23 Mark": 0,
        "Q24 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q24 Candidate Answer": "C: 3",
        "Q24 Correct Key": "C: 3",
        "Q24 Mark": 1,
        "Q25 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q25 Candidate Answer": "D: Fosbury Flop",
        "Q25 Correct Key": "D: Fosbury Flop",
        "Q25 Mark": 1,
        "Q26 Question": "In international competition, the pole vault landing area must be at least:",
        "Q26 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q26 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q26 Mark": 1,
        "Q27 Question": "Which statement about pole vault is correct?",
        "Q27 Candidate Answer": "A: Gloves are not permitted",
        "Q27 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q27 Mark": 0,
        "Q28 Question": "How much energy does 1 g of fat give?",
        "Q28 Candidate Answer": "C: 9.1 kcal",
        "Q28 Correct Key": "C: 9.1 kcal",
        "Q28 Mark": 1,
        "Q29 Question": "What is the correct sequence of phases in the triple jump?",
        "Q29 Candidate Answer": "C: Hop – Step – Jump",
        "Q29 Correct Key": "C: Hop – Step – Jump",
        "Q29 Mark": 1,
        "Q30 Question": "What is the official distance of a marathon?",
        "Q30 Candidate Answer": "D: 44.195 km",
        "Q30 Correct Key": "C: 42.195 km",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 50,
      "registrationNumber": "KOP/2026/09/0024",
      "studentName": "SUSMITA BAGHAR",
      "mobileNumber": "9777702850",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:11:46 pm",
      "startTime": "18 Oct 2026, 02:13:06 pm",
      "submissionTime": "18 Oct 2026, 02:21:44 pm",
      "questionsAnswered": "29 / 30",
      "score": 25,
      "totalMarks": 30,
      "percentage": 83.3,
      "correctCount": 25,
      "wrongCount": 4,
      "unattemptedCount": 1,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 50,
        "Registration ID": "KOP/2026/09/0024",
        "Candidate Name": "SUSMITA BAGHAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "25 / 30",
        "Percentage": "83.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q1 Candidate Answer": "D: 12",
        "Q1 Correct Key": "C: 11",
        "Q1 Mark": 0,
        "Q2 Question": "Which of the following is a Niyama?",
        "Q2 Candidate Answer": "C: Svadhyaya",
        "Q2 Correct Key": "C: Svadhyaya",
        "Q2 Mark": 1,
        "Q3 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q3 Candidate Answer": "C: 20 m",
        "Q3 Correct Key": "C: 20 m",
        "Q3 Mark": 1,
        "Q4 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q4 Candidate Answer": "D: 40 m/s",
        "Q4 Correct Key": "C: 32 m/s",
        "Q4 Mark": 0,
        "Q5 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q5 Candidate Answer": "C: Pratyahara",
        "Q5 Correct Key": "C: Pratyahara",
        "Q5 Mark": 1,
        "Q6 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q6 Candidate Answer": "B: Yama",
        "Q6 Correct Key": "B: Yama",
        "Q6 Mark": 1,
        "Q7 Question": "How is a triple jump measured?",
        "Q7 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q7 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q7 Mark": 1,
        "Q8 Question": "Lactose (milk sugar) is made of:",
        "Q8 Candidate Answer": "C: Glucose + Galactose",
        "Q8 Correct Key": "C: Glucose + Galactose",
        "Q8 Mark": 1,
        "Q9 Question": "What is the official distance of a marathon?",
        "Q9 Candidate Answer": "C: 42.195 km",
        "Q9 Correct Key": "C: 42.195 km",
        "Q9 Mark": 1,
        "Q10 Question": "How high is the plasticine indicator board?",
        "Q10 Candidate Answer": "C: 10 mm",
        "Q10 Correct Key": "B: 7 mm",
        "Q10 Mark": 0,
        "Q11 Question": "In which throwing event are gloves allowed?",
        "Q11 Candidate Answer": "D: Hammer throw",
        "Q11 Correct Key": "D: Hammer throw",
        "Q11 Mark": 1,
        "Q12 Question": "What is the diameter of the discus throwing circle?",
        "Q12 Candidate Answer": "B: 2.50 m",
        "Q12 Correct Key": "B: 2.50 m",
        "Q12 Mark": 1,
        "Q13 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q13 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q13 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the men's shot?",
        "Q14 Candidate Answer": "C: 7.260 kg",
        "Q14 Correct Key": "C: 7.260 kg",
        "Q14 Mark": 1,
        "Q15 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q15 Candidate Answer": "C: 2 minutes",
        "Q15 Correct Key": "C: 2 minutes",
        "Q15 Mark": 1,
        "Q16 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q16 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q16 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q16 Mark": 1,
        "Q17 Question": "What is the weight of the men's javelin?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: 800 g",
        "Q17 Mark": 0,
        "Q18 Question": "In international competition, the pole vault landing area must be at least:",
        "Q18 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q18 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q18 Mark": 1,
        "Q19 Question": "How much energy does 1 g of fat give?",
        "Q19 Candidate Answer": "C: 9.1 kcal",
        "Q19 Correct Key": "C: 9.1 kcal",
        "Q19 Mark": 1,
        "Q20 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q20 Candidate Answer": "C: 3",
        "Q20 Correct Key": "C: 3",
        "Q20 Mark": 1,
        "Q21 Question": "Which of the following is NOT a flight style in long jump?",
        "Q21 Candidate Answer": "D: Fosbury flop",
        "Q21 Correct Key": "D: Fosbury flop",
        "Q21 Mark": 1,
        "Q22 Question": "Which statement about pole vault is correct?",
        "Q22 Candidate Answer": "A: Gloves are not permitted",
        "Q22 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q22 Mark": 0,
        "Q23 Question": "What is the correct sequence of phases in the triple jump?",
        "Q23 Candidate Answer": "C: Hop – Step – Jump",
        "Q23 Correct Key": "C: Hop – Step – Jump",
        "Q23 Mark": 1,
        "Q24 Question": "What is the diameter of the shot put circle?",
        "Q24 Candidate Answer": "B: 2.135 m",
        "Q24 Correct Key": "B: 2.135 m",
        "Q24 Mark": 1,
        "Q25 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q25 Candidate Answer": "B: 45 mm",
        "Q25 Correct Key": "B: 45 mm",
        "Q25 Mark": 1,
        "Q26 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q26 Candidate Answer": "B: To hold or maintain",
        "Q26 Correct Key": "B: To hold or maintain",
        "Q26 Mark": 1,
        "Q27 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q27 Candidate Answer": "D: Fosbury Flop",
        "Q27 Correct Key": "D: Fosbury Flop",
        "Q27 Mark": 1,
        "Q28 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q28 Candidate Answer": "B: Scissors Jump",
        "Q28 Correct Key": "B: Scissors Jump",
        "Q28 Mark": 1,
        "Q29 Question": "What are the dimensions of the take-off board in long jump?",
        "Q29 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q29 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q29 Mark": 1,
        "Q30 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q30 Candidate Answer": "C: Karma Yoga",
        "Q30 Correct Key": "C: Karma Yoga",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 51,
      "registrationNumber": "KOP/2026/08/0459",
      "studentName": "PRAKASH SAGRIA",
      "mobileNumber": "9668435062",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:17 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 24,
      "totalMarks": 30,
      "percentage": 80,
      "correctCount": 24,
      "wrongCount": 6,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 51,
        "Registration ID": "KOP/2026/08/0459",
        "Candidate Name": "PRAKASH SAGRIA",
        "Actually Gave Exam?": "YES",
        "Total Score": "24 / 30",
        "Percentage": "80%",
        "Result": "QUALIFIED",
        "Q1 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q1 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Mark": 1,
        "Q2 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q2 Candidate Answer": "C: Protein",
        "Q2 Correct Key": "C: Protein",
        "Q2 Mark": 1,
        "Q3 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q3 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q3 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q3 Mark": 1,
        "Q4 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q4 Candidate Answer": "B: Scissors Jump",
        "Q4 Correct Key": "B: Scissors Jump",
        "Q4 Mark": 1,
        "Q5 Question": "How high is the plasticine indicator board?",
        "Q5 Candidate Answer": "C: 10 mm",
        "Q5 Correct Key": "B: 7 mm",
        "Q5 Mark": 0,
        "Q6 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q6 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q6 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q6 Mark": 1,
        "Q7 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q7 Candidate Answer": "B: Yama",
        "Q7 Correct Key": "B: Yama",
        "Q7 Mark": 1,
        "Q8 Question": "What is the official distance of a marathon?",
        "Q8 Candidate Answer": "C: 42.195 km",
        "Q8 Correct Key": "C: 42.195 km",
        "Q8 Mark": 1,
        "Q9 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q9 Candidate Answer": "A: Laya Yoga",
        "Q9 Correct Key": "A: Laya Yoga",
        "Q9 Mark": 1,
        "Q10 Question": "What are the dimensions of the take-off board in long jump?",
        "Q10 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Mark": 1,
        "Q11 Question": "How much energy does 1 g of fat give?",
        "Q11 Candidate Answer": "C: 9.1 kcal",
        "Q11 Correct Key": "C: 9.1 kcal",
        "Q11 Mark": 1,
        "Q12 Question": "A javelin throw is valid only if:",
        "Q12 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q12 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q12 Mark": 1,
        "Q13 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q13 Candidate Answer": "C: 11",
        "Q13 Correct Key": "C: 11",
        "Q13 Mark": 1,
        "Q14 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q14 Candidate Answer": "A: Finnish grip",
        "Q14 Correct Key": "D: Orthodox grip",
        "Q14 Mark": 0,
        "Q15 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q15 Candidate Answer": "C: 2 minutes",
        "Q15 Correct Key": "C: 2 minutes",
        "Q15 Mark": 1,
        "Q16 Question": "What is the diameter of the discus throwing circle?",
        "Q16 Candidate Answer": "B: 2.50 m",
        "Q16 Correct Key": "B: 2.50 m",
        "Q16 Mark": 1,
        "Q17 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q17 Candidate Answer": "C: To join or unite",
        "Q17 Correct Key": "C: To join or unite",
        "Q17 Mark": 1,
        "Q18 Question": "In track and field, a green card is shown when:",
        "Q18 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q18 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q18 Mark": 1,
        "Q19 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q19 Candidate Answer": "C: Pratyahara",
        "Q19 Correct Key": "C: Pratyahara",
        "Q19 Mark": 1,
        "Q20 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q20 Candidate Answer": "A: Maharishi Patanjali",
        "Q20 Correct Key": "B: Swami Vivekananda",
        "Q20 Mark": 0,
        "Q21 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q21 Candidate Answer": "B: Glide method",
        "Q21 Correct Key": "B: Glide method",
        "Q21 Mark": 1,
        "Q22 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q22 Candidate Answer": "A: 4",
        "Q22 Correct Key": "C: 6",
        "Q22 Mark": 0,
        "Q23 Question": "Which statement about pole vault is correct?",
        "Q23 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q23 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q23 Mark": 1,
        "Q24 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q24 Candidate Answer": "A: 30 minutes",
        "Q24 Correct Key": "B: 45 minutes",
        "Q24 Mark": 0,
        "Q25 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q25 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q25 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q25 Mark": 1,
        "Q26 Question": "What is the weight of the women's discus?",
        "Q26 Candidate Answer": "C: 1.5 kg",
        "Q26 Correct Key": "B: 1 kg",
        "Q26 Mark": 0,
        "Q27 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q27 Candidate Answer": "B: 1:2:1",
        "Q27 Correct Key": "B: 1:2:1",
        "Q27 Mark": 1,
        "Q28 Question": "What is the correct sequence of phases in the triple jump?",
        "Q28 Candidate Answer": "C: Hop – Step – Jump",
        "Q28 Correct Key": "C: Hop – Step – Jump",
        "Q28 Mark": 1,
        "Q29 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q29 Candidate Answer": "C: 3",
        "Q29 Correct Key": "C: 3",
        "Q29 Mark": 1,
        "Q30 Question": "What is the minimum size of the high jump landing mat?",
        "Q30 Candidate Answer": "B: 5 m × 3 m",
        "Q30 Correct Key": "B: 5 m × 3 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 52,
      "registrationNumber": "KOP/2026/08/0468",
      "studentName": "PRIYANKA PRIYADARSHINI BRAHMA",
      "mobileNumber": "8144296953",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:03:00 pm",
      "startTime": "18 Oct 2026, 01:16:34 pm",
      "submissionTime": "18 Oct 2026, 01:35:14 pm",
      "questionsAnswered": "30 / 30",
      "score": 24,
      "totalMarks": 30,
      "percentage": 80,
      "correctCount": 24,
      "wrongCount": 6,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 52,
        "Registration ID": "KOP/2026/08/0468",
        "Candidate Name": "PRIYANKA PRIYADARSHINI BRAHMA",
        "Actually Gave Exam?": "YES",
        "Total Score": "24 / 30",
        "Percentage": "80%",
        "Result": "QUALIFIED",
        "Q1 Question": "How is a triple jump measured?",
        "Q1 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q1 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q1 Mark": 1,
        "Q2 Question": "What is the weight of the women's discus?",
        "Q2 Candidate Answer": "B: 1 kg",
        "Q2 Correct Key": "B: 1 kg",
        "Q2 Mark": 1,
        "Q3 Question": "Which of the following is a Niyama?",
        "Q3 Candidate Answer": "C: Svadhyaya",
        "Q3 Correct Key": "C: Svadhyaya",
        "Q3 Mark": 1,
        "Q4 Question": "In international competition, the pole vault landing area must be at least:",
        "Q4 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q4 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q4 Mark": 1,
        "Q5 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q5 Candidate Answer": "C: 50 mm",
        "Q5 Correct Key": "B: 45 mm",
        "Q5 Mark": 0,
        "Q6 Question": "A javelin throw is valid only if:",
        "Q6 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q6 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q6 Mark": 1,
        "Q7 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q7 Candidate Answer": "C: To join or unite",
        "Q7 Correct Key": "C: To join or unite",
        "Q7 Mark": 1,
        "Q8 Question": "In which throwing event are gloves allowed?",
        "Q8 Candidate Answer": "D: Hammer throw",
        "Q8 Correct Key": "D: Hammer throw",
        "Q8 Mark": 1,
        "Q9 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q9 Candidate Answer": "C: 32 m/s",
        "Q9 Correct Key": "C: 32 m/s",
        "Q9 Mark": 1,
        "Q10 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q10 Candidate Answer": "A: Finnish grip",
        "Q10 Correct Key": "D: Orthodox grip",
        "Q10 Mark": 0,
        "Q11 Question": "What is the weight of the men's javelin?",
        "Q11 Candidate Answer": "C: 800 g",
        "Q11 Correct Key": "C: 800 g",
        "Q11 Mark": 1,
        "Q12 Question": "What is the javelin throwing sector angle?",
        "Q12 Candidate Answer": "C: 34.92°",
        "Q12 Correct Key": "A: 28.96°",
        "Q12 Mark": 0,
        "Q13 Question": "In track and field, a green card is shown when:",
        "Q13 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q13 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q13 Mark": 1,
        "Q14 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q14 Candidate Answer": "B: Comparing their second-best performances",
        "Q14 Correct Key": "B: Comparing their second-best performances",
        "Q14 Mark": 1,
        "Q15 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q15 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Mark": 1,
        "Q16 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q16 Candidate Answer": "B: To hold or maintain",
        "Q16 Correct Key": "B: To hold or maintain",
        "Q16 Mark": 1,
        "Q17 Question": "What are the dimensions of the take-off board in long jump?",
        "Q17 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q17 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q17 Mark": 1,
        "Q18 Question": "What is the diameter of the discus throwing circle?",
        "Q18 Candidate Answer": "B: 2.50 m",
        "Q18 Correct Key": "B: 2.50 m",
        "Q18 Mark": 1,
        "Q19 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q19 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q19 Mark": 1,
        "Q20 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q20 Candidate Answer": "B: Swami Vivekananda",
        "Q20 Correct Key": "B: Swami Vivekananda",
        "Q20 Mark": 1,
        "Q21 Question": "What is the correct sequence of phases in the triple jump?",
        "Q21 Candidate Answer": "C: Hop – Step – Jump",
        "Q21 Correct Key": "C: Hop – Step – Jump",
        "Q21 Mark": 1,
        "Q22 Question": "Lactose (milk sugar) is made of:",
        "Q22 Candidate Answer": "C: Glucose + Galactose",
        "Q22 Correct Key": "C: Glucose + Galactose",
        "Q22 Mark": 1,
        "Q23 Question": "Which of the following is NOT a flight style in long jump?",
        "Q23 Candidate Answer": "D: Fosbury flop",
        "Q23 Correct Key": "D: Fosbury flop",
        "Q23 Mark": 1,
        "Q24 Question": "What is the minimum size of the high jump landing mat?",
        "Q24 Candidate Answer": "D: 9 m × 2.75 m",
        "Q24 Correct Key": "B: 5 m × 3 m",
        "Q24 Mark": 0,
        "Q25 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q25 Candidate Answer": "C: Pratyahara",
        "Q25 Correct Key": "C: Pratyahara",
        "Q25 Mark": 1,
        "Q26 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q26 Candidate Answer": "C: Karma Yoga",
        "Q26 Correct Key": "C: Karma Yoga",
        "Q26 Mark": 1,
        "Q27 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q27 Candidate Answer": "C: 20 m",
        "Q27 Correct Key": "C: 20 m",
        "Q27 Mark": 1,
        "Q28 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q28 Candidate Answer": "C: 34.92°",
        "Q28 Correct Key": "C: 34.92°",
        "Q28 Mark": 1,
        "Q29 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q29 Candidate Answer": "B: 5",
        "Q29 Correct Key": "C: 6",
        "Q29 Mark": 0,
        "Q30 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q30 Candidate Answer": "B: 10",
        "Q30 Correct Key": "C: 11",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 53,
      "registrationNumber": "KOP/2026/07/0321",
      "studentName": "RAJKISHOR SETHI",
      "mobileNumber": "9937775201",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:08:07 pm",
      "startTime": "18 Oct 2026, 01:16:50 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "26 / 30",
      "score": 24,
      "totalMarks": 30,
      "percentage": 80,
      "correctCount": 24,
      "wrongCount": 2,
      "unattemptedCount": 4,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 53,
        "Registration ID": "KOP/2026/07/0321",
        "Candidate Name": "RAJKISHOR SETHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "24 / 30",
        "Percentage": "80%",
        "Result": "QUALIFIED",
        "Q1 Question": "Lactose (milk sugar) is made of:",
        "Q1 Candidate Answer": "B: Glucose + Fructose",
        "Q1 Correct Key": "C: Glucose + Galactose",
        "Q1 Mark": 0,
        "Q2 Question": "How is a triple jump measured?",
        "Q2 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q2 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q2 Mark": 1,
        "Q3 Question": "A javelin throw is valid only if:",
        "Q3 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q3 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q3 Mark": 1,
        "Q4 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q4 Candidate Answer": "C: 2 minutes",
        "Q4 Correct Key": "C: 2 minutes",
        "Q4 Mark": 1,
        "Q5 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q5 Candidate Answer": "C: 34.92°",
        "Q5 Correct Key": "C: 34.92°",
        "Q5 Mark": 1,
        "Q6 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q6 Candidate Answer": "C: Pratyahara",
        "Q6 Correct Key": "C: Pratyahara",
        "Q6 Mark": 1,
        "Q7 Question": "What is the weight of the men's javelin?",
        "Q7 Candidate Answer": "C: 800 g",
        "Q7 Correct Key": "C: 800 g",
        "Q7 Mark": 1,
        "Q8 Question": "What is the weight of the women's discus?",
        "Q8 Candidate Answer": "B: 1 kg",
        "Q8 Correct Key": "B: 1 kg",
        "Q8 Mark": 1,
        "Q9 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q9 Candidate Answer": "B: Yama",
        "Q9 Correct Key": "B: Yama",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's shot?",
        "Q10 Candidate Answer": "C: 7.260 kg",
        "Q10 Correct Key": "C: 7.260 kg",
        "Q10 Mark": 1,
        "Q11 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q11 Candidate Answer": "B: Swami Vivekananda",
        "Q11 Correct Key": "B: Swami Vivekananda",
        "Q11 Mark": 1,
        "Q12 Question": "What is the javelin throwing sector angle?",
        "Q12 Candidate Answer": "A: 28.96°",
        "Q12 Correct Key": "A: 28.96°",
        "Q12 Mark": 1,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "B: Scissors Jump",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 1,
        "Q14 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q14 Candidate Answer": "C: To join or unite",
        "Q14 Correct Key": "C: To join or unite",
        "Q14 Mark": 1,
        "Q15 Question": "Which of the following is NOT a flight style in long jump?",
        "Q15 Candidate Answer": "D: Fosbury flop",
        "Q15 Correct Key": "D: Fosbury flop",
        "Q15 Mark": 1,
        "Q16 Question": "In track and field, a green card is shown when:",
        "Q16 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q16 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q16 Mark": 1,
        "Q17 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q17 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Mark": 1,
        "Q18 Question": "How much energy does 1 g of fat give?",
        "Q18 Candidate Answer": "C: 9.1 kcal",
        "Q18 Correct Key": "C: 9.1 kcal",
        "Q18 Mark": 1,
        "Q19 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q19 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q19 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q19 Mark": 1,
        "Q20 Question": "What are the dimensions of the take-off board in long jump?",
        "Q20 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q20 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q20 Mark": 1,
        "Q21 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q21 Candidate Answer": "D: Fosbury Flop",
        "Q21 Correct Key": "D: Fosbury Flop",
        "Q21 Mark": 1,
        "Q22 Question": "What is the correct sequence of phases in the triple jump?",
        "Q22 Candidate Answer": "C: Hop – Step – Jump",
        "Q22 Correct Key": "C: Hop – Step – Jump",
        "Q22 Mark": 1,
        "Q23 Question": "What is the minimum size of the high jump landing mat?",
        "Q23 Candidate Answer": "C: 6 m × 6 m",
        "Q23 Correct Key": "B: 5 m × 3 m",
        "Q23 Mark": 0,
        "Q24 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q24 Candidate Answer": "B: 45 minutes",
        "Q24 Correct Key": "B: 45 minutes",
        "Q24 Mark": 1,
        "Q25 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q25 Candidate Answer": "B: 1:2:1",
        "Q25 Correct Key": "B: 1:2:1",
        "Q25 Mark": 1,
        "Q26 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q26 Candidate Answer": "C: 11",
        "Q26 Correct Key": "C: 11",
        "Q26 Mark": 1,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 0,
        "Q28 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q28 Mark": 0,
        "Q29 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "A: Laya Yoga",
        "Q29 Mark": 0,
        "Q30 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: 6",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 54,
      "registrationNumber": "KOP/2026/07/0344",
      "studentName": "JYOTIMAYEE HANS",
      "mobileNumber": "7991013062",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:04:00 pm",
      "startTime": "18 Oct 2026, 02:05:47 pm",
      "submissionTime": "18 Oct 2026, 02:24:26 pm",
      "questionsAnswered": "30 / 30",
      "score": 23,
      "totalMarks": 30,
      "percentage": 76.7,
      "correctCount": 23,
      "wrongCount": 7,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 54,
        "Registration ID": "KOP/2026/07/0344",
        "Candidate Name": "JYOTIMAYEE HANS",
        "Actually Gave Exam?": "YES",
        "Total Score": "23 / 30",
        "Percentage": "76.7%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "C: Svadhyaya",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 1,
        "Q2 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q2 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q2 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q2 Mark": 1,
        "Q3 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q3 Candidate Answer": "D: Fosbury Flop",
        "Q3 Correct Key": "D: Fosbury Flop",
        "Q3 Mark": 1,
        "Q4 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q4 Candidate Answer": "A: 28.96°",
        "Q4 Correct Key": "C: 34.92°",
        "Q4 Mark": 0,
        "Q5 Question": "How is a triple jump measured?",
        "Q5 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q5 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q5 Mark": 1,
        "Q6 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q6 Candidate Answer": "B: To hold or maintain",
        "Q6 Correct Key": "B: To hold or maintain",
        "Q6 Mark": 1,
        "Q7 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q7 Candidate Answer": "B: Scissors Jump",
        "Q7 Correct Key": "B: Scissors Jump",
        "Q7 Mark": 1,
        "Q8 Question": "A javelin throw is valid only if:",
        "Q8 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q8 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q8 Mark": 1,
        "Q9 Question": "Which statement about pole vault is correct?",
        "Q9 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's javelin?",
        "Q10 Candidate Answer": "C: 800 g",
        "Q10 Correct Key": "C: 800 g",
        "Q10 Mark": 1,
        "Q11 Question": "In international competition, the pole vault landing area must be at least:",
        "Q11 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q11 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q11 Mark": 1,
        "Q12 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q12 Candidate Answer": "C: To join or unite",
        "Q12 Correct Key": "C: To join or unite",
        "Q12 Mark": 1,
        "Q13 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q13 Candidate Answer": "C: 3",
        "Q13 Correct Key": "C: 3",
        "Q13 Mark": 1,
        "Q14 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q14 Candidate Answer": "C: Polish grip",
        "Q14 Correct Key": "D: Orthodox grip",
        "Q14 Mark": 0,
        "Q15 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q15 Candidate Answer": "C: Karma Yoga",
        "Q15 Correct Key": "C: Karma Yoga",
        "Q15 Mark": 1,
        "Q16 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q16 Candidate Answer": "B: 28 m/s",
        "Q16 Correct Key": "C: 32 m/s",
        "Q16 Mark": 0,
        "Q17 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q17 Candidate Answer": "C: Protein",
        "Q17 Correct Key": "C: Protein",
        "Q17 Mark": 1,
        "Q18 Question": "What is the minimum size of the high jump landing mat?",
        "Q18 Candidate Answer": "B: 5 m × 3 m",
        "Q18 Correct Key": "B: 5 m × 3 m",
        "Q18 Mark": 1,
        "Q19 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q19 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q19 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q19 Mark": 1,
        "Q20 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q20 Candidate Answer": "A: Laya Yoga",
        "Q20 Correct Key": "A: Laya Yoga",
        "Q20 Mark": 1,
        "Q21 Question": "What are the dimensions of the take-off board in long jump?",
        "Q21 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q21 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q21 Mark": 1,
        "Q22 Question": "If the shot lands on one of the sector lines:",
        "Q22 Candidate Answer": "A: It is measured normally",
        "Q22 Correct Key": "C: It is called a foul and not measured",
        "Q22 Mark": 0,
        "Q23 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q23 Candidate Answer": "B: Glide method",
        "Q23 Correct Key": "B: Glide method",
        "Q23 Mark": 1,
        "Q24 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q24 Candidate Answer": "B: 45 mm",
        "Q24 Correct Key": "B: 45 mm",
        "Q24 Mark": 1,
        "Q25 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q25 Candidate Answer": "B: 45 minutes",
        "Q25 Correct Key": "B: 45 minutes",
        "Q25 Mark": 1,
        "Q26 Question": "What is the javelin throwing sector angle?",
        "Q26 Candidate Answer": "C: 34.92°",
        "Q26 Correct Key": "A: 28.96°",
        "Q26 Mark": 0,
        "Q27 Question": "What is the diameter of the discus throwing circle?",
        "Q27 Candidate Answer": "A: 2.135 m",
        "Q27 Correct Key": "B: 2.50 m",
        "Q27 Mark": 0,
        "Q28 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q28 Candidate Answer": "C: Disqualified",
        "Q28 Correct Key": "C: Disqualified",
        "Q28 Mark": 1,
        "Q29 Question": "What is the correct sequence of phases in the triple jump?",
        "Q29 Candidate Answer": "B: Hop – Jump – Step",
        "Q29 Correct Key": "C: Hop – Step – Jump",
        "Q29 Mark": 0,
        "Q30 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q30 Candidate Answer": "B: Yama",
        "Q30 Correct Key": "B: Yama",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 55,
      "registrationNumber": "KOP/2026/05/0108",
      "studentName": "Prakash Danga",
      "mobileNumber": "7681093770",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:42 pm",
      "startTime": "18 Oct 2026, 01:15:46 pm",
      "submissionTime": "18 Oct 2026, 01:58:41 pm",
      "questionsAnswered": "30 / 30",
      "score": 22,
      "totalMarks": 30,
      "percentage": 73.3,
      "correctCount": 22,
      "wrongCount": 8,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 55,
        "Registration ID": "KOP/2026/05/0108",
        "Candidate Name": "Prakash Danga",
        "Actually Gave Exam?": "YES",
        "Total Score": "22 / 30",
        "Percentage": "73.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "A javelin throw is valid only if:",
        "Q1 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q1 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q1 Mark": 1,
        "Q2 Question": "Which statement about pole vault is correct?",
        "Q2 Candidate Answer": "A: Gloves are not permitted",
        "Q2 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q2 Mark": 0,
        "Q3 Question": "What is the official distance of a marathon?",
        "Q3 Candidate Answer": "C: 42.195 km",
        "Q3 Correct Key": "C: 42.195 km",
        "Q3 Mark": 1,
        "Q4 Question": "How is a triple jump measured?",
        "Q4 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q4 Mark": 1,
        "Q5 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q5 Candidate Answer": "C: 20 m",
        "Q5 Correct Key": "C: 20 m",
        "Q5 Mark": 1,
        "Q6 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q6 Candidate Answer": "B: To hold or maintain",
        "Q6 Correct Key": "B: To hold or maintain",
        "Q6 Mark": 1,
        "Q7 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q7 Candidate Answer": "C: 32 m/s",
        "Q7 Correct Key": "C: 32 m/s",
        "Q7 Mark": 1,
        "Q8 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q8 Candidate Answer": "A: Maharishi Patanjali",
        "Q8 Correct Key": "B: Swami Vivekananda",
        "Q8 Mark": 0,
        "Q9 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q9 Candidate Answer": "C: Disqualified",
        "Q9 Correct Key": "C: Disqualified",
        "Q9 Mark": 1,
        "Q10 Question": "How much energy does 1 g of fat give?",
        "Q10 Candidate Answer": "C: 9.1 kcal",
        "Q10 Correct Key": "C: 9.1 kcal",
        "Q10 Mark": 1,
        "Q11 Question": "What is the javelin throwing sector angle?",
        "Q11 Candidate Answer": "A: 28.96°",
        "Q11 Correct Key": "A: 28.96°",
        "Q11 Mark": 1,
        "Q12 Question": "In which throwing event are gloves allowed?",
        "Q12 Candidate Answer": "D: Hammer throw",
        "Q12 Correct Key": "D: Hammer throw",
        "Q12 Mark": 1,
        "Q13 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q13 Candidate Answer": "C: To join or unite",
        "Q13 Correct Key": "C: To join or unite",
        "Q13 Mark": 1,
        "Q14 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q14 Candidate Answer": "B: Yama",
        "Q14 Correct Key": "B: Yama",
        "Q14 Mark": 1,
        "Q15 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q15 Candidate Answer": "C: Pratyahara",
        "Q15 Correct Key": "C: Pratyahara",
        "Q15 Mark": 1,
        "Q16 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q16 Candidate Answer": "B: 5",
        "Q16 Correct Key": "C: 6",
        "Q16 Mark": 0,
        "Q17 Question": "In track and field, a green card is shown when:",
        "Q17 Candidate Answer": "A: An athlete is warned",
        "Q17 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q17 Mark": 0,
        "Q18 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q18 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q18 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q18 Mark": 1,
        "Q19 Question": "Which of the following is a Niyama?",
        "Q19 Candidate Answer": "B: Ahimsa",
        "Q19 Correct Key": "C: Svadhyaya",
        "Q19 Mark": 0,
        "Q20 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q20 Candidate Answer": "B: Hatha Yoga",
        "Q20 Correct Key": "A: Laya Yoga",
        "Q20 Mark": 0,
        "Q21 Question": "What is the minimum size of the high jump landing mat?",
        "Q21 Candidate Answer": "C: 6 m × 6 m",
        "Q21 Correct Key": "B: 5 m × 3 m",
        "Q21 Mark": 0,
        "Q22 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q22 Candidate Answer": "D: Orthodox grip",
        "Q22 Correct Key": "D: Orthodox grip",
        "Q22 Mark": 1,
        "Q23 Question": "What is the weight of the women's discus?",
        "Q23 Candidate Answer": "B: 1 kg",
        "Q23 Correct Key": "B: 1 kg",
        "Q23 Mark": 1,
        "Q24 Question": "What is the weight of the men's shot?",
        "Q24 Candidate Answer": "C: 7.260 kg",
        "Q24 Correct Key": "C: 7.260 kg",
        "Q24 Mark": 1,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 1,
        "Q26 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q26 Candidate Answer": "C: Protein",
        "Q26 Correct Key": "C: Protein",
        "Q26 Mark": 1,
        "Q27 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q27 Candidate Answer": "C: 34.92°",
        "Q27 Correct Key": "C: 34.92°",
        "Q27 Mark": 1,
        "Q28 Question": "What is the diameter of the discus throwing circle?",
        "Q28 Candidate Answer": "B: 2.50 m",
        "Q28 Correct Key": "B: 2.50 m",
        "Q28 Mark": 1,
        "Q29 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q29 Candidate Answer": "C: Karma Yoga",
        "Q29 Correct Key": "C: Karma Yoga",
        "Q29 Mark": 1,
        "Q30 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q30 Candidate Answer": "D: High Jump, Javelin Throw, 400m",
        "Q30 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 56,
      "registrationNumber": "KOP/2026/08/0523",
      "studentName": "KRISHNA CHANDRA MAHANANDA",
      "mobileNumber": "8658226720",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:06:15 pm",
      "startTime": "18 Oct 2026, 01:16:00 pm",
      "submissionTime": "18 Oct 2026, 01:56:16 pm",
      "questionsAnswered": "30 / 30",
      "score": 22,
      "totalMarks": 30,
      "percentage": 73.3,
      "correctCount": 22,
      "wrongCount": 8,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 56,
        "Registration ID": "KOP/2026/08/0523",
        "Candidate Name": "KRISHNA CHANDRA MAHANANDA",
        "Actually Gave Exam?": "YES",
        "Total Score": "22 / 30",
        "Percentage": "73.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q1 Candidate Answer": "D: 12",
        "Q1 Correct Key": "C: 11",
        "Q1 Mark": 0,
        "Q2 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q2 Candidate Answer": "A: 1 minute",
        "Q2 Correct Key": "C: 2 minutes",
        "Q2 Mark": 0,
        "Q3 Question": "A javelin throw is valid only if:",
        "Q3 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q3 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q3 Mark": 1,
        "Q4 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q4 Candidate Answer": "B: To hold or maintain",
        "Q4 Correct Key": "B: To hold or maintain",
        "Q4 Mark": 1,
        "Q5 Question": "What is the diameter of the discus throwing circle?",
        "Q5 Candidate Answer": "B: 2.50 m",
        "Q5 Correct Key": "B: 2.50 m",
        "Q5 Mark": 1,
        "Q6 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q6 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q6 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q7 Candidate Answer": "C: 50 mm",
        "Q7 Correct Key": "B: 45 mm",
        "Q7 Mark": 0,
        "Q8 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q8 Candidate Answer": "C: 6",
        "Q8 Correct Key": "C: 6",
        "Q8 Mark": 1,
        "Q9 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q9 Candidate Answer": "B: Swami Vivekananda",
        "Q9 Correct Key": "B: Swami Vivekananda",
        "Q9 Mark": 1,
        "Q10 Question": "How much energy does 1 g of fat give?",
        "Q10 Candidate Answer": "C: 9.1 kcal",
        "Q10 Correct Key": "C: 9.1 kcal",
        "Q10 Mark": 1,
        "Q11 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q11 Candidate Answer": "C: Asana",
        "Q11 Correct Key": "B: Yama",
        "Q11 Mark": 0,
        "Q12 Question": "What is the weight of the men's shot?",
        "Q12 Candidate Answer": "C: 7.260 kg",
        "Q12 Correct Key": "C: 7.260 kg",
        "Q12 Mark": 1,
        "Q13 Question": "Which statement about pole vault is correct?",
        "Q13 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q13 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q13 Mark": 0,
        "Q14 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q14 Candidate Answer": "A: A foul throw",
        "Q14 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q14 Mark": 0,
        "Q15 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q15 Candidate Answer": "B: Glide method",
        "Q15 Correct Key": "B: Glide method",
        "Q15 Mark": 1,
        "Q16 Question": "What is the weight of the men's javelin?",
        "Q16 Candidate Answer": "C: 800 g",
        "Q16 Correct Key": "C: 800 g",
        "Q16 Mark": 1,
        "Q17 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q17 Candidate Answer": "B: Scissors Jump",
        "Q17 Correct Key": "B: Scissors Jump",
        "Q17 Mark": 1,
        "Q18 Question": "In which throwing event are gloves allowed?",
        "Q18 Candidate Answer": "D: Hammer throw",
        "Q18 Correct Key": "D: Hammer throw",
        "Q18 Mark": 1,
        "Q19 Question": "What is the weight of the women's discus?",
        "Q19 Candidate Answer": "B: 1 kg",
        "Q19 Correct Key": "B: 1 kg",
        "Q19 Mark": 1,
        "Q20 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q20 Candidate Answer": "C: 32 m/s",
        "Q20 Correct Key": "C: 32 m/s",
        "Q20 Mark": 1,
        "Q21 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q21 Candidate Answer": "C: Protein",
        "Q21 Correct Key": "C: Protein",
        "Q21 Mark": 1,
        "Q22 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q22 Candidate Answer": "C: Pratyahara",
        "Q22 Correct Key": "C: Pratyahara",
        "Q22 Mark": 1,
        "Q23 Question": "What is the correct sequence of phases in the triple jump?",
        "Q23 Candidate Answer": "C: Hop – Step – Jump",
        "Q23 Correct Key": "C: Hop – Step – Jump",
        "Q23 Mark": 1,
        "Q24 Question": "What is the javelin throwing sector angle?",
        "Q24 Candidate Answer": "A: 28.96°",
        "Q24 Correct Key": "A: 28.96°",
        "Q24 Mark": 1,
        "Q25 Question": "Lactose (milk sugar) is made of:",
        "Q25 Candidate Answer": "C: Glucose + Galactose",
        "Q25 Correct Key": "C: Glucose + Galactose",
        "Q25 Mark": 1,
        "Q26 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q26 Candidate Answer": "B: 1:2:1",
        "Q26 Correct Key": "B: 1:2:1",
        "Q26 Mark": 1,
        "Q27 Question": "What are the dimensions of the take-off board in long jump?",
        "Q27 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q27 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Mark": 0,
        "Q28 Question": "What is the minimum size of the high jump landing mat?",
        "Q28 Candidate Answer": "B: 5 m × 3 m",
        "Q28 Correct Key": "B: 5 m × 3 m",
        "Q28 Mark": 1,
        "Q29 Question": "What is the diameter of the shot put circle?",
        "Q29 Candidate Answer": "B: 2.135 m",
        "Q29 Correct Key": "B: 2.135 m",
        "Q29 Mark": 1,
        "Q30 Question": "If the shot lands on one of the sector lines:",
        "Q30 Candidate Answer": "B: A re-throw is given",
        "Q30 Correct Key": "C: It is called a foul and not measured",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 57,
      "registrationNumber": "KOP/2026/05/0109",
      "studentName": "Reenki Bagha",
      "mobileNumber": "7205364497",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:45 pm",
      "startTime": "18 Oct 2026, 01:21:49 pm",
      "submissionTime": "18 Oct 2026, 01:55:22 pm",
      "questionsAnswered": "29 / 30",
      "score": 22,
      "totalMarks": 30,
      "percentage": 73.3,
      "correctCount": 22,
      "wrongCount": 7,
      "unattemptedCount": 1,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 57,
        "Registration ID": "KOP/2026/05/0109",
        "Candidate Name": "Reenki Bagha",
        "Actually Gave Exam?": "YES",
        "Total Score": "22 / 30",
        "Percentage": "73.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q1 Candidate Answer": "A: A foul throw",
        "Q1 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q1 Mark": 0,
        "Q2 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q2 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q2 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q2 Mark": 1,
        "Q3 Question": "What is the weight of the men's javelin?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 800 g",
        "Q3 Mark": 0,
        "Q4 Question": "Which of the following is NOT a flight style in long jump?",
        "Q4 Candidate Answer": "D: Fosbury flop",
        "Q4 Correct Key": "D: Fosbury flop",
        "Q4 Mark": 1,
        "Q5 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q5 Candidate Answer": "B: To hold or maintain",
        "Q5 Correct Key": "B: To hold or maintain",
        "Q5 Mark": 1,
        "Q6 Question": "What is the javelin throwing sector angle?",
        "Q6 Candidate Answer": "A: 28.96°",
        "Q6 Correct Key": "A: 28.96°",
        "Q6 Mark": 1,
        "Q7 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q7 Candidate Answer": "B: 45 minutes",
        "Q7 Correct Key": "B: 45 minutes",
        "Q7 Mark": 1,
        "Q8 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q8 Candidate Answer": "C: The athlete who started at the higher height",
        "Q8 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q8 Mark": 0,
        "Q9 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q9 Candidate Answer": "C: To join or unite",
        "Q9 Correct Key": "C: To join or unite",
        "Q9 Mark": 1,
        "Q10 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q10 Candidate Answer": "B: Glide method",
        "Q10 Correct Key": "B: Glide method",
        "Q10 Mark": 1,
        "Q11 Question": "How is a triple jump measured?",
        "Q11 Candidate Answer": "C: From the end of the runway to the heel mark",
        "Q11 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q11 Mark": 0,
        "Q12 Question": "If the shot lands on one of the sector lines:",
        "Q12 Candidate Answer": "B: A re-throw is given",
        "Q12 Correct Key": "C: It is called a foul and not measured",
        "Q12 Mark": 0,
        "Q13 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q13 Candidate Answer": "B: Yama",
        "Q13 Correct Key": "B: Yama",
        "Q13 Mark": 1,
        "Q14 Question": "What is the minimum size of the high jump landing mat?",
        "Q14 Candidate Answer": "B: 5 m × 3 m",
        "Q14 Correct Key": "B: 5 m × 3 m",
        "Q14 Mark": 1,
        "Q15 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q15 Candidate Answer": "B: Scissors Jump",
        "Q15 Correct Key": "B: Scissors Jump",
        "Q15 Mark": 1,
        "Q16 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q16 Candidate Answer": "C: 20 m",
        "Q16 Correct Key": "C: 20 m",
        "Q16 Mark": 1,
        "Q17 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q17 Candidate Answer": "B: 1:2:1",
        "Q17 Correct Key": "B: 1:2:1",
        "Q17 Mark": 1,
        "Q18 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q18 Candidate Answer": "C: 6",
        "Q18 Correct Key": "C: 6",
        "Q18 Mark": 1,
        "Q19 Question": "Lactose (milk sugar) is made of:",
        "Q19 Candidate Answer": "C: Glucose + Galactose",
        "Q19 Correct Key": "C: Glucose + Galactose",
        "Q19 Mark": 1,
        "Q20 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q20 Candidate Answer": "B: American grip",
        "Q20 Correct Key": "D: Orthodox grip",
        "Q20 Mark": 0,
        "Q21 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q21 Candidate Answer": "D: 3 minutes",
        "Q21 Correct Key": "C: 2 minutes",
        "Q21 Mark": 0,
        "Q22 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q22 Candidate Answer": "C: Disqualified",
        "Q22 Correct Key": "C: Disqualified",
        "Q22 Mark": 1,
        "Q23 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q23 Candidate Answer": "C: Protein",
        "Q23 Correct Key": "C: Protein",
        "Q23 Mark": 1,
        "Q24 Question": "How high is the plasticine indicator board?",
        "Q24 Candidate Answer": "B: 7 mm",
        "Q24 Correct Key": "B: 7 mm",
        "Q24 Mark": 1,
        "Q25 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q25 Candidate Answer": "A: Laya Yoga",
        "Q25 Correct Key": "A: Laya Yoga",
        "Q25 Mark": 1,
        "Q26 Question": "What is the correct sequence of phases in the triple jump?",
        "Q26 Candidate Answer": "C: Hop – Step – Jump",
        "Q26 Correct Key": "C: Hop – Step – Jump",
        "Q26 Mark": 1,
        "Q27 Question": "A javelin throw is valid only if:",
        "Q27 Candidate Answer": "C: It lands flat",
        "Q27 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q27 Mark": 0,
        "Q28 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q28 Candidate Answer": "C: 3",
        "Q28 Correct Key": "C: 3",
        "Q28 Mark": 1,
        "Q29 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q29 Candidate Answer": "C: 11",
        "Q29 Correct Key": "C: 11",
        "Q29 Mark": 1,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "D: Hammer throw",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 58,
      "registrationNumber": "KOP/2026/06/0127",
      "studentName": "Prakash Jena",
      "mobileNumber": "9078843637",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:03:08 pm",
      "startTime": "18 Oct 2026, 01:30:13 pm",
      "submissionTime": "18 Oct 2026, 01:59:34 pm",
      "questionsAnswered": "22 / 30",
      "score": 22,
      "totalMarks": 30,
      "percentage": 73.3,
      "correctCount": 22,
      "wrongCount": 0,
      "unattemptedCount": 8,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 58,
        "Registration ID": "KOP/2026/06/0127",
        "Candidate Name": "Prakash Jena",
        "Actually Gave Exam?": "YES",
        "Total Score": "22 / 30",
        "Percentage": "73.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "In which throwing event are gloves allowed?",
        "Q1 Candidate Answer": "D: Hammer throw",
        "Q1 Correct Key": "D: Hammer throw",
        "Q1 Mark": 1,
        "Q2 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q2 Candidate Answer": "B: 45 minutes",
        "Q2 Correct Key": "B: 45 minutes",
        "Q2 Mark": 1,
        "Q3 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q3 Candidate Answer": "C: 34.92°",
        "Q3 Correct Key": "C: 34.92°",
        "Q3 Mark": 1,
        "Q4 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q4 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q4 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q4 Mark": 1,
        "Q5 Question": "What are the dimensions of the take-off board in long jump?",
        "Q5 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Mark": 1,
        "Q6 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q6 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q6 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q6 Mark": 1,
        "Q7 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q7 Candidate Answer": "B: Yama",
        "Q7 Correct Key": "B: Yama",
        "Q7 Mark": 1,
        "Q8 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q8 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q8 Mark": 1,
        "Q9 Question": "Which of the following is a Niyama?",
        "Q9 Candidate Answer": "C: Svadhyaya",
        "Q9 Correct Key": "C: Svadhyaya",
        "Q9 Mark": 1,
        "Q10 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q10 Candidate Answer": "C: Pratyahara",
        "Q10 Correct Key": "C: Pratyahara",
        "Q10 Mark": 1,
        "Q11 Question": "Which statement about pole vault is correct?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q11 Mark": 0,
        "Q12 Question": "How is a triple jump measured?",
        "Q12 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Mark": 1,
        "Q13 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q13 Candidate Answer": "C: 32 m/s",
        "Q13 Correct Key": "C: 32 m/s",
        "Q13 Mark": 1,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 1,
        "Q15 Question": "If the shot lands on one of the sector lines:",
        "Q15 Candidate Answer": "C: It is called a foul and not measured",
        "Q15 Correct Key": "C: It is called a foul and not measured",
        "Q15 Mark": 1,
        "Q16 Question": "What is the weight of the men's javelin?",
        "Q16 Candidate Answer": "C: 800 g",
        "Q16 Correct Key": "C: 800 g",
        "Q16 Mark": 1,
        "Q17 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q17 Candidate Answer": "B: Swami Vivekananda",
        "Q17 Correct Key": "B: Swami Vivekananda",
        "Q17 Mark": 1,
        "Q18 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q18 Candidate Answer": "B: 1:2:1",
        "Q18 Correct Key": "B: 1:2:1",
        "Q18 Mark": 1,
        "Q19 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q19 Candidate Answer": "C: 6",
        "Q19 Correct Key": "C: 6",
        "Q19 Mark": 1,
        "Q20 Question": "What is the correct sequence of phases in the triple jump?",
        "Q20 Candidate Answer": "C: Hop – Step – Jump",
        "Q20 Correct Key": "C: Hop – Step – Jump",
        "Q20 Mark": 1,
        "Q21 Question": "What is the weight of the men's shot?",
        "Q21 Candidate Answer": "C: 7.260 kg",
        "Q21 Correct Key": "C: 7.260 kg",
        "Q21 Mark": 1,
        "Q22 Question": "What is the javelin throwing sector angle?",
        "Q22 Candidate Answer": "A: 28.96°",
        "Q22 Correct Key": "A: 28.96°",
        "Q22 Mark": 1,
        "Q23 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q23 Candidate Answer": "C: 11",
        "Q23 Correct Key": "C: 11",
        "Q23 Mark": 1,
        "Q24 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: Scissors Jump",
        "Q24 Mark": 0,
        "Q25 Question": "What is the minimum size of the high jump landing mat?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 5 m × 3 m",
        "Q25 Mark": 0,
        "Q26 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: Comparing their second-best performances",
        "Q26 Mark": 0,
        "Q27 Question": "How much energy does 1 g of fat give?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 9.1 kcal",
        "Q27 Mark": 0,
        "Q28 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "A: Laya Yoga",
        "Q28 Mark": 0,
        "Q29 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 45 mm",
        "Q29 Mark": 0,
        "Q30 Question": "What is the diameter of the discus throwing circle?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 2.50 m",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 59,
      "registrationNumber": "KOP/2026/06/0146",
      "studentName": "KISANLAL DIGAL",
      "mobileNumber": "9470642102",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:18 pm",
      "startTime": "18 Oct 2026, 01:15:30 pm",
      "submissionTime": "18 Oct 2026, 01:30:15 pm",
      "questionsAnswered": "30 / 30",
      "score": 21,
      "totalMarks": 30,
      "percentage": 70,
      "correctCount": 21,
      "wrongCount": 9,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 59,
        "Registration ID": "KOP/2026/06/0146",
        "Candidate Name": "KISANLAL DIGAL",
        "Actually Gave Exam?": "YES",
        "Total Score": "21 / 30",
        "Percentage": "70%",
        "Result": "QUALIFIED",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "D: An athlete leaves the track voluntarily",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 0,
        "Q2 Question": "What is the correct sequence of phases in the triple jump?",
        "Q2 Candidate Answer": "C: Hop – Step – Jump",
        "Q2 Correct Key": "C: Hop – Step – Jump",
        "Q2 Mark": 1,
        "Q3 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q3 Candidate Answer": "D: 40 m",
        "Q3 Correct Key": "C: 20 m",
        "Q3 Mark": 0,
        "Q4 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q4 Candidate Answer": "D: 3 minutes",
        "Q4 Correct Key": "C: 2 minutes",
        "Q4 Mark": 0,
        "Q5 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q5 Candidate Answer": "A: Maharishi Patanjali",
        "Q5 Correct Key": "B: Swami Vivekananda",
        "Q5 Mark": 0,
        "Q6 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q6 Candidate Answer": "B: 1:2:1",
        "Q6 Correct Key": "B: 1:2:1",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "C: 42.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 1,
        "Q8 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q8 Candidate Answer": "C: 3",
        "Q8 Correct Key": "C: 3",
        "Q8 Mark": 1,
        "Q9 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q9 Candidate Answer": "D: Orthodox grip",
        "Q9 Correct Key": "D: Orthodox grip",
        "Q9 Mark": 1,
        "Q10 Question": "A javelin throw is valid only if:",
        "Q10 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q10 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q10 Mark": 1,
        "Q11 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q11 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q11 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q11 Mark": 1,
        "Q12 Question": "What is the weight of the women's discus?",
        "Q12 Candidate Answer": "B: 1 kg",
        "Q12 Correct Key": "B: 1 kg",
        "Q12 Mark": 1,
        "Q13 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q13 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q13 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q13 Mark": 1,
        "Q14 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q14 Candidate Answer": "C: Pratyahara",
        "Q14 Correct Key": "C: Pratyahara",
        "Q14 Mark": 1,
        "Q15 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q15 Candidate Answer": "B: To hold or maintain",
        "Q15 Correct Key": "B: To hold or maintain",
        "Q15 Mark": 1,
        "Q16 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q16 Candidate Answer": "B: 45 minutes",
        "Q16 Correct Key": "B: 45 minutes",
        "Q16 Mark": 1,
        "Q17 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q17 Candidate Answer": "A: A foul throw",
        "Q17 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q17 Mark": 0,
        "Q18 Question": "What is the diameter of the shot put circle?",
        "Q18 Candidate Answer": "B: 2.135 m",
        "Q18 Correct Key": "B: 2.135 m",
        "Q18 Mark": 1,
        "Q19 Question": "If the shot lands on one of the sector lines:",
        "Q19 Candidate Answer": "A: It is measured normally",
        "Q19 Correct Key": "C: It is called a foul and not measured",
        "Q19 Mark": 0,
        "Q20 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q20 Candidate Answer": "C: 32 m/s",
        "Q20 Correct Key": "C: 32 m/s",
        "Q20 Mark": 1,
        "Q21 Question": "What is the weight of the men's javelin?",
        "Q21 Candidate Answer": "C: 800 g",
        "Q21 Correct Key": "C: 800 g",
        "Q21 Mark": 1,
        "Q22 Question": "Which of the following is a Niyama?",
        "Q22 Candidate Answer": "C: Svadhyaya",
        "Q22 Correct Key": "C: Svadhyaya",
        "Q22 Mark": 1,
        "Q23 Question": "Lactose (milk sugar) is made of:",
        "Q23 Candidate Answer": "C: Glucose + Galactose",
        "Q23 Correct Key": "C: Glucose + Galactose",
        "Q23 Mark": 1,
        "Q24 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q24 Candidate Answer": "B: Glide method",
        "Q24 Correct Key": "B: Glide method",
        "Q24 Mark": 1,
        "Q25 Question": "Which statement about pole vault is correct?",
        "Q25 Candidate Answer": "A: Gloves are not permitted",
        "Q25 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Mark": 0,
        "Q26 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q26 Candidate Answer": "B: 45 mm",
        "Q26 Correct Key": "B: 45 mm",
        "Q26 Mark": 1,
        "Q27 Question": "What are the dimensions of the take-off board in long jump?",
        "Q27 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Mark": 1,
        "Q28 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q28 Candidate Answer": "B: Comparing their second-best performances",
        "Q28 Correct Key": "B: Comparing their second-best performances",
        "Q28 Mark": 1,
        "Q29 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q29 Candidate Answer": "C: Scissors Jump",
        "Q29 Correct Key": "D: Fosbury Flop",
        "Q29 Mark": 0,
        "Q30 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q30 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q30 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 60,
      "registrationNumber": "KOP/2026/09/0051",
      "studentName": "HARISCHANDRA PADHAN",
      "mobileNumber": "6371121721",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:28 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 21,
      "totalMarks": 30,
      "percentage": 70,
      "correctCount": 21,
      "wrongCount": 9,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 60,
        "Registration ID": "KOP/2026/09/0051",
        "Candidate Name": "HARISCHANDRA PADHAN",
        "Actually Gave Exam?": "YES",
        "Total Score": "21 / 30",
        "Percentage": "70%",
        "Result": "QUALIFIED",
        "Q1 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q1 Candidate Answer": "B: Comparing their second-best performances",
        "Q1 Correct Key": "B: Comparing their second-best performances",
        "Q1 Mark": 1,
        "Q2 Question": "What is the weight of the men's javelin?",
        "Q2 Candidate Answer": "C: 800 g",
        "Q2 Correct Key": "C: 800 g",
        "Q2 Mark": 1,
        "Q3 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q3 Candidate Answer": "B: 1:2:1",
        "Q3 Correct Key": "B: 1:2:1",
        "Q3 Mark": 1,
        "Q4 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q4 Candidate Answer": "B: Yama",
        "Q4 Correct Key": "B: Yama",
        "Q4 Mark": 1,
        "Q5 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q5 Candidate Answer": "D: 40°",
        "Q5 Correct Key": "C: 34.92°",
        "Q5 Mark": 0,
        "Q6 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q6 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q6 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q6 Mark": 1,
        "Q7 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q7 Candidate Answer": "C: Rotatory method",
        "Q7 Correct Key": "B: Glide method",
        "Q7 Mark": 0,
        "Q8 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q8 Candidate Answer": "C: Protein",
        "Q8 Correct Key": "C: Protein",
        "Q8 Mark": 1,
        "Q9 Question": "Which of the following is a Niyama?",
        "Q9 Candidate Answer": "C: Svadhyaya",
        "Q9 Correct Key": "C: Svadhyaya",
        "Q9 Mark": 1,
        "Q10 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q10 Candidate Answer": "D: Tantra Yoga",
        "Q10 Correct Key": "A: Laya Yoga",
        "Q10 Mark": 0,
        "Q11 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q11 Candidate Answer": "A: 1 minute",
        "Q11 Correct Key": "C: 2 minutes",
        "Q11 Mark": 0,
        "Q12 Question": "What is the diameter of the shot put circle?",
        "Q12 Candidate Answer": "B: 2.135 m",
        "Q12 Correct Key": "B: 2.135 m",
        "Q12 Mark": 1,
        "Q13 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q13 Candidate Answer": "D: Fosbury Flop",
        "Q13 Correct Key": "D: Fosbury Flop",
        "Q13 Mark": 1,
        "Q14 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q14 Candidate Answer": "A: 40 mm",
        "Q14 Correct Key": "B: 45 mm",
        "Q14 Mark": 0,
        "Q15 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q15 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Mark": 1,
        "Q16 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q16 Candidate Answer": "C: 3",
        "Q16 Correct Key": "C: 3",
        "Q16 Mark": 1,
        "Q17 Question": "In track and field, a green card is shown when:",
        "Q17 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q17 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q17 Mark": 1,
        "Q18 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q18 Candidate Answer": "A: Takes off from one foot and lands on the opposite foot",
        "Q18 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q18 Mark": 0,
        "Q19 Question": "Which of the following is NOT a flight style in long jump?",
        "Q19 Candidate Answer": "D: Fosbury flop",
        "Q19 Correct Key": "D: Fosbury flop",
        "Q19 Mark": 1,
        "Q20 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q20 Candidate Answer": "A: Pranayama",
        "Q20 Correct Key": "C: Pratyahara",
        "Q20 Mark": 0,
        "Q21 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q21 Candidate Answer": "C: Western Roll",
        "Q21 Correct Key": "B: Scissors Jump",
        "Q21 Mark": 0,
        "Q22 Question": "What is the official distance of a marathon?",
        "Q22 Candidate Answer": "C: 42.195 km",
        "Q22 Correct Key": "C: 42.195 km",
        "Q22 Mark": 1,
        "Q23 Question": "What is the correct sequence of phases in the triple jump?",
        "Q23 Candidate Answer": "C: Hop – Step – Jump",
        "Q23 Correct Key": "C: Hop – Step – Jump",
        "Q23 Mark": 1,
        "Q24 Question": "A javelin throw is valid only if:",
        "Q24 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q24 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q24 Mark": 1,
        "Q25 Question": "Which statement about pole vault is correct?",
        "Q25 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q25 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q25 Mark": 0,
        "Q26 Question": "How is a triple jump measured?",
        "Q26 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q26 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q26 Mark": 1,
        "Q27 Question": "In which throwing event are gloves allowed?",
        "Q27 Candidate Answer": "D: Hammer throw",
        "Q27 Correct Key": "D: Hammer throw",
        "Q27 Mark": 1,
        "Q28 Question": "In international competition, the pole vault landing area must be at least:",
        "Q28 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q28 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q28 Mark": 1,
        "Q29 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q29 Candidate Answer": "C: Disqualified",
        "Q29 Correct Key": "C: Disqualified",
        "Q29 Mark": 1,
        "Q30 Question": "Lactose (milk sugar) is made of:",
        "Q30 Candidate Answer": "C: Glucose + Galactose",
        "Q30 Correct Key": "C: Glucose + Galactose",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 61,
      "registrationNumber": "KOP/2026/06/0191",
      "studentName": "KUMARI ROJALIN SAHOO",
      "mobileNumber": "7978591309",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:07 pm",
      "startTime": "18 Oct 2026, 01:44:50 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "26 / 30",
      "score": 21,
      "totalMarks": 30,
      "percentage": 70,
      "correctCount": 21,
      "wrongCount": 5,
      "unattemptedCount": 4,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 61,
        "Registration ID": "KOP/2026/06/0191",
        "Candidate Name": "KUMARI ROJALIN SAHOO",
        "Actually Gave Exam?": "YES",
        "Total Score": "21 / 30",
        "Percentage": "70%",
        "Result": "QUALIFIED",
        "Q1 Question": "In international competition, the pole vault landing area must be at least:",
        "Q1 Candidate Answer": "A: 5 m × 5 m × 0.8 m",
        "Q1 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q1 Mark": 0,
        "Q2 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q2 Candidate Answer": "D: Fosbury Flop",
        "Q2 Correct Key": "D: Fosbury Flop",
        "Q2 Mark": 1,
        "Q3 Question": "How much energy does 1 g of fat give?",
        "Q3 Candidate Answer": "A: 4.1 kcal",
        "Q3 Correct Key": "C: 9.1 kcal",
        "Q3 Mark": 0,
        "Q4 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q4 Candidate Answer": "C: Disqualified",
        "Q4 Correct Key": "C: Disqualified",
        "Q4 Mark": 1,
        "Q5 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q5 Candidate Answer": "D: Orthodox grip",
        "Q5 Correct Key": "D: Orthodox grip",
        "Q5 Mark": 1,
        "Q6 Question": "How is a triple jump measured?",
        "Q6 Candidate Answer": "A: From the plasticine board to the farthest mark",
        "Q6 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q6 Mark": 0,
        "Q7 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q7 Candidate Answer": "C: 2 minutes",
        "Q7 Correct Key": "C: 2 minutes",
        "Q7 Mark": 1,
        "Q8 Question": "What is the weight of the men's shot?",
        "Q8 Candidate Answer": "C: 7.260 kg",
        "Q8 Correct Key": "C: 7.260 kg",
        "Q8 Mark": 1,
        "Q9 Question": "Which statement about pole vault is correct?",
        "Q9 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q9 Mark": 1,
        "Q10 Question": "What is the correct sequence of phases in the triple jump?",
        "Q10 Candidate Answer": "C: Hop – Step – Jump",
        "Q10 Correct Key": "C: Hop – Step – Jump",
        "Q10 Mark": 1,
        "Q11 Question": "Which of the following is NOT a flight style in long jump?",
        "Q11 Candidate Answer": "D: Fosbury flop",
        "Q11 Correct Key": "D: Fosbury flop",
        "Q11 Mark": 1,
        "Q12 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q12 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q12 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q12 Mark": 1,
        "Q13 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q13 Candidate Answer": "C: Protein",
        "Q13 Correct Key": "C: Protein",
        "Q13 Mark": 1,
        "Q14 Question": "Lactose (milk sugar) is made of:",
        "Q14 Candidate Answer": "C: Glucose + Galactose",
        "Q14 Correct Key": "C: Glucose + Galactose",
        "Q14 Mark": 1,
        "Q15 Question": "What is the weight of the women's discus?",
        "Q15 Candidate Answer": "B: 1 kg",
        "Q15 Correct Key": "B: 1 kg",
        "Q15 Mark": 1,
        "Q16 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q16 Candidate Answer": "C: To join or unite",
        "Q16 Correct Key": "C: To join or unite",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the shot put circle?",
        "Q17 Candidate Answer": "B: 2.135 m",
        "Q17 Correct Key": "B: 2.135 m",
        "Q17 Mark": 1,
        "Q18 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q18 Candidate Answer": "A: 100m Hurdles, High Jump, Shot Put",
        "Q18 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q18 Mark": 0,
        "Q19 Question": "What is the diameter of the discus throwing circle?",
        "Q19 Candidate Answer": "B: 2.50 m",
        "Q19 Correct Key": "B: 2.50 m",
        "Q19 Mark": 1,
        "Q20 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q20 Candidate Answer": "B: Scissors Jump",
        "Q20 Correct Key": "B: Scissors Jump",
        "Q20 Mark": 1,
        "Q21 Question": "What is the javelin throwing sector angle?",
        "Q21 Candidate Answer": "A: 28.96°",
        "Q21 Correct Key": "A: 28.96°",
        "Q21 Mark": 1,
        "Q22 Question": "In track and field, a green card is shown when:",
        "Q22 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q22 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q22 Mark": 1,
        "Q23 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q23 Candidate Answer": "C: 20 m",
        "Q23 Correct Key": "C: 20 m",
        "Q23 Mark": 1,
        "Q24 Question": "What are the dimensions of the take-off board in long jump?",
        "Q24 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q24 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q24 Mark": 0,
        "Q25 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q25 Candidate Answer": "B: Glide method",
        "Q25 Correct Key": "B: Glide method",
        "Q25 Mark": 1,
        "Q26 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q26 Candidate Answer": "C: Pratyahara",
        "Q26 Correct Key": "C: Pratyahara",
        "Q26 Mark": 1,
        "Q27 Question": "What is the official distance of a marathon?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 42.195 km",
        "Q27 Mark": 0,
        "Q28 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 32 m/s",
        "Q28 Mark": 0,
        "Q29 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: To hold or maintain",
        "Q29 Mark": 0,
        "Q30 Question": "How high is the plasticine indicator board?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 7 mm",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 62,
      "registrationNumber": "KOP/2026/07/0350",
      "studentName": "AMAN MAHANAND",
      "mobileNumber": "8658507686",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:20 pm",
      "startTime": "18 Oct 2026, 01:15:51 pm",
      "submissionTime": "18 Oct 2026, 01:31:20 pm",
      "questionsAnswered": "30 / 30",
      "score": 19,
      "totalMarks": 30,
      "percentage": 63.3,
      "correctCount": 19,
      "wrongCount": 11,
      "unattemptedCount": 0,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 62,
        "Registration ID": "KOP/2026/07/0350",
        "Candidate Name": "AMAN MAHANAND",
        "Actually Gave Exam?": "YES",
        "Total Score": "19 / 30",
        "Percentage": "63.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q1 Candidate Answer": "B: 45 mm",
        "Q1 Correct Key": "B: 45 mm",
        "Q1 Mark": 1,
        "Q2 Question": "Lactose (milk sugar) is made of:",
        "Q2 Candidate Answer": "C: Glucose + Galactose",
        "Q2 Correct Key": "C: Glucose + Galactose",
        "Q2 Mark": 1,
        "Q3 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q3 Candidate Answer": "C: 11",
        "Q3 Correct Key": "C: 11",
        "Q3 Mark": 1,
        "Q4 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q4 Candidate Answer": "B: Comparing their second-best performances",
        "Q4 Correct Key": "B: Comparing their second-best performances",
        "Q4 Mark": 1,
        "Q5 Question": "What are the dimensions of the take-off board in long jump?",
        "Q5 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q5 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q5 Mark": 0,
        "Q6 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q6 Candidate Answer": "B: 45 minutes",
        "Q6 Correct Key": "B: 45 minutes",
        "Q6 Mark": 1,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "A: Gloves are not permitted",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 0,
        "Q8 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q8 Candidate Answer": "B: 2",
        "Q8 Correct Key": "C: 3",
        "Q8 Mark": 0,
        "Q9 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q9 Candidate Answer": "C: Protein",
        "Q9 Correct Key": "C: Protein",
        "Q9 Mark": 1,
        "Q10 Question": "In international competition, the pole vault landing area must be at least:",
        "Q10 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q10 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q10 Mark": 1,
        "Q11 Question": "What is the weight of the men's shot?",
        "Q11 Candidate Answer": "B: 7.000 kg",
        "Q11 Correct Key": "C: 7.260 kg",
        "Q11 Mark": 0,
        "Q12 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q12 Candidate Answer": "C: 20 m",
        "Q12 Correct Key": "C: 20 m",
        "Q12 Mark": 1,
        "Q13 Question": "What is the weight of the men's javelin?",
        "Q13 Candidate Answer": "C: 800 g",
        "Q13 Correct Key": "C: 800 g",
        "Q13 Mark": 1,
        "Q14 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q14 Candidate Answer": "A: 4",
        "Q14 Correct Key": "C: 6",
        "Q14 Mark": 0,
        "Q15 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q15 Candidate Answer": "D: 3 minutes",
        "Q15 Correct Key": "C: 2 minutes",
        "Q15 Mark": 0,
        "Q16 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q16 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q16 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q16 Mark": 1,
        "Q17 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q17 Candidate Answer": "C: Karma Yoga",
        "Q17 Correct Key": "C: Karma Yoga",
        "Q17 Mark": 1,
        "Q18 Question": "How high is the plasticine indicator board?",
        "Q18 Candidate Answer": "C: 10 mm",
        "Q18 Correct Key": "B: 7 mm",
        "Q18 Mark": 0,
        "Q19 Question": "What is the javelin throwing sector angle?",
        "Q19 Candidate Answer": "A: 28.96°",
        "Q19 Correct Key": "A: 28.96°",
        "Q19 Mark": 1,
        "Q20 Question": "How is a triple jump measured?",
        "Q20 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q20 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q20 Mark": 1,
        "Q21 Question": "How much energy does 1 g of fat give?",
        "Q21 Candidate Answer": "C: 9.1 kcal",
        "Q21 Correct Key": "C: 9.1 kcal",
        "Q21 Mark": 1,
        "Q22 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q22 Candidate Answer": "A: Niyama",
        "Q22 Correct Key": "B: Yama",
        "Q22 Mark": 0,
        "Q23 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q23 Candidate Answer": "B: Glide method",
        "Q23 Correct Key": "B: Glide method",
        "Q23 Mark": 1,
        "Q24 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q24 Candidate Answer": "C: 32 m/s",
        "Q24 Correct Key": "C: 32 m/s",
        "Q24 Mark": 1,
        "Q25 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q25 Candidate Answer": "B: American grip",
        "Q25 Correct Key": "D: Orthodox grip",
        "Q25 Mark": 0,
        "Q26 Question": "What is the minimum size of the high jump landing mat?",
        "Q26 Candidate Answer": "B: 5 m × 3 m",
        "Q26 Correct Key": "B: 5 m × 3 m",
        "Q26 Mark": 1,
        "Q27 Question": "Which of the following is a Niyama?",
        "Q27 Candidate Answer": "A: Satya",
        "Q27 Correct Key": "C: Svadhyaya",
        "Q27 Mark": 0,
        "Q28 Question": "Which of the following is NOT a flight style in long jump?",
        "Q28 Candidate Answer": "A: Sail style",
        "Q28 Correct Key": "D: Fosbury flop",
        "Q28 Mark": 0,
        "Q29 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q29 Candidate Answer": "B: To hold or maintain",
        "Q29 Correct Key": "B: To hold or maintain",
        "Q29 Mark": 1,
        "Q30 Question": "What is the weight of the women's discus?",
        "Q30 Candidate Answer": "B: 1 kg",
        "Q30 Correct Key": "B: 1 kg",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 63,
      "registrationNumber": "KOP/2026/08/0656",
      "studentName": "ADITYA KUMAR MAJHI",
      "mobileNumber": "7077472310",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:09 pm",
      "startTime": "18 Oct 2026, 01:15:56 pm",
      "submissionTime": "18 Oct 2026, 01:59:58 pm",
      "questionsAnswered": "30 / 30",
      "score": 19,
      "totalMarks": 30,
      "percentage": 63.3,
      "correctCount": 19,
      "wrongCount": 11,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 63,
        "Registration ID": "KOP/2026/08/0656",
        "Candidate Name": "ADITYA KUMAR MAJHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "19 / 30",
        "Percentage": "63.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "Lactose (milk sugar) is made of:",
        "Q1 Candidate Answer": "B: Glucose + Fructose",
        "Q1 Correct Key": "C: Glucose + Galactose",
        "Q1 Mark": 0,
        "Q2 Question": "How much energy does 1 g of fat give?",
        "Q2 Candidate Answer": "C: 9.1 kcal",
        "Q2 Correct Key": "C: 9.1 kcal",
        "Q2 Mark": 1,
        "Q3 Question": "In international competition, the pole vault landing area must be at least:",
        "Q3 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q3 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q3 Mark": 1,
        "Q4 Question": "What is the official distance of a marathon?",
        "Q4 Candidate Answer": "C: 42.195 km",
        "Q4 Correct Key": "C: 42.195 km",
        "Q4 Mark": 1,
        "Q5 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q5 Candidate Answer": "C: To join or unite",
        "Q5 Correct Key": "C: To join or unite",
        "Q5 Mark": 1,
        "Q6 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q6 Candidate Answer": "B: To hold or maintain",
        "Q6 Correct Key": "B: To hold or maintain",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q7 Candidate Answer": "C: 50 mm",
        "Q7 Correct Key": "B: 45 mm",
        "Q7 Mark": 0,
        "Q8 Question": "If the shot lands on one of the sector lines:",
        "Q8 Candidate Answer": "C: It is called a foul and not measured",
        "Q8 Correct Key": "C: It is called a foul and not measured",
        "Q8 Mark": 1,
        "Q9 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q9 Candidate Answer": "A: Maharishi Patanjali",
        "Q9 Correct Key": "B: Swami Vivekananda",
        "Q9 Mark": 0,
        "Q10 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q10 Candidate Answer": "B: Yama",
        "Q10 Correct Key": "B: Yama",
        "Q10 Mark": 1,
        "Q11 Question": "What is the weight of the women's discus?",
        "Q11 Candidate Answer": "B: 1 kg",
        "Q11 Correct Key": "B: 1 kg",
        "Q11 Mark": 1,
        "Q12 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q12 Candidate Answer": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Mark": 1,
        "Q13 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q13 Candidate Answer": "B: Comparing their second-best performances",
        "Q13 Correct Key": "B: Comparing their second-best performances",
        "Q13 Mark": 1,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "A: An athlete is warned",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 0,
        "Q15 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q15 Candidate Answer": "B: 5",
        "Q15 Correct Key": "C: 6",
        "Q15 Mark": 0,
        "Q16 Question": "Which of the following is a Niyama?",
        "Q16 Candidate Answer": "C: Svadhyaya",
        "Q16 Correct Key": "C: Svadhyaya",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the discus throwing circle?",
        "Q17 Candidate Answer": "A: 2.135 m",
        "Q17 Correct Key": "B: 2.50 m",
        "Q17 Mark": 0,
        "Q18 Question": "What is the correct sequence of phases in the triple jump?",
        "Q18 Candidate Answer": "A: Step – Hop – Jump",
        "Q18 Correct Key": "C: Hop – Step – Jump",
        "Q18 Mark": 0,
        "Q19 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q19 Candidate Answer": "B: Scissors Jump",
        "Q19 Correct Key": "B: Scissors Jump",
        "Q19 Mark": 1,
        "Q20 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q20 Candidate Answer": "A: 100m Hurdles, High Jump, Shot Put",
        "Q20 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Mark": 0,
        "Q21 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q21 Candidate Answer": "A: Laya Yoga",
        "Q21 Correct Key": "A: Laya Yoga",
        "Q21 Mark": 1,
        "Q22 Question": "What are the dimensions of the take-off board in long jump?",
        "Q22 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q22 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q22 Mark": 1,
        "Q23 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q23 Candidate Answer": "C: 20 m",
        "Q23 Correct Key": "C: 20 m",
        "Q23 Mark": 1,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "D: A wind reading above the limit",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 0,
        "Q25 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q25 Candidate Answer": "A: 28.96°",
        "Q25 Correct Key": "C: 34.92°",
        "Q25 Mark": 0,
        "Q26 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q26 Candidate Answer": "C: Pratyahara",
        "Q26 Correct Key": "C: Pratyahara",
        "Q26 Mark": 1,
        "Q27 Question": "How high is the plasticine indicator board?",
        "Q27 Candidate Answer": "B: 7 mm",
        "Q27 Correct Key": "B: 7 mm",
        "Q27 Mark": 1,
        "Q28 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q28 Candidate Answer": "C: 2 minutes",
        "Q28 Correct Key": "C: 2 minutes",
        "Q28 Mark": 1,
        "Q29 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q29 Candidate Answer": "C: Polish grip",
        "Q29 Correct Key": "D: Orthodox grip",
        "Q29 Mark": 0,
        "Q30 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q30 Candidate Answer": "D: Fosbury Flop",
        "Q30 Correct Key": "D: Fosbury Flop",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 64,
      "registrationNumber": "KOP/2026/06/0225",
      "studentName": "NAMITA BARIK",
      "mobileNumber": "7008203029",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:04:51 pm",
      "startTime": "18 Oct 2026, 01:18:52 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "25 / 30",
      "score": 19,
      "totalMarks": 30,
      "percentage": 63.3,
      "correctCount": 19,
      "wrongCount": 6,
      "unattemptedCount": 5,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 64,
        "Registration ID": "KOP/2026/06/0225",
        "Candidate Name": "NAMITA BARIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "19 / 30",
        "Percentage": "63.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q1 Candidate Answer": "B: 45 minutes",
        "Q1 Correct Key": "B: 45 minutes",
        "Q1 Mark": 1,
        "Q2 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q2 Candidate Answer": "B: To hold or maintain",
        "Q2 Correct Key": "B: To hold or maintain",
        "Q2 Mark": 1,
        "Q3 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q3 Candidate Answer": "A: 4",
        "Q3 Correct Key": "C: 6",
        "Q3 Mark": 0,
        "Q4 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q4 Candidate Answer": "C: 11",
        "Q4 Correct Key": "C: 11",
        "Q4 Mark": 1,
        "Q5 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q5 Candidate Answer": "C: 3",
        "Q5 Correct Key": "C: 3",
        "Q5 Mark": 1,
        "Q6 Question": "How is a triple jump measured?",
        "Q6 Candidate Answer": "D: Diagonally from the take-off board to the landing point",
        "Q6 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q6 Mark": 0,
        "Q7 Question": "In which throwing event are gloves allowed?",
        "Q7 Candidate Answer": "D: Hammer throw",
        "Q7 Correct Key": "D: Hammer throw",
        "Q7 Mark": 1,
        "Q8 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q8 Candidate Answer": "C: Protein",
        "Q8 Correct Key": "C: Protein",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the men's javelin?",
        "Q9 Candidate Answer": "C: 800 g",
        "Q9 Correct Key": "C: 800 g",
        "Q9 Mark": 1,
        "Q10 Question": "What is the weight of the men's shot?",
        "Q10 Candidate Answer": "C: 7.260 kg",
        "Q10 Correct Key": "C: 7.260 kg",
        "Q10 Mark": 1,
        "Q11 Question": "Which of the following is a Niyama?",
        "Q11 Candidate Answer": "C: Svadhyaya",
        "Q11 Correct Key": "C: Svadhyaya",
        "Q11 Mark": 1,
        "Q12 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q12 Candidate Answer": "D: 3 minutes",
        "Q12 Correct Key": "C: 2 minutes",
        "Q12 Mark": 0,
        "Q13 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 20 m",
        "Q13 Mark": 0,
        "Q14 Question": "What is the diameter of the shot put circle?",
        "Q14 Candidate Answer": "B: 2.135 m",
        "Q14 Correct Key": "B: 2.135 m",
        "Q14 Mark": 1,
        "Q15 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q15 Candidate Answer": "C: Karma Yoga",
        "Q15 Correct Key": "C: Karma Yoga",
        "Q15 Mark": 1,
        "Q16 Question": "What is the correct sequence of phases in the triple jump?",
        "Q16 Candidate Answer": "C: Hop – Step – Jump",
        "Q16 Correct Key": "C: Hop – Step – Jump",
        "Q16 Mark": 1,
        "Q17 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q17 Candidate Answer": "C: Disqualified",
        "Q17 Correct Key": "C: Disqualified",
        "Q17 Mark": 1,
        "Q18 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q18 Candidate Answer": "B: Glide method",
        "Q18 Correct Key": "B: Glide method",
        "Q18 Mark": 1,
        "Q19 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q19 Candidate Answer": "B: Yama",
        "Q19 Correct Key": "B: Yama",
        "Q19 Mark": 1,
        "Q20 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q20 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q20 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q20 Mark": 1,
        "Q21 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q21 Candidate Answer": "B: 45 mm",
        "Q21 Correct Key": "B: 45 mm",
        "Q21 Mark": 1,
        "Q22 Question": "What is the javelin throwing sector angle?",
        "Q22 Candidate Answer": "A: 28.96°",
        "Q22 Correct Key": "A: 28.96°",
        "Q22 Mark": 1,
        "Q23 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q23 Candidate Answer": "D: Orthodox grip",
        "Q23 Correct Key": "D: Orthodox grip",
        "Q23 Mark": 1,
        "Q24 Question": "Lactose (milk sugar) is made of:",
        "Q24 Candidate Answer": "D: Fructose + Galactose",
        "Q24 Correct Key": "C: Glucose + Galactose",
        "Q24 Mark": 0,
        "Q25 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q25 Candidate Answer": "B: 29°",
        "Q25 Correct Key": "C: 34.92°",
        "Q25 Mark": 0,
        "Q26 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q26 Candidate Answer": "A: Western Roll",
        "Q26 Correct Key": "D: Fosbury Flop",
        "Q26 Mark": 0,
        "Q27 Question": "How much energy does 1 g of fat give?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 9.1 kcal",
        "Q27 Mark": 0,
        "Q28 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Pratyahara",
        "Q28 Mark": 0,
        "Q29 Question": "If the shot lands on one of the sector lines:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: It is called a foul and not measured",
        "Q29 Mark": 0,
        "Q30 Question": "In track and field, a green card is shown when:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 65,
      "registrationNumber": "KOP/2026/08/0475",
      "studentName": "ROHINI MEHER",
      "mobileNumber": "8455958414",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:11 pm",
      "startTime": "18 Oct 2026, 01:16:03 pm",
      "submissionTime": "18 Oct 2026, 01:44:02 pm",
      "questionsAnswered": "24 / 30",
      "score": 18,
      "totalMarks": 30,
      "percentage": 60,
      "correctCount": 18,
      "wrongCount": 6,
      "unattemptedCount": 6,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 65,
        "Registration ID": "KOP/2026/08/0475",
        "Candidate Name": "ROHINI MEHER",
        "Actually Gave Exam?": "YES",
        "Total Score": "18 / 30",
        "Percentage": "60%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "C: 7.260 kg",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 1,
        "Q2 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q2 Candidate Answer": "B: Scissors Jump",
        "Q2 Correct Key": "B: Scissors Jump",
        "Q2 Mark": 1,
        "Q3 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: Pratyahara",
        "Q3 Mark": 0,
        "Q4 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q4 Candidate Answer": "A: 28.96°",
        "Q4 Correct Key": "C: 34.92°",
        "Q4 Mark": 0,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 0,
        "Q6 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q6 Candidate Answer": "B: Comparing their second-best performances",
        "Q6 Correct Key": "B: Comparing their second-best performances",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 0,
        "Q8 Question": "In international competition, the pole vault landing area must be at least:",
        "Q8 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q8 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q8 Mark": 1,
        "Q9 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: Protein",
        "Q9 Mark": 0,
        "Q10 Question": "What is the javelin throwing sector angle?",
        "Q10 Candidate Answer": "A: 28.96°",
        "Q10 Correct Key": "A: 28.96°",
        "Q10 Mark": 1,
        "Q11 Question": "What is the diameter of the discus throwing circle?",
        "Q11 Candidate Answer": "A: 2.135 m",
        "Q11 Correct Key": "B: 2.50 m",
        "Q11 Mark": 0,
        "Q12 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: Yama",
        "Q12 Mark": 0,
        "Q13 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q13 Candidate Answer": "A: 30 minutes",
        "Q13 Correct Key": "B: 45 minutes",
        "Q13 Mark": 0,
        "Q14 Question": "Which of the following is NOT a flight style in long jump?",
        "Q14 Candidate Answer": "D: Fosbury flop",
        "Q14 Correct Key": "D: Fosbury flop",
        "Q14 Mark": 1,
        "Q15 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q15 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q15 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q15 Mark": 1,
        "Q16 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q16 Candidate Answer": "D: 3 minutes",
        "Q16 Correct Key": "C: 2 minutes",
        "Q16 Mark": 0,
        "Q17 Question": "What is the weight of the men's javelin?",
        "Q17 Candidate Answer": "C: 800 g",
        "Q17 Correct Key": "C: 800 g",
        "Q17 Mark": 1,
        "Q18 Question": "What are the dimensions of the take-off board in long jump?",
        "Q18 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q18 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q18 Mark": 1,
        "Q19 Question": "How high is the plasticine indicator board?",
        "Q19 Candidate Answer": "C: 10 mm",
        "Q19 Correct Key": "B: 7 mm",
        "Q19 Mark": 0,
        "Q20 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q20 Candidate Answer": "C: Disqualified",
        "Q20 Correct Key": "C: Disqualified",
        "Q20 Mark": 1,
        "Q21 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q21 Candidate Answer": "B: 45 mm",
        "Q21 Correct Key": "B: 45 mm",
        "Q21 Mark": 1,
        "Q22 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q22 Candidate Answer": "C: 20 m",
        "Q22 Correct Key": "C: 20 m",
        "Q22 Mark": 1,
        "Q23 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q23 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q23 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q23 Mark": 0,
        "Q24 Question": "What is the minimum size of the high jump landing mat?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 5 m × 3 m",
        "Q24 Mark": 0,
        "Q25 Question": "What is the diameter of the shot put circle?",
        "Q25 Candidate Answer": "B: 2.135 m",
        "Q25 Correct Key": "B: 2.135 m",
        "Q25 Mark": 1,
        "Q26 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q26 Candidate Answer": "C: 32 m/s",
        "Q26 Correct Key": "C: 32 m/s",
        "Q26 Mark": 1,
        "Q27 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q27 Candidate Answer": "B: Swami Vivekananda",
        "Q27 Correct Key": "B: Swami Vivekananda",
        "Q27 Mark": 1,
        "Q28 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q28 Candidate Answer": "A: Laya Yoga",
        "Q28 Correct Key": "A: Laya Yoga",
        "Q28 Mark": 1,
        "Q29 Question": "What is the correct sequence of phases in the triple jump?",
        "Q29 Candidate Answer": "C: Hop – Step – Jump",
        "Q29 Correct Key": "C: Hop – Step – Jump",
        "Q29 Mark": 1,
        "Q30 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q30 Candidate Answer": "C: To join or unite",
        "Q30 Correct Key": "C: To join or unite",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 66,
      "registrationNumber": "KOP/2026/09/0035",
      "studentName": "RAMESWAR KUDAI",
      "mobileNumber": "7327964836",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:32 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 16,
      "totalMarks": 30,
      "percentage": 53.3,
      "correctCount": 16,
      "wrongCount": 14,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 66,
        "Registration ID": "KOP/2026/09/0035",
        "Candidate Name": "RAMESWAR KUDAI",
        "Actually Gave Exam?": "YES",
        "Total Score": "16 / 30",
        "Percentage": "53.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "B: Ahimsa",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 0,
        "Q2 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q2 Candidate Answer": "C: 34.92°",
        "Q2 Correct Key": "C: 34.92°",
        "Q2 Mark": 1,
        "Q3 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q3 Candidate Answer": "B: Yama",
        "Q3 Correct Key": "B: Yama",
        "Q3 Mark": 1,
        "Q4 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q4 Candidate Answer": "C: The athlete who achieved the distance first",
        "Q4 Correct Key": "B: Comparing their second-best performances",
        "Q4 Mark": 0,
        "Q5 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q5 Candidate Answer": "B: 15 m",
        "Q5 Correct Key": "C: 20 m",
        "Q5 Mark": 0,
        "Q6 Question": "Which statement about pole vault is correct?",
        "Q6 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q6 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q6 Mark": 0,
        "Q7 Question": "What is the minimum size of the high jump landing mat?",
        "Q7 Candidate Answer": "D: 9 m × 2.75 m",
        "Q7 Correct Key": "B: 5 m × 3 m",
        "Q7 Mark": 0,
        "Q8 Question": "A javelin throw is valid only if:",
        "Q8 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q8 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q8 Mark": 1,
        "Q9 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q9 Candidate Answer": "A: To breathe",
        "Q9 Correct Key": "C: To join or unite",
        "Q9 Mark": 0,
        "Q10 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q10 Candidate Answer": "A: Carbohydrates",
        "Q10 Correct Key": "C: Protein",
        "Q10 Mark": 0,
        "Q11 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q11 Candidate Answer": "B: 1:2:1",
        "Q11 Correct Key": "B: 1:2:1",
        "Q11 Mark": 1,
        "Q12 Question": "What is the javelin throwing sector angle?",
        "Q12 Candidate Answer": "A: 28.96°",
        "Q12 Correct Key": "A: 28.96°",
        "Q12 Mark": 1,
        "Q13 Question": "In track and field, a green card is shown when:",
        "Q13 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q13 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q13 Mark": 1,
        "Q14 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q14 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q14 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q14 Mark": 1,
        "Q15 Question": "In which throwing event are gloves allowed?",
        "Q15 Candidate Answer": "A: Shot put",
        "Q15 Correct Key": "D: Hammer throw",
        "Q15 Mark": 0,
        "Q16 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q16 Candidate Answer": "D: 6",
        "Q16 Correct Key": "C: 3",
        "Q16 Mark": 0,
        "Q17 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q17 Candidate Answer": "A: Laya Yoga",
        "Q17 Correct Key": "A: Laya Yoga",
        "Q17 Mark": 1,
        "Q18 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q18 Candidate Answer": "B: Swami Vivekananda",
        "Q18 Correct Key": "B: Swami Vivekananda",
        "Q18 Mark": 1,
        "Q19 Question": "In international competition, the pole vault landing area must be at least:",
        "Q19 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q19 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q19 Mark": 1,
        "Q20 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q20 Candidate Answer": "A: Simple method",
        "Q20 Correct Key": "B: Glide method",
        "Q20 Mark": 0,
        "Q21 Question": "Lactose (milk sugar) is made of:",
        "Q21 Candidate Answer": "C: Glucose + Galactose",
        "Q21 Correct Key": "C: Glucose + Galactose",
        "Q21 Mark": 1,
        "Q22 Question": "How much energy does 1 g of fat give?",
        "Q22 Candidate Answer": "B: 7.1 kcal",
        "Q22 Correct Key": "C: 9.1 kcal",
        "Q22 Mark": 0,
        "Q23 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q23 Candidate Answer": "C: Karma Yoga",
        "Q23 Correct Key": "C: Karma Yoga",
        "Q23 Mark": 1,
        "Q24 Question": "What is the diameter of the shot put circle?",
        "Q24 Candidate Answer": "B: 2.135 m",
        "Q24 Correct Key": "B: 2.135 m",
        "Q24 Mark": 1,
        "Q25 Question": "What is the correct sequence of phases in the triple jump?",
        "Q25 Candidate Answer": "A: Step – Hop – Jump",
        "Q25 Correct Key": "C: Hop – Step – Jump",
        "Q25 Mark": 0,
        "Q26 Question": "If the shot lands on one of the sector lines:",
        "Q26 Candidate Answer": "C: It is called a foul and not measured",
        "Q26 Correct Key": "C: It is called a foul and not measured",
        "Q26 Mark": 1,
        "Q27 Question": "What are the dimensions of the take-off board in long jump?",
        "Q27 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q27 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q27 Mark": 0,
        "Q28 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q28 Candidate Answer": "C: 6",
        "Q28 Correct Key": "C: 6",
        "Q28 Mark": 1,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "A: 5 mm",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 0,
        "Q30 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q30 Candidate Answer": "C: 32 m/s",
        "Q30 Correct Key": "C: 32 m/s",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 67,
      "registrationNumber": "KOP/2026/09/0098",
      "studentName": "KARESH RANA",
      "mobileNumber": "9178584075",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:21 pm",
      "startTime": "18 Oct 2026, 01:15:12 pm",
      "submissionTime": "18 Oct 2026, 01:43:09 pm",
      "questionsAnswered": "30 / 30",
      "score": 16,
      "totalMarks": 30,
      "percentage": 53.3,
      "correctCount": 16,
      "wrongCount": 14,
      "unattemptedCount": 30,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 67,
        "Registration ID": "KOP/2026/09/0098",
        "Candidate Name": "KARESH RANA",
        "Actually Gave Exam?": "YES",
        "Total Score": "16 / 30",
        "Percentage": "53.3%",
        "Result": "QUALIFIED",
        "Q1 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q1 Candidate Answer": "B: 45 minutes",
        "Q1 Correct Key": "B: 45 minutes",
        "Q1 Mark": 1,
        "Q2 Question": "In international competition, the pole vault landing area must be at least:",
        "Q2 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q2 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q2 Mark": 1,
        "Q3 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q3 Candidate Answer": "D: Lands directly in the sand pit",
        "Q3 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q3 Mark": 0,
        "Q4 Question": "How high is the plasticine indicator board?",
        "Q4 Candidate Answer": "C: 10 mm",
        "Q4 Correct Key": "B: 7 mm",
        "Q4 Mark": 0,
        "Q5 Question": "What is the weight of the men's javelin?",
        "Q5 Candidate Answer": "C: 800 g",
        "Q5 Correct Key": "C: 800 g",
        "Q5 Mark": 1,
        "Q6 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q6 Candidate Answer": "B: Yama",
        "Q6 Correct Key": "B: Yama",
        "Q6 Mark": 1,
        "Q7 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q7 Candidate Answer": "C: 34.92°",
        "Q7 Correct Key": "C: 34.92°",
        "Q7 Mark": 1,
        "Q8 Question": "What is the javelin throwing sector angle?",
        "Q8 Candidate Answer": "C: 34.92°",
        "Q8 Correct Key": "A: 28.96°",
        "Q8 Mark": 0,
        "Q9 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q9 Candidate Answer": "D: Orthodox grip",
        "Q9 Correct Key": "D: Orthodox grip",
        "Q9 Mark": 1,
        "Q10 Question": "In track and field, a green card is shown when:",
        "Q10 Candidate Answer": "D: An athlete leaves the track voluntarily",
        "Q10 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q10 Mark": 0,
        "Q11 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q11 Candidate Answer": "C: Yantra Yoga",
        "Q11 Correct Key": "A: Laya Yoga",
        "Q11 Mark": 0,
        "Q12 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q12 Candidate Answer": "B: Swami Vivekananda",
        "Q12 Correct Key": "B: Swami Vivekananda",
        "Q12 Mark": 1,
        "Q13 Question": "What is the minimum size of the high jump landing mat?",
        "Q13 Candidate Answer": "B: 5 m × 3 m",
        "Q13 Correct Key": "B: 5 m × 3 m",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the women's discus?",
        "Q14 Candidate Answer": "B: 1 kg",
        "Q14 Correct Key": "B: 1 kg",
        "Q14 Mark": 1,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 1,
        "Q16 Question": "What is the correct sequence of phases in the triple jump?",
        "Q16 Candidate Answer": "C: Hop – Step – Jump",
        "Q16 Correct Key": "C: Hop – Step – Jump",
        "Q16 Mark": 1,
        "Q17 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q17 Candidate Answer": "C: 20 m",
        "Q17 Correct Key": "C: 20 m",
        "Q17 Mark": 1,
        "Q18 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q18 Candidate Answer": "A: Western Roll",
        "Q18 Correct Key": "D: Fosbury Flop",
        "Q18 Mark": 0,
        "Q19 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q19 Candidate Answer": "A: Straddle",
        "Q19 Correct Key": "B: Scissors Jump",
        "Q19 Mark": 0,
        "Q20 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q20 Candidate Answer": "D: Dhyana",
        "Q20 Correct Key": "C: Pratyahara",
        "Q20 Mark": 0,
        "Q21 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q21 Candidate Answer": "A: A foul throw",
        "Q21 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q21 Mark": 0,
        "Q22 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q22 Candidate Answer": "D: 6",
        "Q22 Correct Key": "C: 3",
        "Q22 Mark": 0,
        "Q23 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q23 Candidate Answer": "D: Averaging all throws",
        "Q23 Correct Key": "B: Comparing their second-best performances",
        "Q23 Mark": 0,
        "Q24 Question": "How much energy does 1 g of fat give?",
        "Q24 Candidate Answer": "C: 9.1 kcal",
        "Q24 Correct Key": "C: 9.1 kcal",
        "Q24 Mark": 1,
        "Q25 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q25 Candidate Answer": "B: 1:2:1",
        "Q25 Correct Key": "B: 1:2:1",
        "Q25 Mark": 1,
        "Q26 Question": "Which of the following is NOT a flight style in long jump?",
        "Q26 Candidate Answer": "D: Fosbury flop",
        "Q26 Correct Key": "D: Fosbury flop",
        "Q26 Mark": 1,
        "Q27 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q27 Candidate Answer": "B: Fat",
        "Q27 Correct Key": "C: Protein",
        "Q27 Mark": 0,
        "Q28 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q28 Candidate Answer": "D: Mantra Yoga",
        "Q28 Correct Key": "C: Karma Yoga",
        "Q28 Mark": 0,
        "Q29 Question": "Which of the following is a Niyama?",
        "Q29 Candidate Answer": "D: Aparigraha",
        "Q29 Correct Key": "C: Svadhyaya",
        "Q29 Mark": 0,
        "Q30 Question": "What is the diameter of the shot put circle?",
        "Q30 Candidate Answer": "B: 2.135 m",
        "Q30 Correct Key": "B: 2.135 m",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 68,
      "registrationNumber": "KOP/2026/08/0637",
      "studentName": "BHUPENDRA KUMAR NAIK",
      "mobileNumber": "8249450037",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:05:36 pm",
      "startTime": "18 Oct 2026, 01:16:44 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "21 / 30",
      "score": 15,
      "totalMarks": 30,
      "percentage": 50,
      "correctCount": 15,
      "wrongCount": 6,
      "unattemptedCount": 9,
      "result": "QUALIFIED",
      "detailedResponses": {
        "Rank": 68,
        "Registration ID": "KOP/2026/08/0637",
        "Candidate Name": "BHUPENDRA KUMAR NAIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "15 / 30",
        "Percentage": "50%",
        "Result": "QUALIFIED",
        "Q1 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q1 Candidate Answer": "C: To join or unite",
        "Q1 Correct Key": "C: To join or unite",
        "Q1 Mark": 1,
        "Q2 Question": "Which statement about pole vault is correct?",
        "Q2 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q2 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q2 Mark": 0,
        "Q3 Question": "What is the diameter of the shot put circle?",
        "Q3 Candidate Answer": "B: 2.135 m",
        "Q3 Correct Key": "B: 2.135 m",
        "Q3 Mark": 1,
        "Q4 Question": "In track and field, a green card is shown when:",
        "Q4 Candidate Answer": "C: There is a technical fault and no athlete is punished",
        "Q4 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q4 Mark": 1,
        "Q5 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q5 Candidate Answer": "B: Comparing their second-best performances",
        "Q5 Correct Key": "B: Comparing their second-best performances",
        "Q5 Mark": 1,
        "Q6 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q6 Candidate Answer": "C: 34.92°",
        "Q6 Correct Key": "C: 34.92°",
        "Q6 Mark": 1,
        "Q7 Question": "Which of the following is a Niyama?",
        "Q7 Candidate Answer": "C: Svadhyaya",
        "Q7 Correct Key": "C: Svadhyaya",
        "Q7 Mark": 1,
        "Q8 Question": "A javelin throw is valid only if:",
        "Q8 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q8 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q8 Mark": 1,
        "Q9 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q9 Candidate Answer": "C: 32 m/s",
        "Q9 Correct Key": "C: 32 m/s",
        "Q9 Mark": 1,
        "Q10 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q10 Candidate Answer": "C: 3",
        "Q10 Correct Key": "C: 3",
        "Q10 Mark": 1,
        "Q11 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q11 Candidate Answer": "B: Yama",
        "Q11 Correct Key": "B: Yama",
        "Q11 Mark": 1,
        "Q12 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q12 Candidate Answer": "D: 12",
        "Q12 Correct Key": "C: 11",
        "Q12 Mark": 0,
        "Q13 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q13 Candidate Answer": "B: 1:2:1",
        "Q13 Correct Key": "B: 1:2:1",
        "Q13 Mark": 1,
        "Q14 Question": "In international competition, the pole vault landing area must be at least:",
        "Q14 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q14 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q14 Mark": 1,
        "Q15 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q15 Candidate Answer": "A: Western Roll",
        "Q15 Correct Key": "D: Fosbury Flop",
        "Q15 Mark": 0,
        "Q16 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q16 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q16 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q16 Mark": 1,
        "Q17 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q17 Candidate Answer": "A: 30 minutes",
        "Q17 Correct Key": "B: 45 minutes",
        "Q17 Mark": 0,
        "Q18 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q18 Candidate Answer": "A: To breathe",
        "Q18 Correct Key": "B: To hold or maintain",
        "Q18 Mark": 0,
        "Q19 Question": "What is the weight of the women's discus?",
        "Q19 Candidate Answer": "B: 1 kg",
        "Q19 Correct Key": "B: 1 kg",
        "Q19 Mark": 1,
        "Q20 Question": "How is a triple jump measured?",
        "Q20 Candidate Answer": "D: Diagonally from the take-off board to the landing point",
        "Q20 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q20 Mark": 0,
        "Q21 Question": "What is the correct sequence of phases in the triple jump?",
        "Q21 Candidate Answer": "C: Hop – Step – Jump",
        "Q21 Correct Key": "C: Hop – Step – Jump",
        "Q21 Mark": 1,
        "Q22 Question": "If the shot lands on one of the sector lines:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: It is called a foul and not measured",
        "Q22 Mark": 0,
        "Q23 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: Glide method",
        "Q23 Mark": 0,
        "Q24 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: 6",
        "Q24 Mark": 0,
        "Q25 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q25 Mark": 0,
        "Q26 Question": "How high is the plasticine indicator board?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: 7 mm",
        "Q26 Mark": 0,
        "Q27 Question": "What is the javelin throwing sector angle?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "A: 28.96°",
        "Q27 Mark": 0,
        "Q28 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Pratyahara",
        "Q28 Mark": 0,
        "Q29 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: 2 minutes",
        "Q29 Mark": 0,
        "Q30 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: Scissors Jump",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 69,
      "registrationNumber": "KOP/2026/06/0212",
      "studentName": "MINA MAJHI",
      "mobileNumber": "7008495183",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:02:08 pm",
      "startTime": "18 Oct 2026, 01:26:30 pm",
      "submissionTime": "18 Oct 2026, 01:50:12 pm",
      "questionsAnswered": "30 / 30",
      "score": 13,
      "totalMarks": 30,
      "percentage": 43.3,
      "correctCount": 13,
      "wrongCount": 17,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 69,
        "Registration ID": "KOP/2026/06/0212",
        "Candidate Name": "MINA MAJHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "13 / 30",
        "Percentage": "43.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "How much energy does 1 g of fat give?",
        "Q1 Candidate Answer": "A: 4.1 kcal",
        "Q1 Correct Key": "C: 9.1 kcal",
        "Q1 Mark": 0,
        "Q2 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q2 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q2 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q2 Mark": 0,
        "Q3 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q3 Candidate Answer": "D: Orthodox grip",
        "Q3 Correct Key": "D: Orthodox grip",
        "Q3 Mark": 1,
        "Q4 Question": "Which of the following is a Niyama?",
        "Q4 Candidate Answer": "B: Ahimsa",
        "Q4 Correct Key": "C: Svadhyaya",
        "Q4 Mark": 0,
        "Q5 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q5 Candidate Answer": "C: Yantra Yoga",
        "Q5 Correct Key": "A: Laya Yoga",
        "Q5 Mark": 0,
        "Q6 Question": "What is the diameter of the discus throwing circle?",
        "Q6 Candidate Answer": "C: 2.75 m",
        "Q6 Correct Key": "B: 2.50 m",
        "Q6 Mark": 0,
        "Q7 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q7 Candidate Answer": "A: Maharishi Patanjali",
        "Q7 Correct Key": "B: Swami Vivekananda",
        "Q7 Mark": 0,
        "Q8 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q8 Candidate Answer": "B: 45 mm",
        "Q8 Correct Key": "B: 45 mm",
        "Q8 Mark": 1,
        "Q9 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q9 Candidate Answer": "A: 100m Hurdles, High Jump, Shot Put",
        "Q9 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q9 Mark": 0,
        "Q10 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q10 Candidate Answer": "C: 11",
        "Q10 Correct Key": "C: 11",
        "Q10 Mark": 1,
        "Q11 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q11 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q11 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q11 Mark": 1,
        "Q12 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q12 Candidate Answer": "D: Standing method",
        "Q12 Correct Key": "B: Glide method",
        "Q12 Mark": 0,
        "Q13 Question": "What is the weight of the men's shot?",
        "Q13 Candidate Answer": "D: 8.000 kg",
        "Q13 Correct Key": "C: 7.260 kg",
        "Q13 Mark": 0,
        "Q14 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q14 Candidate Answer": "B: 28 m/s",
        "Q14 Correct Key": "C: 32 m/s",
        "Q14 Mark": 0,
        "Q15 Question": "What is the correct sequence of phases in the triple jump?",
        "Q15 Candidate Answer": "D: Jump – Hop – Step",
        "Q15 Correct Key": "C: Hop – Step – Jump",
        "Q15 Mark": 0,
        "Q16 Question": "How is a triple jump measured?",
        "Q16 Candidate Answer": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q16 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q16 Mark": 1,
        "Q17 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q17 Candidate Answer": "D: Mantra Yoga",
        "Q17 Correct Key": "C: Karma Yoga",
        "Q17 Mark": 0,
        "Q18 Question": "What is the weight of the men's javelin?",
        "Q18 Candidate Answer": "C: 800 g",
        "Q18 Correct Key": "C: 800 g",
        "Q18 Mark": 1,
        "Q19 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q19 Candidate Answer": "C: Disqualified",
        "Q19 Correct Key": "C: Disqualified",
        "Q19 Mark": 1,
        "Q20 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q20 Candidate Answer": "B: Yama",
        "Q20 Correct Key": "B: Yama",
        "Q20 Mark": 1,
        "Q21 Question": "What is the diameter of the shot put circle?",
        "Q21 Candidate Answer": "D: 2.75 m",
        "Q21 Correct Key": "B: 2.135 m",
        "Q21 Mark": 0,
        "Q22 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q22 Candidate Answer": "D: Vitamins",
        "Q22 Correct Key": "C: Protein",
        "Q22 Mark": 0,
        "Q23 Question": "What is the official distance of a marathon?",
        "Q23 Candidate Answer": "C: 42.195 km",
        "Q23 Correct Key": "C: 42.195 km",
        "Q23 Mark": 1,
        "Q24 Question": "In which throwing event are gloves allowed?",
        "Q24 Candidate Answer": "C: Javelin",
        "Q24 Correct Key": "D: Hammer throw",
        "Q24 Mark": 0,
        "Q25 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q25 Candidate Answer": "A: Pranayama",
        "Q25 Correct Key": "C: Pratyahara",
        "Q25 Mark": 0,
        "Q26 Question": "A javelin throw is valid only if:",
        "Q26 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q26 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q26 Mark": 1,
        "Q27 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q27 Candidate Answer": "C: 34.92°",
        "Q27 Correct Key": "C: 34.92°",
        "Q27 Mark": 1,
        "Q28 Question": "What are the dimensions of the take-off board in long jump?",
        "Q28 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q28 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q28 Mark": 1,
        "Q29 Question": "What is the javelin throwing sector angle?",
        "Q29 Candidate Answer": "A: 28.96°",
        "Q29 Correct Key": "A: 28.96°",
        "Q29 Mark": 1,
        "Q30 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q30 Candidate Answer": "A: 1",
        "Q30 Correct Key": "C: 3",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 70,
      "registrationNumber": "KOP/2026/08/0669",
      "studentName": "TULSE MAJHI",
      "mobileNumber": "8249859181",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:11 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 13,
      "totalMarks": 30,
      "percentage": 43.3,
      "correctCount": 13,
      "wrongCount": 17,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 70,
        "Registration ID": "KOP/2026/08/0669",
        "Candidate Name": "TULSE MAJHI",
        "Actually Gave Exam?": "YES",
        "Total Score": "13 / 30",
        "Percentage": "43.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "What is the diameter of the shot put circle?",
        "Q1 Candidate Answer": "D: 2.75 m",
        "Q1 Correct Key": "B: 2.135 m",
        "Q1 Mark": 0,
        "Q2 Question": "What is the weight of the women's discus?",
        "Q2 Candidate Answer": "D: 2 kg",
        "Q2 Correct Key": "B: 1 kg",
        "Q2 Mark": 0,
        "Q3 Question": "Lactose (milk sugar) is made of:",
        "Q3 Candidate Answer": "C: Glucose + Galactose",
        "Q3 Correct Key": "C: Glucose + Galactose",
        "Q3 Mark": 1,
        "Q4 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q4 Candidate Answer": "A: Maharishi Patanjali",
        "Q4 Correct Key": "B: Swami Vivekananda",
        "Q4 Mark": 0,
        "Q5 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q5 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q5 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q5 Mark": 1,
        "Q6 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q6 Candidate Answer": "B: 45 minutes",
        "Q6 Correct Key": "B: 45 minutes",
        "Q6 Mark": 1,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 0,
        "Q8 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q8 Candidate Answer": "C: To join or unite",
        "Q8 Correct Key": "C: To join or unite",
        "Q8 Mark": 1,
        "Q9 Question": "In international competition, the pole vault landing area must be at least:",
        "Q9 Candidate Answer": "A: 5 m × 5 m × 0.8 m",
        "Q9 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q9 Mark": 0,
        "Q10 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q10 Candidate Answer": "D: High Jump, Javelin Throw, 400m",
        "Q10 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Mark": 0,
        "Q11 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q11 Candidate Answer": "C: 20 m",
        "Q11 Correct Key": "C: 20 m",
        "Q11 Mark": 1,
        "Q12 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q12 Candidate Answer": "A: Finnish grip",
        "Q12 Correct Key": "D: Orthodox grip",
        "Q12 Mark": 0,
        "Q13 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q13 Candidate Answer": "C: 11",
        "Q13 Correct Key": "C: 11",
        "Q13 Mark": 1,
        "Q14 Question": "A javelin throw is valid only if:",
        "Q14 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q14 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q14 Mark": 1,
        "Q15 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q15 Candidate Answer": "A: 28.96°",
        "Q15 Correct Key": "C: 34.92°",
        "Q15 Mark": 0,
        "Q16 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q16 Candidate Answer": "A: Gyan Yoga",
        "Q16 Correct Key": "C: Karma Yoga",
        "Q16 Mark": 0,
        "Q17 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q17 Candidate Answer": "D: Fosbury Flop",
        "Q17 Correct Key": "B: Scissors Jump",
        "Q17 Mark": 0,
        "Q18 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q18 Candidate Answer": "C: Disqualified",
        "Q18 Correct Key": "C: Disqualified",
        "Q18 Mark": 1,
        "Q19 Question": "Which of the following is a Niyama?",
        "Q19 Candidate Answer": "C: Svadhyaya",
        "Q19 Correct Key": "C: Svadhyaya",
        "Q19 Mark": 1,
        "Q20 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q20 Candidate Answer": "C: Pratyahara",
        "Q20 Correct Key": "C: Pratyahara",
        "Q20 Mark": 1,
        "Q21 Question": "In track and field, a green card is shown when:",
        "Q21 Candidate Answer": "B: An athlete is disqualified",
        "Q21 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q21 Mark": 0,
        "Q22 Question": "What is the weight of the men's shot?",
        "Q22 Candidate Answer": "B: 7.000 kg",
        "Q22 Correct Key": "C: 7.260 kg",
        "Q22 Mark": 0,
        "Q23 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q23 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q23 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q23 Mark": 1,
        "Q24 Question": "What is the official distance of a marathon?",
        "Q24 Candidate Answer": "A: 40.195 km",
        "Q24 Correct Key": "C: 42.195 km",
        "Q24 Mark": 0,
        "Q25 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q25 Candidate Answer": "B: Comparing their second-best performances",
        "Q25 Correct Key": "B: Comparing their second-best performances",
        "Q25 Mark": 1,
        "Q26 Question": "How high is the plasticine indicator board?",
        "Q26 Candidate Answer": "D: 20 mm",
        "Q26 Correct Key": "B: 7 mm",
        "Q26 Mark": 0,
        "Q27 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q27 Candidate Answer": "B: Yama",
        "Q27 Correct Key": "B: Yama",
        "Q27 Mark": 1,
        "Q28 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q28 Candidate Answer": "B: Eastern Roll",
        "Q28 Correct Key": "D: Fosbury Flop",
        "Q28 Mark": 0,
        "Q29 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q29 Candidate Answer": "A: 40 mm",
        "Q29 Correct Key": "B: 45 mm",
        "Q29 Mark": 0,
        "Q30 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q30 Candidate Answer": "B: 28 m/s",
        "Q30 Correct Key": "C: 32 m/s",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 71,
      "registrationNumber": "KOP/2026/07/0405",
      "studentName": "DROPADI SABAR",
      "mobileNumber": "7854949939",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:12 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "27 / 30",
      "score": 13,
      "totalMarks": 30,
      "percentage": 43.3,
      "correctCount": 13,
      "wrongCount": 14,
      "unattemptedCount": 3,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 71,
        "Registration ID": "KOP/2026/07/0405",
        "Candidate Name": "DROPADI SABAR",
        "Actually Gave Exam?": "YES",
        "Total Score": "13 / 30",
        "Percentage": "43.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q1 Candidate Answer": "C: The athlete who started at the higher height",
        "Q1 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q1 Mark": 0,
        "Q2 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q2 Candidate Answer": "A: Carbohydrates",
        "Q2 Correct Key": "C: Protein",
        "Q2 Mark": 0,
        "Q3 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q3 Candidate Answer": "C: 3",
        "Q3 Correct Key": "C: 3",
        "Q3 Mark": 1,
        "Q4 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q4 Candidate Answer": "B: 5",
        "Q4 Correct Key": "C: 6",
        "Q4 Mark": 0,
        "Q5 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q5 Candidate Answer": "B: Scissors Jump",
        "Q5 Correct Key": "B: Scissors Jump",
        "Q5 Mark": 1,
        "Q6 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "D: Fosbury Flop",
        "Q6 Mark": 0,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "A: 40.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 0,
        "Q8 Question": "A javelin throw is valid only if:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q8 Mark": 0,
        "Q9 Question": "What is the weight of the men's shot?",
        "Q9 Candidate Answer": "C: 7.260 kg",
        "Q9 Correct Key": "C: 7.260 kg",
        "Q9 Mark": 1,
        "Q10 Question": "If the shot lands on one of the sector lines:",
        "Q10 Candidate Answer": "A: It is measured normally",
        "Q10 Correct Key": "C: It is called a foul and not measured",
        "Q10 Mark": 0,
        "Q11 Question": "What is the correct sequence of phases in the triple jump?",
        "Q11 Candidate Answer": "C: Hop – Step – Jump",
        "Q11 Correct Key": "C: Hop – Step – Jump",
        "Q11 Mark": 1,
        "Q12 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q12 Candidate Answer": "A: Laya Yoga",
        "Q12 Correct Key": "A: Laya Yoga",
        "Q12 Mark": 1,
        "Q13 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q13 Candidate Answer": "C: Karma Yoga",
        "Q13 Correct Key": "C: Karma Yoga",
        "Q13 Mark": 1,
        "Q14 Question": "Lactose (milk sugar) is made of:",
        "Q14 Candidate Answer": "A: Glucose + Glucose",
        "Q14 Correct Key": "C: Glucose + Galactose",
        "Q14 Mark": 0,
        "Q15 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q15 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q15 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q15 Mark": 1,
        "Q16 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q16 Candidate Answer": "A: Maharishi Patanjali",
        "Q16 Correct Key": "B: Swami Vivekananda",
        "Q16 Mark": 0,
        "Q17 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q17 Candidate Answer": "B: 1:2:1",
        "Q17 Correct Key": "B: 1:2:1",
        "Q17 Mark": 1,
        "Q18 Question": "Which of the following is a Niyama?",
        "Q18 Candidate Answer": "A: Satya",
        "Q18 Correct Key": "C: Svadhyaya",
        "Q18 Mark": 0,
        "Q19 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q19 Candidate Answer": "D: 40 m",
        "Q19 Correct Key": "C: 20 m",
        "Q19 Mark": 0,
        "Q20 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q20 Candidate Answer": "B: 45 minutes",
        "Q20 Correct Key": "B: 45 minutes",
        "Q20 Mark": 1,
        "Q21 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q21 Candidate Answer": "A: 1 minute",
        "Q21 Correct Key": "C: 2 minutes",
        "Q21 Mark": 0,
        "Q22 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q22 Candidate Answer": "D: Standing method",
        "Q22 Correct Key": "B: Glide method",
        "Q22 Mark": 0,
        "Q23 Question": "How is a triple jump measured?",
        "Q23 Candidate Answer": "D: Diagonally from the take-off board to the landing point",
        "Q23 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q23 Mark": 0,
        "Q24 Question": "What is the weight of the men's javelin?",
        "Q24 Candidate Answer": "C: 800 g",
        "Q24 Correct Key": "C: 800 g",
        "Q24 Mark": 1,
        "Q25 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q25 Candidate Answer": "C: 200m, Long Jump, Shot Put",
        "Q25 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q25 Mark": 0,
        "Q26 Question": "Which statement about pole vault is correct?",
        "Q26 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q26 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q26 Mark": 0,
        "Q27 Question": "What is the weight of the women's discus?",
        "Q27 Candidate Answer": "B: 1 kg",
        "Q27 Correct Key": "B: 1 kg",
        "Q27 Mark": 1,
        "Q28 Question": "What are the dimensions of the take-off board in long jump?",
        "Q28 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q28 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q28 Mark": 1,
        "Q29 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q29 Candidate Answer": "C: 32 m/s",
        "Q29 Correct Key": "C: 32 m/s",
        "Q29 Mark": 1,
        "Q30 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: To hold or maintain",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 72,
      "registrationNumber": "KOP/2026/09/0308",
      "studentName": "SASMITA NAIK",
      "mobileNumber": "7205634415",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:02:36 pm",
      "startTime": "18 Oct 2026, 01:30:54 pm",
      "submissionTime": "18 Oct 2026, 02:01:22 pm",
      "questionsAnswered": "14 / 30",
      "score": 13,
      "totalMarks": 30,
      "percentage": 43.3,
      "correctCount": 13,
      "wrongCount": 1,
      "unattemptedCount": 16,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 72,
        "Registration ID": "KOP/2026/09/0308",
        "Candidate Name": "SASMITA NAIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "13 / 30",
        "Percentage": "43.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "What is the diameter of the shot put circle?",
        "Q1 Candidate Answer": "B: 2.135 m",
        "Q1 Correct Key": "B: 2.135 m",
        "Q1 Mark": 1,
        "Q2 Question": "Which of the following is NOT a flight style in long jump?",
        "Q2 Candidate Answer": "D: Fosbury flop",
        "Q2 Correct Key": "D: Fosbury flop",
        "Q2 Mark": 1,
        "Q3 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q3 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q3 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q3 Mark": 1,
        "Q4 Question": "In which throwing event are gloves allowed?",
        "Q4 Candidate Answer": "D: Hammer throw",
        "Q4 Correct Key": "D: Hammer throw",
        "Q4 Mark": 1,
        "Q5 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q5 Candidate Answer": "B: To hold or maintain",
        "Q5 Correct Key": "B: To hold or maintain",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the men's shot?",
        "Q6 Candidate Answer": "C: 7.260 kg",
        "Q6 Correct Key": "C: 7.260 kg",
        "Q6 Mark": 1,
        "Q7 Question": "If the shot lands on one of the sector lines:",
        "Q7 Candidate Answer": "A: It is measured normally",
        "Q7 Correct Key": "C: It is called a foul and not measured",
        "Q7 Mark": 0,
        "Q8 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q8 Candidate Answer": "C: Pratyahara",
        "Q8 Correct Key": "C: Pratyahara",
        "Q8 Mark": 1,
        "Q9 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q9 Candidate Answer": "B: Glide method",
        "Q9 Correct Key": "B: Glide method",
        "Q9 Mark": 1,
        "Q10 Question": "How much energy does 1 g of fat give?",
        "Q10 Candidate Answer": "C: 9.1 kcal",
        "Q10 Correct Key": "C: 9.1 kcal",
        "Q10 Mark": 1,
        "Q11 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q11 Candidate Answer": "C: 3",
        "Q11 Correct Key": "C: 3",
        "Q11 Mark": 1,
        "Q12 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q12 Candidate Answer": "C: Karma Yoga",
        "Q12 Correct Key": "C: Karma Yoga",
        "Q12 Mark": 1,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "B: Scissors Jump",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 1,
        "Q14 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q14 Candidate Answer": "B: Comparing their second-best performances",
        "Q14 Correct Key": "B: Comparing their second-best performances",
        "Q14 Mark": 1,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 0,
        "Q16 Question": "What is the correct sequence of phases in the triple jump?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: Hop – Step – Jump",
        "Q16 Mark": 0,
        "Q17 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: Disqualified",
        "Q17 Mark": 0,
        "Q18 Question": "What is the diameter of the discus throwing circle?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: 2.50 m",
        "Q18 Mark": 0,
        "Q19 Question": "In track and field, a green card is shown when:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q19 Mark": 0,
        "Q20 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: 2 minutes",
        "Q20 Mark": 0,
        "Q21 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: 45 mm",
        "Q21 Mark": 0,
        "Q22 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "D: Fosbury Flop",
        "Q22 Mark": 0,
        "Q23 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "A: Laya Yoga",
        "Q23 Mark": 0,
        "Q24 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "D: Orthodox grip",
        "Q24 Mark": 0,
        "Q25 Question": "How is a triple jump measured?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q25 Mark": 0,
        "Q26 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Protein",
        "Q26 Mark": 0,
        "Q27 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Swami Vivekananda",
        "Q27 Mark": 0,
        "Q28 Question": "In international competition, the pole vault landing area must be at least:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q28 Mark": 0,
        "Q29 Question": "Which statement about pole vault is correct?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q29 Mark": 0,
        "Q30 Question": "What is the javelin throwing sector angle?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "A: 28.96°",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 73,
      "registrationNumber": "KOP/2026/08/0540",
      "studentName": "SUDAM BARIK",
      "mobileNumber": "9078039797",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:18 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 12,
      "totalMarks": 30,
      "percentage": 40,
      "correctCount": 12,
      "wrongCount": 18,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 73,
        "Registration ID": "KOP/2026/08/0540",
        "Candidate Name": "SUDAM BARIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "12 / 30",
        "Percentage": "40%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "How high is the plasticine indicator board?",
        "Q1 Candidate Answer": "B: 7 mm",
        "Q1 Correct Key": "B: 7 mm",
        "Q1 Mark": 1,
        "Q2 Question": "If the shot lands on one of the sector lines:",
        "Q2 Candidate Answer": "B: A re-throw is given",
        "Q2 Correct Key": "C: It is called a foul and not measured",
        "Q2 Mark": 0,
        "Q3 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q3 Candidate Answer": "C: 200m, Long Jump, Shot Put",
        "Q3 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q3 Mark": 0,
        "Q4 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q4 Candidate Answer": "B: Glide method",
        "Q4 Correct Key": "B: Glide method",
        "Q4 Mark": 1,
        "Q5 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q5 Candidate Answer": "A: Laya Yoga",
        "Q5 Correct Key": "A: Laya Yoga",
        "Q5 Mark": 1,
        "Q6 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q6 Candidate Answer": "C: 6",
        "Q6 Correct Key": "C: 6",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q7 Candidate Answer": "C: 50 mm",
        "Q7 Correct Key": "B: 45 mm",
        "Q7 Mark": 0,
        "Q8 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q8 Candidate Answer": "C: Protein",
        "Q8 Correct Key": "C: Protein",
        "Q8 Mark": 1,
        "Q9 Question": "What is the weight of the women's discus?",
        "Q9 Candidate Answer": "B: 1 kg",
        "Q9 Correct Key": "B: 1 kg",
        "Q9 Mark": 1,
        "Q10 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q10 Candidate Answer": "A: Finnish grip",
        "Q10 Correct Key": "D: Orthodox grip",
        "Q10 Mark": 0,
        "Q11 Question": "What is the diameter of the shot put circle?",
        "Q11 Candidate Answer": "B: 2.135 m",
        "Q11 Correct Key": "B: 2.135 m",
        "Q11 Mark": 1,
        "Q12 Question": "How is a triple jump measured?",
        "Q12 Candidate Answer": "C: From the end of the runway to the heel mark",
        "Q12 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q12 Mark": 0,
        "Q13 Question": "What is the official distance of a marathon?",
        "Q13 Candidate Answer": "C: 42.195 km",
        "Q13 Correct Key": "C: 42.195 km",
        "Q13 Mark": 1,
        "Q14 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q14 Candidate Answer": "C: Disqualified",
        "Q14 Correct Key": "C: Disqualified",
        "Q14 Mark": 1,
        "Q15 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q15 Candidate Answer": "A: To breathe",
        "Q15 Correct Key": "B: To hold or maintain",
        "Q15 Mark": 0,
        "Q16 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q16 Candidate Answer": "C: Western Roll",
        "Q16 Correct Key": "B: Scissors Jump",
        "Q16 Mark": 0,
        "Q17 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q17 Candidate Answer": "C: 32 m/s",
        "Q17 Correct Key": "C: 32 m/s",
        "Q17 Mark": 1,
        "Q18 Question": "Which statement about pole vault is correct?",
        "Q18 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q18 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q18 Mark": 0,
        "Q19 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q19 Candidate Answer": "C: Asana",
        "Q19 Correct Key": "B: Yama",
        "Q19 Mark": 0,
        "Q20 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q20 Candidate Answer": "B: 2",
        "Q20 Correct Key": "C: 3",
        "Q20 Mark": 0,
        "Q21 Question": "In which throwing event are gloves allowed?",
        "Q21 Candidate Answer": "C: Javelin",
        "Q21 Correct Key": "D: Hammer throw",
        "Q21 Mark": 0,
        "Q22 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q22 Candidate Answer": "C: 60 minutes",
        "Q22 Correct Key": "B: 45 minutes",
        "Q22 Mark": 0,
        "Q23 Question": "In track and field, a green card is shown when:",
        "Q23 Candidate Answer": "D: An athlete leaves the track voluntarily",
        "Q23 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q23 Mark": 0,
        "Q24 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q24 Candidate Answer": "C: The athlete who achieved the distance first",
        "Q24 Correct Key": "B: Comparing their second-best performances",
        "Q24 Mark": 0,
        "Q25 Question": "In international competition, the pole vault landing area must be at least:",
        "Q25 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q25 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q25 Mark": 1,
        "Q26 Question": "What is the minimum size of the high jump landing mat?",
        "Q26 Candidate Answer": "B: 5 m × 3 m",
        "Q26 Correct Key": "B: 5 m × 3 m",
        "Q26 Mark": 1,
        "Q27 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q27 Candidate Answer": "B: 29°",
        "Q27 Correct Key": "C: 34.92°",
        "Q27 Mark": 0,
        "Q28 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q28 Candidate Answer": "C: Swami Ramdev",
        "Q28 Correct Key": "B: Swami Vivekananda",
        "Q28 Mark": 0,
        "Q29 Question": "What is the weight of the men's shot?",
        "Q29 Candidate Answer": "B: 7.000 kg",
        "Q29 Correct Key": "C: 7.260 kg",
        "Q29 Mark": 0,
        "Q30 Question": "What are the dimensions of the take-off board in long jump?",
        "Q30 Candidate Answer": "D: 1.25 m × 0.20 m × 0.07 m",
        "Q30 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 74,
      "registrationNumber": "KOP/2026/08/0650",
      "studentName": "SARITA NAHAK",
      "mobileNumber": "7735223282",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:24 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "29 / 30",
      "score": 12,
      "totalMarks": 30,
      "percentage": 40,
      "correctCount": 12,
      "wrongCount": 17,
      "unattemptedCount": 1,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 74,
        "Registration ID": "KOP/2026/08/0650",
        "Candidate Name": "SARITA NAHAK",
        "Actually Gave Exam?": "YES",
        "Total Score": "12 / 30",
        "Percentage": "40%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "How high is the plasticine indicator board?",
        "Q1 Candidate Answer": "C: 10 mm",
        "Q1 Correct Key": "B: 7 mm",
        "Q1 Mark": 0,
        "Q2 Question": "Which statement about pole vault is correct?",
        "Q2 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q2 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q2 Mark": 0,
        "Q3 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q3 Candidate Answer": "C: Yantra Yoga",
        "Q3 Correct Key": "A: Laya Yoga",
        "Q3 Mark": 0,
        "Q4 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q4 Candidate Answer": "A: Carbohydrates",
        "Q4 Correct Key": "C: Protein",
        "Q4 Mark": 0,
        "Q5 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q5 Candidate Answer": "B: To hold or maintain",
        "Q5 Correct Key": "B: To hold or maintain",
        "Q5 Mark": 1,
        "Q6 Question": "What is the weight of the men's shot?",
        "Q6 Candidate Answer": "C: 7.260 kg",
        "Q6 Correct Key": "C: 7.260 kg",
        "Q6 Mark": 1,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "C: 42.195 km",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 1,
        "Q8 Question": "Lactose (milk sugar) is made of:",
        "Q8 Candidate Answer": "C: Glucose + Galactose",
        "Q8 Correct Key": "C: Glucose + Galactose",
        "Q8 Mark": 1,
        "Q9 Question": "A javelin throw is valid only if:",
        "Q9 Candidate Answer": "B: The metal head strikes the ground before any other part",
        "Q9 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q9 Mark": 1,
        "Q10 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q10 Candidate Answer": "B: Scissors Jump",
        "Q10 Correct Key": "B: Scissors Jump",
        "Q10 Mark": 1,
        "Q11 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q11 Candidate Answer": "C: 34.92°",
        "Q11 Correct Key": "C: 34.92°",
        "Q11 Mark": 1,
        "Q12 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q12 Candidate Answer": "D: Lands directly in the sand pit",
        "Q12 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q12 Mark": 0,
        "Q13 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q13 Candidate Answer": "D: 90 minutes",
        "Q13 Correct Key": "B: 45 minutes",
        "Q13 Mark": 0,
        "Q14 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q14 Candidate Answer": "D: Standing method",
        "Q14 Correct Key": "B: Glide method",
        "Q14 Mark": 0,
        "Q15 Question": "What is the javelin throwing sector angle?",
        "Q15 Candidate Answer": "A: 28.96°",
        "Q15 Correct Key": "A: 28.96°",
        "Q15 Mark": 1,
        "Q16 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q16 Candidate Answer": "B: Yama",
        "Q16 Correct Key": "B: Yama",
        "Q16 Mark": 1,
        "Q17 Question": "What is the correct sequence of phases in the triple jump?",
        "Q17 Candidate Answer": "C: Hop – Step – Jump",
        "Q17 Correct Key": "C: Hop – Step – Jump",
        "Q17 Mark": 1,
        "Q18 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q18 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q18 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q18 Mark": 1,
        "Q19 Question": "Which of the following is NOT a flight style in long jump?",
        "Q19 Candidate Answer": "C: Hitch kick",
        "Q19 Correct Key": "D: Fosbury flop",
        "Q19 Mark": 0,
        "Q20 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q20 Candidate Answer": "A: 1 minute",
        "Q20 Correct Key": "C: 2 minutes",
        "Q20 Mark": 0,
        "Q21 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q21 Mark": 0,
        "Q22 Question": "In which throwing event are gloves allowed?",
        "Q22 Candidate Answer": "B: Discus",
        "Q22 Correct Key": "D: Hammer throw",
        "Q22 Mark": 0,
        "Q23 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q23 Candidate Answer": "C: To join or unite",
        "Q23 Correct Key": "C: To join or unite",
        "Q23 Mark": 1,
        "Q24 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q24 Candidate Answer": "C: Swami Ramdev",
        "Q24 Correct Key": "B: Swami Vivekananda",
        "Q24 Mark": 0,
        "Q25 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q25 Candidate Answer": "D: 40 m/s",
        "Q25 Correct Key": "C: 32 m/s",
        "Q25 Mark": 0,
        "Q26 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q26 Candidate Answer": "B: Eastern Roll",
        "Q26 Correct Key": "D: Fosbury Flop",
        "Q26 Mark": 0,
        "Q27 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q27 Candidate Answer": "A: 4",
        "Q27 Correct Key": "C: 6",
        "Q27 Mark": 0,
        "Q28 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q28 Candidate Answer": "A: Gyan Yoga",
        "Q28 Correct Key": "C: Karma Yoga",
        "Q28 Mark": 0,
        "Q29 Question": "In international competition, the pole vault landing area must be at least:",
        "Q29 Candidate Answer": "C: 6 m × 5 m × 0.7 m",
        "Q29 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q29 Mark": 0,
        "Q30 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q30 Candidate Answer": "D: Averaging all throws",
        "Q30 Correct Key": "B: Comparing their second-best performances",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 75,
      "registrationNumber": "KOP/2026/09/0005",
      "studentName": "SUBARAO KUNDIKA",
      "mobileNumber": "8895885464",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:12 pm",
      "startTime": "18 Oct 2026, 01:18:06 pm",
      "submissionTime": "18 Oct 2026, 01:38:13 pm",
      "questionsAnswered": "29 / 30",
      "score": 10,
      "totalMarks": 30,
      "percentage": 33.3,
      "correctCount": 10,
      "wrongCount": 19,
      "unattemptedCount": 1,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 75,
        "Registration ID": "KOP/2026/09/0005",
        "Candidate Name": "SUBARAO KUNDIKA",
        "Actually Gave Exam?": "YES",
        "Total Score": "10 / 30",
        "Percentage": "33.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q1 Candidate Answer": "A: Straddle",
        "Q1 Correct Key": "B: Scissors Jump",
        "Q1 Mark": 0,
        "Q2 Question": "In which throwing event are gloves allowed?",
        "Q2 Candidate Answer": "A: Shot put",
        "Q2 Correct Key": "D: Hammer throw",
        "Q2 Mark": 0,
        "Q3 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q3 Candidate Answer": "C: Takes off from both feet",
        "Q3 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q3 Mark": 0,
        "Q4 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q4 Candidate Answer": "B: The athlete with the lighter body weight",
        "Q4 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q4 Mark": 0,
        "Q5 Question": "How high is the plasticine indicator board?",
        "Q5 Candidate Answer": "B: 7 mm",
        "Q5 Correct Key": "B: 7 mm",
        "Q5 Mark": 1,
        "Q6 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q6 Candidate Answer": "C: 2 minutes",
        "Q6 Correct Key": "C: 2 minutes",
        "Q6 Mark": 1,
        "Q7 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q7 Candidate Answer": "C: To join or unite",
        "Q7 Correct Key": "C: To join or unite",
        "Q7 Mark": 1,
        "Q8 Question": "What is the weight of the men's javelin?",
        "Q8 Candidate Answer": "C: 800 g",
        "Q8 Correct Key": "C: 800 g",
        "Q8 Mark": 1,
        "Q9 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q9 Candidate Answer": "A: Western Roll",
        "Q9 Correct Key": "D: Fosbury Flop",
        "Q9 Mark": 0,
        "Q10 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q10 Candidate Answer": "C: Protein",
        "Q10 Correct Key": "C: Protein",
        "Q10 Mark": 1,
        "Q11 Question": "Which of the following is a Niyama?",
        "Q11 Candidate Answer": "B: Ahimsa",
        "Q11 Correct Key": "C: Svadhyaya",
        "Q11 Mark": 0,
        "Q12 Question": "What is the minimum size of the high jump landing mat?",
        "Q12 Candidate Answer": "A: 4 m × 2 m",
        "Q12 Correct Key": "B: 5 m × 3 m",
        "Q12 Mark": 0,
        "Q13 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q13 Candidate Answer": "D: 40°",
        "Q13 Correct Key": "C: 34.92°",
        "Q13 Mark": 0,
        "Q14 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q14 Candidate Answer": "C: 11",
        "Q14 Correct Key": "C: 11",
        "Q14 Mark": 1,
        "Q15 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q15 Candidate Answer": "B: Dharana",
        "Q15 Correct Key": "C: Pratyahara",
        "Q15 Mark": 0,
        "Q16 Question": "What are the dimensions of the take-off board in long jump?",
        "Q16 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q16 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q16 Mark": 0,
        "Q17 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q17 Candidate Answer": "A: To breathe",
        "Q17 Correct Key": "B: To hold or maintain",
        "Q17 Mark": 0,
        "Q18 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q18 Candidate Answer": "A: A foul throw",
        "Q18 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q18 Mark": 0,
        "Q19 Question": "In international competition, the pole vault landing area must be at least:",
        "Q19 Candidate Answer": "A: 5 m × 5 m × 0.8 m",
        "Q19 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q19 Mark": 0,
        "Q20 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q20 Candidate Answer": "D: 7",
        "Q20 Correct Key": "C: 6",
        "Q20 Mark": 0,
        "Q21 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q21 Candidate Answer": "D: 1:2:2",
        "Q21 Correct Key": "B: 1:2:1",
        "Q21 Mark": 0,
        "Q22 Question": "What is the official distance of a marathon?",
        "Q22 Candidate Answer": "A: 40.195 km",
        "Q22 Correct Key": "C: 42.195 km",
        "Q22 Mark": 0,
        "Q23 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q23 Candidate Answer": "A: Maharishi Patanjali",
        "Q23 Correct Key": "B: Swami Vivekananda",
        "Q23 Mark": 0,
        "Q24 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: 20 m",
        "Q24 Mark": 0,
        "Q25 Question": "What is the javelin throwing sector angle?",
        "Q25 Candidate Answer": "B: 30°",
        "Q25 Correct Key": "A: 28.96°",
        "Q25 Mark": 0,
        "Q26 Question": "Which of the following is NOT a flight style in long jump?",
        "Q26 Candidate Answer": "D: Fosbury flop",
        "Q26 Correct Key": "D: Fosbury flop",
        "Q26 Mark": 1,
        "Q27 Question": "What is the weight of the women's discus?",
        "Q27 Candidate Answer": "B: 1 kg",
        "Q27 Correct Key": "B: 1 kg",
        "Q27 Mark": 1,
        "Q28 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q28 Candidate Answer": "C: Disqualified",
        "Q28 Correct Key": "C: Disqualified",
        "Q28 Mark": 1,
        "Q29 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q29 Candidate Answer": "C: Polish grip",
        "Q29 Correct Key": "D: Orthodox grip",
        "Q29 Mark": 0,
        "Q30 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q30 Candidate Answer": "B: 45 mm",
        "Q30 Correct Key": "B: 45 mm",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 76,
      "registrationNumber": "KOP/2026/08/0663",
      "studentName": "RAJESH KU SAHU",
      "mobileNumber": "8249495357",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:18 pm",
      "startTime": "18 Oct 2026, 01:16:53 pm",
      "submissionTime": "18 Oct 2026, 01:44:51 pm",
      "questionsAnswered": "30 / 30",
      "score": 9,
      "totalMarks": 30,
      "percentage": 30,
      "correctCount": 9,
      "wrongCount": 21,
      "unattemptedCount": 0,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 76,
        "Registration ID": "KOP/2026/08/0663",
        "Candidate Name": "RAJESH KU SAHU",
        "Actually Gave Exam?": "YES",
        "Total Score": "9 / 30",
        "Percentage": "30%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "B: 7.000 kg",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 0,
        "Q2 Question": "How much energy does 1 g of fat give?",
        "Q2 Candidate Answer": "C: 9.1 kcal",
        "Q2 Correct Key": "C: 9.1 kcal",
        "Q2 Mark": 1,
        "Q3 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q3 Candidate Answer": "B: Eastern Roll",
        "Q3 Correct Key": "D: Fosbury Flop",
        "Q3 Mark": 0,
        "Q4 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q4 Candidate Answer": "B: 45 minutes",
        "Q4 Correct Key": "B: 45 minutes",
        "Q4 Mark": 1,
        "Q5 Question": "What is the javelin throwing sector angle?",
        "Q5 Candidate Answer": "D: 36.5°",
        "Q5 Correct Key": "A: 28.96°",
        "Q5 Mark": 0,
        "Q6 Question": "What is the diameter of the shot put circle?",
        "Q6 Candidate Answer": "B: 2.135 m",
        "Q6 Correct Key": "B: 2.135 m",
        "Q6 Mark": 1,
        "Q7 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q7 Candidate Answer": "D: 55 mm",
        "Q7 Correct Key": "B: 45 mm",
        "Q7 Mark": 0,
        "Q8 Question": "In international competition, the pole vault landing area must be at least:",
        "Q8 Candidate Answer": "A: 5 m × 5 m × 0.8 m",
        "Q8 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q8 Mark": 0,
        "Q9 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q9 Candidate Answer": "C: Swami Ramdev",
        "Q9 Correct Key": "B: Swami Vivekananda",
        "Q9 Mark": 0,
        "Q10 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q10 Candidate Answer": "C: Polish grip",
        "Q10 Correct Key": "D: Orthodox grip",
        "Q10 Mark": 0,
        "Q11 Question": "Lactose (milk sugar) is made of:",
        "Q11 Candidate Answer": "D: Fructose + Galactose",
        "Q11 Correct Key": "C: Glucose + Galactose",
        "Q11 Mark": 0,
        "Q12 Question": "How high is the plasticine indicator board?",
        "Q12 Candidate Answer": "D: 20 mm",
        "Q12 Correct Key": "B: 7 mm",
        "Q12 Mark": 0,
        "Q13 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q13 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q13 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q13 Mark": 1,
        "Q14 Question": "What is the weight of the women's discus?",
        "Q14 Candidate Answer": "C: 1.5 kg",
        "Q14 Correct Key": "B: 1 kg",
        "Q14 Mark": 0,
        "Q15 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q15 Candidate Answer": "A: Given a warning",
        "Q15 Correct Key": "C: Disqualified",
        "Q15 Mark": 0,
        "Q16 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q16 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q16 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q16 Mark": 1,
        "Q17 Question": "What is the diameter of the discus throwing circle?",
        "Q17 Candidate Answer": "A: 2.135 m",
        "Q17 Correct Key": "B: 2.50 m",
        "Q17 Mark": 0,
        "Q18 Question": "Which of the following is a Niyama?",
        "Q18 Candidate Answer": "A: Satya",
        "Q18 Correct Key": "C: Svadhyaya",
        "Q18 Mark": 0,
        "Q19 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q19 Candidate Answer": "C: 2:1:1",
        "Q19 Correct Key": "B: 1:2:1",
        "Q19 Mark": 0,
        "Q20 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q20 Candidate Answer": "C: 20 m",
        "Q20 Correct Key": "C: 20 m",
        "Q20 Mark": 1,
        "Q21 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q21 Candidate Answer": "A: Gyan Yoga",
        "Q21 Correct Key": "C: Karma Yoga",
        "Q21 Mark": 0,
        "Q22 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q22 Candidate Answer": "B: To hold or maintain",
        "Q22 Correct Key": "B: To hold or maintain",
        "Q22 Mark": 1,
        "Q23 Question": "What is the weight of the men's javelin?",
        "Q23 Candidate Answer": "A: 600 g",
        "Q23 Correct Key": "C: 800 g",
        "Q23 Mark": 0,
        "Q24 Question": "Which statement about pole vault is correct?",
        "Q24 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q24 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q24 Mark": 0,
        "Q25 Question": "Which of the following is NOT a flight style in long jump?",
        "Q25 Candidate Answer": "A: Sail style",
        "Q25 Correct Key": "D: Fosbury flop",
        "Q25 Mark": 0,
        "Q26 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q26 Candidate Answer": "B: 10",
        "Q26 Correct Key": "C: 11",
        "Q26 Mark": 0,
        "Q27 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q27 Candidate Answer": "B: 28 m/s",
        "Q27 Correct Key": "C: 32 m/s",
        "Q27 Mark": 0,
        "Q28 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q28 Candidate Answer": "C: Pratyahara",
        "Q28 Correct Key": "C: Pratyahara",
        "Q28 Mark": 1,
        "Q29 Question": "In which throwing event are gloves allowed?",
        "Q29 Candidate Answer": "C: Javelin",
        "Q29 Correct Key": "D: Hammer throw",
        "Q29 Mark": 0,
        "Q30 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q30 Candidate Answer": "B: Scissors Jump",
        "Q30 Correct Key": "B: Scissors Jump",
        "Q30 Mark": 1
      }
    },
    {
      "rank": 77,
      "registrationNumber": "KOP/2026/07/0259",
      "studentName": "SARASWATI BHOI",
      "mobileNumber": "7853831321",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:11:23 pm",
      "startTime": "18 Oct 2026, 01:18:16 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "17 / 30",
      "score": 8,
      "totalMarks": 30,
      "percentage": 26.7,
      "correctCount": 8,
      "wrongCount": 9,
      "unattemptedCount": 13,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 77,
        "Registration ID": "KOP/2026/07/0259",
        "Candidate Name": "SARASWATI BHOI",
        "Actually Gave Exam?": "YES",
        "Total Score": "8 / 30",
        "Percentage": "26.7%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "In track and field, a green card is shown when:",
        "Q1 Candidate Answer": "B: An athlete is disqualified",
        "Q1 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q1 Mark": 0,
        "Q2 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q2 Candidate Answer": "C: 34.92°",
        "Q2 Correct Key": "C: 34.92°",
        "Q2 Mark": 1,
        "Q3 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q3 Candidate Answer": "B: 2",
        "Q3 Correct Key": "C: 3",
        "Q3 Mark": 0,
        "Q4 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q4 Candidate Answer": "D: Fosbury Flop",
        "Q4 Correct Key": "D: Fosbury Flop",
        "Q4 Mark": 1,
        "Q5 Question": "Lactose (milk sugar) is made of:",
        "Q5 Candidate Answer": "B: Glucose + Fructose",
        "Q5 Correct Key": "C: Glucose + Galactose",
        "Q5 Mark": 0,
        "Q6 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q6 Candidate Answer": "D: A wind reading above the limit",
        "Q6 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q6 Mark": 0,
        "Q7 Question": "What is the minimum size of the high jump landing mat?",
        "Q7 Candidate Answer": "C: 6 m × 6 m",
        "Q7 Correct Key": "B: 5 m × 3 m",
        "Q7 Mark": 0,
        "Q8 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q8 Candidate Answer": "C: 2 minutes",
        "Q8 Correct Key": "C: 2 minutes",
        "Q8 Mark": 1,
        "Q9 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q9 Candidate Answer": "C: 20 m",
        "Q9 Correct Key": "C: 20 m",
        "Q9 Mark": 1,
        "Q10 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q10 Candidate Answer": "A: 100m Hurdles, High Jump, Shot Put",
        "Q10 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q10 Mark": 0,
        "Q11 Question": "What is the diameter of the shot put circle?",
        "Q11 Candidate Answer": "B: 2.135 m",
        "Q11 Correct Key": "B: 2.135 m",
        "Q11 Mark": 1,
        "Q12 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q12 Candidate Answer": "A: To breathe",
        "Q12 Correct Key": "B: To hold or maintain",
        "Q12 Mark": 0,
        "Q13 Question": "Which of the following is NOT a flight style in long jump?",
        "Q13 Candidate Answer": "A: Sail style",
        "Q13 Correct Key": "D: Fosbury flop",
        "Q13 Mark": 0,
        "Q14 Question": "If the shot lands on one of the sector lines:",
        "Q14 Candidate Answer": "D: Half the distance is recorded",
        "Q14 Correct Key": "C: It is called a foul and not measured",
        "Q14 Mark": 0,
        "Q15 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q15 Candidate Answer": "C: Pratyahara",
        "Q15 Correct Key": "C: Pratyahara",
        "Q15 Mark": 1,
        "Q16 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: Yama",
        "Q16 Mark": 0,
        "Q17 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: Karma Yoga",
        "Q17 Mark": 0,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 0,
        "Q19 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Disqualified",
        "Q19 Mark": 0,
        "Q20 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q20 Candidate Answer": "B: Glide method",
        "Q20 Correct Key": "B: Glide method",
        "Q20 Mark": 1,
        "Q21 Question": "Which of the following is a Niyama?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: Svadhyaya",
        "Q21 Mark": 0,
        "Q22 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q22 Candidate Answer": "B: 45 minutes",
        "Q22 Correct Key": "B: 45 minutes",
        "Q22 Mark": 1,
        "Q23 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: Protein",
        "Q23 Mark": 0,
        "Q24 Question": "What is the diameter of the discus throwing circle?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 2.50 m",
        "Q24 Mark": 0,
        "Q25 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: Scissors Jump",
        "Q25 Mark": 0,
        "Q26 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "A: Laya Yoga",
        "Q26 Mark": 0,
        "Q27 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q27 Mark": 0,
        "Q28 Question": "What is the weight of the men's shot?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 7.260 kg",
        "Q28 Mark": 0,
        "Q29 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: 11",
        "Q29 Mark": 0,
        "Q30 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 45 mm",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 78,
      "registrationNumber": "KOP/2026/07/0360",
      "studentName": "JYOTIRMAYEE DHAL",
      "mobileNumber": "8018945561",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:06:19 pm",
      "startTime": "18 Oct 2026, 01:21:12 pm",
      "submissionTime": "18/10/2026, 2:08:42 pm",
      "questionsAnswered": "14 / 30",
      "score": 7,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 78,
        "Registration ID": "KOP/2026/07/0360",
        "Candidate Name": "JYOTIRMAYEE DHAL",
        "Actually Gave Exam?": "YES",
        "Total Score": "7 / 30",
        "Percentage": "0%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q1 Candidate Answer": "C: To join or unite",
        "Q1 Correct Key": "C: To join or unite",
        "Q1 Mark": 1,
        "Q2 Question": "What is the weight of the men's javelin?",
        "Q2 Candidate Answer": "C: 800 g",
        "Q2 Correct Key": "C: 800 g",
        "Q2 Mark": 1,
        "Q3 Question": "In international competition, the pole vault landing area must be at least:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q3 Mark": 0,
        "Q4 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q4 Candidate Answer": "D: 55 mm",
        "Q4 Correct Key": "B: 45 mm",
        "Q4 Mark": 0,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 0,
        "Q6 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q6 Candidate Answer": "B: Takes off from one foot and lands on the same foot",
        "Q6 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q6 Mark": 1,
        "Q7 Question": "In which throwing event are gloves allowed?",
        "Q7 Candidate Answer": "D: Hammer throw",
        "Q7 Correct Key": "D: Hammer throw",
        "Q7 Mark": 1,
        "Q8 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q8 Candidate Answer": "C: Western Roll",
        "Q8 Correct Key": "B: Scissors Jump",
        "Q8 Mark": 0,
        "Q9 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q9 Candidate Answer": "A: 1 minute",
        "Q9 Correct Key": "C: 2 minutes",
        "Q9 Mark": 0,
        "Q10 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q10 Candidate Answer": "C: Pratyahara",
        "Q10 Correct Key": "C: Pratyahara",
        "Q10 Mark": 1,
        "Q11 Question": "If the shot lands on one of the sector lines:",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: It is called a foul and not measured",
        "Q11 Mark": 0,
        "Q12 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q12 Candidate Answer": "D: Samadhi",
        "Q12 Correct Key": "B: Yama",
        "Q12 Mark": 0,
        "Q13 Question": "In track and field, a green card is shown when:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q13 Mark": 0,
        "Q14 Question": "A javelin throw is valid only if:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q14 Mark": 0,
        "Q15 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q15 Candidate Answer": "D: High Jump, Javelin Throw, 400m",
        "Q15 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q15 Mark": 0,
        "Q16 Question": "Which of the following is NOT a flight style in long jump?",
        "Q16 Candidate Answer": "A: Sail style",
        "Q16 Correct Key": "D: Fosbury flop",
        "Q16 Mark": 0,
        "Q17 Question": "What is the minimum size of the high jump landing mat?",
        "Q17 Candidate Answer": "B: 5 m × 3 m",
        "Q17 Correct Key": "B: 5 m × 3 m",
        "Q17 Mark": 1,
        "Q18 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q18 Candidate Answer": "C: 3",
        "Q18 Correct Key": "C: 3",
        "Q18 Mark": 1,
        "Q19 Question": "What is the diameter of the discus throwing circle?",
        "Q19 Candidate Answer": "C: 2.75 m",
        "Q19 Correct Key": "B: 2.50 m",
        "Q19 Mark": 0,
        "Q20 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q20 Mark": 0,
        "Q21 Question": "How is a triple jump measured?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q21 Mark": 0,
        "Q22 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: Comparing their second-best performances",
        "Q22 Mark": 0,
        "Q23 Question": "Which statement about pole vault is correct?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q23 Mark": 0,
        "Q24 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: 20 m",
        "Q24 Mark": 0,
        "Q25 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q25 Mark": 0,
        "Q26 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Disqualified",
        "Q26 Mark": 0,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 0,
        "Q28 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Protein",
        "Q28 Mark": 0,
        "Q29 Question": "Lactose (milk sugar) is made of:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Glucose + Galactose",
        "Q29 Mark": 0,
        "Q30 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: Karma Yoga",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 79,
      "registrationNumber": "KOP/2026/09/0028",
      "studentName": "SASMITA NAIK",
      "mobileNumber": "9609878532",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 02:05:55 pm",
      "startTime": "18 Oct 2026, 02:07:21 pm",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "12 / 30",
      "score": 7,
      "totalMarks": 30,
      "percentage": 23.3,
      "correctCount": 7,
      "wrongCount": 5,
      "unattemptedCount": 18,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 79,
        "Registration ID": "KOP/2026/09/0028",
        "Candidate Name": "SASMITA NAIK",
        "Actually Gave Exam?": "YES",
        "Total Score": "7 / 30",
        "Percentage": "23.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "What is the diameter of the shot put circle?",
        "Q1 Candidate Answer": "B: 2.135 m",
        "Q1 Correct Key": "B: 2.135 m",
        "Q1 Mark": 1,
        "Q2 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q2 Candidate Answer": "A: To breathe",
        "Q2 Correct Key": "B: To hold or maintain",
        "Q2 Mark": 0,
        "Q3 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q3 Candidate Answer": "C: Western Roll",
        "Q3 Correct Key": "B: Scissors Jump",
        "Q3 Mark": 0,
        "Q4 Question": "What is the minimum size of the high jump landing mat?",
        "Q4 Candidate Answer": "A: 4 m × 2 m",
        "Q4 Correct Key": "B: 5 m × 3 m",
        "Q4 Mark": 0,
        "Q5 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q5 Candidate Answer": "A: Laya Yoga",
        "Q5 Correct Key": "A: Laya Yoga",
        "Q5 Mark": 1,
        "Q6 Question": "In international competition, the pole vault landing area must be at least:",
        "Q6 Candidate Answer": "B: 6 m × 6 m × 0.8 m",
        "Q6 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q6 Mark": 1,
        "Q7 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q7 Candidate Answer": "B: Glide method",
        "Q7 Correct Key": "B: Glide method",
        "Q7 Mark": 1,
        "Q8 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q8 Candidate Answer": "C: Protein",
        "Q8 Correct Key": "C: Protein",
        "Q8 Mark": 1,
        "Q9 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q9 Candidate Answer": "B: Long Jump, Javelin Throw, 800m",
        "Q9 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q9 Mark": 1,
        "Q10 Question": "Which of the following is a Niyama?",
        "Q10 Candidate Answer": "D: Aparigraha",
        "Q10 Correct Key": "C: Svadhyaya",
        "Q10 Mark": 0,
        "Q11 Question": "In which throwing event are gloves allowed?",
        "Q11 Candidate Answer": "A: Shot put",
        "Q11 Correct Key": "D: Hammer throw",
        "Q11 Mark": 0,
        "Q12 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q12 Candidate Answer": "D: Orthodox grip",
        "Q12 Correct Key": "D: Orthodox grip",
        "Q12 Mark": 1,
        "Q13 Question": "Which of the following is NOT a flight style in long jump?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "D: Fosbury flop",
        "Q13 Mark": 0,
        "Q14 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: Yama",
        "Q14 Mark": 0,
        "Q15 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q15 Mark": 0,
        "Q16 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 6",
        "Q16 Mark": 0,
        "Q17 Question": "What is the weight of the men's javelin?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: 800 g",
        "Q17 Mark": 0,
        "Q18 Question": "In track and field, a green card is shown when:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q18 Mark": 0,
        "Q19 Question": "What is the official distance of a marathon?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 42.195 km",
        "Q19 Mark": 0,
        "Q20 Question": "How much energy does 1 g of fat give?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: 9.1 kcal",
        "Q20 Mark": 0,
        "Q21 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "D: Fosbury Flop",
        "Q21 Mark": 0,
        "Q22 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: To join or unite",
        "Q22 Mark": 0,
        "Q23 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 32 m/s",
        "Q23 Mark": 0,
        "Q24 Question": "Lactose (milk sugar) is made of:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: Glucose + Galactose",
        "Q24 Mark": 0,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 0,
        "Q26 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Disqualified",
        "Q26 Mark": 0,
        "Q27 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q27 Mark": 0,
        "Q28 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Karma Yoga",
        "Q28 Mark": 0,
        "Q29 Question": "What is the weight of the women's discus?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 1 kg",
        "Q29 Mark": 0,
        "Q30 Question": "What is the javelin throwing sector angle?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "A: 28.96°",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 80,
      "registrationNumber": "KOP/2026/07/0266",
      "studentName": "HEMAPRASAD NAG",
      "mobileNumber": "8658308578",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:16 pm",
      "startTime": "18 Oct 2026, 01:17:57 pm",
      "submissionTime": "18 Oct 2026, 02:23:22 pm",
      "questionsAnswered": "8 / 30",
      "score": 6,
      "totalMarks": 30,
      "percentage": 20,
      "correctCount": 6,
      "wrongCount": 2,
      "unattemptedCount": 22,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 80,
        "Registration ID": "KOP/2026/07/0266",
        "Candidate Name": "HEMAPRASAD NAG",
        "Actually Gave Exam?": "YES",
        "Total Score": "6 / 30",
        "Percentage": "20%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "D: Fosbury flop",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 1,
        "Q2 Question": "Which statement about pole vault is correct?",
        "Q2 Candidate Answer": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q2 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q2 Mark": 1,
        "Q3 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q3 Candidate Answer": "B: To hold or maintain",
        "Q3 Correct Key": "B: To hold or maintain",
        "Q3 Mark": 1,
        "Q4 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q4 Candidate Answer": "B: The final 15 seconds of the allowed time",
        "Q4 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q4 Mark": 1,
        "Q5 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q5 Candidate Answer": "A: Laya Yoga",
        "Q5 Correct Key": "A: Laya Yoga",
        "Q5 Mark": 1,
        "Q6 Question": "How high is the plasticine indicator board?",
        "Q6 Candidate Answer": "C: 10 mm",
        "Q6 Correct Key": "B: 7 mm",
        "Q6 Mark": 0,
        "Q7 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q7 Candidate Answer": "D: 40 m",
        "Q7 Correct Key": "C: 20 m",
        "Q7 Mark": 0,
        "Q8 Question": "What are the dimensions of the take-off board in long jump?",
        "Q8 Candidate Answer": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q8 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q8 Mark": 1,
        "Q9 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Glide method",
        "Q9 Mark": 0,
        "Q10 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: Yama",
        "Q10 Mark": 0,
        "Q11 Question": "What is the javelin throwing sector angle?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "A: 28.96°",
        "Q11 Mark": 0,
        "Q12 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: Protein",
        "Q12 Mark": 0,
        "Q13 Question": "In international competition, the pole vault landing area must be at least:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q13 Mark": 0,
        "Q14 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: Comparing their second-best performances",
        "Q14 Mark": 0,
        "Q15 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "C: 32 m/s",
        "Q15 Mark": 0,
        "Q16 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 34.92°",
        "Q16 Mark": 0,
        "Q17 Question": "In track and field, a green card is shown when:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q17 Mark": 0,
        "Q18 Question": "Lactose (milk sugar) is made of:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: Glucose + Galactose",
        "Q18 Mark": 0,
        "Q19 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 6",
        "Q19 Mark": 0,
        "Q20 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: Pratyahara",
        "Q20 Mark": 0,
        "Q21 Question": "What is the weight of the women's discus?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: 1 kg",
        "Q21 Mark": 0,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 0,
        "Q23 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q23 Mark": 0,
        "Q24 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 45 minutes",
        "Q24 Mark": 0,
        "Q25 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: 11",
        "Q25 Mark": 0,
        "Q26 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "D: Fosbury Flop",
        "Q26 Mark": 0,
        "Q27 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Swami Vivekananda",
        "Q27 Mark": 0,
        "Q28 Question": "A javelin throw is valid only if:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q28 Mark": 0,
        "Q29 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Karma Yoga",
        "Q29 Mark": 0,
        "Q30 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 1:2:1",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 81,
      "registrationNumber": "KOP/2026/08/0641",
      "studentName": "LAXMIPRIYA BAG",
      "mobileNumber": "9827708840",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:01:18 pm",
      "startTime": "18 Oct 2026, 01:35:17 pm",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "28 / 30",
      "score": 4,
      "totalMarks": 30,
      "percentage": 13.3,
      "correctCount": 4,
      "wrongCount": 24,
      "unattemptedCount": 2,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 81,
        "Registration ID": "KOP/2026/08/0641",
        "Candidate Name": "LAXMIPRIYA BAG",
        "Actually Gave Exam?": "YES",
        "Total Score": "4 / 30",
        "Percentage": "13.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "Lactose (milk sugar) is made of:",
        "Q1 Candidate Answer": "B: Glucose + Fructose",
        "Q1 Correct Key": "C: Glucose + Galactose",
        "Q1 Mark": 0,
        "Q2 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q2 Candidate Answer": "C: 50 mm",
        "Q2 Correct Key": "B: 45 mm",
        "Q2 Mark": 0,
        "Q3 Question": "What is the correct sequence of phases in the triple jump?",
        "Q3 Candidate Answer": "A: Step – Hop – Jump",
        "Q3 Correct Key": "C: Hop – Step – Jump",
        "Q3 Mark": 0,
        "Q4 Question": "What is the diameter of the discus throwing circle?",
        "Q4 Candidate Answer": "D: 3.00 m",
        "Q4 Correct Key": "B: 2.50 m",
        "Q4 Mark": 0,
        "Q5 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q5 Candidate Answer": "D: Standing method",
        "Q5 Correct Key": "B: Glide method",
        "Q5 Mark": 0,
        "Q6 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q6 Candidate Answer": "C: 6",
        "Q6 Correct Key": "C: 6",
        "Q6 Mark": 1,
        "Q7 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q7 Candidate Answer": "A: A foul throw",
        "Q7 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q7 Mark": 0,
        "Q8 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q8 Candidate Answer": "A: 30 minutes",
        "Q8 Correct Key": "B: 45 minutes",
        "Q8 Mark": 0,
        "Q9 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q9 Candidate Answer": "C: 2:1:1",
        "Q9 Correct Key": "B: 1:2:1",
        "Q9 Mark": 0,
        "Q10 Question": "How is a triple jump measured?",
        "Q10 Candidate Answer": "D: Diagonally from the take-off board to the landing point",
        "Q10 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q10 Mark": 0,
        "Q11 Question": "What is the weight of the women's discus?",
        "Q11 Candidate Answer": "C: 1.5 kg",
        "Q11 Correct Key": "B: 1 kg",
        "Q11 Mark": 0,
        "Q12 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q12 Candidate Answer": "C: The athlete who started at the higher height",
        "Q12 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Mark": 0,
        "Q13 Question": "What is the weight of the men's javelin?",
        "Q13 Candidate Answer": "A: 600 g",
        "Q13 Correct Key": "C: 800 g",
        "Q13 Mark": 0,
        "Q14 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q14 Candidate Answer": "C: 34.92°",
        "Q14 Correct Key": "C: 34.92°",
        "Q14 Mark": 1,
        "Q15 Question": "Which of the following is a Niyama?",
        "Q15 Candidate Answer": "B: Ahimsa",
        "Q15 Correct Key": "C: Svadhyaya",
        "Q15 Mark": 0,
        "Q16 Question": "In which throwing event are gloves allowed?",
        "Q16 Candidate Answer": "D: Hammer throw",
        "Q16 Correct Key": "D: Hammer throw",
        "Q16 Mark": 1,
        "Q17 Question": "How high is the plasticine indicator board?",
        "Q17 Candidate Answer": "D: 20 mm",
        "Q17 Correct Key": "B: 7 mm",
        "Q17 Mark": 0,
        "Q18 Question": "A javelin throw is valid only if:",
        "Q18 Candidate Answer": "D: It crosses the 30 m line",
        "Q18 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q18 Mark": 0,
        "Q19 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q19 Candidate Answer": "A: To breathe",
        "Q19 Correct Key": "C: To join or unite",
        "Q19 Mark": 0,
        "Q20 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q20 Candidate Answer": "D: High Jump, Javelin Throw, 400m",
        "Q20 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Mark": 0,
        "Q21 Question": "What are the dimensions of the take-off board in long jump?",
        "Q21 Candidate Answer": "D: 1.25 m × 0.20 m × 0.07 m",
        "Q21 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q21 Mark": 0,
        "Q22 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q22 Candidate Answer": "B: Hatha Yoga",
        "Q22 Correct Key": "A: Laya Yoga",
        "Q22 Mark": 0,
        "Q23 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q23 Candidate Answer": "D: Allowed to restart from 1 m behind",
        "Q23 Correct Key": "C: Disqualified",
        "Q23 Mark": 0,
        "Q24 Question": "What is the official distance of a marathon?",
        "Q24 Candidate Answer": "A: 40.195 km",
        "Q24 Correct Key": "C: 42.195 km",
        "Q24 Mark": 0,
        "Q25 Question": "In international competition, the pole vault landing area must be at least:",
        "Q25 Candidate Answer": "C: 6 m × 5 m × 0.7 m",
        "Q25 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q25 Mark": 0,
        "Q26 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: 11",
        "Q26 Mark": 0,
        "Q27 Question": "Which of the following is NOT a flight style in long jump?",
        "Q27 Candidate Answer": "A: Sail style",
        "Q27 Correct Key": "D: Fosbury flop",
        "Q27 Mark": 0,
        "Q28 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: Scissors Jump",
        "Q28 Mark": 0,
        "Q29 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q29 Candidate Answer": "C: 32 m/s",
        "Q29 Correct Key": "C: 32 m/s",
        "Q29 Mark": 1,
        "Q30 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q30 Candidate Answer": "C: Swami Ramdev",
        "Q30 Correct Key": "B: Swami Vivekananda",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 82,
      "registrationNumber": "KOP/2026/08/0639",
      "studentName": "BANITA ROUT",
      "mobileNumber": "7735788829",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:49 pm",
      "startTime": "13:15 IST",
      "submissionTime": "18 Oct 2026, 01:21:08 pm",
      "questionsAnswered": "30 / 30",
      "score": 3,
      "totalMarks": 30,
      "percentage": 10,
      "correctCount": 3,
      "wrongCount": 27,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 82,
        "Registration ID": "KOP/2026/08/0639",
        "Candidate Name": "BANITA ROUT",
        "Actually Gave Exam?": "YES",
        "Total Score": "3 / 30",
        "Percentage": "10%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q1 Candidate Answer": "D: 3 minutes",
        "Q1 Correct Key": "C: 2 minutes",
        "Q1 Mark": 0,
        "Q2 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q2 Candidate Answer": "C: 6",
        "Q2 Correct Key": "C: 6",
        "Q2 Mark": 1,
        "Q3 Question": "Which of the following is NOT a flight style in long jump?",
        "Q3 Candidate Answer": "A: Sail style",
        "Q3 Correct Key": "D: Fosbury flop",
        "Q3 Mark": 0,
        "Q4 Question": "Which statement about pole vault is correct?",
        "Q4 Candidate Answer": "D: Athletes must use poles provided by the organisers",
        "Q4 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q4 Mark": 0,
        "Q5 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q5 Candidate Answer": "B: 10",
        "Q5 Correct Key": "C: 11",
        "Q5 Mark": 0,
        "Q6 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q6 Candidate Answer": "D: 6",
        "Q6 Correct Key": "C: 3",
        "Q6 Mark": 0,
        "Q7 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q7 Candidate Answer": "D: 40 m",
        "Q7 Correct Key": "C: 20 m",
        "Q7 Mark": 0,
        "Q8 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q8 Candidate Answer": "C: Protein",
        "Q8 Correct Key": "C: Protein",
        "Q8 Mark": 1,
        "Q9 Question": "In track and field, a green card is shown when:",
        "Q9 Candidate Answer": "A: An athlete is warned",
        "Q9 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q9 Mark": 0,
        "Q10 Question": "In international competition, the pole vault landing area must be at least:",
        "Q10 Candidate Answer": "C: 6 m × 5 m × 0.7 m",
        "Q10 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q10 Mark": 0,
        "Q11 Question": "If the shot lands on one of the sector lines:",
        "Q11 Candidate Answer": "D: Half the distance is recorded",
        "Q11 Correct Key": "C: It is called a foul and not measured",
        "Q11 Mark": 0,
        "Q12 Question": "What is the weight of the women's discus?",
        "Q12 Candidate Answer": "A: 0.75 kg",
        "Q12 Correct Key": "B: 1 kg",
        "Q12 Mark": 0,
        "Q13 Question": "What is the diameter of the discus throwing circle?",
        "Q13 Candidate Answer": "C: 2.75 m",
        "Q13 Correct Key": "B: 2.50 m",
        "Q13 Mark": 0,
        "Q14 Question": "How is a triple jump measured?",
        "Q14 Candidate Answer": "A: From the plasticine board to the farthest mark",
        "Q14 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q14 Mark": 0,
        "Q15 Question": "What are the dimensions of the take-off board in long jump?",
        "Q15 Candidate Answer": "A: 1.22 m × 0.10 m × 0.20 m",
        "Q15 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q15 Mark": 0,
        "Q16 Question": "What is the official distance of a marathon?",
        "Q16 Candidate Answer": "A: 40.195 km",
        "Q16 Correct Key": "C: 42.195 km",
        "Q16 Mark": 0,
        "Q17 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q17 Candidate Answer": "C: Polish grip",
        "Q17 Correct Key": "D: Orthodox grip",
        "Q17 Mark": 0,
        "Q18 Question": "A javelin throw is valid only if:",
        "Q18 Candidate Answer": "D: It crosses the 30 m line",
        "Q18 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q18 Mark": 0,
        "Q19 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q19 Candidate Answer": "A: Given a warning",
        "Q19 Correct Key": "C: Disqualified",
        "Q19 Mark": 0,
        "Q20 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q20 Candidate Answer": "C: Western Roll",
        "Q20 Correct Key": "B: Scissors Jump",
        "Q20 Mark": 0,
        "Q21 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q21 Candidate Answer": "B: 28 m/s",
        "Q21 Correct Key": "C: 32 m/s",
        "Q21 Mark": 0,
        "Q22 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q22 Candidate Answer": "A: A foul throw",
        "Q22 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q22 Mark": 0,
        "Q23 Question": "What is the diameter of the shot put circle?",
        "Q23 Candidate Answer": "B: 2.135 m",
        "Q23 Correct Key": "B: 2.135 m",
        "Q23 Mark": 1,
        "Q24 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q24 Candidate Answer": "A: Simple method",
        "Q24 Correct Key": "B: Glide method",
        "Q24 Mark": 0,
        "Q25 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q25 Candidate Answer": "A: Pranayama",
        "Q25 Correct Key": "C: Pratyahara",
        "Q25 Mark": 0,
        "Q26 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q26 Candidate Answer": "D: 1:2:2",
        "Q26 Correct Key": "B: 1:2:1",
        "Q26 Mark": 0,
        "Q27 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q27 Candidate Answer": "A: To breathe",
        "Q27 Correct Key": "C: To join or unite",
        "Q27 Mark": 0,
        "Q28 Question": "What is the weight of the men's shot?",
        "Q28 Candidate Answer": "A: 6.00 kg",
        "Q28 Correct Key": "C: 7.260 kg",
        "Q28 Mark": 0,
        "Q29 Question": "Lactose (milk sugar) is made of:",
        "Q29 Candidate Answer": "A: Glucose + Glucose",
        "Q29 Correct Key": "C: Glucose + Galactose",
        "Q29 Mark": 0,
        "Q30 Question": "Which of the following is a Niyama?",
        "Q30 Candidate Answer": "A: Satya",
        "Q30 Correct Key": "C: Svadhyaya",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 83,
      "registrationNumber": "KOP/2026/09/0015",
      "studentName": "RUPESHWAR MALLICK",
      "mobileNumber": "6370014887",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18 Oct 2026, 01:00:48 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "30 / 30",
      "score": 2,
      "totalMarks": 30,
      "percentage": 6.7,
      "correctCount": 2,
      "wrongCount": 28,
      "unattemptedCount": 30,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 83,
        "Registration ID": "KOP/2026/09/0015",
        "Candidate Name": "RUPESHWAR MALLICK",
        "Actually Gave Exam?": "YES",
        "Total Score": "2 / 30",
        "Percentage": "6.7%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "What is the diameter of the discus throwing circle?",
        "Q1 Candidate Answer": "D: 3.00 m",
        "Q1 Correct Key": "B: 2.50 m",
        "Q1 Mark": 0,
        "Q2 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q2 Candidate Answer": "A: Given a warning",
        "Q2 Correct Key": "C: Disqualified",
        "Q2 Mark": 0,
        "Q3 Question": "Which of the following is a Niyama?",
        "Q3 Candidate Answer": "D: Aparigraha",
        "Q3 Correct Key": "C: Svadhyaya",
        "Q3 Mark": 0,
        "Q4 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q4 Candidate Answer": "A: 30 minutes",
        "Q4 Correct Key": "B: 45 minutes",
        "Q4 Mark": 0,
        "Q5 Question": "A javelin throw is valid only if:",
        "Q5 Candidate Answer": "A: The tail touches the ground first",
        "Q5 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q5 Mark": 0,
        "Q6 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q6 Candidate Answer": "A: 25 m/s",
        "Q6 Correct Key": "C: 32 m/s",
        "Q6 Mark": 0,
        "Q7 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q7 Candidate Answer": "C: Takes off from both feet",
        "Q7 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q7 Mark": 0,
        "Q8 Question": "Which statement about pole vault is correct?",
        "Q8 Candidate Answer": "B: Taping of the hands and fingers is freely allowed",
        "Q8 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q8 Mark": 0,
        "Q9 Question": "How high is the plasticine indicator board?",
        "Q9 Candidate Answer": "C: 10 mm",
        "Q9 Correct Key": "B: 7 mm",
        "Q9 Mark": 0,
        "Q10 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q10 Candidate Answer": "A: Gyan Yoga",
        "Q10 Correct Key": "C: Karma Yoga",
        "Q10 Mark": 0,
        "Q11 Question": "What is the correct sequence of phases in the triple jump?",
        "Q11 Candidate Answer": "A: Step – Hop – Jump",
        "Q11 Correct Key": "C: Hop – Step – Jump",
        "Q11 Mark": 0,
        "Q12 Question": "What is the weight of the women's discus?",
        "Q12 Candidate Answer": "D: 2 kg",
        "Q12 Correct Key": "B: 1 kg",
        "Q12 Mark": 0,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "C: Western Roll",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 0,
        "Q14 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q14 Candidate Answer": "A: 10 m",
        "Q14 Correct Key": "C: 20 m",
        "Q14 Mark": 0,
        "Q15 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q15 Candidate Answer": "C: Polish grip",
        "Q15 Correct Key": "D: Orthodox grip",
        "Q15 Mark": 0,
        "Q16 Question": "What is the official distance of a marathon?",
        "Q16 Candidate Answer": "B: 42.000 km",
        "Q16 Correct Key": "C: 42.195 km",
        "Q16 Mark": 0,
        "Q17 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q17 Candidate Answer": "D: 6",
        "Q17 Correct Key": "C: 3",
        "Q17 Mark": 0,
        "Q18 Question": "What are the dimensions of the take-off board in long jump?",
        "Q18 Candidate Answer": "C: 1.20 m × 0.22 m × 0.10 m",
        "Q18 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q18 Mark": 0,
        "Q19 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q19 Candidate Answer": "C: To withdraw",
        "Q19 Correct Key": "B: To hold or maintain",
        "Q19 Mark": 0,
        "Q20 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q20 Candidate Answer": "B: To meditate",
        "Q20 Correct Key": "C: To join or unite",
        "Q20 Mark": 0,
        "Q21 Question": "What is the diameter of the shot put circle?",
        "Q21 Candidate Answer": "A: 2.00 m",
        "Q21 Correct Key": "B: 2.135 m",
        "Q21 Mark": 0,
        "Q22 Question": "How much energy does 1 g of fat give?",
        "Q22 Candidate Answer": "C: 9.1 kcal",
        "Q22 Correct Key": "C: 9.1 kcal",
        "Q22 Mark": 1,
        "Q23 Question": "What is the javelin throwing sector angle?",
        "Q23 Candidate Answer": "B: 30°",
        "Q23 Correct Key": "A: 28.96°",
        "Q23 Mark": 0,
        "Q24 Question": "In which throwing event are gloves allowed?",
        "Q24 Candidate Answer": "D: Hammer throw",
        "Q24 Correct Key": "D: Hammer throw",
        "Q24 Mark": 1,
        "Q25 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q25 Candidate Answer": "D: Standing method",
        "Q25 Correct Key": "B: Glide method",
        "Q25 Mark": 0,
        "Q26 Question": "What is the weight of the men's javelin?",
        "Q26 Candidate Answer": "D: 900 g",
        "Q26 Correct Key": "C: 800 g",
        "Q26 Mark": 0,
        "Q27 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q27 Candidate Answer": "B: 10",
        "Q27 Correct Key": "C: 11",
        "Q27 Mark": 0,
        "Q28 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q28 Candidate Answer": "C: Swami Ramdev",
        "Q28 Correct Key": "B: Swami Vivekananda",
        "Q28 Mark": 0,
        "Q29 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q29 Candidate Answer": "C: 50 mm",
        "Q29 Correct Key": "B: 45 mm",
        "Q29 Mark": 0,
        "Q30 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q30 Candidate Answer": "A: Niyama",
        "Q30 Correct Key": "B: Yama",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 84,
      "registrationNumber": "KOP/2026/07/0262",
      "studentName": "SANGEETA TRIPATHY",
      "mobileNumber": "9556670870",
      "batch": "Unified Examination Batch",
      "status": "COMPLETED & SUBMITTED",
      "actuallyGaveExam": true,
      "loginTime": "18-Oct-2026, 01:02:44 pm",
      "startTime": "13:15 IST",
      "submissionTime": "02:00:00 PM (Exam Concluded)",
      "questionsAnswered": "1 / 30",
      "score": 1,
      "totalMarks": 30,
      "percentage": 3.3,
      "correctCount": 1,
      "wrongCount": 0,
      "unattemptedCount": 29,
      "result": "NEEDS IMPROVEMENT",
      "detailedResponses": {
        "Rank": 84,
        "Registration ID": "KOP/2026/07/0262",
        "Candidate Name": "SANGEETA TRIPATHY",
        "Actually Gave Exam?": "YES",
        "Total Score": "1 / 30",
        "Percentage": "3.3%",
        "Result": "NEEDS IMPROVEMENT",
        "Q1 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q1 Candidate Answer": "C: 20 m",
        "Q1 Correct Key": "C: 20 m",
        "Q1 Mark": 1,
        "Q2 Question": "A javelin throw is valid only if:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q2 Mark": 0,
        "Q3 Question": "In track and field, a green card is shown when:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q3 Mark": 0,
        "Q4 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: Glide method",
        "Q4 Mark": 0,
        "Q5 Question": "In which throwing event are gloves allowed?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "D: Hammer throw",
        "Q5 Mark": 0,
        "Q6 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q6 Mark": 0,
        "Q7 Question": "What are the dimensions of the take-off board in long jump?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q7 Mark": 0,
        "Q8 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q8 Mark": 0,
        "Q9 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q9 Mark": 0,
        "Q10 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "D: Orthodox grip",
        "Q10 Mark": 0,
        "Q11 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: 32 m/s",
        "Q11 Mark": 0,
        "Q12 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: 1:2:1",
        "Q12 Mark": 0,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 0,
        "Q14 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: 3",
        "Q14 Mark": 0,
        "Q15 Question": "If the shot lands on one of the sector lines:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "C: It is called a foul and not measured",
        "Q15 Mark": 0,
        "Q16 Question": "How is a triple jump measured?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q16 Mark": 0,
        "Q17 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: Yama",
        "Q17 Mark": 0,
        "Q18 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: Disqualified",
        "Q18 Mark": 0,
        "Q19 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 2 minutes",
        "Q19 Mark": 0,
        "Q20 Question": "What is the correct sequence of phases in the triple jump?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: Hop – Step – Jump",
        "Q20 Mark": 0,
        "Q21 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 6",
        "Q21 Mark": 0,
        "Q22 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "A: Laya Yoga",
        "Q22 Mark": 0,
        "Q23 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: Swami Vivekananda",
        "Q23 Mark": 0,
        "Q24 Question": "What is the javelin throwing sector angle?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "A: 28.96°",
        "Q24 Mark": 0,
        "Q25 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 45 minutes",
        "Q25 Mark": 0,
        "Q26 Question": "What is the minimum size of the high jump landing mat?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: 5 m × 3 m",
        "Q26 Mark": 0,
        "Q27 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q27 Mark": 0,
        "Q28 Question": "What is the weight of the women's discus?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: 1 kg",
        "Q28 Mark": 0,
        "Q29 Question": "How high is the plasticine indicator board?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 7 mm",
        "Q29 Mark": 0,
        "Q30 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: 11",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 85,
      "registrationNumber": "HD/KOP/2026/0731",
      "studentName": "ANIL PATEL",
      "mobileNumber": "8455897830",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:13:32 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 85,
        "Registration ID": "HD/KOP/2026/0731",
        "Candidate Name": "ANIL PATEL",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "D: Fosbury Flop",
        "Q1 Mark": 0,
        "Q2 Question": "Which of the following is NOT a flight style in long jump?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "D: Fosbury flop",
        "Q2 Mark": 0,
        "Q3 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Scissors Jump",
        "Q3 Mark": 0,
        "Q4 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: Karma Yoga",
        "Q4 Mark": 0,
        "Q5 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 45 minutes",
        "Q5 Mark": 0,
        "Q6 Question": "In international competition, the pole vault landing area must be at least:",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q6 Mark": 0,
        "Q7 Question": "What is the weight of the women's discus?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "B: 1 kg",
        "Q7 Mark": 0,
        "Q8 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: Yama",
        "Q8 Mark": 0,
        "Q9 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: Pratyahara",
        "Q9 Mark": 0,
        "Q10 Question": "A javelin throw is valid only if:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q10 Mark": 0,
        "Q11 Question": "Which statement about pole vault is correct?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q11 Mark": 0,
        "Q12 Question": "What is the weight of the men's javelin?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: 800 g",
        "Q12 Mark": 0,
        "Q13 Question": "In track and field, a green card is shown when:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q13 Mark": 0,
        "Q14 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: Swami Vivekananda",
        "Q14 Mark": 0,
        "Q15 Question": "How high is the plasticine indicator board?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: 7 mm",
        "Q15 Mark": 0,
        "Q16 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 32 m/s",
        "Q16 Mark": 0,
        "Q17 Question": "What is the minimum size of the high jump landing mat?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: 5 m × 3 m",
        "Q17 Mark": 0,
        "Q18 Question": "If the shot lands on one of the sector lines:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: It is called a foul and not measured",
        "Q18 Mark": 0,
        "Q19 Question": "Lactose (milk sugar) is made of:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Glucose + Galactose",
        "Q19 Mark": 0,
        "Q20 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: 20 m",
        "Q20 Mark": 0,
        "Q21 Question": "What is the weight of the men's shot?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 7.260 kg",
        "Q21 Mark": 0,
        "Q22 Question": "What is the javelin throwing sector angle?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "A: 28.96°",
        "Q22 Mark": 0,
        "Q23 Question": "In which throwing event are gloves allowed?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "D: Hammer throw",
        "Q23 Mark": 0,
        "Q24 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 45 mm",
        "Q24 Mark": 0,
        "Q25 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: Comparing their second-best performances",
        "Q25 Mark": 0,
        "Q26 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q26 Mark": 0,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 0,
        "Q28 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q28 Mark": 0,
        "Q29 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q29 Mark": 0,
        "Q30 Question": "What is the diameter of the discus throwing circle?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 2.50 m",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 86,
      "registrationNumber": "HD/KOP/2026/0747",
      "studentName": "SIDDHARTHA DAS",
      "mobileNumber": "9668041621",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18-Oct-2026, 02:09:30 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 86,
        "Registration ID": "HD/KOP/2026/0747",
        "Candidate Name": "SIDDHARTHA DAS",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "Which of the following is NOT a flight style in long jump?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "D: Fosbury flop",
        "Q1 Mark": 0,
        "Q2 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: Protein",
        "Q2 Mark": 0,
        "Q3 Question": "If the shot lands on one of the sector lines:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: It is called a foul and not measured",
        "Q3 Mark": 0,
        "Q4 Question": "How much energy does 1 g of fat give?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: 9.1 kcal",
        "Q4 Mark": 0,
        "Q5 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: Glide method",
        "Q5 Mark": 0,
        "Q6 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "B: Yama",
        "Q6 Mark": 0,
        "Q7 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Pratyahara",
        "Q7 Mark": 0,
        "Q8 Question": "What is the weight of the men's javelin?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "C: 800 g",
        "Q8 Mark": 0,
        "Q9 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 2 minutes",
        "Q9 Mark": 0,
        "Q10 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: 11",
        "Q10 Mark": 0,
        "Q11 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Disqualified",
        "Q11 Mark": 0,
        "Q12 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q12 Mark": 0,
        "Q13 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "D: Fosbury Flop",
        "Q13 Mark": 0,
        "Q14 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: 32 m/s",
        "Q14 Mark": 0,
        "Q15 Question": "What is the javelin throwing sector angle?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "A: 28.96°",
        "Q15 Mark": 0,
        "Q16 Question": "What is the correct sequence of phases in the triple jump?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: Hop – Step – Jump",
        "Q16 Mark": 0,
        "Q17 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: 45 minutes",
        "Q17 Mark": 0,
        "Q18 Question": "In international competition, the pole vault landing area must be at least:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q18 Mark": 0,
        "Q19 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 6",
        "Q19 Mark": 0,
        "Q20 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q20 Mark": 0,
        "Q21 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 20 m",
        "Q21 Mark": 0,
        "Q22 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: Comparing their second-best performances",
        "Q22 Mark": 0,
        "Q23 Question": "What is the weight of the men's shot?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 7.260 kg",
        "Q23 Mark": 0,
        "Q24 Question": "How high is the plasticine indicator board?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 7 mm",
        "Q24 Mark": 0,
        "Q25 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "A: Laya Yoga",
        "Q25 Mark": 0,
        "Q26 Question": "A javelin throw is valid only if:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q26 Mark": 0,
        "Q27 Question": "In which throwing event are gloves allowed?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "D: Hammer throw",
        "Q27 Mark": 0,
        "Q28 Question": "What is the diameter of the discus throwing circle?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: 2.50 m",
        "Q28 Mark": 0,
        "Q29 Question": "What is the weight of the women's discus?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 1 kg",
        "Q29 Mark": 0,
        "Q30 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: To join or unite",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 87,
      "registrationNumber": "KOP/2026/06/0179",
      "studentName": "DEB KUMAR NAYAK",
      "mobileNumber": "7489620012",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:14:15 pm",
      "startTime": "18 Oct 2026, 02:14:48 pm",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 87,
        "Registration ID": "KOP/2026/06/0179",
        "Candidate Name": "DEB KUMAR NAYAK",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the official distance of a marathon?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: 42.195 km",
        "Q1 Mark": 0,
        "Q2 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q2 Mark": 0,
        "Q3 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 34.92°",
        "Q3 Mark": 0,
        "Q4 Question": "What is the diameter of the discus throwing circle?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 2.50 m",
        "Q4 Mark": 0,
        "Q5 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 45 mm",
        "Q5 Mark": 0,
        "Q6 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: To join or unite",
        "Q6 Mark": 0,
        "Q7 Question": "What is the javelin throwing sector angle?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "A: 28.96°",
        "Q7 Mark": 0,
        "Q8 Question": "Which of the following is NOT a flight style in long jump?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "D: Fosbury flop",
        "Q8 Mark": 0,
        "Q9 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 20 m",
        "Q9 Mark": 0,
        "Q10 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: 3",
        "Q10 Mark": 0,
        "Q11 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "B: Scissors Jump",
        "Q11 Mark": 0,
        "Q12 Question": "Which of the following is a Niyama?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: Svadhyaya",
        "Q12 Mark": 0,
        "Q13 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: 1:2:1",
        "Q13 Mark": 0,
        "Q14 Question": "What is the correct sequence of phases in the triple jump?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: Hop – Step – Jump",
        "Q14 Mark": 0,
        "Q15 Question": "How is a triple jump measured?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q15 Mark": 0,
        "Q16 Question": "How much energy does 1 g of fat give?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 9.1 kcal",
        "Q16 Mark": 0,
        "Q17 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "D: Orthodox grip",
        "Q17 Mark": 0,
        "Q18 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q18 Mark": 0,
        "Q19 Question": "What is the minimum size of the high jump landing mat?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: 5 m × 3 m",
        "Q19 Mark": 0,
        "Q20 Question": "What is the diameter of the shot put circle?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 2.135 m",
        "Q20 Mark": 0,
        "Q21 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "D: Fosbury Flop",
        "Q21 Mark": 0,
        "Q22 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: Yama",
        "Q22 Mark": 0,
        "Q23 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: Protein",
        "Q23 Mark": 0,
        "Q24 Question": "How high is the plasticine indicator board?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 7 mm",
        "Q24 Mark": 0,
        "Q25 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: 6",
        "Q25 Mark": 0,
        "Q26 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: 11",
        "Q26 Mark": 0,
        "Q27 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: To hold or maintain",
        "Q27 Mark": 0,
        "Q28 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 2 minutes",
        "Q28 Mark": 0,
        "Q29 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: Comparing their second-best performances",
        "Q29 Mark": 0,
        "Q30 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "A: Laya Yoga",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 88,
      "registrationNumber": "KOP/2026/06/0205",
      "studentName": "SOURAV RANJAN MUND",
      "mobileNumber": "7735366818",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:13:37 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 88,
        "Registration ID": "KOP/2026/06/0205",
        "Candidate Name": "SOURAV RANJAN MUND",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the minimum size of the high jump landing mat?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "B: 5 m × 3 m",
        "Q1 Mark": 0,
        "Q2 Question": "What is the diameter of the shot put circle?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: 2.135 m",
        "Q2 Mark": 0,
        "Q3 Question": "How much energy does 1 g of fat give?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 9.1 kcal",
        "Q3 Mark": 0,
        "Q4 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: Karma Yoga",
        "Q4 Mark": 0,
        "Q5 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: Scissors Jump",
        "Q5 Mark": 0,
        "Q6 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 2 minutes",
        "Q6 Mark": 0,
        "Q7 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "D: Fosbury Flop",
        "Q7 Mark": 0,
        "Q8 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q8 Mark": 0,
        "Q9 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 34.92°",
        "Q9 Mark": 0,
        "Q10 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q10 Mark": 0,
        "Q11 Question": "Which of the following is NOT a flight style in long jump?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "D: Fosbury flop",
        "Q11 Mark": 0,
        "Q12 Question": "Lactose (milk sugar) is made of:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: Glucose + Galactose",
        "Q12 Mark": 0,
        "Q13 Question": "What is the javelin throwing sector angle?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "A: 28.96°",
        "Q13 Mark": 0,
        "Q14 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: To join or unite",
        "Q14 Mark": 0,
        "Q15 Question": "What is the correct sequence of phases in the triple jump?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "C: Hop – Step – Jump",
        "Q15 Mark": 0,
        "Q16 Question": "In which throwing event are gloves allowed?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "D: Hammer throw",
        "Q16 Mark": 0,
        "Q17 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: 45 minutes",
        "Q17 Mark": 0,
        "Q18 Question": "Which statement about pole vault is correct?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q18 Mark": 0,
        "Q19 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q19 Mark": 0,
        "Q20 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: Disqualified",
        "Q20 Mark": 0,
        "Q21 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Yama",
        "Q21 Mark": 0,
        "Q22 Question": "What is the weight of the men's javelin?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 800 g",
        "Q22 Mark": 0,
        "Q23 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 11",
        "Q23 Mark": 0,
        "Q24 Question": "What is the official distance of a marathon?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: 42.195 km",
        "Q24 Mark": 0,
        "Q25 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 45 mm",
        "Q25 Mark": 0,
        "Q26 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: Glide method",
        "Q26 Mark": 0,
        "Q27 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "A: Laya Yoga",
        "Q27 Mark": 0,
        "Q28 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: Comparing their second-best performances",
        "Q28 Mark": 0,
        "Q29 Question": "How is a triple jump measured?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q29 Mark": 0,
        "Q30 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: Swami Vivekananda",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 89,
      "registrationNumber": "KOP/2026/06/0216",
      "studentName": "JAMBUBATI PRADHANI",
      "mobileNumber": "8984645695",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18-Oct-2026, 02:02:57 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 89,
        "Registration ID": "KOP/2026/06/0216",
        "Candidate Name": "JAMBUBATI PRADHANI",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What are the dimensions of the take-off board in long jump?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q1 Mark": 0,
        "Q2 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: Yama",
        "Q2 Mark": 0,
        "Q3 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 6",
        "Q3 Mark": 0,
        "Q4 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: Swami Vivekananda",
        "Q4 Mark": 0,
        "Q5 Question": "In which throwing event are gloves allowed?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "D: Hammer throw",
        "Q5 Mark": 0,
        "Q6 Question": "Which of the following is a Niyama?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: Svadhyaya",
        "Q6 Mark": 0,
        "Q7 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: 11",
        "Q7 Mark": 0,
        "Q8 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "A: Laya Yoga",
        "Q8 Mark": 0,
        "Q9 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q9 Mark": 0,
        "Q10 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: To join or unite",
        "Q10 Mark": 0,
        "Q11 Question": "What is the correct sequence of phases in the triple jump?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Hop – Step – Jump",
        "Q11 Mark": 0,
        "Q12 Question": "How much energy does 1 g of fat give?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: 9.1 kcal",
        "Q12 Mark": 0,
        "Q13 Question": "What is the weight of the men's shot?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 7.260 kg",
        "Q13 Mark": 0,
        "Q14 Question": "What is the official distance of a marathon?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: 42.195 km",
        "Q14 Mark": 0,
        "Q15 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: Scissors Jump",
        "Q15 Mark": 0,
        "Q16 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 34.92°",
        "Q16 Mark": 0,
        "Q17 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: 2 minutes",
        "Q17 Mark": 0,
        "Q18 Question": "How high is the plasticine indicator board?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: 7 mm",
        "Q18 Mark": 0,
        "Q19 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: Glide method",
        "Q19 Mark": 0,
        "Q20 Question": "What is the weight of the men's javelin?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: 800 g",
        "Q20 Mark": 0,
        "Q21 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: Pratyahara",
        "Q21 Mark": 0,
        "Q22 Question": "If the shot lands on one of the sector lines:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: It is called a foul and not measured",
        "Q22 Mark": 0,
        "Q23 Question": "What is the weight of the women's discus?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: 1 kg",
        "Q23 Mark": 0,
        "Q24 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: Protein",
        "Q24 Mark": 0,
        "Q25 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: Comparing their second-best performances",
        "Q25 Mark": 0,
        "Q26 Question": "What is the diameter of the shot put circle?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: 2.135 m",
        "Q26 Mark": 0,
        "Q27 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "D: Fosbury Flop",
        "Q27 Mark": 0,
        "Q28 Question": "What is the diameter of the discus throwing circle?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: 2.50 m",
        "Q28 Mark": 0,
        "Q29 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "D: Orthodox grip",
        "Q29 Mark": 0,
        "Q30 Question": "Which statement about pole vault is correct?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 90,
      "registrationNumber": "KOP/2026/06/0234",
      "studentName": "AMARNATH MISHRA",
      "mobileNumber": "9929019252",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:15:09 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 90,
        "Registration ID": "KOP/2026/06/0234",
        "Candidate Name": "AMARNATH MISHRA",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the correct sequence of phases in the triple jump?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: Hop – Step – Jump",
        "Q1 Mark": 0,
        "Q2 Question": "Which of the following is a Niyama?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: Svadhyaya",
        "Q2 Mark": 0,
        "Q3 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 32 m/s",
        "Q3 Mark": 0,
        "Q4 Question": "What is the weight of the women's discus?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 1 kg",
        "Q4 Mark": 0,
        "Q5 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q5 Mark": 0,
        "Q6 Question": "How much energy does 1 g of fat give?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 9.1 kcal",
        "Q6 Mark": 0,
        "Q7 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Karma Yoga",
        "Q7 Mark": 0,
        "Q8 Question": "How is a triple jump measured?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q8 Mark": 0,
        "Q9 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 2 minutes",
        "Q9 Mark": 0,
        "Q10 Question": "In which throwing event are gloves allowed?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "D: Hammer throw",
        "Q10 Mark": 0,
        "Q11 Question": "What is the official distance of a marathon?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: 42.195 km",
        "Q11 Mark": 0,
        "Q12 Question": "What is the minimum size of the high jump landing mat?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: 5 m × 3 m",
        "Q12 Mark": 0,
        "Q13 Question": "What is the weight of the men's javelin?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 800 g",
        "Q13 Mark": 0,
        "Q14 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: Pratyahara",
        "Q14 Mark": 0,
        "Q15 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "D: Fosbury Flop",
        "Q15 Mark": 0,
        "Q16 Question": "Lactose (milk sugar) is made of:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: Glucose + Galactose",
        "Q16 Mark": 0,
        "Q17 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q17 Mark": 0,
        "Q18 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: Yama",
        "Q18 Mark": 0,
        "Q19 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: 45 mm",
        "Q19 Mark": 0,
        "Q20 Question": "In international competition, the pole vault landing area must be at least:",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q20 Mark": 0,
        "Q21 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: To hold or maintain",
        "Q21 Mark": 0,
        "Q22 Question": "In track and field, a green card is shown when:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q22 Mark": 0,
        "Q23 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: Disqualified",
        "Q23 Mark": 0,
        "Q24 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: Comparing their second-best performances",
        "Q24 Mark": 0,
        "Q25 Question": "What are the dimensions of the take-off board in long jump?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q25 Mark": 0,
        "Q26 Question": "A javelin throw is valid only if:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q26 Mark": 0,
        "Q27 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "D: Orthodox grip",
        "Q27 Mark": 0,
        "Q28 Question": "What is the diameter of the discus throwing circle?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: 2.50 m",
        "Q28 Mark": 0,
        "Q29 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Protein",
        "Q29 Mark": 0,
        "Q30 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: 45 minutes",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 91,
      "registrationNumber": "KOP/2026/08/0469",
      "studentName": "RAHASH BIHARI MAHANAND",
      "mobileNumber": "8457916886",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:03:25 pm",
      "startTime": "N/A",
      "submissionTime": "18/10/2026, 2:08:42 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 91,
        "Registration ID": "KOP/2026/08/0469",
        "Candidate Name": "RAHASH BIHARI MAHANAND",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q1 Mark": 0,
        "Q2 Question": "How high is the plasticine indicator board?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: 7 mm",
        "Q2 Mark": 0,
        "Q3 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 20 m",
        "Q3 Mark": 0,
        "Q4 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: Comparing their second-best performances",
        "Q4 Mark": 0,
        "Q5 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "C: Pratyahara",
        "Q5 Mark": 0,
        "Q6 Question": "A javelin throw is valid only if:",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q6 Mark": 0,
        "Q7 Question": "What is the official distance of a marathon?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: 42.195 km",
        "Q7 Mark": 0,
        "Q8 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: 1:2:1",
        "Q8 Mark": 0,
        "Q9 Question": "How is a triple jump measured?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q9 Mark": 0,
        "Q10 Question": "What are the dimensions of the take-off board in long jump?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q10 Mark": 0,
        "Q11 Question": "What is the diameter of the shot put circle?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "B: 2.135 m",
        "Q11 Mark": 0,
        "Q12 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q12 Mark": 0,
        "Q13 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: Scissors Jump",
        "Q13 Mark": 0,
        "Q14 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: 45 minutes",
        "Q14 Mark": 0,
        "Q15 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: Yama",
        "Q15 Mark": 0,
        "Q16 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: To hold or maintain",
        "Q16 Mark": 0,
        "Q17 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q17 Mark": 0,
        "Q18 Question": "If the shot lands on one of the sector lines:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: It is called a foul and not measured",
        "Q18 Mark": 0,
        "Q19 Question": "Which of the following is NOT a flight style in long jump?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "D: Fosbury flop",
        "Q19 Mark": 0,
        "Q20 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: Swami Vivekananda",
        "Q20 Mark": 0,
        "Q21 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Glide method",
        "Q21 Mark": 0,
        "Q22 Question": "In international competition, the pole vault landing area must be at least:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q22 Mark": 0,
        "Q23 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: 45 mm",
        "Q23 Mark": 0,
        "Q24 Question": "How much energy does 1 g of fat give?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: 9.1 kcal",
        "Q24 Mark": 0,
        "Q25 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: Disqualified",
        "Q25 Mark": 0,
        "Q26 Question": "What is the weight of the women's discus?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: 1 kg",
        "Q26 Mark": 0,
        "Q27 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "A: Laya Yoga",
        "Q27 Mark": 0,
        "Q28 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Protein",
        "Q28 Mark": 0,
        "Q29 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: 11",
        "Q29 Mark": 0,
        "Q30 Question": "In track and field, a green card is shown when:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 92,
      "registrationNumber": "KOP/2026/08/0501",
      "studentName": "SASHIKANTA PUTEL",
      "mobileNumber": "9556093809",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:23:42 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:23:49 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 92,
        "Registration ID": "KOP/2026/08/0501",
        "Candidate Name": "SASHIKANTA PUTEL",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 0,
        "Q2 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: Pratyahara",
        "Q2 Mark": 0,
        "Q3 Question": "Lactose (milk sugar) is made of:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: Glucose + Galactose",
        "Q3 Mark": 0,
        "Q4 Question": "In international competition, the pole vault landing area must be at least:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q4 Mark": 0,
        "Q5 Question": "How high is the plasticine indicator board?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 7 mm",
        "Q5 Mark": 0,
        "Q6 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: Karma Yoga",
        "Q6 Mark": 0,
        "Q7 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: 2 minutes",
        "Q7 Mark": 0,
        "Q8 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: To hold or maintain",
        "Q8 Mark": 0,
        "Q9 Question": "What is the weight of the women's discus?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: 1 kg",
        "Q9 Mark": 0,
        "Q10 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q10 Mark": 0,
        "Q11 Question": "Which of the following is NOT a flight style in long jump?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "D: Fosbury flop",
        "Q11 Mark": 0,
        "Q12 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: 20 m",
        "Q12 Mark": 0,
        "Q13 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 34.92°",
        "Q13 Mark": 0,
        "Q14 Question": "If the shot lands on one of the sector lines:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: It is called a foul and not measured",
        "Q14 Mark": 0,
        "Q15 Question": "What is the diameter of the shot put circle?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: 2.135 m",
        "Q15 Mark": 0,
        "Q16 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: Glide method",
        "Q16 Mark": 0,
        "Q17 Question": "What is the official distance of a marathon?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: 42.195 km",
        "Q17 Mark": 0,
        "Q18 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: 45 minutes",
        "Q18 Mark": 0,
        "Q19 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q19 Mark": 0,
        "Q20 Question": "What is the diameter of the discus throwing circle?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 2.50 m",
        "Q20 Mark": 0,
        "Q21 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 11",
        "Q21 Mark": 0,
        "Q22 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "D: Orthodox grip",
        "Q22 Mark": 0,
        "Q23 Question": "In which throwing event are gloves allowed?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "D: Hammer throw",
        "Q23 Mark": 0,
        "Q24 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q24 Mark": 0,
        "Q25 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "D: Fosbury Flop",
        "Q25 Mark": 0,
        "Q26 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: 32 m/s",
        "Q26 Mark": 0,
        "Q27 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 6",
        "Q27 Mark": 0,
        "Q28 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: To join or unite",
        "Q28 Mark": 0,
        "Q29 Question": "How is a triple jump measured?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q29 Mark": 0,
        "Q30 Question": "Which statement about pole vault is correct?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 93,
      "registrationNumber": "KOP/2026/08/0505",
      "studentName": "FAKIRA PATEL",
      "mobileNumber": "9777820845",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:21:45 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:21:51 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 93,
        "Registration ID": "KOP/2026/08/0505",
        "Candidate Name": "FAKIRA PATEL",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 0,
        "Q2 Question": "Which of the following is NOT a flight style in long jump?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "D: Fosbury flop",
        "Q2 Mark": 0,
        "Q3 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Swami Vivekananda",
        "Q3 Mark": 0,
        "Q4 Question": "If the shot lands on one of the sector lines:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: It is called a foul and not measured",
        "Q4 Mark": 0,
        "Q5 Question": "What is the javelin throwing sector angle?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "A: 28.96°",
        "Q5 Mark": 0,
        "Q6 Question": "Which statement about pole vault is correct?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q6 Mark": 0,
        "Q7 Question": "Lactose (milk sugar) is made of:",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Glucose + Galactose",
        "Q7 Mark": 0,
        "Q8 Question": "What is the weight of the women's discus?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: 1 kg",
        "Q8 Mark": 0,
        "Q9 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: To join or unite",
        "Q9 Mark": 0,
        "Q10 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: 6",
        "Q10 Mark": 0,
        "Q11 Question": "What is the official distance of a marathon?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: 42.195 km",
        "Q11 Mark": 0,
        "Q12 Question": "In which throwing event are gloves allowed?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "D: Hammer throw",
        "Q12 Mark": 0,
        "Q13 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: 1:2:1",
        "Q13 Mark": 0,
        "Q14 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: Disqualified",
        "Q14 Mark": 0,
        "Q15 Question": "How is a triple jump measured?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q15 Mark": 0,
        "Q16 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: Scissors Jump",
        "Q16 Mark": 0,
        "Q17 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: To hold or maintain",
        "Q17 Mark": 0,
        "Q18 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "D: Orthodox grip",
        "Q18 Mark": 0,
        "Q19 Question": "What is the minimum size of the high jump landing mat?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: 5 m × 3 m",
        "Q19 Mark": 0,
        "Q20 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q20 Mark": 0,
        "Q21 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 2 minutes",
        "Q21 Mark": 0,
        "Q22 Question": "In international competition, the pole vault landing area must be at least:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q22 Mark": 0,
        "Q23 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 11",
        "Q23 Mark": 0,
        "Q24 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q24 Mark": 0,
        "Q25 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "A: Laya Yoga",
        "Q25 Mark": 0,
        "Q26 Question": "In track and field, a green card is shown when:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q26 Mark": 0,
        "Q27 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Yama",
        "Q27 Mark": 0,
        "Q28 Question": "How much energy does 1 g of fat give?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 9.1 kcal",
        "Q28 Mark": 0,
        "Q29 Question": "What is the correct sequence of phases in the triple jump?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Hop – Step – Jump",
        "Q29 Mark": 0,
        "Q30 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 94,
      "registrationNumber": "KOP/2026/08/0541",
      "studentName": "PUJA PATEL",
      "mobileNumber": "6372690664",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 01:04:00 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:00:00 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 94,
        "Registration ID": "KOP/2026/08/0541",
        "Candidate Name": "PUJA PATEL",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 0,
        "Q2 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q2 Mark": 0,
        "Q3 Question": "How high is the plasticine indicator board?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: 7 mm",
        "Q3 Mark": 0,
        "Q4 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 45 mm",
        "Q4 Mark": 0,
        "Q5 Question": "What is the diameter of the shot put circle?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 2.135 m",
        "Q5 Mark": 0,
        "Q6 Question": "How much energy does 1 g of fat give?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 9.1 kcal",
        "Q6 Mark": 0,
        "Q7 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q7 Mark": 0,
        "Q8 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "C: 2 minutes",
        "Q8 Mark": 0,
        "Q9 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Swami Vivekananda",
        "Q9 Mark": 0,
        "Q10 Question": "What is the weight of the women's discus?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: 1 kg",
        "Q10 Mark": 0,
        "Q11 Question": "Which of the following is a Niyama?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Svadhyaya",
        "Q11 Mark": 0,
        "Q12 Question": "In international competition, the pole vault landing area must be at least:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q12 Mark": 0,
        "Q13 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: Disqualified",
        "Q13 Mark": 0,
        "Q14 Question": "How is a triple jump measured?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q14 Mark": 0,
        "Q15 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: Comparing their second-best performances",
        "Q15 Mark": 0,
        "Q16 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: 45 minutes",
        "Q16 Mark": 0,
        "Q17 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: Glide method",
        "Q17 Mark": 0,
        "Q18 Question": "In track and field, a green card is shown when:",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q18 Mark": 0,
        "Q19 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Karma Yoga",
        "Q19 Mark": 0,
        "Q20 Question": "What is the minimum size of the high jump landing mat?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 5 m × 3 m",
        "Q20 Mark": 0,
        "Q21 Question": "If the shot lands on one of the sector lines:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: It is called a foul and not measured",
        "Q21 Mark": 0,
        "Q22 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 20 m",
        "Q22 Mark": 0,
        "Q23 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q23 Mark": 0,
        "Q24 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: Scissors Jump",
        "Q24 Mark": 0,
        "Q25 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 1:2:1",
        "Q25 Mark": 0,
        "Q26 Question": "Lactose (milk sugar) is made of:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Glucose + Galactose",
        "Q26 Mark": 0,
        "Q27 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Yama",
        "Q27 Mark": 0,
        "Q28 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: To hold or maintain",
        "Q28 Mark": 0,
        "Q29 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "D: Orthodox grip",
        "Q29 Mark": 0,
        "Q30 Question": "In which throwing event are gloves allowed?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "D: Hammer throw",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 95,
      "registrationNumber": "KOP/2026/08/0595",
      "studentName": "PRAKASH KUMAR BEHERA",
      "mobileNumber": "7682029065",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:25:42 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:25:48 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 95,
        "Registration ID": "KOP/2026/08/0595",
        "Candidate Name": "PRAKASH KUMAR BEHERA",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the diameter of the shot put circle?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "B: 2.135 m",
        "Q1 Mark": 0,
        "Q2 Question": "A javelin throw is valid only if:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q2 Mark": 0,
        "Q3 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Comparing their second-best performances",
        "Q3 Mark": 0,
        "Q4 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "A: Laya Yoga",
        "Q4 Mark": 0,
        "Q5 Question": "What is the diameter of the discus throwing circle?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 2.50 m",
        "Q5 Mark": 0,
        "Q6 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: Karma Yoga",
        "Q6 Mark": 0,
        "Q7 Question": "What is the correct sequence of phases in the triple jump?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Hop – Step – Jump",
        "Q7 Mark": 0,
        "Q8 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: Swami Vivekananda",
        "Q8 Mark": 0,
        "Q9 Question": "What is the javelin throwing sector angle?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "A: 28.96°",
        "Q9 Mark": 0,
        "Q10 Question": "Which statement about pole vault is correct?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q10 Mark": 0,
        "Q11 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: 34.92°",
        "Q11 Mark": 0,
        "Q12 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: To hold or maintain",
        "Q12 Mark": 0,
        "Q13 Question": "What is the weight of the men's shot?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 7.260 kg",
        "Q13 Mark": 0,
        "Q14 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: 2 minutes",
        "Q14 Mark": 0,
        "Q15 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q15 Mark": 0,
        "Q16 Question": "In which throwing event are gloves allowed?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "D: Hammer throw",
        "Q16 Mark": 0,
        "Q17 Question": "In international competition, the pole vault landing area must be at least:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q17 Mark": 0,
        "Q18 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: 1:2:1",
        "Q18 Mark": 0,
        "Q19 Question": "What are the dimensions of the take-off board in long jump?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q19 Mark": 0,
        "Q20 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 45 mm",
        "Q20 Mark": 0,
        "Q21 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Yama",
        "Q21 Mark": 0,
        "Q22 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 6",
        "Q22 Mark": 0,
        "Q23 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: Scissors Jump",
        "Q23 Mark": 0,
        "Q24 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: Protein",
        "Q24 Mark": 0,
        "Q25 Question": "Which of the following is NOT a flight style in long jump?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "D: Fosbury flop",
        "Q25 Mark": 0,
        "Q26 Question": "Which of the following is a Niyama?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Svadhyaya",
        "Q26 Mark": 0,
        "Q27 Question": "What is the weight of the women's discus?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: 1 kg",
        "Q27 Mark": 0,
        "Q28 Question": "Lactose (milk sugar) is made of:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: Glucose + Galactose",
        "Q28 Mark": 0,
        "Q29 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "D: Orthodox grip",
        "Q29 Mark": 0,
        "Q30 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 96,
      "registrationNumber": "KOP/2026/08/0623",
      "studentName": "SWARNALATA DAS",
      "mobileNumber": "8917419114",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:26:33 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:26:38 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 96,
        "Registration ID": "KOP/2026/08/0623",
        "Candidate Name": "SWARNALATA DAS",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the weight of the men's shot?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: 7.260 kg",
        "Q1 Mark": 0,
        "Q2 Question": "In international competition, the pole vault landing area must be at least:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q2 Mark": 0,
        "Q3 Question": "If the shot lands on one of the sector lines:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: It is called a foul and not measured",
        "Q3 Mark": 0,
        "Q4 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: To hold or maintain",
        "Q4 Mark": 0,
        "Q5 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 1:2:1",
        "Q5 Mark": 0,
        "Q6 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 2 minutes",
        "Q6 Mark": 0,
        "Q7 Question": "What are the dimensions of the take-off board in long jump?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q7 Mark": 0,
        "Q8 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "D: Orthodox grip",
        "Q8 Mark": 0,
        "Q9 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q9 Mark": 0,
        "Q10 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: Protein",
        "Q10 Mark": 0,
        "Q11 Question": "In which throwing event are gloves allowed?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "D: Hammer throw",
        "Q11 Mark": 0,
        "Q12 Question": "Which statement about pole vault is correct?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q12 Mark": 0,
        "Q13 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 34.92°",
        "Q13 Mark": 0,
        "Q14 Question": "In track and field, a green card is shown when:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q14 Mark": 0,
        "Q15 Question": "What is the diameter of the discus throwing circle?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: 2.50 m",
        "Q15 Mark": 0,
        "Q16 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q16 Mark": 0,
        "Q17 Question": "What is the diameter of the shot put circle?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: 2.135 m",
        "Q17 Mark": 0,
        "Q18 Question": "How is a triple jump measured?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q18 Mark": 0,
        "Q19 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Karma Yoga",
        "Q19 Mark": 0,
        "Q20 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "A: Laya Yoga",
        "Q20 Mark": 0,
        "Q21 Question": "What is the official distance of a marathon?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 42.195 km",
        "Q21 Mark": 0,
        "Q22 Question": "How high is the plasticine indicator board?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: 7 mm",
        "Q22 Mark": 0,
        "Q23 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: To join or unite",
        "Q23 Mark": 0,
        "Q24 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: 45 mm",
        "Q24 Mark": 0,
        "Q25 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "D: Fosbury Flop",
        "Q25 Mark": 0,
        "Q26 Question": "How much energy does 1 g of fat give?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: 9.1 kcal",
        "Q26 Mark": 0,
        "Q27 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 3",
        "Q27 Mark": 0,
        "Q28 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 11",
        "Q28 Mark": 0,
        "Q29 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: Scissors Jump",
        "Q29 Mark": 0,
        "Q30 Question": "What is the correct sequence of phases in the triple jump?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: Hop – Step – Jump",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 97,
      "registrationNumber": "KOP/2026/08/0660",
      "studentName": "BABLU PUTEL",
      "mobileNumber": "8018310142",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:24:53 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:24:58 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 97,
        "Registration ID": "KOP/2026/08/0660",
        "Candidate Name": "BABLU PUTEL",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: Protein",
        "Q1 Mark": 0,
        "Q2 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: Yama",
        "Q2 Mark": 0,
        "Q3 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: 32 m/s",
        "Q3 Mark": 0,
        "Q4 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 45 mm",
        "Q4 Mark": 0,
        "Q5 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 1:2:1",
        "Q5 Mark": 0,
        "Q6 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "B: Scissors Jump",
        "Q6 Mark": 0,
        "Q7 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Disqualified",
        "Q7 Mark": 0,
        "Q8 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q8 Mark": 0,
        "Q9 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "B: Glide method",
        "Q9 Mark": 0,
        "Q10 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: 6",
        "Q10 Mark": 0,
        "Q11 Question": "What is the weight of the men's shot?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: 7.260 kg",
        "Q11 Mark": 0,
        "Q12 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: 11",
        "Q12 Mark": 0,
        "Q13 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "B: Comparing their second-best performances",
        "Q13 Mark": 0,
        "Q14 Question": "Which of the following is NOT a flight style in long jump?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "D: Fosbury flop",
        "Q14 Mark": 0,
        "Q15 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q15 Mark": 0,
        "Q16 Question": "What is the weight of the men's javelin?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 800 g",
        "Q16 Mark": 0,
        "Q17 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "D: Orthodox grip",
        "Q17 Mark": 0,
        "Q18 Question": "In which throwing event are gloves allowed?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "D: Hammer throw",
        "Q18 Mark": 0,
        "Q19 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 2 minutes",
        "Q19 Mark": 0,
        "Q20 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "A: Laya Yoga",
        "Q20 Mark": 0,
        "Q21 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: To join or unite",
        "Q21 Mark": 0,
        "Q22 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: Karma Yoga",
        "Q22 Mark": 0,
        "Q23 Question": "Which statement about pole vault is correct?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q23 Mark": 0,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 0,
        "Q25 Question": "In track and field, a green card is shown when:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q25 Mark": 0,
        "Q26 Question": "What is the diameter of the discus throwing circle?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: 2.50 m",
        "Q26 Mark": 0,
        "Q27 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 34.92°",
        "Q27 Mark": 0,
        "Q28 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "C: 20 m",
        "Q28 Mark": 0,
        "Q29 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: Pratyahara",
        "Q29 Mark": 0,
        "Q30 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 98,
      "registrationNumber": "KOP/2026/08/0690",
      "studentName": "NITU DANDASENA",
      "mobileNumber": "9937076932",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 01:03:03 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:00:41 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 98,
        "Registration ID": "KOP/2026/08/0690",
        "Candidate Name": "NITU DANDASENA",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "Which of the following is a Niyama?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: Svadhyaya",
        "Q1 Mark": 0,
        "Q2 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: 11",
        "Q2 Mark": 0,
        "Q3 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Comparing their second-best performances",
        "Q3 Mark": 0,
        "Q4 Question": "If the shot lands on one of the sector lines:",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "C: It is called a foul and not measured",
        "Q4 Mark": 0,
        "Q5 Question": "Which of the following is NOT a flight style in long jump?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "D: Fosbury flop",
        "Q5 Mark": 0,
        "Q6 Question": "What is the weight of the men's shot?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 7.260 kg",
        "Q6 Mark": 0,
        "Q7 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Karma Yoga",
        "Q7 Mark": 0,
        "Q8 Question": "What is the minimum size of the high jump landing mat?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: 5 m × 3 m",
        "Q8 Mark": 0,
        "Q9 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 20 m",
        "Q9 Mark": 0,
        "Q10 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: Glide method",
        "Q10 Mark": 0,
        "Q11 Question": "What is the correct sequence of phases in the triple jump?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Hop – Step – Jump",
        "Q11 Mark": 0,
        "Q12 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: 45 mm",
        "Q12 Mark": 0,
        "Q13 Question": "Which statement about pole vault is correct?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q13 Mark": 0,
        "Q14 Question": "In which throwing event are gloves allowed?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "D: Hammer throw",
        "Q14 Mark": 0,
        "Q15 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "C: Protein",
        "Q15 Mark": 0,
        "Q16 Question": "What is the javelin throwing sector angle?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "A: 28.96°",
        "Q16 Mark": 0,
        "Q17 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q17 Mark": 0,
        "Q18 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: 6",
        "Q18 Mark": 0,
        "Q19 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: Pratyahara",
        "Q19 Mark": 0,
        "Q20 Question": "What is the weight of the women's discus?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "B: 1 kg",
        "Q20 Mark": 0,
        "Q21 Question": "How much energy does 1 g of fat give?",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "C: 9.1 kcal",
        "Q21 Mark": 0,
        "Q22 Question": "Lactose (milk sugar) is made of:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: Glucose + Galactose",
        "Q22 Mark": 0,
        "Q23 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: 45 minutes",
        "Q23 Mark": 0,
        "Q24 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q24 Mark": 0,
        "Q25 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: 3",
        "Q25 Mark": 0,
        "Q26 Question": "\"Asteya\" (non-stealing) falls under which limb?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "B: Yama",
        "Q26 Mark": 0,
        "Q27 Question": "In international competition, the pole vault landing area must be at least:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q27 Mark": 0,
        "Q28 Question": "Which events are held on the 2nd day of the Heptathlon?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: Long Jump, Javelin Throw, 800m",
        "Q28 Mark": 0,
        "Q29 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "C: To join or unite",
        "Q29 Mark": 0,
        "Q30 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: 34.92°",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 99,
      "registrationNumber": "KOP/2026/09/0011",
      "studentName": "ASHIKANTA SAHOO",
      "mobileNumber": "7205146842",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:25:24 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:25:28 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 99,
        "Registration ID": "KOP/2026/09/0011",
        "Candidate Name": "ASHIKANTA SAHOO",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "In long jump, the wind gauge is placed how far from the take-off board?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "C: 20 m",
        "Q1 Mark": 0,
        "Q2 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: To join or unite",
        "Q2 Mark": 0,
        "Q3 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Swami Vivekananda",
        "Q3 Mark": 0,
        "Q4 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "A: Laya Yoga",
        "Q4 Mark": 0,
        "Q5 Question": "How is a triple jump measured?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q5 Mark": 0,
        "Q6 Question": "What is the correct sequence of phases in the triple jump?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: Hop – Step – Jump",
        "Q6 Mark": 0,
        "Q7 Question": "Which statement about pole vault is correct?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q7 Mark": 0,
        "Q8 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "D: Orthodox grip",
        "Q8 Mark": 0,
        "Q9 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 11",
        "Q9 Mark": 0,
        "Q10 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: 45 minutes",
        "Q10 Mark": 0,
        "Q11 Question": "What is the diameter of the discus throwing circle?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "B: 2.50 m",
        "Q11 Mark": 0,
        "Q12 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "C: Protein",
        "Q12 Mark": 0,
        "Q13 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: 3",
        "Q13 Mark": 0,
        "Q14 Question": "In international competition, the pole vault landing area must be at least:",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: 6 m × 6 m × 0.8 m",
        "Q14 Mark": 0,
        "Q15 Question": "What is the javelin throwing sector angle?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "A: 28.96°",
        "Q15 Mark": 0,
        "Q16 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "B: 45 mm",
        "Q16 Mark": 0,
        "Q17 Question": "The root of the word \"Dharana\" is \"dhri\", which means:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: To hold or maintain",
        "Q17 Mark": 0,
        "Q18 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "D: Fosbury Flop",
        "Q18 Mark": 0,
        "Q19 Question": "In track and field, a green card is shown when:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q19 Mark": 0,
        "Q20 Question": "Which type of yoga is the path of action without attachment to the outcome?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "C: Karma Yoga",
        "Q20 Mark": 0,
        "Q21 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q21 Mark": 0,
        "Q22 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q22 Mark": 0,
        "Q23 Question": "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "B: Scissors Jump",
        "Q23 Mark": 0,
        "Q24 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: Pratyahara",
        "Q24 Mark": 0,
        "Q25 Question": "A javelin throw is valid only if:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q25 Mark": 0,
        "Q26 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Disqualified",
        "Q26 Mark": 0,
        "Q27 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "C: 2 minutes",
        "Q27 Mark": 0,
        "Q28 Question": "In which throwing event are gloves allowed?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "D: Hammer throw",
        "Q28 Mark": 0,
        "Q29 Question": "What is the diameter of the shot put circle?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 2.135 m",
        "Q29 Mark": 0,
        "Q30 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: 34.92°",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 100,
      "registrationNumber": "KOP/2026/09/0019",
      "studentName": "RAJENDRA KUMBHAR",
      "mobileNumber": "8917279156",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:16:38 pm",
      "startTime": "N/A",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 100,
        "Registration ID": "KOP/2026/09/0019",
        "Candidate Name": "RAJENDRA KUMBHAR",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "What is the minimum time between two rounds of races up to and including 200m?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "B: 45 minutes",
        "Q1 Mark": 0,
        "Q2 Question": "In the men's Decathlon, how many of the 10 events are field events?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "C: 6",
        "Q2 Mark": 0,
        "Q3 Question": "Kwashiorkor and Marasmus are caused by a deficiency of:",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "C: Protein",
        "Q3 Mark": 0,
        "Q4 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "A: Laya Yoga",
        "Q4 Mark": 0,
        "Q5 Question": "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: 1:2:1",
        "Q5 Mark": 0,
        "Q6 Question": "Which of the following is NOT a flight style in long jump?",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "D: Fosbury flop",
        "Q6 Mark": 0,
        "Q7 Question": "In which throwing event are gloves allowed?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "D: Hammer throw",
        "Q7 Mark": 0,
        "Q8 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q8 Mark": 0,
        "Q9 Question": "How much energy does 1 g of fat give?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: 9.1 kcal",
        "Q9 Mark": 0,
        "Q10 Question": "What is the weight of the women's discus?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "B: 1 kg",
        "Q10 Mark": 0,
        "Q11 Question": "How high is the plasticine indicator board?",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "B: 7 mm",
        "Q11 Mark": 0,
        "Q12 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q12 Mark": 0,
        "Q13 Question": "If the shot lands on one of the sector lines:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: It is called a foul and not measured",
        "Q13 Mark": 0,
        "Q14 Question": "How many attempts does an athlete get to clear a particular height in high jump?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "C: 3",
        "Q14 Mark": 0,
        "Q15 Question": "Which statement about pole vault is correct?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q15 Mark": 0,
        "Q16 Question": "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: To join or unite",
        "Q16 Mark": 0,
        "Q17 Question": "A javelin throw is valid only if:",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q17 Mark": 0,
        "Q18 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: 11",
        "Q18 Mark": 0,
        "Q19 Question": "Two discus throwers finish with the same best distance. The tie is broken by:",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "B: Comparing their second-best performances",
        "Q19 Mark": 0,
        "Q20 Question": "In which high jump style does the athlete's back face the bar, with a curved approach run?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "D: Fosbury Flop",
        "Q20 Mark": 0,
        "Q21 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Glide method",
        "Q21 Mark": 0,
        "Q22 Question": "What is the official distance of a marathon?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 42.195 km",
        "Q22 Mark": 0,
        "Q23 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 34.92°",
        "Q23 Mark": 0,
        "Q24 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: Pratyahara",
        "Q24 Mark": 0,
        "Q25 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "B: 45 mm",
        "Q25 Mark": 0,
        "Q26 Question": "Which of the following is a Niyama?",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "C: Svadhyaya",
        "Q26 Mark": 0,
        "Q27 Question": "What is the javelin throwing sector angle?",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "A: 28.96°",
        "Q27 Mark": 0,
        "Q28 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "D: Orthodox grip",
        "Q28 Mark": 0,
        "Q29 Question": "What are the dimensions of the take-off board in long jump?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 1.22 m × 0.20 m × 0.10 m",
        "Q29 Mark": 0,
        "Q30 Question": "Lactose (milk sugar) is made of:",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: Glucose + Galactose",
        "Q30 Mark": 0
      }
    },
    {
      "rank": 101,
      "registrationNumber": "KOP/2026/09/0099",
      "studentName": "TULASI NAIK",
      "mobileNumber": "9937150232",
      "batch": "Unified Examination Batch",
      "status": "LOBBY ONLY (NO ANSWERS)",
      "actuallyGaveExam": false,
      "loginTime": "18 Oct 2026, 02:12:06 pm",
      "startTime": "18 Oct 2026, 02:12:23 pm",
      "submissionTime": "18 Oct 2026, 02:18:37 pm",
      "questionsAnswered": "0 / 30",
      "score": 0,
      "totalMarks": 30,
      "percentage": 0,
      "correctCount": 0,
      "wrongCount": 0,
      "unattemptedCount": 30,
      "result": "ABSENT IN TEST",
      "detailedResponses": {
        "Rank": 101,
        "Registration ID": "KOP/2026/09/0099",
        "Candidate Name": "TULASI NAIK",
        "Actually Gave Exam?": "NO",
        "Total Score": "0 / 30",
        "Percentage": "0%",
        "Result": "NOT ATTEMPTED",
        "Q1 Question": "Which grip is NOT one of the javelin grips listed in the material?",
        "Q1 Candidate Answer": "UNATTEMPTED",
        "Q1 Correct Key": "D: Orthodox grip",
        "Q1 Mark": 0,
        "Q2 Question": "What is the diameter of the discus throwing circle?",
        "Q2 Candidate Answer": "UNATTEMPTED",
        "Q2 Correct Key": "B: 2.50 m",
        "Q2 Mark": 0,
        "Q3 Question": "How is a triple jump measured?",
        "Q3 Candidate Answer": "UNATTEMPTED",
        "Q3 Correct Key": "B: Perpendicular from the take-off line to the nearest mark in the sand",
        "Q3 Mark": 0,
        "Q4 Question": "How high is the plasticine indicator board?",
        "Q4 Candidate Answer": "UNATTEMPTED",
        "Q4 Correct Key": "B: 7 mm",
        "Q4 Mark": 0,
        "Q5 Question": "In javelin, a yellow flag is raised to indicate:",
        "Q5 Candidate Answer": "UNATTEMPTED",
        "Q5 Correct Key": "B: The final 15 seconds of the allowed time",
        "Q5 Mark": 0,
        "Q6 Question": "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
        "Q6 Candidate Answer": "UNATTEMPTED",
        "Q6 Correct Key": "C: 32 m/s",
        "Q6 Mark": 0,
        "Q7 Question": "Which form of yoga is also called Kundalini Yoga?",
        "Q7 Candidate Answer": "UNATTEMPTED",
        "Q7 Correct Key": "A: Laya Yoga",
        "Q7 Mark": 0,
        "Q8 Question": "What is the official distance of a marathon?",
        "Q8 Candidate Answer": "UNATTEMPTED",
        "Q8 Correct Key": "C: 42.195 km",
        "Q8 Mark": 0,
        "Q9 Question": "What is the 5th limb of Ashtanga Yoga?",
        "Q9 Candidate Answer": "UNATTEMPTED",
        "Q9 Correct Key": "C: Pratyahara",
        "Q9 Mark": 0,
        "Q10 Question": "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
        "Q10 Candidate Answer": "UNATTEMPTED",
        "Q10 Correct Key": "C: 2 minutes",
        "Q10 Mark": 0,
        "Q11 Question": "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
        "Q11 Candidate Answer": "UNATTEMPTED",
        "Q11 Correct Key": "C: Disqualified",
        "Q11 Mark": 0,
        "Q12 Question": "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
        "Q12 Candidate Answer": "UNATTEMPTED",
        "Q12 Correct Key": "B: Swami Vivekananda",
        "Q12 Mark": 0,
        "Q13 Question": "Lactose (milk sugar) is made of:",
        "Q13 Candidate Answer": "UNATTEMPTED",
        "Q13 Correct Key": "C: Glucose + Galactose",
        "Q13 Mark": 0,
        "Q14 Question": "What is the maximum mesh size for the cord netting of a hammer cage?",
        "Q14 Candidate Answer": "UNATTEMPTED",
        "Q14 Correct Key": "B: 45 mm",
        "Q14 Mark": 0,
        "Q15 Question": "What is the weight of the women's discus?",
        "Q15 Candidate Answer": "UNATTEMPTED",
        "Q15 Correct Key": "B: 1 kg",
        "Q15 Mark": 0,
        "Q16 Question": "What is the maximum number of spikes allowed on a track shoe?",
        "Q16 Candidate Answer": "UNATTEMPTED",
        "Q16 Correct Key": "C: 11",
        "Q16 Mark": 0,
        "Q17 Question": "Which statement about pole vault is correct?",
        "Q17 Candidate Answer": "UNATTEMPTED",
        "Q17 Correct Key": "C: Gloves are permitted, and taping of the wrist is allowed",
        "Q17 Mark": 0,
        "Q18 Question": "Which of the following is a Niyama?",
        "Q18 Candidate Answer": "UNATTEMPTED",
        "Q18 Correct Key": "C: Svadhyaya",
        "Q18 Mark": 0,
        "Q19 Question": "What is the weight of the men's javelin?",
        "Q19 Candidate Answer": "UNATTEMPTED",
        "Q19 Correct Key": "C: 800 g",
        "Q19 Mark": 0,
        "Q20 Question": "In which throwing event are gloves allowed?",
        "Q20 Candidate Answer": "UNATTEMPTED",
        "Q20 Correct Key": "D: Hammer throw",
        "Q20 Mark": 0,
        "Q21 Question": "In the \"hop\" phase of the triple jump, the athlete:",
        "Q21 Candidate Answer": "UNATTEMPTED",
        "Q21 Correct Key": "B: Takes off from one foot and lands on the same foot",
        "Q21 Mark": 0,
        "Q22 Question": "What is the sector angle for shot put, discus and hammer throw?",
        "Q22 Candidate Answer": "UNATTEMPTED",
        "Q22 Correct Key": "C: 34.92°",
        "Q22 Mark": 0,
        "Q23 Question": "How much energy does 1 g of fat give?",
        "Q23 Candidate Answer": "UNATTEMPTED",
        "Q23 Correct Key": "C: 9.1 kcal",
        "Q23 Mark": 0,
        "Q24 Question": "In track and field, a green card is shown when:",
        "Q24 Candidate Answer": "UNATTEMPTED",
        "Q24 Correct Key": "C: There is a technical fault and no athlete is punished",
        "Q24 Mark": 0,
        "Q25 Question": "If the shot lands on one of the sector lines:",
        "Q25 Candidate Answer": "UNATTEMPTED",
        "Q25 Correct Key": "C: It is called a foul and not measured",
        "Q25 Mark": 0,
        "Q26 Question": "In a pole vault tie, the first deciding criterion is:",
        "Q26 Candidate Answer": "UNATTEMPTED",
        "Q26 Correct Key": "A: The athlete with the fewest jumps at the height last cleared",
        "Q26 Mark": 0,
        "Q27 Question": "The Parry O'Brien style of shot put is also known as the:",
        "Q27 Candidate Answer": "UNATTEMPTED",
        "Q27 Correct Key": "B: Glide method",
        "Q27 Mark": 0,
        "Q28 Question": "A javelin throw is valid only if:",
        "Q28 Candidate Answer": "UNATTEMPTED",
        "Q28 Correct Key": "B: The metal head strikes the ground before any other part",
        "Q28 Mark": 0,
        "Q29 Question": "What is the minimum size of the high jump landing mat?",
        "Q29 Candidate Answer": "UNATTEMPTED",
        "Q29 Correct Key": "B: 5 m × 3 m",
        "Q29 Mark": 0,
        "Q30 Question": "What is the weight of the men's shot?",
        "Q30 Candidate Answer": "UNATTEMPTED",
        "Q30 Correct Key": "C: 7.260 kg",
        "Q30 Mark": 0
      }
    }
  ]
} as const;
